// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root {
    /* font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Helvetica, Arial, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol";
    --font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto,
        Helvetica, Arial, sans-serif, "Apple Color Emoji", "Segoe UI Emoji",
        "Segoe UI Symbol"; */
    --surface-a: #ffffff;
    --surface-b: #efefef;
    --surface-c: #e9ecef;
    --surface-d: #dee2e6;
    --surface-e: #ffffff;
    --surface-f: #ffffff;
    --text-color: #212529;
    --text-color-secondary: #6c757d;
    --primary-color: rgb(207, 0, 0);
    --primary-color-text: #ffffff;
    --secondary-color: #efefef;
    --surface-0: #ffffff;
    --surface-50: #f9fafb;
    --surface-100: #f8f9fa;
    --surface-200: #e9ecef;
    --surface-300: #dee2e6;
    --surface-400: #ced4da;
    --surface-500: #adb5bd;
    --surface-600: #6c757d;
    --surface-700: #495057;
    --surface-800: #343a40;
    --surface-900: #212529;
    --gray-50: #f9fafb;
    --gray-100: #f8f9fa;
    --gray-200: #e9ecef;
    --gray-300: #dee2e6;
    --gray-400: #ced4da;
    --gray-500: #adb5bd;
    --gray-600: #6c757d;
    --gray-700: #495057;
    --gray-800: #343a40;
    --gray-900: #212529;
    --content-padding: 1.25rem;
    --inline-spacing: 0.5rem;
    --border-radius: 5px;
    --surface-ground: #efefef;
    --surface-section: #ffffff;
    --surface-card: #ffffff;
    --surface-overlay: #ffffff;
    --surface-border: #dee2e6;
    --surface-hover: #e9ecef;
    --focus-ring: 0 0 0 0.2rem #f7979b;
    --maskbg: rgba(0, 0, 0, 0.4);
    --highlight-bg: #007bff;
    --highlight-text-color: #ffffff;
    color-scheme: light;
}

:root {
    --blue-50: #f3f8ff;
    --blue-100: #c5dcff;
    --blue-200: #97c1fe;
    --blue-300: #69a5fe;
    --blue-400: #3b8afd;
    --blue-500: #0d6efd;
    --blue-600: #0b5ed7;
    --blue-700: #094db1;
    --blue-800: #073d8b;
    --blue-900: #052c65;
    --green-50: #f4f9f6;
    --green-100: #c8e2d6;
    --green-200: #9ccbb5;
    --green-300: #70b595;
    --green-400: #459e74;
    --green-500: #198754;
    --green-600: #157347;
    --green-700: #125f3b;
    --green-800: #0e4a2e;
    --green-900: #0a3622;
    --yellow-50: #fffcf3;
    --yellow-100: #fff0c3;
    --yellow-200: #ffe494;
    --yellow-300: #ffd965;
    --yellow-400: #ffcd36;
    --yellow-500: #ffc107;
    --yellow-600: #d9a406;
    --yellow-700: #b38705;
    --yellow-800: #8c6a04;
    --yellow-900: #664d03;
    --cyan-50: #f3fcfe;
    --cyan-100: #c5f2fb;
    --cyan-200: #97e8f9;
    --cyan-300: #69def6;
    --cyan-400: #3bd4f3;
    --cyan-500: #0dcaf0;
    --cyan-600: #0baccc;
    --cyan-700: #098da8;
    --cyan-800: #076f84;
    --cyan-900: #055160;
    --pink-50: #fdf5f9;
    --pink-100: #f5cee1;
    --pink-200: #eda7ca;
    --pink-300: #e681b3;
    --pink-400: #de5a9b;
    --pink-500: #d63384;
    --pink-600: #b62b70;
    --pink-700: #96245c;
    --pink-800: #761c49;
    --pink-900: #561435;
    --indigo-50: #f7f3fe;
    --indigo-100: #dac6fc;
    --indigo-200: #bd98f9;
    --indigo-300: #a06bf7;
    --indigo-400: #833df4;
    --indigo-500: #6610f2;
    --indigo-600: #570ece;
    --indigo-700: #470ba9;
    --indigo-800: #380985;
    --indigo-900: #290661;
    --teal-50: #f4fcfa;
    --teal-100: #c9f2e6;
    --teal-200: #9fe8d2;
    --teal-300: #75debf;
    --teal-400: #4ad3ab;
    --teal-500: #20c997;
    --teal-600: #1bab80;
    --teal-700: #168d6a;
    --teal-800: #126f53;
    --teal-900: #0d503c;
    --orange-50: #fff9f3;
    --orange-100: #ffe0c7;
    --orange-200: #fec89a;
    --orange-300: #feaf6d;
    --orange-400: #fd9741;
    --orange-500: #fd7e14;
    --orange-600: #d76b11;
    --orange-700: #b1580e;
    --orange-800: #8b450b;
    --orange-900: #653208;
    --bluegray-50: #f8f9fb;
    --bluegray-100: #e0e4ea;
    --bluegray-200: #c7ced9;
    --bluegray-300: #aeb9c8;
    --bluegray-400: #95a3b8;
    --bluegray-500: #7c8ea7;
    --bluegray-600: #69798e;
    --bluegray-700: #576375;
    --bluegray-800: #444e5c;
    --bluegray-900: #323943;
    --purple-50: #f8f6fc;
    --purple-100: #dcd2f0;
    --purple-200: #c1aee4;
    --purple-300: #a68ad9;
    --purple-400: #8a66cd;
    --purple-500: #6f42c1;
    --purple-600: #5e38a4;
    --purple-700: #4e2e87;
    --purple-800: #3d246a;
    --purple-900: #2c1a4d;
    --red-50: #fdf5f6;
    --red-100: #f7cfd2;
    --red-200: #f0a8af;
    --red-300: #e9828c;
    --red-400: #e35b68;
    --red-500: #dc3545;
    --red-600: #bb2d3b;
    --red-700: #9a2530;
    --red-800: #791d26;
    --red-900: #58151c;
    --primary-50: #f2f8ff;
    --primary-100: #c2dfff;
    --primary-200: #91c6ff;
    --primary-300: #61adff;
    --primary-400: #3094ff;
    --primary-500: #007bff;
    --primary-600: #0069d9;
    --primary-700: #0056b3;
    --primary-800: #00448c;
    --primary-900: #003166;
}

.p-editor-container .p-editor-toolbar {
    background: #efefef;
    border-top-right-radius: 4px;
    border-top-left-radius: 4px;
}

.p-editor-container .p-editor-toolbar.ql-snow {
    border: 1px solid #dee2e6;
}

.p-editor-container .p-editor-toolbar.ql-snow .ql-stroke {
    stroke: #6c757d;
}

.p-editor-container .p-editor-toolbar.ql-snow .ql-fill {
    fill: #6c757d;
}

.p-editor-container .p-editor-toolbar.ql-snow .ql-picker .ql-picker-label {
    border: 0 none;
    color: #6c757d;
}

.p-editor-container .p-editor-toolbar.ql-snow .ql-picker .ql-picker-label:hover {
    color: #212529;
}

.p-editor-container .p-editor-toolbar.ql-snow .ql-picker .ql-picker-label:hover .ql-stroke {
    stroke: #212529;
}

.p-editor-container .p-editor-toolbar.ql-snow .ql-picker .ql-picker-label:hover .ql-fill {
    fill: #212529;
}

.p-editor-container .p-editor-toolbar.ql-snow .ql-picker.ql-expanded .ql-picker-label {
    color: #212529;
}

.p-editor-container .p-editor-toolbar.ql-snow .ql-picker.ql-expanded .ql-picker-label .ql-stroke {
    stroke: #212529;
}

.p-editor-container .p-editor-toolbar.ql-snow .ql-picker.ql-expanded .ql-picker-label .ql-fill {
    fill: #212529;
}

.p-editor-container .p-editor-toolbar.ql-snow .ql-picker.ql-expanded .ql-picker-options {
    background: #ffffff;
    border: 1px solid rgba(0, 0, 0, 0.15);
    box-shadow: none;
    border-radius: 4px;
    padding: 0.5rem 0;
}

.p-editor-container .p-editor-toolbar.ql-snow .ql-picker.ql-expanded .ql-picker-options .ql-picker-item {
    color: #212529;
}

.p-editor-container .p-editor-toolbar.ql-snow .ql-picker.ql-expanded .ql-picker-options .ql-picker-item:hover {
    color: #212529;
    background: #e9ecef;
}

.p-editor-container .p-editor-toolbar.ql-snow .ql-picker.ql-expanded:not(.ql-icon-picker) .ql-picker-item {
    padding: 0.5rem 1.5rem;
}

.p-editor-container .p-editor-content {
    border-bottom-right-radius: 4px;
    border-bottom-left-radius: 4px;
}

.p-editor-container .p-editor-content.ql-snow {
    border: 1px solid #dee2e6;
}

.p-editor-container .p-editor-content .ql-editor {
    background: #ffffff;
    color: #495057;
    border-bottom-right-radius: 4px;
    border-bottom-left-radius: 4px;
}

.p-editor-container .ql-snow.ql-toolbar button:hover,
.p-editor-container .ql-snow.ql-toolbar button:focus {
    color: #212529;
}

.p-editor-container .ql-snow.ql-toolbar button:hover .ql-stroke,
.p-editor-container .ql-snow.ql-toolbar button:focus .ql-stroke {
    stroke: #212529;
}

.p-editor-container .ql-snow.ql-toolbar button:hover .ql-fill,
.p-editor-container .ql-snow.ql-toolbar button:focus .ql-fill {
    fill: #212529;
}

.p-editor-container .ql-snow.ql-toolbar button.ql-active,
.p-editor-container .ql-snow.ql-toolbar .ql-picker-label.ql-active,
.p-editor-container .ql-snow.ql-toolbar .ql-picker-item.ql-selected {
    color: #007bff;
}

.p-editor-container .ql-snow.ql-toolbar button.ql-active .ql-stroke,
.p-editor-container .ql-snow.ql-toolbar .ql-picker-label.ql-active .ql-stroke,
.p-editor-container .ql-snow.ql-toolbar .ql-picker-item.ql-selected .ql-stroke {
    stroke: #007bff;
}

.p-editor-container .ql-snow.ql-toolbar button.ql-active .ql-fill,
.p-editor-container .ql-snow.ql-toolbar .ql-picker-label.ql-active .ql-fill,
.p-editor-container .ql-snow.ql-toolbar .ql-picker-item.ql-selected .ql-fill {
    fill: #007bff;
}

.p-editor-container .ql-snow.ql-toolbar button.ql-active .ql-picker-label,
.p-editor-container .ql-snow.ql-toolbar .ql-picker-label.ql-active .ql-picker-label,
.p-editor-container .ql-snow.ql-toolbar .ql-picker-item.ql-selected .ql-picker-label {
    color: #007bff;
}

@layer primereact {
    * {
        box-sizing: border-box;
    }

    .p-component {
        font-family: var(--font-family);
        font-feature-settings: var(--font-feature-settings, normal);
        font-size: 12px;
        font-weight: normal;
    }

    .p-component-overlay {
        background-color: rgba(0, 0, 0, 0.4);
        transition-duration: 0.15s;
    }

    .p-disabled,
    .p-component:disabled {
        opacity: 0.65;
    }

    .p-error {
        color: #dc3545;
    }

    .p-text-secondary {
        color: #6c757d;
    }

    .pi {
        font-size: 12px;
    }

    .p-icon {
        width: 1rem;
        height: 1rem;
    }

    .p-link {
        font-family: var(--font-family);
        font-feature-settings: var(--font-feature-settings, normal);
        font-size: 12px;
        border-radius: 4px;
    }

    .p-link:focus-visible {
        outline: 0 none;
        outline-offset: 0;
        box-shadow: 0 0 0 0.2rem #e4717c;
    }

    .p-component-overlay-enter {
        animation: p-component-overlay-enter-animation 150ms forwards;
    }

    .p-component-overlay-leave {
        animation: p-component-overlay-leave-animation 150ms forwards;
    }

    @keyframes p-component-overlay-enter-animation {
        from {
            background-color: transparent;
        }

        to {
            background-color: var(--maskbg);
        }
    }

    @keyframes p-component-overlay-leave-animation {
        from {
            background-color: var(--maskbg);
        }

        to {
            background-color: transparent;
        }
    }

    .p-autocomplete .p-autocomplete-loader {
        right: 0.75rem;
    }

    .p-autocomplete.p-autocomplete-dd .p-autocomplete-loader {
        right: 3.107rem;
    }

    .p-autocomplete .p-autocomplete-multiple-container {
        padding: 0.25rem 0.75rem;
        gap: 0.5rem;
    }

    .p-autocomplete .p-autocomplete-multiple-container:not(.p-disabled):hover {
        border-color: #ced4da;
    }

    .p-autocomplete .p-autocomplete-multiple-container:not(.p-disabled).p-focus {
        outline: 0 none;
        outline-offset: 0;
        box-shadow: 0 0 0 0.2rem rgba(38, 143, 255, 0.5);
        border-color: #007bff;
    }

    .p-autocomplete .p-autocomplete-multiple-container .p-autocomplete-input-token {
        padding: 0.25rem 0;
    }

    .p-autocomplete .p-autocomplete-multiple-container .p-autocomplete-input-token input {
        font-family: var(--font-family);
        font-feature-settings: var(--font-feature-settings, normal);
        font-size: 12px;
        color: #212529;
        padding: 0;
        margin: 0;
    }

    .p-autocomplete .p-autocomplete-multiple-container .p-autocomplete-token {
        padding: 0.25rem 0.75rem;
        margin-right: 0.5rem;
        background: #007bff;
        color: #ffffff;
        border-radius: 4px;
    }

    .p-autocomplete .p-autocomplete-multiple-container .p-autocomplete-token .p-autocomplete-token-icon {
        margin-left: 0.5rem;
    }

    .p-autocomplete.p-invalid.p-component>.p-inputtext {
        border-color: #dc3545;
    }

    .p-autocomplete-panel {
        background: #ffffff;
        color: #212529;
        border: 1px solid rgba(0, 0, 0, 0.15);
        border-radius: 4px;
        box-shadow: none;
    }

    .p-autocomplete-panel .p-autocomplete-items {
        padding: 0.5rem 0;
    }

    .p-autocomplete-panel .p-autocomplete-items .p-autocomplete-item {
        margin: 0;
        padding: 0.5rem 1.5rem;
        border: 0 none;
        color: #212529;
        background: transparent;
        transition: box-shadow 0.15s;
        border-radius: 0;
    }

    .p-autocomplete-panel .p-autocomplete-items .p-autocomplete-item:hover {
        color: #212529;
        background: #e9ecef;
    }

    .p-autocomplete-panel .p-autocomplete-items .p-autocomplete-item.p-highlight {
        color: #ffffff;
        background: #007bff;
    }

    .p-autocomplete-panel .p-autocomplete-items .p-autocomplete-item-group {
        margin: 0;
        padding: 0.75rem 1rem;
        color: #212529;
        background: #ffffff;
        font-weight: 600;
    }

    .p-calendar.p-invalid.p-component>.p-inputtext {
        border-color: #dc3545;
    }

    .p-calendar:not(.p-calendar-disabled).p-focus>.p-inputtext {
        outline: 0 none;
        outline-offset: 0;
        box-shadow: 0 0 0 0.2rem #e4717c;
        border-color: #e4717c
    }

    .p-datepicker {
        padding: 0;
        background: #ffffff;
        color: #212529;
        border: 1px solid #ced4da;
        border-radius: 4px;
    }

    .p-datepicker:not(.p-datepicker-inline) {
        background: #ffffff;
        border: 1px solid rgba(0, 0, 0, 0.15);
        box-shadow: none;
    }

    .p-datepicker:not(.p-datepicker-inline) .p-datepicker-header {
        background: #efefef;
    }

    .p-datepicker .p-datepicker-header {
        padding: 0.5rem;
        color: #212529;
        background: #ffffff;
        font-weight: 600;
        margin: 0;
        border-bottom: 1px solid #dee2e6;
        border-top-right-radius: 4px;
        border-top-left-radius: 4px;
    }

    .p-datepicker .p-datepicker-header .p-datepicker-prev,
    .p-datepicker .p-datepicker-header .p-datepicker-next {
        width: 2rem;
        height: 2rem;
        color: #6c757d;
        border: 0 none;
        background: transparent;
        border-radius: 50%;
        transition: box-shadow 0.15s;
    }

    .p-datepicker .p-datepicker-header .p-datepicker-prev:enabled:hover,
    .p-datepicker .p-datepicker-header .p-datepicker-next:enabled:hover {
        color: #495057;
        border-color: transparent;
        background: transparent;
    }

    .p-datepicker .p-datepicker-header .p-datepicker-prev:focus-visible,
    .p-datepicker .p-datepicker-header .p-datepicker-next:focus-visible {
        outline: 0 none;
        outline-offset: 0;
        box-shadow: 0 0 0 0.2rem rgba(38, 143, 255, 0.5);
    }

    .p-datepicker .p-datepicker-header .p-datepicker-title {
        line-height: 2rem;
    }

    .p-datepicker .p-datepicker-header .p-datepicker-title .p-datepicker-year,
    .p-datepicker .p-datepicker-header .p-datepicker-title .p-datepicker-month {
        color: #212529;
        transition: box-shadow 0.15s;
        font-weight: 600;
        padding: 0.5rem;
    }

    .p-datepicker .p-datepicker-header .p-datepicker-title .p-datepicker-year:enabled:hover,
    .p-datepicker .p-datepicker-header .p-datepicker-title .p-datepicker-month:enabled:hover {
        color: #007bff;
    }

    .p-datepicker .p-datepicker-header .p-datepicker-title .p-datepicker-month {
        margin-right: 0.5rem;
    }

    .p-datepicker table {
        font-size: 12px;
        margin: 0.5rem 0;
    }

    .p-datepicker table th {
        padding: 0.5rem;
    }

    .p-datepicker table th>span {
        width: 2.5rem;
        height: 2.5rem;
    }

    .p-datepicker table td {
        padding: 0.5rem;
    }

    .p-datepicker table td>span {
        width: 2.5rem;
        height: 2.5rem;
        border-radius: 4px;
        transition: box-shadow 0.15s;
        border: 1px solid transparent;
    }

    .p-datepicker table td>span.p-highlight {
        color: #ffffff;
        background: #cf0000;
    }

    .p-datepicker table td>span:focus {
        outline: 0 none;
        outline-offset: 0;
        box-shadow: 0 0 0 0.2rem rgba(38, 143, 255, 0.5);
    }

    .p-datepicker table td.p-datepicker-today>span {
        background: #ced4da;
        color: #212529;
        border-color: transparent;
    }

    .p-datepicker table td.p-datepicker-today>span.p-highlight {
        color: #ffffff;
        background: #080808;
    }

    .p-datepicker .p-datepicker-buttonbar {
        padding: 1rem 0;
        border-top: 1px solid #dee2e6;
    }

    .p-datepicker .p-datepicker-buttonbar .p-button {
        width: auto;
    }

    .p-datepicker .p-timepicker {
        border-top: 1px solid #dee2e6;
        padding: 0.5rem;
    }

    .p-datepicker .p-timepicker button {
        width: 2rem;
        height: 2rem;
        color: #6c757d;
        border: 0 none;
        background: transparent;
        border-radius: 50%;
        transition: box-shadow 0.15s;
    }

    .p-datepicker .p-timepicker button:enabled:hover {
        color: #495057;
        border-color: transparent;
        background: transparent;
    }

    .p-datepicker .p-timepicker button:focus-visible {
        outline: 0 none;
        outline-offset: 0;
        box-shadow: 0 0 0 0.2rem rgba(38, 143, 255, 0.5);
    }

    .p-datepicker .p-timepicker button:last-child {
        margin-top: 0.2em;
    }

    .p-datepicker .p-timepicker span {
        font-size: 12px;
    }

    .p-datepicker .p-timepicker>div {
        padding: 0 0.5rem;
    }

    .p-datepicker.p-datepicker-timeonly .p-timepicker {
        border-top: 0 none;
    }

    .p-datepicker .p-monthpicker {
        margin: 0.5rem 0;
    }

    .p-datepicker .p-monthpicker .p-monthpicker-month {
        padding: 0.5rem;
        transition: box-shadow 0.15s;
        border-radius: 4px;
    }

    .p-datepicker .p-monthpicker .p-monthpicker-month.p-highlight {
        color: #ffffff;
        background: #007bff;
    }

    .p-datepicker .p-yearpicker {
        margin: 0.5rem 0;
    }

    .p-datepicker .p-yearpicker .p-yearpicker-year {
        padding: 0.5rem;
        transition: box-shadow 0.15s;
        border-radius: 4px;
    }

    .p-datepicker .p-yearpicker .p-yearpicker-year.p-highlight {
        color: #ffffff;
        background: #007bff;
    }

    .p-datepicker.p-datepicker-multiple-month .p-datepicker-group {
        border-left: 1px solid #dee2e6;
        padding-right: 0;
        padding-left: 0;
        padding-top: 0;
        padding-bottom: 0;
    }

    .p-datepicker.p-datepicker-multiple-month .p-datepicker-group:first-child {
        padding-left: 0;
    }

    .p-datepicker.p-datepicker-multiple-month .p-datepicker-group:last-child {
        padding-right: 0;
        border-left: 0 none;
    }

    .p-datepicker:not(.p-disabled) table td span:not(.p-highlight):not(.p-disabled):hover {
        background: #e9ecef;
    }

    .p-datepicker:not(.p-disabled) table td span:not(.p-highlight):not(.p-disabled):focus {
        outline: 0 none;
        outline-offset: 0;
        box-shadow: 0 0 0 0.2rem #e4717c;
    }

    .p-datepicker:not(.p-disabled) .p-monthpicker .p-monthpicker-month:not(.p-disabled):not(.p-highlight):hover {
        background: #e9ecef;
    }

    .p-datepicker:not(.p-disabled) .p-monthpicker .p-monthpicker-month:not(.p-disabled):focus {
        outline: 0 none;
        outline-offset: 0;
        box-shadow: 0 0 0 0.2rem rgba(38, 143, 255, 0.5);
    }

    .p-datepicker:not(.p-disabled) .p-yearpicker .p-yearpicker-year:not(.p-disabled):not(.p-highlight):hover {
        background: #e9ecef;
    }

    .p-datepicker:not(.p-disabled) .p-yearpicker .p-yearpicker-year:not(.p-disabled):focus {
        outline: 0 none;
        outline-offset: 0;
        box-shadow: 0 0 0 0.2rem rgba(38, 143, 255, 0.5);
    }

    @media screen and (max-width: 769px) {

        .p-datepicker table th,
        .p-datepicker table td {
            padding: 0;
        }
    }

    .p-cascadeselect {
        background: #ffffff;
        border: 1px solid #ced4da;
        transition: background-color 0.15s, border-color 0.15s, box-shadow 0.15s;
        border-radius: 4px;
    }

    .p-cascadeselect:not(.p-disabled):hover {
        border-color: #ced4da;
    }

    .p-cascadeselect:not(.p-disabled).p-focus {
        outline: 0 none;
        outline-offset: 0;
        box-shadow: 0 0 0 0.2rem rgba(38, 143, 255, 0.5);
        border-color: #007bff;
    }

    .p-cascadeselect .p-cascadeselect-label {
        background: transparent;
        border: 0 none;
        padding: 0.5rem 0.75rem;
    }

    .p-cascadeselect .p-cascadeselect-label.p-placeholder {
        color: #6c757d;
    }

    .p-cascadeselect .p-cascadeselect-label:enabled:focus {
        outline: 0 none;
        box-shadow: none;
    }

    .p-cascadeselect .p-cascadeselect-trigger {
        background: transparent;
        color: #495057;
        width: 2.357rem;
        border-top-right-radius: 4px;
        border-bottom-right-radius: 4px;
    }

    .p-cascadeselect.p-invalid.p-component {
        border-color: #dc3545;
    }

    .p-cascadeselect-panel {
        background: #ffffff;
        color: #212529;
        border: 1px solid rgba(0, 0, 0, 0.15);
        border-radius: 4px;
        box-shadow: none;
    }

    .p-cascadeselect-panel .p-cascadeselect-items {
        padding: 0.5rem 0;
    }

    .p-cascadeselect-panel .p-cascadeselect-items .p-cascadeselect-item {
        margin: 0;
        border: 0 none;
        color: #212529;
        background: transparent;
        transition: box-shadow 0.15s;
        border-radius: 0;
    }

    .p-cascadeselect-panel .p-cascadeselect-items .p-cascadeselect-item .p-cascadeselect-item-content {
        padding: 0.5rem 1.5rem;
    }

    .p-cascadeselect-panel .p-cascadeselect-items .p-cascadeselect-item .p-cascadeselect-item-content:focus {
        outline: 0 none;
        outline-offset: 0;
        box-shadow: inset 0 0 0 0.15rem rgba(38, 143, 255, 0.5);
    }

    .p-cascadeselect-panel .p-cascadeselect-items .p-cascadeselect-item.p-highlight {
        color: #ffffff;
        background: #007bff;
    }

    .p-cascadeselect-panel .p-cascadeselect-items .p-cascadeselect-item:not(.p-highlight):not(.p-disabled):hover {
        color: #212529;
        background: #e9ecef;
    }

    .p-cascadeselect-panel .p-cascadeselect-items .p-cascadeselect-item .p-cascadeselect-group-icon {
        font-size: 0.875rem;
    }

    .p-cascadeselect-panel .p-cascadeselect-items .p-cascadeselect-item .p-cascadeselect-group-icon.p-icon {
        width: 0.875rem;
        height: 0.875rem;
    }

    .p-input-filled .p-cascadeselect {
        background: #efefef;
    }

    .p-input-filled .p-cascadeselect:not(.p-disabled):hover {
        background-color: #efefef;
    }

    .p-input-filled .p-cascadeselect:not(.p-disabled).p-focus {
        background-color: #efefef;
    }

    .p-checkbox {
        width: 20px;
        height: 20px;
    }

    .p-checkbox .p-checkbox-box {
        border: 2px solid #ced4da;
        background: #ffffff;
        width: 20px;
        height: 20px;
        color: #212529;
        border-radius: 4px;
        transition: background-color 0.15s, border-color 0.15s, box-shadow 0.15s;
    }

    .p-checkbox .p-checkbox-box .p-checkbox-icon {
        transition-duration: 0.15s;
        color: #ffffff;
        font-size: 14px;
    }

    .p-checkbox .p-checkbox-box .p-checkbox-icon.p-icon {
        width: 14px;
        height: 14px;
    }

    .p-checkbox .p-checkbox-box.p-highlight {
        border-color: #cf0000;
        background: #cf0000;
    }

    .p-checkbox .p-checkbox-box.p-highlight:not(.p-disabled):hover {
        border-color: #0062cc;
        background: #0062cc;
        color: #ffffff;
    }

    .p-checkbox:not(.p-checkbox-disabled) .p-checkbox-box:hover {
        border-color: #ced4da;
    }

    .p-checkbox:not(.p-checkbox-disabled) .p-checkbox-box.p-focus {
        outline: 0 none;
        outline-offset: 0;
        box-shadow: 0 0 0 0.2rem #e4717c;
        border-color: #e4717c;
    }

    .p-checkbox:not(.p-checkbox-disabled) .p-checkbox-box.p-highlight:hover {
        border-color: #a60622;
        background: #a60622;
        color: #ffffff;
    }

    .p-checkbox.p-invalid>.p-checkbox-box {
        border-color: #dc3545;
    }

    .p-input-filled .p-checkbox .p-checkbox-box {
        background-color: #efefef;
    }

    .p-input-filled .p-checkbox .p-checkbox-box.p-highlight {
        background: #ff0404;
    }

    .p-input-filled .p-checkbox:not(.p-checkbox-disabled) .p-checkbox-box:hover {
        background-color: #efefef;
    }

    .p-input-filled .p-checkbox:not(.p-checkbox-disabled) .p-checkbox-box.p-highlight:hover {
        background: #0062cc;
    }

    .p-highlight .p-checkbox .p-checkbox-box {
        border-color: #ffffff;
    }

    .p-chips {
        display: inline-flex;
    }

    .p-chips-multiple-container {
        margin: 0;
        padding: 0;
        list-style-type: none;
        cursor: text;
        overflow: hidden;
        display: flex;
        align-items: center;
        flex-wrap: wrap;
    }

    .p-chips-token {
        cursor: default;
        display: inline-flex;
        align-items: center;
        flex: 0 0 auto;
    }

    .p-chips-input-token {
        flex: 1 1 auto;
        display: inline-flex;
    }

    .p-chips-token-icon {
        cursor: pointer;
    }

    .p-chips-input-token input {
        border: 0 none;
        outline: 0 none;
        background-color: transparent;
        margin: 0;
        padding: 0;
        box-shadow: none;
        border-radius: 0;
        width: 100%;
    }

    .p-fluid .p-chips {
        display: flex;
    }

    .p-chips:not(.p-disabled):hover .p-chips-multiple-container {
        border-color: #ced4da;
    }

    .p-chips:not(.p-disabled).p-focus .p-chips-multiple-container {
        outline: 0 none;
        outline-offset: 0;
        box-shadow: 0 0 0 0.2rem rgba(38, 143, 255, 0.5);
        border-color: #007bff;
    }

    .p-chips .p-chips-multiple-container {
        padding: 0.25rem 0.75rem;
        outline-color: transparent;
    }

    .p-chips .p-chips-multiple-container .p-chips-token {
        padding: 0.25rem 0.75rem;
        margin-right: 0.5rem;
        background: #dee2e6;
        color: #212529;
        border-radius: 16px;
    }

    .p-chips .p-chips-multiple-container .p-chips-token.p-focus {
        background: #ced4da;
        color: #212529;
    }

    .p-chips .p-chips-multiple-container .p-chips-token .p-chips-token-icon {
        margin-left: 0.5rem;
    }

    .p-chips .p-chips-multiple-container .p-chips-input-token {
        padding: 0.25rem 0;
    }

    .p-chips .p-chips-multiple-container .p-chips-input-token input {
        font-family: var(--font-family);
        font-feature-settings: var(--font-feature-settings, normal);
        font-size: 12px;
        color: #212529;
        padding: 0;
        margin: 0;
    }

    .p-chips.p-invalid.p-component>.p-inputtext {
        border-color: #dc3545;
    }

    .p-colorpicker-preview {
        width: 2rem;
        height: 2rem;
    }

    .p-colorpicker-panel {
        background: #212529;
        border: 1px solid #212529;
    }

    .p-colorpicker-panel .p-colorpicker-color-handle,
    .p-colorpicker-panel .p-colorpicker-hue-handle {
        border-color: #ffffff;
    }

    .p-colorpicker-overlay-panel {
        box-shadow: none;
    }

    .p-dropdown {
        display: inline-flex;
        cursor: pointer;
        position: relative;
        -webkit-user-select: none;
                user-select: none;
    }

    .p-dropdown-clear-icon {
        position: absolute;
        top: 50%;
        margin-top: -0.5rem;
    }

    .p-dropdown-trigger {
        display: flex;
        align-items: center;
        justify-content: center;
        flex-shrink: 0;
    }

    .p-dropdown-label {
        display: block;
        white-space: nowrap;
        overflow: hidden;
        flex: 1 1 auto;
        width: 1%;
        text-overflow: ellipsis;
        cursor: pointer;
    }

    .p-dropdown-label-empty {
        overflow: hidden;
        opacity: 0;
    }

    input.p-dropdown-label {
        cursor: default;
    }

    .p-dropdown .p-dropdown-panel {
        min-width: 100%;
    }

    .p-dropdown-panel {
        position: absolute;
        top: 0;
        left: 0;
    }

    .p-dropdown-items-wrapper {
        overflow: auto;
    }

    .p-dropdown-item {
        cursor: pointer;
        font-weight: normal;
        white-space: nowrap;
        position: relative;
        overflow: hidden;
        display: flex;
        align-items: center;
    }

    .p-dropdown-item-group {
        cursor: auto;
    }

    .p-dropdown-items {
        margin: 0;
        padding: 0;
        list-style-type: none;
    }

    .p-dropdown-filter {
        width: 100%;
    }

    .p-dropdown-filter-container {
        position: relative;
    }

    .p-dropdown-filter-icon {
        position: absolute;
        top: 50%;
        margin-top: -0.5rem;
    }

    .p-fluid .p-dropdown {
        display: flex;
    }

    .p-fluid .p-dropdown .p-dropdown-label {
        width: 1%;
    }

    .p-dropdown {
        background: #ffffff;
        border: 1px solid #ced4da;
        transition: background-color 0.15s, border-color 0.15s, box-shadow 0.15s;
        border-radius: 4px;
        outline-color: transparent;
    }

    .p-dropdown:not(.p-disabled):hover {
        border-color: #ced4da;
    }

    .p-dropdown:not(.p-disabled).p-focus {
        outline: 0 none;
        outline-offset: 0;
        box-shadow: 0 0 0 0.2rem #e4717c;
        border-color: #e4717c;
    }

    .p-dropdown.p-variant-filled {
        background: #efefef;
    }

    .p-dropdown.p-variant-filled:not(.p-disabled):hover {
        background-color: #efefef;
    }

    .p-dropdown.p-variant-filled:not(.p-disabled).p-focus {
        background-color: #efefef;
    }

    .p-dropdown.p-variant-filled:not(.p-disabled).p-focus .p-inputtext {
        background-color: transparent;
    }

    .p-dropdown.p-dropdown-clearable .p-dropdown-label {
        padding-right: 1.75rem;
    }

    .p-dropdown .p-dropdown-label {
        background: transparent;
        border: 0 none;
    }

    .p-dropdown .p-dropdown-label.p-placeholder {
        color: #6c757d;
    }

    .p-dropdown .p-dropdown-label:focus,
    .p-dropdown .p-dropdown-label:enabled:focus {
        outline: 0 none;
        box-shadow: none;
    }

    .p-dropdown .p-dropdown-trigger {
        background: transparent;
        color: #cf0000;
        width: 2.357rem;
        border-top-right-radius: 4px;
        border-bottom-right-radius: 4px;
    }

    .p-dropdown .p-dropdown-clear-icon {
        color: #495057;
        right: 2.357rem;
    }

    .p-dropdown.p-invalid.p-component {
        border-color: #dc3545;
    }

    .p-dropdown-panel {
        background: #ffffff;
        color: #212529;
        border: 1px solid rgba(0, 0, 0, 0.15);
        border-radius: 4px;
        box-shadow: none;
    }

    .p-dropdown-panel .p-dropdown-header {
        padding: 0.75rem 1.5rem;
        border-bottom: 1px solid #dee2e6;
        color: #212529;
        background: #efefef;
        margin: 0;
        border-top-right-radius: 4px;
        border-top-left-radius: 4px;
    }

    .p-dropdown-panel .p-dropdown-header .p-dropdown-filter {
        padding-right: 1.75rem;
        margin-right: -1.75rem;
    }

    .p-dropdown-panel .p-dropdown-header .p-dropdown-filter-icon {
        right: 0.75rem;
        color: #495057;
    }

    .p-dropdown-panel .p-dropdown-items {
        padding: 0.5rem 0;
    }

    .p-dropdown-panel .p-dropdown-items .p-dropdown-item {
        margin: 0;
        padding: 0.5rem 1.5rem;
        border: 0 none;
        color: #212529;
        background: transparent;
        transition: box-shadow 0.15s;
        border-radius: 0;
    }

    .p-dropdown-panel .p-dropdown-items .p-dropdown-item:first-child {
        margin-top: 0;
    }

    .p-dropdown-panel .p-dropdown-items .p-dropdown-item:last-child {
        margin-bottom: 0;
    }

    .p-dropdown-panel .p-dropdown-items .p-dropdown-item.p-highlight {
        color: #ffffff;
        background: #cf0000;
    }

    .p-dropdown-panel .p-dropdown-items .p-dropdown-item.p-highlight.p-focus {
        background: #cf0000;
    }

    .p-dropdown-panel .p-dropdown-items .p-dropdown-item:not(.p-highlight):not(.p-disabled).p-focus {
        color: #212529;
        background: #e9ecef;
    }

    .p-dropdown-panel .p-dropdown-items .p-dropdown-item .p-dropdown-check-icon {
        position: relative;
        margin-left: -0.5rem;
        margin-right: 0.5rem;
    }

    .p-dropdown-panel .p-dropdown-items .p-dropdown-item-group {
        margin: 0;
        padding: 0.75rem 1rem;
        color: #212529;
        background: #ffffff;
        font-weight: 600;
    }

    .p-dropdown-panel .p-dropdown-items .p-dropdown-empty-message {
        padding: 0.5rem 1.5rem;
        color: #212529;
        background: transparent;
    }

    .p-inputgroup-addon {
        background: #e9ecef;
        color: #495057;
        border-top: 1px solid #ced4da;
        border-left: 1px solid #ced4da;
        border-bottom: 1px solid #ced4da;
        padding: 0.5rem 0.75rem;
        min-width: 2.357rem;
    }

    .p-inputgroup-addon:last-child {
        border-right: 1px solid #ced4da;
    }

    .p-inputgroup>.p-component,
    .p-inputgroup>.p-inputwrapper>.p-inputtext,
    .p-inputgroup>.p-float-label>.p-component {
        border-radius: 0;
        margin: 0;
    }

    .p-inputgroup>.p-component+.p-inputgroup-addon,
    .p-inputgroup>.p-inputwrapper>.p-inputtext+.p-inputgroup-addon,
    .p-inputgroup>.p-float-label>.p-component+.p-inputgroup-addon {
        border-left: 0 none;
    }

    .p-inputgroup>.p-component:focus,
    .p-inputgroup>.p-inputwrapper>.p-inputtext:focus,
    .p-inputgroup>.p-float-label>.p-component:focus {
        z-index: 1;
    }

    .p-inputgroup>.p-component:focus~label,
    .p-inputgroup>.p-inputwrapper>.p-inputtext:focus~label,
    .p-inputgroup>.p-float-label>.p-component:focus~label {
        z-index: 1;
    }

    .p-inputgroup-addon:first-child,
    .p-inputgroup button:first-child,
    .p-inputgroup input:first-child,
    .p-inputgroup>.p-inputwrapper:first-child,
    .p-inputgroup>.p-inputwrapper:first-child>.p-inputtext {
        border-top-left-radius: 4px;
        border-bottom-left-radius: 4px;
    }

    .p-inputgroup .p-float-label:first-child input {
        border-top-left-radius: 4px;
        border-bottom-left-radius: 4px;
    }

    .p-inputgroup-addon:last-child,
    .p-inputgroup button:last-child,
    .p-inputgroup input:last-child,
    .p-inputgroup>.p-inputwrapper:last-child,
    .p-inputgroup>.p-inputwrapper:last-child>.p-inputtext {
        border-top-right-radius: 4px;
        border-bottom-right-radius: 4px;
    }

    .p-inputgroup .p-float-label:last-child input {
        border-top-right-radius: 4px;
        border-bottom-right-radius: 4px;
    }

    .p-fluid .p-inputgroup .p-button {
        width: auto;
    }

    .p-fluid .p-inputgroup .p-button.p-button-icon-only {
        width: 2.357rem;
    }

    .p-inputnumber.p-invalid.p-component>.p-inputtext {
        border-color: #dc3545;
    }

    .p-inputswitch {
        width: 3rem;
        height: 1.75rem;
    }

    .p-inputswitch .p-inputswitch-slider {
        background: #ced4da;
        transition: background-color 0.15s, border-color 0.15s, box-shadow 0.15s;
        border-radius: 30px;
    }

    .p-inputswitch .p-inputswitch-slider:before {
        background: #ffffff;
        width: 1.25rem;
        height: 1.25rem;
        left: 0.25rem;
        margin-top: -0.625rem;
        border-radius: 30px;
        transition-duration: 0.15s;
    }

    .p-inputswitch.p-inputswitch-checked .p-inputswitch-slider:before {
        transform: translateX(1.25rem);
    }

    .p-inputswitch.p-focus .p-inputswitch-slider {
        outline: 0 none;
        outline-offset: 0;
        box-shadow: 0 0 0 0.2rem #e4717c;
    }

    .p-inputswitch:not(.p-disabled):hover .p-inputswitch-slider {
        background: #ced4da;
    }

    .p-inputswitch.p-inputswitch-checked .p-inputswitch-slider {
        background: #cf0000;
        box-shadow: 0px 1px 8px -1px #dc3545;
    }

    .p-inputswitch.p-inputswitch-checked .p-inputswitch-slider:before {
        background: #ffffff;
    }

    .p-inputswitch.p-inputswitch-checked:not(.p-disabled):hover .p-inputswitch-slider {
        background: #a60622;
    }

    .p-inputswitch.p-invalid .p-inputswitch-slider {
        border-color: #dc3545;
    }

    .p-inputtext {
        font-family: var(--font-family);
        font-feature-settings: var(--font-feature-settings, normal);
        font-size: 12px;
        color: #495057;
        background: #ffffff;
        padding: 0.5rem 0.75rem;
        border: 1px solid #ced4da;
        transition: background-color 0.15s, border-color 0.15s, box-shadow 0.15s;
        appearance: none;
        border-radius: 4px;
    }

    .p-inputtext:enabled:hover {
        border-color: #ced4da;
    }

    .p-inputtext:enabled:focus {
        outline: 0 none;
        outline-offset: 0;
        box-shadow: 0 0 0 0.2rem #e4717c;
        border-color: #e4717c;
    }

    .p-inputtext.p-invalid.p-component {
        border-color: #dc3545;
    }

    .p-inputtext.p-inputtext-sm {
        font-size: 12px;
        padding: 0.4375rem 0.65625rem;
    }

    .p-inputtext.p-inputtext-lg {
        font-size: 12px;
        padding: 0.625rem 0.9375rem;
    }

    .p-float-label>label {
        left: 0.75rem;
        color: #6c757d;
        transition-duration: 0.15s;
    }

    .p-float-label>label.p-error {
        color: #dc3545;
    }

    .p-input-icon-left>i:first-of-type,
    .p-input-icon-left>svg:first-of-type,
    .p-input-icon-left>.p-input-prefix {
        left: 0.75rem;
        color: #495057;
    }

    .p-input-icon-left>.p-inputtext {
        padding-left: 2.5rem;
    }

    .p-input-icon-left.p-float-label>label {
        left: 2.5rem;
    }

    .p-input-icon-right>i:last-of-type,
    .p-input-icon-right>svg:last-of-type,
    .p-input-icon-right>.p-input-suffix {
        right: 0.75rem;
        color: #495057;
    }

    .p-input-icon-right>.p-inputtext {
        padding-right: 2.5rem;
    }

    ::-webkit-input-placeholder {
        color: #6c757d;
    }

    :-moz-placeholder {
        color: #6c757d;
    }

    ::-moz-placeholder {
        color: #6c757d;
    }

    :-ms-input-placeholder {
        color: #6c757d;
    }

    .p-input-filled .p-inputtext {
        background-color: #efefef;
    }

    .p-input-filled .p-inputtext:enabled:hover {
        background-color: #efefef;
    }

    .p-input-filled .p-inputtext:enabled:focus {
        background-color: #efefef;
    }

    .p-inputtext-sm .p-inputtext {
        font-size: 12px;
        padding: 0.4375rem 0.65625rem;
    }

    .p-inputtext-lg .p-inputtext {
        font-size: 12px;
        padding: 0.625rem 0.9375rem;
    }

    .p-listbox-list-wrapper {
        overflow: auto;
    }

    .p-listbox-list {
        list-style-type: none;
        margin: 0;
        padding: 0;
    }

    .p-listbox-item {
        cursor: pointer;
        position: relative;
        overflow: hidden;
    }

    .p-listbox-item-group {
        cursor: auto;
    }

    .p-listbox-filter-container {
        position: relative;
    }

    .p-listbox-filter-icon {
        position: absolute;
        top: 50%;
        margin-top: -0.5rem;
    }

    .p-listbox-filter {
        width: 100%;
    }

    .p-listbox {
        background: #ffffff;
        color: #212529;
        border: 1px solid #ced4da;
        border-radius: 4px;
        transition: background-color 0.15s, border-color 0.15s, box-shadow 0.15s;
        outline-color: transparent;
    }

    .p-listbox .p-listbox-header {
        padding: 0.75rem 1.5rem;
        border-bottom: 1px solid #dee2e6;
        color: #212529;
        background: #efefef;
        margin: 0;
        border-top-right-radius: 4px;
        border-top-left-radius: 4px;
    }

    .p-listbox .p-listbox-header .p-listbox-filter {
        padding-right: 1.75rem;
    }

    .p-listbox .p-listbox-header .p-listbox-filter-icon {
        right: 0.75rem;
        color: #495057;
    }

    .p-listbox .p-listbox-list {
        padding: 0.5rem 0;
        outline: 0 none;
    }

    .p-listbox .p-listbox-list .p-listbox-item {
        margin: 0;
        padding: 0.5rem 1.5rem;
        border: 0 none;
        color: #212529;
        transition: box-shadow 0.15s;
        border-radius: 0;
    }

    .p-listbox .p-listbox-list .p-listbox-item:first-child {
        margin-top: 0;
    }

    .p-listbox .p-listbox-list .p-listbox-item:last-child {
        margin-bottom: 0;
    }

    .p-listbox .p-listbox-list .p-listbox-item.p-highlight {
        color: #ffffff;
        background: #007bff;
    }

    .p-listbox .p-listbox-list .p-listbox-item-group {
        margin: 0;
        padding: 0.75rem 1rem;
        color: #212529;
        background: #ffffff;
        font-weight: 600;
    }

    .p-listbox .p-listbox-list .p-listbox-empty-message {
        padding: 0.5rem 1.5rem;
        color: #212529;
        background: transparent;
    }

    .p-listbox:not(.p-disabled) .p-listbox-item.p-highlight.p-focus {
        background: #0067d6;
    }

    .p-listbox:not(.p-disabled) .p-listbox-item:not(.p-highlight):not(.p-disabled).p-focus {
        color: #212529;
        background: #e9ecef;
    }

    .p-listbox:not(.p-disabled) .p-listbox-item:not(.p-highlight):not(.p-disabled):hover {
        color: #212529;
        background: #e9ecef;
    }

    .p-listbox:not(.p-disabled) .p-listbox-item:not(.p-highlight):not(.p-disabled):hover.p-focus {
        color: #212529;
        background: #e9ecef;
    }

    .p-listbox.p-focus {
        outline: 0 none;
        outline-offset: 0;
        box-shadow: 0 0 0 0.2rem rgba(38, 143, 255, 0.5);
        border-color: #007bff;
    }

    .p-listbox.p-invalid {
        border-color: #dc3545;
    }

    .p-mention-panel {
        background: #ffffff;
        color: #212529;
        border: 1px solid rgba(0, 0, 0, 0.15);
        border-radius: 4px;
        box-shadow: none;
    }

    .p-mention-panel .p-mention-items {
        padding: 0.5rem 0;
    }

    .p-mention-panel .p-mention-items .p-mention-item {
        margin: 0;
        padding: 0.5rem 1.5rem;
        border: 0 none;
        color: #212529;
        background: transparent;
        transition: box-shadow 0.15s;
        border-radius: 0;
    }

    .p-mention-panel .p-mention-items .p-mention-item:hover {
        color: #212529;
        background: #e9ecef;
    }

    .p-mention-panel .p-mention-items .p-mention-item.p-highlight {
        color: #ffffff;
        background: #007bff;
    }

    .p-multiselect {
        display: inline-flex;
        cursor: pointer;
        -webkit-user-select: none;
                user-select: none;
    }

    .p-multiselect-trigger {
        display: flex;
        align-items: center;
        justify-content: center;
        flex-shrink: 0;
    }

    .p-multiselect-label-container {
        overflow: hidden;
        flex: 1 1 auto;
        cursor: pointer;
    }

    .p-multiselect-label {
        display: block;
        white-space: nowrap;
        cursor: pointer;
        overflow: hidden;
        text-overflow: ellipsis;
    }

    .p-multiselect-label-empty {
        overflow: hidden;
        visibility: hidden;
    }

    .p-multiselect-token {
        cursor: default;
        display: inline-flex;
        align-items: center;
        flex: 0 0 auto;
    }

    .p-multiselect-token-icon {
        cursor: pointer;
    }

    .p-multiselect .p-multiselect-panel {
        min-width: 100%;
    }

    .p-multiselect-items-wrapper {
        overflow: auto;
    }

    .p-multiselect-items {
        margin: 0;
        padding: 0;
        list-style-type: none;
    }

    .p-multiselect-item {
        cursor: pointer;
        display: flex;
        align-items: center;
        font-weight: normal;
        white-space: nowrap;
        position: relative;
        overflow: hidden;
    }

    .p-multiselect-item-group {
        cursor: auto;
    }

    .p-multiselect-header {
        display: flex;
        align-items: center;
        justify-content: space-between;
    }

    .p-multiselect-filter-container {
        position: relative;
        flex: 1 1 auto;
    }

    .p-multiselect-filter-icon {
        position: absolute;
        top: 50%;
        margin-top: -0.5rem;
    }

    .p-multiselect-filter-container .p-inputtext {
        width: 100%;
    }

    .p-multiselect-close {
        display: flex;
        align-items: center;
        justify-content: center;
        flex-shrink: 0;
        overflow: hidden;
        position: relative;
        margin-left: auto;
    }

    .p-fluid .p-multiselect {
        display: flex;
    }

    .p-multiselect {
        background: #ffffff;
        border: 1px solid #ced4da;
        transition: background-color 0.15s, border-color 0.15s, box-shadow 0.15s;
        border-radius: 4px;
        outline-color: transparent;
    }

    .p-multiselect:not(.p-disabled):hover {
        border-color: #ced4da;
    }

    .p-multiselect:not(.p-disabled).p-focus {
        outline: 0 none;
        outline-offset: 0;
        box-shadow: 0 0 0 0.2rem #e4717c;
        border-color: #e4717c;
    }

    .p-multiselect.p-variant-filled {
        background: #efefef;
    }

    .p-multiselect.p-variant-filled:not(.p-disabled):hover {
        background-color: #efefef;
    }

    .p-multiselect.p-variant-filled:not(.p-disabled).p-focus {
        background-color: #efefef;
    }

    .p-multiselect .p-multiselect-label {
        padding: 0.5rem 0.75rem;
        transition: background-color 0.15s, border-color 0.15s, box-shadow 0.15s;
    }

    .p-multiselect .p-multiselect-label.p-placeholder {
        color: #6c757d;
    }

    .p-multiselect.p-multiselect-chip .p-multiselect-token {
        padding: 0.25rem 0.75rem;
        margin-right: 0.5rem;
        background: #dee2e6;
        color: #212529;
        border-radius: 16px;
    }

    .p-multiselect.p-multiselect-chip .p-multiselect-token .p-multiselect-token-icon {
        margin-left: 0.5rem;
    }

    .p-multiselect .p-multiselect-trigger {
        background: transparent;
        color: #cf0000;
        width: 2.357rem;
        border-top-right-radius: 4px;
        border-bottom-right-radius: 4px;
    }

    .p-multiselect.p-invalid.p-component {
        border-color: #dc3545;
    }

    .p-inputwrapper-filled.p-multiselect.p-multiselect-chip .p-multiselect-label {
        padding: 0.25rem 0.75rem;
    }

    .p-multiselect-panel {
        background: #ffffff;
        color: #212529;
        border: 1px solid rgba(0, 0, 0, 0.15);
        border-radius: 4px;
        box-shadow: none;
    }

    .p-multiselect-panel .p-multiselect-header {
        padding: 0.75rem 1.5rem;
        border-bottom: 1px solid #dee2e6;
        color: #212529;
        background: #efefef;
        margin: 0;
        border-top-right-radius: 4px;
        border-top-left-radius: 4px;
    }

    .p-multiselect-panel .p-multiselect-header .p-multiselect-filter-container .p-inputtext {
        padding-right: 1.75rem;
    }

    .p-multiselect-panel .p-multiselect-header .p-multiselect-filter-container .p-multiselect-filter-icon {
        right: 0.75rem;
        color: #495057;
    }

    .p-multiselect-panel .p-multiselect-header .p-checkbox {
        margin-right: 0.5rem;
    }

    .p-multiselect-panel .p-multiselect-header .p-multiselect-close {
        margin-left: 0.5rem;
        width: 2rem;
        height: 2rem;
        color: #6c757d;
        border: 0 none;
        background: transparent;
        border-radius: 50%;
        transition: box-shadow 0.15s;
    }

    .p-multiselect-panel .p-multiselect-header .p-multiselect-close:enabled:hover {
        color: #495057;
        border-color: transparent;
        background: transparent;
    }

    .p-multiselect-panel .p-multiselect-header .p-multiselect-close:focus-visible {
        outline: 0 none;
        outline-offset: 0;
        box-shadow: 0 0 0 0.2rem rgba(38, 143, 255, 0.5);
    }

    .p-multiselect-panel .p-multiselect-items {
        padding: 0.5rem 0;
    }

    .p-multiselect-panel .p-multiselect-items .p-multiselect-item {
        margin: 0;
        padding: 0.5rem 1.5rem;
        border: 0 none;
        color: #212529;
        background: transparent;
        transition: box-shadow 0.15s;
        border-radius: 0;
    }

    .p-multiselect-panel .p-multiselect-items .p-multiselect-item:first-child {
        margin-top: 0;
    }

    .p-multiselect-panel .p-multiselect-items .p-multiselect-item:last-child {
        margin-bottom: 0;
    }

    .p-multiselect-panel .p-multiselect-items .p-multiselect-item.p-highlight {
        color: #ffffff;
        background: #cf0000;
    }

    .p-multiselect-panel .p-multiselect-items .p-multiselect-item.p-highlight.p-focus {
        background: #cf0000;
    }

    .p-multiselect-panel .p-multiselect-items .p-multiselect-item:not(.p-highlight):not(.p-disabled).p-focus {
        color: #212529;
        background: #e9ecef;
    }

    .p-multiselect-panel .p-multiselect-items .p-multiselect-item .p-checkbox {
        margin-right: 0.5rem;
    }

    .p-multiselect-panel .p-multiselect-items .p-multiselect-item-group {
        margin: 0;
        padding: 0.75rem 1rem;
        color: #212529;
        background: #ffffff;
        font-weight: 600;
    }

    .p-multiselect-panel .p-multiselect-items .p-multiselect-empty-message {
        padding: 0.5rem 1.5rem;
        color: #212529;
        background: transparent;
    }

    .p-password.p-invalid.p-component>.p-inputtext {
        border-color: #dc3545;
    }

    .p-password-panel {
        padding: 1.25rem;
        background: #ffffff;
        color: #212529;
        border: 1px solid rgba(0, 0, 0, 0.2);
        box-shadow: none;
        border-radius: 4px;
    }

    .p-password-panel .p-password-meter {
        margin-bottom: 0.5rem;
        background: #e9ecef;
    }

    .p-password-panel .p-password-meter .p-password-strength.weak {
        background: #dc3545;
    }

    .p-password-panel .p-password-meter .p-password-strength.medium {
        background: #ffc107;
    }

    .p-password-panel .p-password-meter .p-password-strength.strong {
        background: #28a745;
    }

    .p-radiobutton {
        width: 20px;
        height: 20px;
    }

    .p-radiobutton .p-radiobutton-box {
        border: 2px solid #ced4da;
        background: #ffffff;
        width: 20px;
        height: 20px;
        color: #212529;
        border-radius: 50%;
        transition: background-color 0.15s, border-color 0.15s, box-shadow 0.15s;
    }

    .p-radiobutton .p-radiobutton-box:not(.p-disabled):not(.p-highlight):hover {
        border-color: #ced4da;
    }

    .p-radiobutton .p-radiobutton-box:not(.p-disabled).p-focus {
        outline: 0 none;
        outline-offset: 0;
        box-shadow: 0 0 0 0.2rem rgba(228, 113, 124, 0.5);
        border-color: #e4717c;
    }

    .p-radiobutton .p-radiobutton-box .p-radiobutton-icon {
        width: 12px;
        height: 12px;
        transition-duration: 0.15s;
        background-color: #e83636;
    }

    .p-radiobutton .p-radiobutton-box.p-highlight {
        border-color: #e4717c;
        background: #a60622;
    }

    .p-radiobutton .p-radiobutton-box.p-highlight:not(.p-disabled):hover {
        border-color: #a60622;
        background: #a60622;
        /* border-color: #0062cc;
        background: #0062cc; */
        color: #ffffff;
    }

    .p-radiobutton.p-invalid>.p-radiobutton-box {
        border-color: #dc3545;
    }

    .p-radiobutton:focus {
        outline: 0 none;
    }

    .p-input-filled .p-radiobutton .p-radiobutton-box {
        background-color: #efefef;
    }

    .p-input-filled .p-radiobutton .p-radiobutton-box:not(.p-disabled):hover {
        background-color: #efefef;
    }

    .p-input-filled .p-radiobutton .p-radiobutton-box.p-highlight {
        background: #007bff;
    }

    .p-input-filled .p-radiobutton .p-radiobutton-box.p-highlight:not(.p-disabled):hover {
        background: #0062cc;
    }

    .p-highlight .p-radiobutton .p-radiobutton-box {
        border-color: #ffffff;
    }

    .p-rating {
        gap: 0.5rem;
    }

    .p-rating .p-rating-item .p-rating-icon {
        color: #495057;
        transition: background-color 0.15s, border-color 0.15s, box-shadow 0.15s;
        font-size: 1.143rem;
    }

    .p-rating .p-rating-item .p-rating-icon.p-icon {
        width: 1.143rem;
        height: 1.143rem;
    }

    .p-rating .p-rating-item .p-rating-icon.p-rating-cancel {
        color: #dc3545;
    }

    .p-rating .p-rating-item:focus {
        outline: 0 none;
        outline-offset: 0;
        box-shadow: 0 0 0 0.2rem rgba(38, 143, 255, 0.5);
    }

    .p-rating .p-rating-item.p-rating-item-active .p-rating-icon {
        color: #007bff;
    }

    .p-rating:not(.p-disabled):not(.p-readonly) .p-rating-item:hover .p-rating-icon {
        color: #007bff;
    }

    .p-rating:not(.p-disabled):not(.p-readonly) .p-rating-item:hover .p-rating-icon.p-rating-cancel {
        color: #dc3545;
    }

    .p-highlight .p-rating .p-rating-item.p-rating-item-active .p-rating-icon {
        color: #ffffff;
    }

    .p-selectbutton .p-button {
        background: #ffffff;
        border: 1px solid #cf0000;
        color: #cf0000;
        transition: background-color 0.15s, border-color 0.15s, box-shadow 0.15s;
    }

    .p-selectbutton .p-button .p-button-icon-left,
    .p-selectbutton .p-button .p-button-icon-right {
        color: #ffffff;
    }

    .p-selectbutton .p-button:not(.p-disabled):not(.p-highlight):hover {
        background: #e4717c;
        border-color: #e4717c;
        color: #ffffff;
    }

    .p-selectbutton .p-button:not(.p-disabled):not(.p-highlight):hover .p-button-icon-left,
    .p-selectbutton .p-button:not(.p-disabled):not(.p-highlight):hover .p-button-icon-right {
        color: #ffffff;
    }

    .p-selectbutton .p-button.p-highlight {
        background: #cf0000;
        border-color: #cf0000;
        color: #ffffff;
    }

    .p-selectbutton .p-button.p-highlight .p-button-icon-left,
    .p-selectbutton .p-button.p-highlight .p-button-icon-right {
        color: #ffffff;
    }

    .p-selectbutton .p-button.p-highlight:hover {
        background: #a60622;
        border-color: #a60622;
        color: #ffffff;
    }

    .p-selectbutton .p-button.p-highlight:hover .p-button-icon-left,
    .p-selectbutton .p-button.p-highlight:hover .p-button-icon-right {
        color: #ffffff;
    }

    .p-selectbutton.p-invalid>.p-button {
        border-color: #dc3545;
    }

    .p-slider {
        background: #e9ecef;
        border: 0 none;
        border-radius: 4px;
    }

    .p-slider.p-slider-horizontal {
        height: 0.286rem;
    }

    .p-slider.p-slider-horizontal .p-slider-handle {
        margin-top: -0.5715rem;
        margin-left: -0.5715rem;
    }

    .p-slider.p-slider-vertical {
        width: 0.286rem;
    }

    .p-slider.p-slider-vertical .p-slider-handle {
        margin-left: -0.5715rem;
        margin-bottom: -0.5715rem;
    }

    .p-slider .p-slider-handle {
        height: 1.143rem;
        width: 1.143rem;
        background: #007bff;
        border: 2px solid #007bff;
        border-radius: 4px;
        transition: background-color 0.15s, border-color 0.15s, box-shadow 0.15s;
    }

    .p-slider .p-slider-handle:focus {
        outline: 0 none;
        outline-offset: 0;
        box-shadow: 0 0 0 0.2rem rgba(38, 143, 255, 0.5);
    }

    .p-slider .p-slider-range {
        background: #007bff;
    }

    .p-slider:not(.p-disabled) .p-slider-handle:hover {
        background: #0069d9;
        border-color: #0069d9;
    }

    .p-treeselect {
        background: #ffffff;
        border: 1px solid #ced4da;
        transition: background-color 0.15s, border-color 0.15s, box-shadow 0.15s;
        border-radius: 4px;
    }

    .p-treeselect:not(.p-disabled):hover {
        border-color: #ced4da;
    }

    .p-treeselect:not(.p-disabled).p-focus {
        outline: 0 none;
        outline-offset: 0;
        box-shadow: 0 0 0 0.2rem rgba(38, 143, 255, 0.5);
        border-color: #007bff;
    }

    .p-treeselect.p-treeselect-clearable .p-treeselect-label {
        padding-right: 1.75rem;
    }

    .p-treeselect .p-treeselect-label {
        padding: 0.5rem 0.75rem;
        transition: background-color 0.15s, border-color 0.15s, box-shadow 0.15s;
    }

    .p-treeselect .p-treeselect-label.p-placeholder {
        color: #6c757d;
    }

    .p-treeselect.p-treeselect-chip .p-treeselect-token {
        padding: 0.25rem 0.75rem;
        margin-right: 0.5rem;
        background: #dee2e6;
        color: #212529;
        border-radius: 16px;
    }

    .p-treeselect .p-treeselect-trigger {
        background: transparent;
        color: #495057;
        width: 2.357rem;
        border-top-right-radius: 4px;
        border-bottom-right-radius: 4px;
    }

    .p-treeselect .p-treeselect-clear-icon {
        color: #495057;
        right: 2.357rem;
    }

    .p-treeselect.p-invalid.p-component {
        border-color: #dc3545;
    }

    .p-inputwrapper-filled.p-treeselect.p-treeselect-chip .p-treeselect-label {
        padding: 0.25rem 0.75rem;
    }

    .p-treeselect-panel {
        background: #ffffff;
        color: #212529;
        border: 1px solid rgba(0, 0, 0, 0.15);
        border-radius: 4px;
        box-shadow: none;
    }

    .p-treeselect-panel .p-treeselect-header {
        padding: 0.75rem 1.5rem;
        border-bottom: 1px solid #dee2e6;
        color: #212529;
        background: #efefef;
        margin: 0;
        border-top-right-radius: 4px;
        border-top-left-radius: 4px;
    }

    .p-treeselect-panel .p-treeselect-header .p-treeselect-filter-container {
        margin-right: 0.5rem;
    }

    .p-treeselect-panel .p-treeselect-header .p-treeselect-filter-container .p-treeselect-filter {
        padding-right: 1.75rem;
    }

    .p-treeselect-panel .p-treeselect-header .p-treeselect-filter-container .p-treeselect-filter-icon {
        right: 0.75rem;
        color: #495057;
    }

    .p-treeselect-panel .p-treeselect-header .p-treeselect-filter-container.p-treeselect-clearable-filter .p-treeselect-filter {
        padding-right: 3.5rem;
    }

    .p-treeselect-panel .p-treeselect-header .p-treeselect-filter-container.p-treeselect-clearable-filter .p-treeselect-filter-clear-icon {
        right: 2.5rem;
    }

    .p-treeselect-panel .p-treeselect-header .p-treeselect-close {
        width: 2rem;
        height: 2rem;
        color: #6c757d;
        border: 0 none;
        background: transparent;
        border-radius: 50%;
        transition: box-shadow 0.15s;
    }

    .p-treeselect-panel .p-treeselect-header .p-treeselect-close:enabled:hover {
        color: #495057;
        border-color: transparent;
        background: transparent;
    }

    .p-treeselect-panel .p-treeselect-header .p-treeselect-close:focus-visible {
        outline: 0 none;
        outline-offset: 0;
        box-shadow: 0 0 0 0.2rem rgba(38, 143, 255, 0.5);
    }

    .p-treeselect-panel .p-treeselect-items-wrapper .p-tree {
        border: 0 none;
    }

    .p-treeselect-panel .p-treeselect-items-wrapper .p-treeselect-empty-message {
        padding: 0.5rem 1.5rem;
        color: #212529;
        background: transparent;
    }

    .p-input-filled .p-treeselect {
        background: #efefef;
    }

    .p-input-filled .p-treeselect:not(.p-disabled):hover {
        background-color: #efefef;
    }

    .p-input-filled .p-treeselect:not(.p-disabled).p-focus {
        background-color: #efefef;
    }

    .p-togglebutton.p-button {
        background: #6c757d;
        border: 1px solid #6c757d;
        color: #ffffff;
        transition: background-color 0.15s, border-color 0.15s, box-shadow 0.15s;
    }

    .p-togglebutton.p-button .p-button-icon-left,
    .p-togglebutton.p-button .p-button-icon-right {
        color: #ffffff;
    }

    .p-togglebutton.p-button:not(.p-disabled):not(.p-highlight):hover {
        background: #5a6268;
        border-color: #545b62;
        color: #ffffff;
    }

    .p-togglebutton.p-button:not(.p-disabled):not(.p-highlight):hover .p-button-icon-left,
    .p-togglebutton.p-button:not(.p-disabled):not(.p-highlight):hover .p-button-icon-right {
        color: #ffffff;
    }

    .p-togglebutton.p-button.p-highlight {
        background: #545b62;
        border-color: #4e555b;
        color: #ffffff;
    }

    .p-togglebutton.p-button.p-highlight .p-button-icon-left,
    .p-togglebutton.p-button.p-highlight .p-button-icon-right {
        color: #ffffff;
    }

    .p-togglebutton.p-button.p-highlight:hover {
        background: #545b62;
        border-color: #4e555b;
        color: #ffffff;
    }

    .p-togglebutton.p-button.p-highlight:hover .p-button-icon-left,
    .p-togglebutton.p-button.p-highlight:hover .p-button-icon-right {
        color: #ffffff;
    }

    .p-togglebutton.p-button.p-invalid>.p-button {
        border-color: #dc3545;
    }

    .p-button {
        color: #ffffff;
        background: #cf0000;
        border: 1px solid #cf0000;
        padding: 0.5rem 0.75rem;
        font-size: 12px;
        transition: background-color 0.15s, border-color 0.15s, box-shadow 0.15s;
        border-radius: 4px;
        box-shadow: 0px 1px 8px -1px #dc3545;
    }

    .p-button:not(:disabled):hover {
        background: #a60622;
        color: #ffffff;
        border-color: #959aa0;
    }

    .p-button:not(:disabled):active {
        background: #a60622;
        color: #ffffff;
        border-color: #959aa0;
    }

    .p-button.p-button-outlined {
        background-color: transparent;
        color: #cf0000;
        border: 1px solid;
    }

    .p-button.p-button-outlined:not(:disabled):hover {
        background: rgba(0, 123, 255, 0.04);
        color: #a60622;
        ;
        border: 1px solid;
    }

    .p-button.p-button-outlined:not(:disabled):active {
        background: rgba(0, 123, 255, 0.16);
        color: #a60622;
        border: 1px solid;
    }

    .p-button.p-button-outlined.p-button-plain {
        color: #6c757d;
        border-color: #6c757d;
    }

    .p-button.p-button-outlined.p-button-plain:not(:disabled):hover {
        background: #e9ecef;
        color: #6c757d;
    }

    .p-button.p-button-outlined.p-button-plain:not(:disabled):active {
        background: #dee2e6;
        color: #6c757d;
    }

    .p-button.p-button-text {
        background-color: transparent;
        color: #007bff;
        border-color: transparent;
    }

    .p-button.p-button-text:not(:disabled):hover {
        background: rgba(0, 123, 255, 0.04);
        color: #007bff;
        border-color: transparent;
    }

    .p-button.p-button-text:not(:disabled):active {
        background: rgba(0, 123, 255, 0.16);
        color: #007bff;
        border-color: transparent;
    }

    .p-button.p-button-text.p-button-plain {
        color: #6c757d;
    }

    .p-button.p-button-text.p-button-plain:not(:disabled):hover {
        background: #e9ecef;
        color: #6c757d;
    }

    .p-button.p-button-text.p-button-plain:not(:disabled):active {
        background: #dee2e6;
        color: #6c757d;
    }

    .p-button:focus {
        outline: 0 none;
        outline-offset: 0;
        box-shadow: 0 0 0 0.2rem #e4717c;
    }

    .p-button .p-button-label {
        transition-duration: 0.15s;
    }

    .p-button .p-button-icon-left {
        margin-right: 0.5rem;
    }

    .p-button .p-button-icon-right {
        margin-left: 0.5rem;
    }

    .p-button .p-button-icon-bottom {
        margin-top: 0.5rem;
    }

    .p-button .p-button-icon-top {
        margin-bottom: 0.5rem;
    }

    .p-button .p-badge {
        margin-left: 0.5rem;
        min-width: 1rem;
        height: 1rem;
        line-height: 1rem;
        color: #007bff;
        background-color: #ffffff;
    }

    .p-button.p-button-raised {
        box-shadow: 0 3px 1px -2px rgba(0, 0, 0, 0.2), 0 2px 2px 0 rgba(0, 0, 0, 0.14), 0 1px 5px 0 rgba(0, 0, 0, 0.12);
    }

    .p-button.p-button-rounded {
        border-radius: 2rem;
    }

    .p-button.p-button-icon-only {
        width: 2.357rem;
        padding: 0.5rem 0;
    }

    .p-button.p-button-icon-only .p-button-icon-left,
    .p-button.p-button-icon-only .p-button-icon-right {
        margin: 0;
    }

    .p-button.p-button-icon-only.p-button-rounded {
        border-radius: 50%;
        height: 2.357rem;
    }

    .p-button.p-button-sm {
        font-size: 12px;
        padding: 0.4375rem 0.65625rem;
    }

    .p-button.p-button-sm .p-button-icon {
        font-size: 0.875rem;
    }

    .p-button.p-button-lg {
        font-size: 12px;
        padding: 0.625rem 0.9375rem;
    }

    .p-button.p-button-lg .p-button-icon {
        font-size: 1.25rem;
    }

    .p-button.p-button-loading-label-only.p-button-loading-left .p-button-label {
        margin-left: 0.5rem;
    }

    .p-button.p-button-loading-label-only.p-button-loading-right .p-button-label {
        margin-right: 0.5rem;
    }

    .p-button.p-button-loading-label-only.p-button-loading-top .p-button-label {
        margin-top: 0.5rem;
    }

    .p-button.p-button-loading-label-only.p-button-loading-bottom .p-button-label {
        margin-bottom: 0.5rem;
    }

    .p-button.p-button-loading-label-only .p-button-loading-icon {
        margin: 0;
    }

    .p-fluid .p-button {
        width: 100%;
    }

    .p-fluid .p-button-icon-only {
        width: 2.357rem;
    }

    .p-fluid .p-buttonset {
        display: flex;
    }

    .p-fluid .p-buttonset .p-button {
        flex: 1 1;
    }

    .p-button.p-button-secondary,
    .p-buttonset.p-button-secondary>.p-button,
    .p-splitbutton.p-button-secondary>.p-button,
    .p-fileupload-choose.p-button-secondary {
        color: #000000;
        background: #bcbcbc;
        border: 1px solid #bcbcbc;
    }

    .p-button.p-button-secondary:not(:disabled):hover,
    .p-buttonset.p-button-secondary>.p-button:not(:disabled):hover,
    .p-splitbutton.p-button-secondary>.p-button:not(:disabled):hover,
    .p-fileupload-choose.p-button-secondary:not(:disabled):hover {
        background: #5a6268;
        color: #ffffff;
        border-color: #5a6268;
    }

    .p-button.p-button-secondary:not(:disabled):focus,
    .p-buttonset.p-button-secondary>.p-button:not(:disabled):focus,
    .p-splitbutton.p-button-secondary>.p-button:not(:disabled):focus,
    .p-fileupload-choose.p-button-secondary:not(:disabled):focus {
        box-shadow: 0 0 0 0.2rem rgba(130, 138, 145, 0.5);
    }

    .p-button.p-button-secondary:not(:disabled):active,
    .p-buttonset.p-button-secondary>.p-button:not(:disabled):active,
    .p-splitbutton.p-button-secondary>.p-button:not(:disabled):active,
    .p-fileupload-choose.p-button-secondary:not(:disabled):active {
        background: #545b62;
        color: #ffffff;
        border-color: #4e555b;
    }

    .p-button.p-button-secondary.p-button-outlined,
    .p-buttonset.p-button-secondary>.p-button.p-button-outlined,
    .p-splitbutton.p-button-secondary>.p-button.p-button-outlined,
    .p-fileupload-choose.p-button-secondary.p-button-outlined {
        background-color: transparent;
        color: #6c757d;
        border: 1px solid;
    }

    .p-button.p-button-secondary.p-button-outlined:not(:disabled):hover,
    .p-buttonset.p-button-secondary>.p-button.p-button-outlined:not(:disabled):hover,
    .p-splitbutton.p-button-secondary>.p-button.p-button-outlined:not(:disabled):hover,
    .p-fileupload-choose.p-button-secondary.p-button-outlined:not(:disabled):hover {
        background: rgba(108, 117, 125, 0.04);
        color: #6c757d;
        border: 1px solid;
    }

    .p-button.p-button-secondary.p-button-outlined:not(:disabled):active,
    .p-buttonset.p-button-secondary>.p-button.p-button-outlined:not(:disabled):active,
    .p-splitbutton.p-button-secondary>.p-button.p-button-outlined:not(:disabled):active,
    .p-fileupload-choose.p-button-secondary.p-button-outlined:not(:disabled):active {
        background: rgba(108, 117, 125, 0.16);
        color: #6c757d;
        border: 1px solid;
    }

    .p-button.p-button-secondary.p-button-text,
    .p-buttonset.p-button-secondary>.p-button.p-button-text,
    .p-splitbutton.p-button-secondary>.p-button.p-button-text,
    .p-fileupload-choose.p-button-secondary.p-button-text {
        background-color: transparent;
        color: #6c757d;
        border-color: transparent;
    }

    .p-button.p-button-secondary.p-button-text:not(:disabled):hover,
    .p-buttonset.p-button-secondary>.p-button.p-button-text:not(:disabled):hover,
    .p-splitbutton.p-button-secondary>.p-button.p-button-text:not(:disabled):hover,
    .p-fileupload-choose.p-button-secondary.p-button-text:not(:disabled):hover {
        background: rgba(108, 117, 125, 0.04);
        border-color: transparent;
        color: #6c757d;
    }

    .p-button.p-button-secondary.p-button-text:not(:disabled):active,
    .p-buttonset.p-button-secondary>.p-button.p-button-text:not(:disabled):active,
    .p-splitbutton.p-button-secondary>.p-button.p-button-text:not(:disabled):active,
    .p-fileupload-choose.p-button-secondary.p-button-text:not(:disabled):active {
        background: rgba(108, 117, 125, 0.16);
        border-color: transparent;
        color: #6c757d;
    }

    .p-button.p-button-info,
    .p-buttonset.p-button-info>.p-button,
    .p-splitbutton.p-button-info>.p-button,
    .p-fileupload-choose.p-button-info {
        color: #ffffff;
        background: #17a2b8;
        border: 1px solid #17a2b8;
    }

    .p-button.p-button-info:not(:disabled):hover,
    .p-buttonset.p-button-info>.p-button:not(:disabled):hover,
    .p-splitbutton.p-button-info>.p-button:not(:disabled):hover,
    .p-fileupload-choose.p-button-info:not(:disabled):hover {
        background: #138496;
        color: #ffffff;
        border-color: #117a8b;
    }

    .p-button.p-button-info:not(:disabled):focus,
    .p-buttonset.p-button-info>.p-button:not(:disabled):focus,
    .p-splitbutton.p-button-info>.p-button:not(:disabled):focus,
    .p-fileupload-choose.p-button-info:not(:disabled):focus {
        box-shadow: 0 0 0 0.2rem rgba(58, 176, 195, 0.5);
    }

    .p-button.p-button-info:not(:disabled):active,
    .p-buttonset.p-button-info>.p-button:not(:disabled):active,
    .p-splitbutton.p-button-info>.p-button:not(:disabled):active,
    .p-fileupload-choose.p-button-info:not(:disabled):active {
        background: #138496;
        color: #ffffff;
        border-color: #117a8b;
    }

    .p-button.p-button-info.p-button-outlined,
    .p-buttonset.p-button-info>.p-button.p-button-outlined,
    .p-splitbutton.p-button-info>.p-button.p-button-outlined,
    .p-fileupload-choose.p-button-info.p-button-outlined {
        background-color: transparent;
        color: #17a2b8;
        border: 1px solid;
    }

    .p-button.p-button-info.p-button-outlined:not(:disabled):hover,
    .p-buttonset.p-button-info>.p-button.p-button-outlined:not(:disabled):hover,
    .p-splitbutton.p-button-info>.p-button.p-button-outlined:not(:disabled):hover,
    .p-fileupload-choose.p-button-info.p-button-outlined:not(:disabled):hover {
        background: rgba(23, 162, 184, 0.04);
        color: #17a2b8;
        border: 1px solid;
    }

    .p-button.p-button-info.p-button-outlined:not(:disabled):active,
    .p-buttonset.p-button-info>.p-button.p-button-outlined:not(:disabled):active,
    .p-splitbutton.p-button-info>.p-button.p-button-outlined:not(:disabled):active,
    .p-fileupload-choose.p-button-info.p-button-outlined:not(:disabled):active {
        background: rgba(23, 162, 184, 0.16);
        color: #17a2b8;
        border: 1px solid;
    }

    .p-button.p-button-info.p-button-text,
    .p-buttonset.p-button-info>.p-button.p-button-text,
    .p-splitbutton.p-button-info>.p-button.p-button-text,
    .p-fileupload-choose.p-button-info.p-button-text {
        background-color: transparent;
        color: #17a2b8;
        border-color: transparent;
    }

    .p-button.p-button-info.p-button-text:not(:disabled):hover,
    .p-buttonset.p-button-info>.p-button.p-button-text:not(:disabled):hover,
    .p-splitbutton.p-button-info>.p-button.p-button-text:not(:disabled):hover,
    .p-fileupload-choose.p-button-info.p-button-text:not(:disabled):hover {
        background: rgba(23, 162, 184, 0.04);
        border-color: transparent;
        color: #17a2b8;
    }

    .p-button.p-button-info.p-button-text:not(:disabled):active,
    .p-buttonset.p-button-info>.p-button.p-button-text:not(:disabled):active,
    .p-splitbutton.p-button-info>.p-button.p-button-text:not(:disabled):active,
    .p-fileupload-choose.p-button-info.p-button-text:not(:disabled):active {
        background: rgba(23, 162, 184, 0.16);
        border-color: transparent;
        color: #17a2b8;
    }

    .p-button.p-button-success,
    .p-buttonset.p-button-success>.p-button,
    .p-splitbutton.p-button-success>.p-button,
    .p-fileupload-choose.p-button-success {
        color: #ffffff;
        background: #28a745;
        border: 1px solid #28a745;
    }

    .p-button.p-button-success:not(:disabled):hover,
    .p-buttonset.p-button-success>.p-button:not(:disabled):hover,
    .p-splitbutton.p-button-success>.p-button:not(:disabled):hover,
    .p-fileupload-choose.p-button-success:not(:disabled):hover {
        background: #218838;
        color: #ffffff;
        border-color: #1e7e34;
    }

    .p-button.p-button-success:not(:disabled):focus,
    .p-buttonset.p-button-success>.p-button:not(:disabled):focus,
    .p-splitbutton.p-button-success>.p-button:not(:disabled):focus,
    .p-fileupload-choose.p-button-success:not(:disabled):focus {
        box-shadow: 0 0 0 0.2rem rgba(72, 180, 97, 0.5);
    }

    .p-button.p-button-success:not(:disabled):active,
    .p-buttonset.p-button-success>.p-button:not(:disabled):active,
    .p-splitbutton.p-button-success>.p-button:not(:disabled):active,
    .p-fileupload-choose.p-button-success:not(:disabled):active {
        background: #1e7e34;
        color: #ffffff;
        border-color: #1c7430;
    }

    .p-button.p-button-success.p-button-outlined,
    .p-buttonset.p-button-success>.p-button.p-button-outlined,
    .p-splitbutton.p-button-success>.p-button.p-button-outlined,
    .p-fileupload-choose.p-button-success.p-button-outlined {
        background-color: transparent;
        color: #28a745;
        border: 1px solid;
    }

    .p-button.p-button-success.p-button-outlined:not(:disabled):hover,
    .p-buttonset.p-button-success>.p-button.p-button-outlined:not(:disabled):hover,
    .p-splitbutton.p-button-success>.p-button.p-button-outlined:not(:disabled):hover,
    .p-fileupload-choose.p-button-success.p-button-outlined:not(:disabled):hover {
        background: rgba(40, 167, 69, 0.04);
        color: #28a745;
        border: 1px solid;
    }

    .p-button.p-button-success.p-button-outlined:not(:disabled):active,
    .p-buttonset.p-button-success>.p-button.p-button-outlined:not(:disabled):active,
    .p-splitbutton.p-button-success>.p-button.p-button-outlined:not(:disabled):active,
    .p-fileupload-choose.p-button-success.p-button-outlined:not(:disabled):active {
        background: rgba(40, 167, 69, 0.16);
        color: #28a745;
        border: 1px solid;
    }

    .p-button.p-button-success.p-button-text,
    .p-buttonset.p-button-success>.p-button.p-button-text,
    .p-splitbutton.p-button-success>.p-button.p-button-text,
    .p-fileupload-choose.p-button-success.p-button-text {
        background-color: transparent;
        color: #28a745;
        border-color: transparent;
    }

    .p-button.p-button-success.p-button-text:not(:disabled):hover,
    .p-buttonset.p-button-success>.p-button.p-button-text:not(:disabled):hover,
    .p-splitbutton.p-button-success>.p-button.p-button-text:not(:disabled):hover,
    .p-fileupload-choose.p-button-success.p-button-text:not(:disabled):hover {
        background: rgba(40, 167, 69, 0.04);
        border-color: transparent;
        color: #28a745;
    }

    .p-button.p-button-success.p-button-text:not(:disabled):active,
    .p-buttonset.p-button-success>.p-button.p-button-text:not(:disabled):active,
    .p-splitbutton.p-button-success>.p-button.p-button-text:not(:disabled):active,
    .p-fileupload-choose.p-button-success.p-button-text:not(:disabled):active {
        background: rgba(40, 167, 69, 0.16);
        border-color: transparent;
        color: #28a745;
    }

    .p-button.p-button-warning,
    .p-buttonset.p-button-warning>.p-button,
    .p-splitbutton.p-button-warning>.p-button,
    .p-fileupload-choose.p-button-warning {
        color: #212529;
        background: #ffc107;
        border: 1px solid #ffc107;
    }

    .p-button.p-button-warning:not(:disabled):hover,
    .p-buttonset.p-button-warning>.p-button:not(:disabled):hover,
    .p-splitbutton.p-button-warning>.p-button:not(:disabled):hover,
    .p-fileupload-choose.p-button-warning:not(:disabled):hover {
        background: #e0a800;
        color: #212529;
        border-color: #d39e00;
    }

    .p-button.p-button-warning:not(:disabled):focus,
    .p-buttonset.p-button-warning>.p-button:not(:disabled):focus,
    .p-splitbutton.p-button-warning>.p-button:not(:disabled):focus,
    .p-fileupload-choose.p-button-warning:not(:disabled):focus {
        box-shadow: 0 0 0 0.2rem rgba(222, 170, 12, 0.5);
    }

    .p-button.p-button-warning:not(:disabled):active,
    .p-buttonset.p-button-warning>.p-button:not(:disabled):active,
    .p-splitbutton.p-button-warning>.p-button:not(:disabled):active,
    .p-fileupload-choose.p-button-warning:not(:disabled):active {
        background: #d39e00;
        color: #212529;
        border-color: #c69500;
    }

    .p-button.p-button-warning.p-button-outlined,
    .p-buttonset.p-button-warning>.p-button.p-button-outlined,
    .p-splitbutton.p-button-warning>.p-button.p-button-outlined,
    .p-fileupload-choose.p-button-warning.p-button-outlined {
        background-color: transparent;
        color: #ffc107;
        border: 1px solid;
    }

    .p-button.p-button-warning.p-button-outlined:not(:disabled):hover,
    .p-buttonset.p-button-warning>.p-button.p-button-outlined:not(:disabled):hover,
    .p-splitbutton.p-button-warning>.p-button.p-button-outlined:not(:disabled):hover,
    .p-fileupload-choose.p-button-warning.p-button-outlined:not(:disabled):hover {
        background: rgba(255, 193, 7, 0.04);
        color: #ffc107;
        border: 1px solid;
    }

    .p-button.p-button-warning.p-button-outlined:not(:disabled):active,
    .p-buttonset.p-button-warning>.p-button.p-button-outlined:not(:disabled):active,
    .p-splitbutton.p-button-warning>.p-button.p-button-outlined:not(:disabled):active,
    .p-fileupload-choose.p-button-warning.p-button-outlined:not(:disabled):active {
        background: rgba(255, 193, 7, 0.16);
        color: #ffc107;
        border: 1px solid;
    }

    .p-button.p-button-warning.p-button-text,
    .p-buttonset.p-button-warning>.p-button.p-button-text,
    .p-splitbutton.p-button-warning>.p-button.p-button-text,
    .p-fileupload-choose.p-button-warning.p-button-text {
        background-color: transparent;
        color: #ffc107;
        border-color: transparent;
    }

    .p-button.p-button-warning.p-button-text:not(:disabled):hover,
    .p-buttonset.p-button-warning>.p-button.p-button-text:not(:disabled):hover,
    .p-splitbutton.p-button-warning>.p-button.p-button-text:not(:disabled):hover,
    .p-fileupload-choose.p-button-warning.p-button-text:not(:disabled):hover {
        background: rgba(255, 193, 7, 0.04);
        border-color: transparent;
        color: #ffc107;
    }

    .p-button.p-button-warning.p-button-text:not(:disabled):active,
    .p-buttonset.p-button-warning>.p-button.p-button-text:not(:disabled):active,
    .p-splitbutton.p-button-warning>.p-button.p-button-text:not(:disabled):active,
    .p-fileupload-choose.p-button-warning.p-button-text:not(:disabled):active {
        background: rgba(255, 193, 7, 0.16);
        border-color: transparent;
        color: #ffc107;
    }

    .p-button.p-button-help,
    .p-buttonset.p-button-help>.p-button,
    .p-splitbutton.p-button-help>.p-button,
    .p-fileupload-choose.p-button-help {
        color: #ffffff;
        background: #6f42c1;
        border: 1px solid #6f42c1;
    }

    .p-button.p-button-help:not(:disabled):hover,
    .p-buttonset.p-button-help>.p-button:not(:disabled):hover,
    .p-splitbutton.p-button-help>.p-button:not(:disabled):hover,
    .p-fileupload-choose.p-button-help:not(:disabled):hover {
        background: #633bad;
        color: #ffffff;
        border-color: #58349a;
    }

    .p-button.p-button-help:not(:disabled):focus,
    .p-buttonset.p-button-help>.p-button:not(:disabled):focus,
    .p-splitbutton.p-button-help>.p-button:not(:disabled):focus,
    .p-fileupload-choose.p-button-help:not(:disabled):focus {
        box-shadow: 0 0 0 0.2rem #d3c6ec;
    }

    .p-button.p-button-help:not(:disabled):active,
    .p-buttonset.p-button-help>.p-button:not(:disabled):active,
    .p-splitbutton.p-button-help>.p-button:not(:disabled):active,
    .p-fileupload-choose.p-button-help:not(:disabled):active {
        background: #58349a;
        color: #ffffff;
        border-color: #4d2e87;
    }

    .p-button.p-button-help.p-button-outlined,
    .p-buttonset.p-button-help>.p-button.p-button-outlined,
    .p-splitbutton.p-button-help>.p-button.p-button-outlined,
    .p-fileupload-choose.p-button-help.p-button-outlined {
        background-color: transparent;
        color: #6f42c1;
        border: 1px solid;
    }

    .p-button.p-button-help.p-button-outlined:not(:disabled):hover,
    .p-buttonset.p-button-help>.p-button.p-button-outlined:not(:disabled):hover,
    .p-splitbutton.p-button-help>.p-button.p-button-outlined:not(:disabled):hover,
    .p-fileupload-choose.p-button-help.p-button-outlined:not(:disabled):hover {
        background: rgba(111, 66, 193, 0.04);
        color: #6f42c1;
        border: 1px solid;
    }

    .p-button.p-button-help.p-button-outlined:not(:disabled):active,
    .p-buttonset.p-button-help>.p-button.p-button-outlined:not(:disabled):active,
    .p-splitbutton.p-button-help>.p-button.p-button-outlined:not(:disabled):active,
    .p-fileupload-choose.p-button-help.p-button-outlined:not(:disabled):active {
        background: rgba(111, 66, 193, 0.16);
        color: #6f42c1;
        border: 1px solid;
    }

    .p-button.p-button-help.p-button-text,
    .p-buttonset.p-button-help>.p-button.p-button-text,
    .p-splitbutton.p-button-help>.p-button.p-button-text,
    .p-fileupload-choose.p-button-help.p-button-text {
        background-color: transparent;
        color: #6f42c1;
        border-color: transparent;
    }

    .p-button.p-button-help.p-button-text:not(:disabled):hover,
    .p-buttonset.p-button-help>.p-button.p-button-text:not(:disabled):hover,
    .p-splitbutton.p-button-help>.p-button.p-button-text:not(:disabled):hover,
    .p-fileupload-choose.p-button-help.p-button-text:not(:disabled):hover {
        background: rgba(111, 66, 193, 0.04);
        border-color: transparent;
        color: #6f42c1;
    }

    .p-button.p-button-help.p-button-text:not(:disabled):active,
    .p-buttonset.p-button-help>.p-button.p-button-text:not(:disabled):active,
    .p-splitbutton.p-button-help>.p-button.p-button-text:not(:disabled):active,
    .p-fileupload-choose.p-button-help.p-button-text:not(:disabled):active {
        background: rgba(111, 66, 193, 0.16);
        border-color: transparent;
        color: #6f42c1;
    }

    .p-button.p-button-danger,
    .p-buttonset.p-button-danger>.p-button,
    .p-splitbutton.p-button-danger>.p-button,
    .p-fileupload-choose.p-button-danger {
        color: #ffffff;
        background: #dc3545;
        border: 1px solid #dc3545;
    }

    .p-button.p-button-danger:not(:disabled):hover,
    .p-buttonset.p-button-danger>.p-button:not(:disabled):hover,
    .p-splitbutton.p-button-danger>.p-button:not(:disabled):hover,
    .p-fileupload-choose.p-button-danger:not(:disabled):hover {
        background: #c82333;
        color: #ffffff;
        border-color: #bd2130;
    }

    .p-button.p-button-danger:not(:disabled):focus,
    .p-buttonset.p-button-danger>.p-button:not(:disabled):focus,
    .p-splitbutton.p-button-danger>.p-button:not(:disabled):focus,
    .p-fileupload-choose.p-button-danger:not(:disabled):focus {
        box-shadow: 0 0 0 0.2rem rgba(225, 83, 97, 0.5);
    }

    .p-button.p-button-danger:not(:disabled):active,
    .p-buttonset.p-button-danger>.p-button:not(:disabled):active,
    .p-splitbutton.p-button-danger>.p-button:not(:disabled):active,
    .p-fileupload-choose.p-button-danger:not(:disabled):active {
        background: #bd2130;
        color: #ffffff;
        border-color: #b21f2d;
    }

    .p-button.p-button-danger.p-button-outlined,
    .p-buttonset.p-button-danger>.p-button.p-button-outlined,
    .p-splitbutton.p-button-danger>.p-button.p-button-outlined,
    .p-fileupload-choose.p-button-danger.p-button-outlined {
        background-color: transparent;
        color: #dc3545;
        border: 1px solid;
    }

    .p-button.p-button-danger.p-button-outlined:not(:disabled):hover,
    .p-buttonset.p-button-danger>.p-button.p-button-outlined:not(:disabled):hover,
    .p-splitbutton.p-button-danger>.p-button.p-button-outlined:not(:disabled):hover,
    .p-fileupload-choose.p-button-danger.p-button-outlined:not(:disabled):hover {
        background: rgba(220, 53, 69, 0.04);
        color: #dc3545;
        border: 1px solid;
    }

    .p-button.p-button-danger.p-button-outlined:not(:disabled):active,
    .p-buttonset.p-button-danger>.p-button.p-button-outlined:not(:disabled):active,
    .p-splitbutton.p-button-danger>.p-button.p-button-outlined:not(:disabled):active,
    .p-fileupload-choose.p-button-danger.p-button-outlined:not(:disabled):active {
        background: rgba(220, 53, 69, 0.16);
        color: #dc3545;
        border: 1px solid;
    }

    .p-button.p-button-danger.p-button-text,
    .p-buttonset.p-button-danger>.p-button.p-button-text,
    .p-splitbutton.p-button-danger>.p-button.p-button-text,
    .p-fileupload-choose.p-button-danger.p-button-text {
        background-color: transparent;
        color: #dc3545;
        border-color: transparent;
    }

    .p-button.p-button-danger.p-button-text:not(:disabled):hover,
    .p-buttonset.p-button-danger>.p-button.p-button-text:not(:disabled):hover,
    .p-splitbutton.p-button-danger>.p-button.p-button-text:not(:disabled):hover,
    .p-fileupload-choose.p-button-danger.p-button-text:not(:disabled):hover {
        background: rgba(220, 53, 69, 0.04);
        border-color: transparent;
        color: #dc3545;
    }

    .p-button.p-button-danger.p-button-text:not(:disabled):active,
    .p-buttonset.p-button-danger>.p-button.p-button-text:not(:disabled):active,
    .p-splitbutton.p-button-danger>.p-button.p-button-text:not(:disabled):active,
    .p-fileupload-choose.p-button-danger.p-button-text:not(:disabled):active {
        background: rgba(220, 53, 69, 0.16);
        border-color: transparent;
        color: #dc3545;
    }

    .p-button.p-button-link {
        color: #007bff;
        background: transparent;
        border: transparent;
    }

    .p-button.p-button-link:not(:disabled):hover {
        background: transparent;
        color: #0069d9;
        border-color: transparent;
    }

    .p-button.p-button-link:not(:disabled):hover .p-button-label {
        text-decoration: underline;
    }

    .p-button.p-button-link:not(:disabled):focus {
        background: transparent;
        box-shadow: 0 0 0 0.2rem rgba(38, 143, 255, 0.5);
        border-color: transparent;
    }

    .p-button.p-button-link:not(:disabled):active {
        background: transparent;
        color: #007bff;
        border-color: transparent;
    }

    .p-splitbutton {
        border-radius: 4px;
    }

    .p-splitbutton.p-button-outlined>.p-button {
        background-color: transparent;
        color: #007bff;
        border: 1px solid;
    }

    .p-splitbutton.p-button-outlined>.p-button:not(:disabled):hover {
        background: rgba(0, 123, 255, 0.04);
        color: #007bff;
    }

    .p-splitbutton.p-button-outlined>.p-button:not(:disabled):active {
        background: rgba(0, 123, 255, 0.16);
        color: #007bff;
    }

    .p-splitbutton.p-button-outlined.p-button-plain>.p-button {
        color: #6c757d;
        border-color: #6c757d;
    }

    .p-splitbutton.p-button-outlined.p-button-plain>.p-button:not(:disabled):hover {
        background: #e9ecef;
        color: #6c757d;
    }

    .p-splitbutton.p-button-outlined.p-button-plain>.p-button:not(:disabled):active {
        background: #dee2e6;
        color: #6c757d;
    }

    .p-splitbutton.p-button-text>.p-button {
        background-color: transparent;
        color: #007bff;
        border-color: transparent;
    }

    .p-splitbutton.p-button-text>.p-button:not(:disabled):hover {
        background: rgba(0, 123, 255, 0.04);
        color: #007bff;
        border-color: transparent;
    }

    .p-splitbutton.p-button-text>.p-button:not(:disabled):active {
        background: rgba(0, 123, 255, 0.16);
        color: #007bff;
        border-color: transparent;
    }

    .p-splitbutton.p-button-text.p-button-plain>.p-button {
        color: #6c757d;
    }

    .p-splitbutton.p-button-text.p-button-plain>.p-button:not(:disabled):hover {
        background: #e9ecef;
        color: #6c757d;
    }

    .p-splitbutton.p-button-text.p-button-plain>.p-button:not(:disabled):active {
        background: #dee2e6;
        color: #6c757d;
    }

    .p-splitbutton.p-button-raised {
        box-shadow: 0 3px 1px -2px rgba(0, 0, 0, 0.2), 0 2px 2px 0 rgba(0, 0, 0, 0.14), 0 1px 5px 0 rgba(0, 0, 0, 0.12);
    }

    .p-splitbutton.p-button-rounded {
        border-radius: 2rem;
    }

    .p-splitbutton.p-button-rounded>.p-button {
        border-radius: 2rem;
    }

    .p-splitbutton.p-button-sm>.p-button {
        font-size: 12px;
        padding: 0.4375rem 0.65625rem;
    }

    .p-splitbutton.p-button-sm>.p-button .p-button-icon {
        font-size: 0.875rem;
    }

    .p-splitbutton.p-button-lg>.p-button {
        font-size: 12px;
        padding: 0.625rem 0.9375rem;
    }

    .p-splitbutton.p-button-lg>.p-button.p-button-icon-only {
        width: auto;
    }

    .p-splitbutton.p-button-lg>.p-button .p-button-icon {
        font-size: 1.25rem;
    }

    .p-splitbutton .p-splitbutton-menubutton,
    .p-splitbutton .p-splitbutton.p-button-rounded>.p-splitbutton-menubutton.p-button,
    .p-splitbutton .p-splitbutton.p-button-outlined>.p-splitbutton-menubutton.p-button {
        border-top-left-radius: 0;
        border-bottom-left-radius: 0;
    }

    .p-splitbutton.p-button-secondary.p-button-outlined>.p-button {
        background-color: transparent;
        color: #6c757d;
        border: 1px solid;
    }

    .p-splitbutton.p-button-secondary.p-button-outlined>.p-button:not(:disabled):hover {
        background: rgba(108, 117, 125, 0.04);
        color: #6c757d;
    }

    .p-splitbutton.p-button-secondary.p-button-outlined>.p-button:not(:disabled):active {
        background: rgba(108, 117, 125, 0.16);
        color: #6c757d;
    }

    .p-splitbutton.p-button-secondary.p-button-text>.p-button {
        background-color: transparent;
        color: #6c757d;
        border-color: transparent;
    }

    .p-splitbutton.p-button-secondary.p-button-text>.p-button:not(:disabled):hover {
        background: rgba(108, 117, 125, 0.04);
        border-color: transparent;
        color: #6c757d;
    }

    .p-splitbutton.p-button-secondary.p-button-text>.p-button:not(:disabled):active {
        background: rgba(108, 117, 125, 0.16);
        border-color: transparent;
        color: #6c757d;
    }

    .p-splitbutton.p-button-info.p-button-outlined>.p-button {
        background-color: transparent;
        color: #17a2b8;
        border: 1px solid;
    }

    .p-splitbutton.p-button-info.p-button-outlined>.p-button:not(:disabled):hover {
        background: rgba(23, 162, 184, 0.04);
        color: #17a2b8;
    }

    .p-splitbutton.p-button-info.p-button-outlined>.p-button:not(:disabled):active {
        background: rgba(23, 162, 184, 0.16);
        color: #17a2b8;
    }

    .p-splitbutton.p-button-info.p-button-text>.p-button {
        background-color: transparent;
        color: #17a2b8;
        border-color: transparent;
    }

    .p-splitbutton.p-button-info.p-button-text>.p-button:not(:disabled):hover {
        background: rgba(23, 162, 184, 0.04);
        border-color: transparent;
        color: #17a2b8;
    }

    .p-splitbutton.p-button-info.p-button-text>.p-button:not(:disabled):active {
        background: rgba(23, 162, 184, 0.16);
        border-color: transparent;
        color: #17a2b8;
    }

    .p-splitbutton.p-button-success.p-button-outlined>.p-button {
        background-color: transparent;
        color: #28a745;
        border: 1px solid;
    }

    .p-splitbutton.p-button-success.p-button-outlined>.p-button:not(:disabled):hover {
        background: rgba(40, 167, 69, 0.04);
        color: #28a745;
    }

    .p-splitbutton.p-button-success.p-button-outlined>.p-button:not(:disabled):active {
        background: rgba(40, 167, 69, 0.16);
        color: #28a745;
    }

    .p-splitbutton.p-button-success.p-button-text>.p-button {
        background-color: transparent;
        color: #28a745;
        border-color: transparent;
    }

    .p-splitbutton.p-button-success.p-button-text>.p-button:not(:disabled):hover {
        background: rgba(40, 167, 69, 0.04);
        border-color: transparent;
        color: #28a745;
    }

    .p-splitbutton.p-button-success.p-button-text>.p-button:not(:disabled):active {
        background: rgba(40, 167, 69, 0.16);
        border-color: transparent;
        color: #28a745;
    }

    .p-splitbutton.p-button-warning.p-button-outlined>.p-button {
        background-color: transparent;
        color: #ffc107;
        border: 1px solid;
    }

    .p-splitbutton.p-button-warning.p-button-outlined>.p-button:not(:disabled):hover {
        background: rgba(255, 193, 7, 0.04);
        color: #ffc107;
    }

    .p-splitbutton.p-button-warning.p-button-outlined>.p-button:not(:disabled):active {
        background: rgba(255, 193, 7, 0.16);
        color: #ffc107;
    }

    .p-splitbutton.p-button-warning.p-button-text>.p-button {
        background-color: transparent;
        color: #ffc107;
        border-color: transparent;
    }

    .p-splitbutton.p-button-warning.p-button-text>.p-button:not(:disabled):hover {
        background: rgba(255, 193, 7, 0.04);
        border-color: transparent;
        color: #ffc107;
    }

    .p-splitbutton.p-button-warning.p-button-text>.p-button:not(:disabled):active {
        background: rgba(255, 193, 7, 0.16);
        border-color: transparent;
        color: #ffc107;
    }

    .p-splitbutton.p-button-help.p-button-outlined>.p-button {
        background-color: transparent;
        color: #6f42c1;
        border: 1px solid;
    }

    .p-splitbutton.p-button-help.p-button-outlined>.p-button:not(:disabled):hover {
        background: rgba(111, 66, 193, 0.04);
        color: #6f42c1;
    }

    .p-splitbutton.p-button-help.p-button-outlined>.p-button:not(:disabled):active {
        background: rgba(111, 66, 193, 0.16);
        color: #6f42c1;
    }

    .p-splitbutton.p-button-help.p-button-text>.p-button {
        background-color: transparent;
        color: #6f42c1;
        border-color: transparent;
    }

    .p-splitbutton.p-button-help.p-button-text>.p-button:not(:disabled):hover {
        background: rgba(111, 66, 193, 0.04);
        border-color: transparent;
        color: #6f42c1;
    }

    .p-splitbutton.p-button-help.p-button-text>.p-button:not(:disabled):active {
        background: rgba(111, 66, 193, 0.16);
        border-color: transparent;
        color: #6f42c1;
    }

    .p-splitbutton.p-button-danger.p-button-outlined>.p-button {
        background-color: transparent;
        color: #dc3545;
        border: 1px solid;
    }

    .p-splitbutton.p-button-danger.p-button-outlined>.p-button:not(:disabled):hover {
        background: rgba(220, 53, 69, 0.04);
        color: #dc3545;
    }

    .p-splitbutton.p-button-danger.p-button-outlined>.p-button:not(:disabled):active {
        background: rgba(220, 53, 69, 0.16);
        color: #dc3545;
    }

    .p-splitbutton.p-button-danger.p-button-text>.p-button {
        background-color: transparent;
        color: #dc3545;
        border-color: transparent;
    }

    .p-splitbutton.p-button-danger.p-button-text>.p-button:not(:disabled):hover {
        background: rgba(220, 53, 69, 0.04);
        border-color: transparent;
        color: #dc3545;
    }

    .p-splitbutton.p-button-danger.p-button-text>.p-button:not(:disabled):active {
        background: rgba(220, 53, 69, 0.16);
        border-color: transparent;
        color: #dc3545;
    }

    .p-speeddial-button.p-button.p-button-icon-only {
        width: 4rem;
        height: 4rem;
    }

    .p-speeddial-button.p-button.p-button-icon-only .p-button-icon {
        font-size: 1.3rem;
    }

    .p-speeddial-button.p-button.p-button-icon-only .p-button-icon.p-icon {
        width: 1.3rem;
        height: 1.3rem;
    }

    .p-speeddial-list {
        outline: 0 none;
    }

    .p-speeddial-action {
        width: 3rem;
        height: 3rem;
        background: #495057;
        color: #fff;
    }

    .p-speeddial-action:hover {
        background: #343a40;
        color: #fff;
    }

    .p-speeddial-direction-up .p-speeddial-item {
        margin: 0.25rem;
    }

    .p-speeddial-direction-up .p-speeddial-item:first-child {
        margin-bottom: 0.5rem;
    }

    .p-speeddial-direction-down .p-speeddial-item {
        margin: 0.25rem;
    }

    .p-speeddial-direction-down .p-speeddial-item:first-child {
        margin-top: 0.5rem;
    }

    .p-speeddial-direction-left .p-speeddial-item {
        margin: 0 0.25rem;
    }

    .p-speeddial-direction-left .p-speeddial-item:first-child {
        margin-right: 0.5rem;
    }

    .p-speeddial-direction-right .p-speeddial-item {
        margin: 0 0.25rem;
    }

    .p-speeddial-direction-right .p-speeddial-item:first-child {
        margin-left: 0.5rem;
    }

    .p-speeddial-circle .p-speeddial-item,
    .p-speeddial-semi-circle .p-speeddial-item,
    .p-speeddial-quarter-circle .p-speeddial-item {
        margin: 0;
    }

    .p-speeddial-circle .p-speeddial-item:first-child,
    .p-speeddial-circle .p-speeddial-item:last-child,
    .p-speeddial-semi-circle .p-speeddial-item:first-child,
    .p-speeddial-semi-circle .p-speeddial-item:last-child,
    .p-speeddial-quarter-circle .p-speeddial-item:first-child,
    .p-speeddial-quarter-circle .p-speeddial-item:last-child {
        margin: 0;
    }

    .p-speeddial-mask {
        background-color: rgba(0, 0, 0, 0.4);
        border-radius: 4px;
    }

    .p-carousel .p-carousel-content .p-carousel-prev,
    .p-carousel .p-carousel-content .p-carousel-next {
        width: 2rem;
        height: 2rem;
        color: #6c757d;
        border: 0 none;
        background: transparent;
        border-radius: 50%;
        transition: box-shadow 0.15s;
        margin: 0.5rem;
    }

    .p-carousel .p-carousel-content .p-carousel-prev:enabled:hover,
    .p-carousel .p-carousel-content .p-carousel-next:enabled:hover {
        color: #495057;
        border-color: transparent;
        background: transparent;
    }

    .p-carousel .p-carousel-content .p-carousel-prev:focus-visible,
    .p-carousel .p-carousel-content .p-carousel-next:focus-visible {
        outline: 0 none;
        outline-offset: 0;
        box-shadow: 0 0 0 0.2rem rgba(38, 143, 255, 0.5);
    }

    .p-carousel .p-carousel-indicators {
        padding: 1rem;
    }

    .p-carousel .p-carousel-indicators .p-carousel-indicator {
        margin-right: 0.5rem;
        margin-bottom: 0.5rem;
    }

    .p-carousel .p-carousel-indicators .p-carousel-indicator button {
        background-color: #e9ecef;
        width: 2rem;
        height: 0.5rem;
        transition: box-shadow 0.15s;
        border-radius: 0;
    }

    .p-carousel .p-carousel-indicators .p-carousel-indicator button:hover {
        background: #dee2e6;
    }

    .p-carousel .p-carousel-indicators .p-carousel-indicator.p-highlight button {
        background: #007bff;
        color: #ffffff;
    }

    .p-datatable .p-paginator-top {
        border-width: 1px 0 0 0;
        border-radius: 0;
    }

    .p-datatable .p-paginator-bottom {
        border-width: 1px 0 0 0;
        border-bottom-right-radius: 5px;
        border-bottom-left-radius: 5px;
    }

    .p-datatable .p-datatable-header {
        background: #efefef;
        color: #212529;
        border: solid #dee2e6;
        border-width: 1px 0 0 0;
        padding: 0.75rem 0.75rem;
        font-weight: 600;
    }

    .p-datatable .p-datatable-footer {
        background: #efefef;
        color: #212529;
        border: 1px solid #dee2e6;
        border-width: 1px 0 1px 0;
        padding: 1rem 1rem;
        font-weight: 600;
    }

    .p-datatable .p-datatable-thead>tr>th {
        text-align: left;
        padding: 0.5rem 0.5rem;
        border: 1px solid #dee2e6;
        border-width: 1px 0 2px 0;
        font-weight: 600;
        color: #212529;
        background: #ffffff;
        transition: box-shadow 0.15s;
    }

    .p-datatable .p-datatable-tfoot>tr>td {
        text-align: left;
        padding: 1rem 1rem;
        border: 1px solid #dee2e6;
        border-width: 1px 0 1px 0;
        font-weight: 600;
        color: #212529;
        background: #ffffff;
    }

    .p-datatable .p-sortable-column .p-sortable-column-icon {
        color: #6c757d;
        margin-left: 0.5rem;
    }

    .p-datatable .p-sortable-column .p-sortable-column-badge {
        border-radius: 50%;
        height: 1.143rem;
        min-width: 1.143rem;
        line-height: 1.143rem;
        color: #ffffff;
        background: #007bff;
        margin-left: 0.5rem;
    }

    .p-datatable .p-sortable-column:not(.p-highlight):not(.p-sortable-disabled):hover {
        background: #e9ecef;
        color: #212529;
    }

    .p-datatable .p-sortable-column:not(.p-highlight):not(.p-sortable-disabled):hover .p-sortable-column-icon {
        color: #6c757d;
    }

    .p-datatable .p-sortable-column.p-highlight {
        background: #ffffff;
        color: #cf0000;
    }

    .p-datatable .p-sortable-column.p-highlight .p-sortable-column-icon {
        color: #cf0000;
    }

    .p-datatable .p-sortable-column.p-highlight:not(.p-sortable-disabled):hover {
        background: #e9ecef;
        color: #cf0000;
    }

    .p-datatable .p-sortable-column.p-highlight:not(.p-sortable-disabled):hover .p-sortable-column-icon {
        color: #cf0000;
    }

    .p-datatable .p-sortable-column:focus-visible {
        box-shadow: inset 0 0 0 0.15rem rgba(38, 143, 255, 0.5);
        outline: 0 none;
    }

    .p-datatable .p-datatable-tbody>tr {
        background: #ffffff;
        color: #212529;
        transition: box-shadow 0.15s;
    }

    .p-datatable .p-datatable-tbody>tr>td {
        text-align: left;
        border: 1px solid #dee2e6;
        border-width: 1px 0 0 0;
        padding: 0.5rem 0.5rem;
    }

    .p-datatable .p-datatable-tbody>tr>td .p-row-toggler,
    .p-datatable .p-datatable-tbody>tr>td .p-row-editor-init,
    .p-datatable .p-datatable-tbody>tr>td .p-row-editor-save,
    .p-datatable .p-datatable-tbody>tr>td .p-row-editor-cancel {
        width: 2rem;
        height: 2rem;
        color: #6c757d;
        border: 0 none;
        background: transparent;
        border-radius: 50%;
        transition: box-shadow 0.15s;
    }

    .p-datatable .p-datatable-tbody>tr>td .p-row-toggler:enabled:hover,
    .p-datatable .p-datatable-tbody>tr>td .p-row-editor-init:enabled:hover,
    .p-datatable .p-datatable-tbody>tr>td .p-row-editor-save:enabled:hover,
    .p-datatable .p-datatable-tbody>tr>td .p-row-editor-cancel:enabled:hover {
        color: #495057;
        border-color: transparent;
        background: transparent;
    }

    .p-datatable .p-datatable-tbody>tr>td .p-row-toggler:focus-visible,
    .p-datatable .p-datatable-tbody>tr>td .p-row-editor-init:focus-visible,
    .p-datatable .p-datatable-tbody>tr>td .p-row-editor-save:focus-visible,
    .p-datatable .p-datatable-tbody>tr>td .p-row-editor-cancel:focus-visible {
        outline: 0 none;
        outline-offset: 0;
        box-shadow: 0 0 0 0.2rem rgba(38, 143, 255, 0.5);
    }

    .p-datatable .p-datatable-tbody>tr>td .p-row-editor-save {
        margin-right: 0.5rem;
    }

    .p-datatable .p-datatable-tbody>tr>td>.p-column-title {
        font-weight: 600;
    }

    .p-datatable .p-datatable-tbody>tr>td.p-highlight {
        background: #007bff;
        color: #ffffff;
    }

    .p-datatable .p-datatable-tbody>tr.p-highlight {
        background: #cf0000;
        color: #ffffff;
    }

    .p-datatable .p-datatable-tbody>tr.p-highlight-contextmenu {
        outline: 0.15rem solid rgba(38, 143, 255, 0.5);
        outline-offset: -0.15rem;
    }

    .p-datatable .p-datatable-tbody>tr.p-datatable-dragpoint-top>td {
        box-shadow: inset 0 2px 0 0 #007bff;
    }

    .p-datatable .p-datatable-tbody>tr.p-datatable-dragpoint-bottom>td {
        box-shadow: inset 0 -2px 0 0 #007bff;
    }

    .p-datatable.p-datatable-selectable .p-datatable-tbody>tr.p-selectable-row:not(.p-highlight):not(.p-datatable-emptymessage):hover {
        background: #e9ecef;
        color: #212529;
    }

    .p-datatable.p-datatable-selectable .p-datatable-tbody>tr.p-selectable-row:focus-visible {
        outline: 0.15rem solid rgba(38, 143, 255, 0.5);
        outline-offset: -0.15rem;
    }

    .p-datatable.p-datatable-selectable-cell .p-datatable-tbody>tr.p-selectable-row>td.p-selectable-cell:not(.p-highlight):hover {
        background: #e9ecef;
        color: #212529;
    }

    .p-datatable.p-datatable-selectable-cell .p-datatable-tbody>tr.p-selectable-row>td.p-selectable-cell:focus-visible {
        outline: 0.15rem solid rgba(38, 143, 255, 0.5);
        outline-offset: -0.15rem;
    }

    .p-datatable.p-datatable-hoverable-rows .p-datatable-tbody>tr:not(.p-highlight):not(.p-datatable-emptymessage):hover {
        background: #e9ecef;
        color: #212529;
    }

    .p-datatable .p-column-resizer-helper {
        background: #007bff;
    }

    .p-datatable .p-datatable-scrollable-header,
    .p-datatable .p-datatable-scrollable-footer {
        background: #efefef;
    }

    .p-datatable.p-datatable-scrollable>.p-datatable-wrapper>.p-datatable-table>.p-datatable-thead,
    .p-datatable.p-datatable-scrollable>.p-datatable-wrapper>.p-datatable-table>.p-datatable-tfoot,
    .p-datatable.p-datatable-scrollable>.p-datatable-wrapper>.p-virtualscroller>.p-datatable-table>.p-datatable-thead,
    .p-datatable.p-datatable-scrollable>.p-datatable-wrapper>.p-virtualscroller>.p-datatable-table>.p-datatable-tfoot {
        background-color: #ffffff;
    }

    .p-datatable .p-datatable-loading-icon {
        font-size: 2rem;
    }

    .p-datatable .p-datatable-loading-icon.p-icon {
        width: 2rem;
        height: 2rem;
    }

    .p-datatable.p-datatable-gridlines .p-datatable-header {
        border-width: 1px 1px 0 1px;
        border-top-right-radius: 5px;
        border-top-left-radius: 5px;
    }

    .p-datatable.p-datatable-gridlines .p-datatable-footer {
        border-width: 0 1px 1px 1px;
    }

    .p-datatable.p-datatable-gridlines .p-paginator-top {
        border-width: 0 1px 0 1px;
    }

    .p-datatable.p-datatable-gridlines .p-paginator-bottom {
        border-width: 0 1px 1px 1px;
    }

    .p-datatable.p-datatable-gridlines .p-datatable-thead>tr>th {
        border-width: 1px 0 1px 1px;
    }

    .p-datatable.p-datatable-gridlines .p-datatable-thead>tr>th:last-child {
        border-width: 1px;
    }

    .p-datatable.p-datatable-gridlines .p-datatable-tbody>tr>td {
        border-width: 1px 0 0 1px;
    }

    .p-datatable.p-datatable-gridlines .p-datatable-tbody>tr>td:last-child {
        border-width: 1px 1px 0 1px;
    }

    .p-datatable.p-datatable-gridlines .p-datatable-tbody>tr:last-child>td {
        border-width: 1px 0 1px 1px;
    }

    .p-datatable.p-datatable-gridlines .p-datatable-tbody>tr:last-child>td:last-child {
        border-width: 1px;
    }

    .p-datatable.p-datatable-gridlines .p-datatable-tfoot>tr>td {
        border-width: 1px 0 1px 1px;
    }

    .p-datatable.p-datatable-gridlines .p-datatable-tfoot>tr>td:last-child {
        border-width: 1px 1px 1px 1px;
    }

    .p-datatable.p-datatable-gridlines .p-datatable-thead+.p-datatable-tfoot>tr>td {
        border-width: 0 0 1px 1px;
    }

    .p-datatable.p-datatable-gridlines .p-datatable-thead+.p-datatable-tfoot>tr>td:last-child {
        border-width: 0 1px 1px 1px;
    }

    .p-datatable.p-datatable-gridlines:has(.p-datatable-thead):has(.p-datatable-tbody) .p-datatable-tbody>tr>td {
        border-width: 0 0 1px 1px;
    }

    .p-datatable.p-datatable-gridlines:has(.p-datatable-thead):has(.p-datatable-tbody) .p-datatable-tbody>tr>td:last-child {
        border-width: 0 1px 1px 1px;
    }

    .p-datatable.p-datatable-gridlines:has(.p-datatable-tbody):has(.p-datatable-tfoot) .p-datatable-tbody>tr:last-child>td {
        border-width: 0 0 0 1px;
    }

    .p-datatable.p-datatable-gridlines:has(.p-datatable-tbody):has(.p-datatable-tfoot) .p-datatable-tbody>tr:last-child>td:last-child {
        border-width: 0 1px 0 1px;
    }

    .p-datatable.p-datatable-striped .p-datatable-tbody>tr.p-row-odd {
        background: rgba(0, 0, 0, 0.05);
    }

    .p-datatable.p-datatable-striped .p-datatable-tbody>tr.p-row-odd.p-highlight {
        background: #cf0000;
        color: #ffffff;
    }

    .p-datatable.p-datatable-striped .p-datatable-tbody>tr.p-row-odd.p-highlight .p-row-toggler {
        color: #ffffff;
    }

    .p-datatable.p-datatable-striped .p-datatable-tbody>tr.p-row-odd.p-highlight .p-row-toggler:hover {
        color: #ffffff;
    }

    .p-datatable.p-datatable-striped .p-datatable-tbody>tr.p-row-odd+.p-row-expanded {
        background: rgba(0, 0, 0, 0.05);
    }

    .p-datatable.p-datatable-sm .p-datatable-header {
        padding: 0.5rem 0.5rem;
    }

    .p-datatable.p-datatable-sm .p-datatable-thead>tr>th {
        padding: 0.5rem 0.5rem;
    }

    .p-datatable.p-datatable-sm .p-datatable-tbody>tr>td {
        padding: 0.5rem 0.5rem;
    }

    .p-datatable.p-datatable-sm .p-datatable-tfoot>tr>td {
        padding: 0.5rem 0.5rem;
    }

    .p-datatable.p-datatable-sm .p-datatable-footer {
        padding: 0.5rem 0.5rem;
    }

    .p-datatable.p-datatable-lg .p-datatable-header {
        padding: 1.25rem 1.25rem;
    }

    .p-datatable.p-datatable-lg .p-datatable-thead>tr>th {
        padding: 1.25rem 1.25rem;
    }

    .p-datatable.p-datatable-lg .p-datatable-tbody>tr>td {
        padding: 1.25rem 1.25rem;
    }

    .p-datatable.p-datatable-lg .p-datatable-tfoot>tr>td {
        padding: 1.25rem 1.25rem;
    }

    .p-datatable.p-datatable-lg .p-datatable-footer {
        padding: 1.25rem 1.25rem;
    }

    .p-datatable-drag-selection-helper {
        background: rgba(0, 123, 255, 0.16);
    }

    .p-dataview .p-paginator-top {
        border-width: 1px 0 0 0;
        border-radius: 0;
    }

    .p-dataview .p-paginator-bottom {
        border-width: 1px 0 0 0;
        border-radius: 0;
    }

    .p-dataview .p-dataview-header {
        background: #efefef;
        color: #212529;
        border: solid #dee2e6;
        border-width: 1px 0 0 0;
        padding: 1rem 1rem;
        font-weight: 600;
    }

    .p-dataview .p-dataview-content {
        background: #ffffff;
        color: #212529;
        border: 0 none;
        padding: 0;
    }

    .p-dataview .p-dataview-footer {
        background: #efefef;
        color: #212529;
        border: 1px solid #dee2e6;
        border-width: 1px 0 1px 0;
        padding: 1rem 1rem;
        font-weight: 600;
        border-bottom-left-radius: 4px;
        border-bottom-right-radius: 4px;
    }

    .p-dataview .p-dataview-loading-icon {
        font-size: 2rem;
    }

    .p-dataview .p-dataview-loading-icon.p-icon {
        width: 2rem;
        height: 2rem;
    }

    .p-datascroller .p-paginator-top {
        border-width: 1px 0 0 0;
        border-radius: 0;
    }

    .p-datascroller .p-paginator-bottom {
        border-width: 1px 0 0 0;
        border-radius: 0;
    }

    .p-datascroller .p-datascroller-header {
        background: #efefef;
        color: #212529;
        border: solid #dee2e6;
        border-width: 1px 0 0 0;
        padding: 1rem 1rem;
        font-weight: 600;
    }

    .p-datascroller .p-datascroller-content {
        background: #ffffff;
        color: #212529;
        border: 0 none;
        padding: 0;
    }

    .p-datascroller.p-datascroller-inline .p-datascroller-list>li {
        border: 1px solid #dee2e6;
        border-width: 1px 0 0 0;
    }

    .p-datascroller .p-datascroller-footer {
        background: #efefef;
        color: #212529;
        border: 1px solid #dee2e6;
        border-width: 1px 0 1px 0;
        padding: 1rem 1rem;
        font-weight: 600;
        border-bottom-left-radius: 4px;
        border-bottom-right-radius: 4px;
    }

    .p-column-filter-row .p-column-filter-menu-button,
    .p-column-filter-row .p-column-filter-clear-button {
        margin-left: 0.5rem;
    }

    .p-column-filter-menu-button {
        width: 2rem;
        height: 2rem;
        color: #6c757d;
        border: 0 none;
        background: transparent;
        border-radius: 50%;
        transition: box-shadow 0.15s;
    }

    .p-column-filter-menu-button:hover {
        color: #495057;
        border-color: transparent;
        background: transparent;
    }

    .p-column-filter-menu-button.p-column-filter-menu-button-open,
    .p-column-filter-menu-button.p-column-filter-menu-button-open:hover {
        background: transparent;
        color: #495057;
    }

    .p-column-filter-menu-button.p-column-filter-menu-button-active,
    .p-column-filter-menu-button.p-column-filter-menu-button-active:hover {
        background: #007bff;
        color: #ffffff;
    }

    .p-column-filter-menu-button:focus-visible {
        outline: 0 none;
        outline-offset: 0;
        box-shadow: 0 0 0 0.2rem rgba(38, 143, 255, 0.5);
    }

    .p-column-filter-clear-button {
        width: 2rem;
        height: 2rem;
        color: #6c757d;
        border: 0 none;
        background: transparent;
        border-radius: 50%;
        transition: box-shadow 0.15s;
    }

    .p-column-filter-clear-button:hover {
        color: #495057;
        border-color: transparent;
        background: transparent;
    }

    .p-column-filter-clear-button:focus-visible {
        outline: 0 none;
        outline-offset: 0;
        box-shadow: 0 0 0 0.2rem rgba(38, 143, 255, 0.5);
    }

    .p-column-filter-overlay {
        background: #ffffff;
        color: #212529;
        border: 1px solid rgba(0, 0, 0, 0.15);
        border-radius: 4px;
        box-shadow: none;
        min-width: 12.5rem;
    }

    .p-column-filter-overlay .p-column-filter-row-items {
        padding: 0.5rem 0;
    }

    .p-column-filter-overlay .p-column-filter-row-items .p-column-filter-row-item {
        margin: 0;
        padding: 0.5rem 1.5rem;
        border: 0 none;
        color: #212529;
        background: transparent;
        transition: box-shadow 0.15s;
        border-radius: 0;
    }

    .p-column-filter-overlay .p-column-filter-row-items .p-column-filter-row-item.p-highlight {
        color: #ffffff;
        background: #007bff;
    }

    .p-column-filter-overlay .p-column-filter-row-items .p-column-filter-row-item:not(.p-highlight):not(.p-disabled):hover {
        color: #212529;
        background: #e9ecef;
    }

    .p-column-filter-overlay .p-column-filter-row-items .p-column-filter-row-item:focus-visible {
        outline: 0 none;
        outline-offset: 0;
        box-shadow: inset 0 0 0 0.15rem rgba(38, 143, 255, 0.5);
    }

    .p-column-filter-overlay .p-column-filter-row-items .p-column-filter-separator {
        border-top: 1px solid #dee2e6;
        margin: 0.5rem 0;
    }

    .p-column-filter-overlay-menu .p-column-filter-operator {
        padding: 0.75rem 1.5rem;
        border-bottom: 1px solid #dee2e6;
        color: #212529;
        background: #efefef;
        margin: 0;
        border-top-right-radius: 4px;
        border-top-left-radius: 4px;
    }

    .p-column-filter-overlay-menu .p-column-filter-constraint {
        padding: 1.25rem;
        border-bottom: 1px solid #dee2e6;
    }

    .p-column-filter-overlay-menu .p-column-filter-constraint .p-column-filter-matchmode-dropdown {
        margin-bottom: 0.5rem;
    }

    .p-column-filter-overlay-menu .p-column-filter-constraint .p-column-filter-remove-button {
        margin-top: 0.5rem;
    }

    .p-column-filter-overlay-menu .p-column-filter-constraint:last-child {
        border-bottom: 0 none;
    }

    .p-column-filter-overlay-menu .p-column-filter-add-rule {
        padding: 0.5rem 1.25rem;
    }

    .p-column-filter-overlay-menu .p-column-filter-buttonbar {
        padding: 1.25rem;
    }

    .p-orderlist .p-orderlist-controls {
        padding: 1.25rem;
    }

    .p-orderlist .p-orderlist-controls .p-button {
        margin-bottom: 0.5rem;
    }

    .p-orderlist .p-orderlist-header {
        background: #efefef;
        color: #212529;
        border: 1px solid #dee2e6;
        padding: 1rem 1.25rem;
        font-weight: 600;
        border-bottom: 0 none;
        border-top-right-radius: 4px;
        border-top-left-radius: 4px;
    }

    .p-orderlist .p-orderlist-filter-container {
        padding: 1rem 1.25rem;
        background: #ffffff;
        border: 1px solid #dee2e6;
        border-bottom: 0 none;
    }

    .p-orderlist .p-orderlist-filter-container .p-orderlist-filter-input {
        padding-right: 1.75rem;
    }

    .p-orderlist .p-orderlist-filter-container .p-orderlist-filter-icon {
        right: 0.75rem;
        color: #495057;
    }

    .p-orderlist .p-orderlist-list {
        border: 1px solid #dee2e6;
        background: #ffffff;
        color: #212529;
        padding: 0.5rem 0;
        border-bottom-right-radius: 4px;
        border-bottom-left-radius: 4px;
        outline: 0 none;
    }

    .p-orderlist .p-orderlist-list .p-orderlist-item {
        padding: 0.5rem 1.5rem;
        margin: 0;
        border: 0 none;
        color: #212529;
        background: transparent;
        transition: transform 0.15s, box-shadow 0.15s;
    }

    .p-orderlist .p-orderlist-list .p-orderlist-item:not(.p-highlight):hover {
        background: #e9ecef;
        color: #212529;
    }

    .p-orderlist .p-orderlist-list .p-orderlist-item.p-focus {
        color: #212529;
        background: #dee2e6;
    }

    .p-orderlist .p-orderlist-list .p-orderlist-item.p-highlight {
        color: #ffffff;
        background: #007bff;
    }

    .p-orderlist .p-orderlist-list .p-orderlist-item.p-highlight.p-focus {
        background: #0067d6;
    }

    .p-orderlist.p-orderlist-striped .p-orderlist-list .p-orderlist-item:nth-child(even) {
        background: rgba(0, 0, 0, 0.05);
    }

    .p-orderlist.p-orderlist-striped .p-orderlist-list .p-orderlist-item:nth-child(even):hover {
        background: #e9ecef;
    }

    .p-organizationchart .p-organizationchart-node-content.p-organizationchart-selectable-node:not(.p-highlight):hover {
        background: #e9ecef;
        color: #212529;
    }

    .p-organizationchart .p-organizationchart-node-content.p-highlight {
        background: #007bff;
        color: #ffffff;
    }

    .p-organizationchart .p-organizationchart-node-content.p-highlight .p-node-toggler i {
        color: #003e80;
    }

    .p-organizationchart .p-organizationchart-line-down {
        background: #dee2e6;
    }

    .p-organizationchart .p-organizationchart-line-left {
        border-right: 1px solid #dee2e6;
        border-color: #dee2e6;
    }

    .p-organizationchart .p-organizationchart-line-top {
        border-top: 1px solid #dee2e6;
        border-color: #dee2e6;
    }

    .p-organizationchart .p-organizationchart-node-content {
        border: 1px solid #dee2e6;
        background: #ffffff;
        color: #212529;
        padding: 1.25rem;
    }

    .p-organizationchart .p-organizationchart-node-content .p-node-toggler {
        background: inherit;
        color: inherit;
        border-radius: 50%;
    }

    .p-organizationchart .p-organizationchart-node-content .p-node-toggler:focus-visible {
        outline: 0 none;
        outline-offset: 0;
        box-shadow: 0 0 0 0.2rem rgba(38, 143, 255, 0.5);
    }

    .p-paginator {
        background: #ffffff;
        color: #007bff;
        border: solid #dee2e6;
        border-width: 0;
        padding: 0.5rem;
        border-radius: 4px;
    }

    .p-paginator .p-paginator-first,
    .p-paginator .p-paginator-prev,
    .p-paginator .p-paginator-next,
    .p-paginator .p-paginator-last {
        background-color: #ffffff;
        border: 1px solid #dee2e6;
        color: #cf0000;
        min-width: 2.357rem;
        height: 2.357rem;
        margin: 0 0 0 -1px;
        transition: box-shadow 0.15s;
        border-radius: 0;
    }

    .p-paginator .p-paginator-first:not(.p-disabled):not(.p-highlight):hover,
    .p-paginator .p-paginator-prev:not(.p-disabled):not(.p-highlight):hover,
    .p-paginator .p-paginator-next:not(.p-disabled):not(.p-highlight):hover,
    .p-paginator .p-paginator-last:not(.p-disabled):not(.p-highlight):hover {
        background: #e9ecef;
        border-color: #dee2e6;
        color: #cf0000;
    }

    .p-paginator .p-paginator-first {
        border-top-left-radius: 10px;
        border-bottom-left-radius: 10px;
    }

    .p-paginator .p-paginator-last {
        border-top-right-radius: 10px;
        border-bottom-right-radius: 10px;
    }

    .p-paginator .p-dropdown {
        margin-left: 0.5rem;
        height: 2.357rem;
    }

    .p-paginator .p-dropdown .p-dropdown-label {
        padding-right: 0;
        color: #cf0000;
    }

    .p-paginator .p-paginator-page-input {
        margin-left: 0.5rem;
        margin-right: 0.5rem;
    }

    .p-paginator .p-paginator-page-input .p-inputtext {
        max-width: 2.357rem;
    }

    .p-paginator .p-paginator-current {
        background-color: #ffffff;
        border: 1px solid #dee2e6;
        color: #cf0000;
        min-width: 2.357rem;
        height: 2.357rem;
        margin: 0 0 0 -1px;
        padding: 0 0.5rem;
    }

    .p-paginator .p-paginator-pages .p-paginator-page {
        background-color: #ffffff;
        border: 1px solid #dee2e6;
        color: #cf0000;
        min-width: 2.357rem;
        height: 2.357rem;
        margin: 0 0 0 -1px;
        transition: box-shadow 0.15s;
        border-radius: 0;
    }

    .p-paginator .p-paginator-pages .p-paginator-page.p-highlight {
        background: #ffffff;
        border-color: #cf0000;
        color: #cf0000;
    }

    .p-paginator .p-paginator-pages .p-paginator-page:not(.p-highlight):hover {
        background: #e9ecef;
        border-color: #dee2e6;
        color: #cf0000;
    }

    .p-picklist .p-picklist-buttons {
        padding: 1.25rem;
    }

    .p-picklist .p-picklist-buttons .p-button {
        margin-bottom: 0.5rem;
    }

    .p-picklist .p-picklist-header {
        background: #efefef;
        color: #212529;
        border: 1px solid #dee2e6;
        padding: 1rem 1.25rem;
        font-weight: 600;
        border-bottom: 0 none;
        border-top-right-radius: 4px;
        border-top-left-radius: 4px;
    }

    .p-picklist .p-picklist-filter-container {
        padding: 1rem 1.25rem;
        background: #ffffff;
        border: 1px solid #dee2e6;
        border-bottom: 0 none;
    }

    .p-picklist .p-picklist-filter-container .p-picklist-filter-input {
        padding-right: 1.75rem;
    }

    .p-picklist .p-picklist-filter-container .p-picklist-filter-icon {
        right: 0.75rem;
        color: #495057;
    }

    .p-picklist .p-picklist-list {
        border: 1px solid #dee2e6;
        background: #ffffff;
        color: #212529;
        padding: 0.5rem 0;
        border-bottom-right-radius: 4px;
        border-bottom-left-radius: 4px;
        outline: 0 none;
    }

    .p-picklist .p-picklist-list .p-picklist-item {
        padding: 0.5rem 1.5rem;
        margin: 0;
        border: 0 none;
        color: #212529;
        background: transparent;
        transition: transform 0.15s, box-shadow 0.15s;
    }

    .p-picklist .p-picklist-list .p-picklist-item:not(.p-highlight):hover {
        background: #e9ecef;
        color: #212529;
    }

    .p-picklist .p-picklist-list .p-picklist-item.p-focus {
        color: #212529;
        background: #dee2e6;
    }

    .p-picklist .p-picklist-list .p-picklist-item.p-highlight {
        color: #ffffff;
        background: #007bff;
    }

    .p-picklist .p-picklist-list .p-picklist-item.p-highlight.p-focus {
        background: #0067d6;
    }

    .p-tree {
        border: 1px solid #dee2e6;
        background: #ffffff;
        color: #212529;
        padding: 1.25rem;
        border-radius: 4px;
    }

    .p-tree .p-tree-container .p-treenode {
        padding: 0.143rem;
        outline: 0 none;
    }

    .p-tree .p-tree-container .p-treenode:focus>.p-treenode-content {
        outline: 0 none;
        outline-offset: 0;
        box-shadow: inset 0 0 0 0.15rem rgba(38, 143, 255, 0.5);
    }

    .p-tree .p-tree-container .p-treenode .p-treenode-content {
        border-radius: 4px;
        transition: box-shadow 0.15s;
        padding: 0.286rem;
    }

    .p-tree .p-tree-container .p-treenode .p-treenode-content .p-tree-toggler {
        margin-right: 0.5rem;
        width: 2rem;
        height: 2rem;
        color: #6c757d;
        border: 0 none;
        background: transparent;
        border-radius: 50%;
        transition: box-shadow 0.15s;
    }

    .p-tree .p-tree-container .p-treenode .p-treenode-content .p-tree-toggler:enabled:hover {
        color: #495057;
        border-color: transparent;
        background: transparent;
    }

    .p-tree .p-tree-container .p-treenode .p-treenode-content .p-tree-toggler:focus-visible {
        outline: 0 none;
        outline-offset: 0;
        box-shadow: 0 0 0 0.2rem rgba(38, 143, 255, 0.5);
    }

    .p-tree .p-tree-container .p-treenode .p-treenode-content .p-treenode-icon {
        margin-right: 0.5rem;
        color: #6c757d;
    }

    .p-tree .p-tree-container .p-treenode .p-treenode-content .p-checkbox {
        margin-right: 0.5rem;
    }

    .p-tree .p-tree-container .p-treenode .p-treenode-content .p-checkbox .p-indeterminate .p-checkbox-icon {
        color: #212529;
    }

    .p-tree .p-tree-container .p-treenode .p-treenode-content.p-highlight {
        background: #007bff;
        color: #ffffff;
    }

    .p-tree .p-tree-container .p-treenode .p-treenode-content.p-highlight .p-tree-toggler,
    .p-tree .p-tree-container .p-treenode .p-treenode-content.p-highlight .p-treenode-icon {
        color: #ffffff;
    }

    .p-tree .p-tree-container .p-treenode .p-treenode-content.p-highlight .p-tree-toggler:hover,
    .p-tree .p-tree-container .p-treenode .p-treenode-content.p-highlight .p-treenode-icon:hover {
        color: #ffffff;
    }

    .p-tree .p-tree-container .p-treenode .p-treenode-content.p-treenode-selectable:not(.p-highlight):hover {
        background: #e9ecef;
        color: #212529;
    }

    .p-tree .p-tree-container .p-treenode .p-treenode-content.p-treenode-dragover {
        background: #e9ecef;
        color: #212529;
    }

    .p-tree .p-tree-filter-container {
        margin-bottom: 0.5rem;
    }

    .p-tree .p-tree-filter-container .p-tree-filter {
        width: 100%;
        padding-right: 1.75rem;
    }

    .p-tree .p-tree-filter-container .p-tree-filter-icon {
        right: 0.75rem;
        color: #495057;
    }

    .p-tree .p-treenode-children {
        padding: 0 0 0 1rem;
    }

    .p-tree .p-tree-loading-icon {
        font-size: 2rem;
    }

    .p-tree .p-tree-loading-icon.p-icon {
        width: 2rem;
        height: 2rem;
    }

    .p-tree .p-treenode-droppoint {
        height: 0.5rem;
    }

    .p-tree .p-treenode-droppoint.p-treenode-droppoint-active {
        background: #0062cc;
    }

    .p-treetable .p-paginator-top {
        border-width: 1px 0 0 0;
        border-radius: 0;
    }

    .p-treetable .p-paginator-bottom {
        border-width: 1px 0 0 0;
        border-radius: 0;
    }

    .p-treetable .p-treetable-header {
        background: #efefef;
        color: #212529;
        border: solid #dee2e6;
        border-width: 1px 0 0 0;
        padding: 1rem 1rem;
        font-weight: 600;
    }

    .p-treetable .p-treetable-footer {
        background: #efefef;
        color: #212529;
        border: 1px solid #dee2e6;
        border-width: 1px 0 1px 0;
        padding: 1rem 1rem;
        font-weight: 600;
    }

    .p-treetable .p-treetable-thead>tr>th {
        text-align: left;
        padding: 1rem 1rem;
        border: 1px solid #dee2e6;
        border-width: 1px 0 2px 0;
        font-weight: 600;
        color: #212529;
        background: #ffffff;
        transition: box-shadow 0.15s;
    }

    .p-treetable .p-treetable-tfoot>tr>td {
        text-align: left;
        padding: 1rem 1rem;
        border: 1px solid #dee2e6;
        border-width: 1px 0 1px 0;
        font-weight: 600;
        color: #212529;
        background: #ffffff;
    }

    .p-treetable .p-sortable-column {
        outline-color: rgba(38, 143, 255, 0.5);
    }

    .p-treetable .p-sortable-column .p-sortable-column-icon {
        color: #6c757d;
        margin-left: 0.5rem;
    }

    .p-treetable .p-sortable-column .p-sortable-column-badge {
        border-radius: 50%;
        height: 1.143rem;
        min-width: 1.143rem;
        line-height: 1.143rem;
        color: #ffffff;
        background: #007bff;
        margin-left: 0.5rem;
    }

    .p-treetable .p-sortable-column:not(.p-highlight):hover {
        background: #e9ecef;
        color: #212529;
    }

    .p-treetable .p-sortable-column:not(.p-highlight):hover .p-sortable-column-icon {
        color: #6c757d;
    }

    .p-treetable .p-sortable-column.p-highlight {
        background: #ffffff;
        color: #007bff;
    }

    .p-treetable .p-sortable-column.p-highlight .p-sortable-column-icon {
        color: #007bff;
    }

    .p-treetable .p-treetable-tbody>tr {
        background: #ffffff;
        color: #212529;
        transition: box-shadow 0.15s;
    }

    .p-treetable .p-treetable-tbody>tr>td {
        text-align: left;
        border: 1px solid #dee2e6;
        border-width: 1px 0 0 0;
        padding: 1rem 1rem;
    }

    .p-treetable .p-treetable-tbody>tr>td .p-treetable-toggler {
        width: 2rem;
        height: 2rem;
        color: #6c757d;
        border: 0 none;
        background: transparent;
        border-radius: 50%;
        transition: box-shadow 0.15s;
        margin-right: 0.5rem;
    }

    .p-treetable .p-treetable-tbody>tr>td .p-treetable-toggler:enabled:hover {
        color: #495057;
        border-color: transparent;
        background: transparent;
    }

    .p-treetable .p-treetable-tbody>tr>td .p-treetable-toggler:focus-visible {
        outline: 0 none;
        outline-offset: 0;
        box-shadow: 0 0 0 0.2rem rgba(38, 143, 255, 0.5);
    }

    .p-treetable .p-treetable-tbody>tr>td .p-treetable-toggler+.p-checkbox {
        margin-right: 0.5rem;
    }

    .p-treetable .p-treetable-tbody>tr>td .p-treetable-toggler+.p-checkbox .p-indeterminate .p-checkbox-icon {
        color: #212529;
    }

    .p-treetable .p-treetable-tbody>tr:focus-visible {
        outline: 0.15rem solid rgba(38, 143, 255, 0.5);
        outline-offset: -0.15rem;
    }

    .p-treetable .p-treetable-tbody>tr.p-highlight {
        background: #007bff;
        color: #ffffff;
    }

    .p-treetable .p-treetable-tbody>tr.p-highlight .p-treetable-toggler {
        color: #ffffff;
    }

    .p-treetable .p-treetable-tbody>tr.p-highlight .p-treetable-toggler:hover {
        color: #ffffff;
    }

    .p-treetable.p-treetable-selectable .p-treetable-tbody>tr:not(.p-highlight):hover,
    .p-treetable.p-treetable-hoverable-rows .p-treetable-tbody>tr:not(.p-highlight):hover {
        background: #e9ecef;
        color: #212529;
    }

    .p-treetable.p-treetable-selectable .p-treetable-tbody>tr:not(.p-highlight):hover .p-treetable-toggler,
    .p-treetable.p-treetable-hoverable-rows .p-treetable-tbody>tr:not(.p-highlight):hover .p-treetable-toggler {
        color: #212529;
    }

    .p-treetable .p-column-resizer-helper {
        background: #007bff;
    }

    .p-treetable .p-treetable-scrollable-header,
    .p-treetable .p-treetable-scrollable-footer {
        background: #efefef;
    }

    .p-treetable .p-treetable-loading-icon {
        font-size: 2rem;
    }

    .p-treetable .p-treetable-loading-icon.p-icon {
        width: 2rem;
        height: 2rem;
    }

    .p-treetable.p-treetable-gridlines .p-treetable-header {
        border-width: 1px 1px 0 1px;
    }

    .p-treetable.p-treetable-gridlines .p-treetable-footer {
        border-width: 0 1px 1px 1px;
    }

    .p-treetable.p-treetable-gridlines .p-treetable-top {
        border-width: 0 1px 0 1px;
    }

    .p-treetable.p-treetable-gridlines .p-treetable-bottom {
        border-width: 0 1px 1px 1px;
    }

    .p-treetable.p-treetable-gridlines .p-treetable-thead>tr>th {
        border-width: 1px;
    }

    .p-treetable.p-treetable-gridlines .p-treetable-tbody>tr>td {
        border-width: 1px;
    }

    .p-treetable.p-treetable-gridlines .p-treetable-tfoot>tr>td {
        border-width: 1px;
    }

    .p-treetable.p-treetable-striped .p-treetable-tbody>tr.p-row-odd {
        background: rgba(0, 0, 0, 0.05);
    }

    .p-treetable.p-treetable-striped .p-treetable-tbody>tr.p-row-odd.p-highlight {
        background: #007bff;
        color: #ffffff;
    }

    .p-treetable.p-treetable-striped .p-treetable-tbody>tr.p-row-odd.p-highlight .p-row-toggler {
        color: #ffffff;
    }

    .p-treetable.p-treetable-striped .p-treetable-tbody>tr.p-row-odd.p-highlight .p-row-toggler:hover {
        color: #ffffff;
    }

    .p-treetable.p-treetable-striped .p-treetable-tbody>tr.p-row-odd+.p-row-expanded {
        background: rgba(0, 0, 0, 0.05);
    }

    .p-treetable.p-treetable-sm .p-treetable-header {
        padding: 0.875rem 0.875rem;
    }

    .p-treetable.p-treetable-sm .p-treetable-thead>tr>th {
        padding: 0.5rem 0.5rem;
    }

    .p-treetable.p-treetable-sm .p-treetable-tbody>tr>td {
        padding: 0.5rem 0.5rem;
    }

    .p-treetable.p-treetable-sm .p-treetable-tfoot>tr>td {
        padding: 0.5rem 0.5rem;
    }

    .p-treetable.p-treetable-sm .p-treetable-footer {
        padding: 0.5rem 0.5rem;
    }

    .p-treetable.p-treetable-lg .p-treetable-header {
        padding: 1.25rem 1.25rem;
    }

    .p-treetable.p-treetable-lg .p-treetable-thead>tr>th {
        padding: 1.25rem 1.25rem;
    }

    .p-treetable.p-treetable-lg .p-treetable-tbody>tr>td {
        padding: 1.25rem 1.25rem;
    }

    .p-treetable.p-treetable-lg .p-treetable-tfoot>tr>td {
        padding: 1.25rem 1.25rem;
    }

    .p-treetable.p-treetable-lg .p-treetable-footer {
        padding: 1.25rem 1.25rem;
    }

    .p-timeline .p-timeline-event-marker {
        border: 0 none;
        border-radius: 50%;
        width: 1rem;
        height: 1rem;
        background-color: #007bff;
    }

    .p-timeline .p-timeline-event-connector {
        background-color: #dee2e6;
    }

    .p-timeline.p-timeline-vertical .p-timeline-event-opposite,
    .p-timeline.p-timeline-vertical .p-timeline-event-content {
        padding: 0 1rem;
    }

    .p-timeline.p-timeline-vertical .p-timeline-event-connector {
        width: 2px;
    }

    .p-timeline.p-timeline-horizontal .p-timeline-event-opposite,
    .p-timeline.p-timeline-horizontal .p-timeline-event-content {
        padding: 1rem 0;
    }

    .p-timeline.p-timeline-horizontal .p-timeline-event-connector {
        height: 2px;
    }

    .p-accordion .p-accordion-header .p-accordion-header-link {
        padding: 1rem 1.25rem;
        border: 1px solid #dee2e6;
        color: #212529;
        background: #efefef;
        font-weight: 600;
        border-radius: 4px;
        transition: box-shadow 0.15s;
    }

    .p-accordion .p-accordion-header .p-accordion-header-link .p-accordion-toggle-icon {
        margin-right: 0.5rem;
    }

    .p-accordion .p-accordion-header:not(.p-disabled) .p-accordion-header-link:focus-visible {
        outline: 0 none;
        outline-offset: 0;
        box-shadow: 0 0 0 0.2rem rgba(38, 143, 255, 0.5);
    }

    .p-accordion .p-accordion-header:not(.p-highlight):not(.p-disabled):hover .p-accordion-header-link {
        background: #e9ecef;
        border-color: #dee2e6;
        color: #212529;
    }

    .p-accordion .p-accordion-header:not(.p-disabled).p-highlight .p-accordion-header-link {
        background: #efefef;
        border-color: #dee2e6;
        color: #212529;
        border-bottom-right-radius: 0;
        border-bottom-left-radius: 0;
    }

    .p-accordion .p-accordion-header:not(.p-disabled).p-highlight:hover .p-accordion-header-link {
        border-color: #dee2e6;
        background: #e9ecef;
        color: #212529;
    }

    .p-accordion .p-accordion-content {
        padding: 1.25rem;
        border: 1px solid #dee2e6;
        background: #ffffff;
        color: #212529;
        border-top: 0;
        border-top-right-radius: 0;
        border-top-left-radius: 0;
        border-bottom-right-radius: 4px;
        border-bottom-left-radius: 4px;
    }

    .p-accordion .p-accordion-tab {
        margin-bottom: 0;
    }

    .p-accordion .p-accordion-tab .p-accordion-header .p-accordion-header-link {
        border-radius: 0;
    }

    .p-accordion .p-accordion-tab .p-accordion-content {
        border-bottom-right-radius: 0;
        border-bottom-left-radius: 0;
    }

    .p-accordion .p-accordion-tab:not(:first-child) .p-accordion-header .p-accordion-header-link {
        border-top: 0 none;
    }

    .p-accordion .p-accordion-tab:not(:first-child) .p-accordion-header:not(.p-highlight):not(.p-disabled):hover .p-accordion-header-link,
    .p-accordion .p-accordion-tab:not(:first-child) .p-accordion-header:not(.p-disabled).p-highlight:hover .p-accordion-header-link {
        border-top: 0 none;
    }

    .p-accordion .p-accordion-tab:first-child .p-accordion-header .p-accordion-header-link {
        border-top-right-radius: 4px;
        border-top-left-radius: 4px;
    }

    .p-accordion .p-accordion-tab:last-child .p-accordion-header:not(.p-highlight) .p-accordion-header-link {
        border-bottom-right-radius: 4px;
        border-bottom-left-radius: 4px;
    }

    .p-accordion .p-accordion-tab:last-child .p-accordion-header:not(.p-highlight) .p-accordion-content {
        border-bottom-right-radius: 4px;
        border-bottom-left-radius: 4px;
    }

    .p-card {
        background: #ffffff;
        color: #212529;
        box-shadow: 0 2px 1px -1px rgba(0, 0, 0, 0.2), 0 1px 1px 0 rgba(0, 0, 0, 0.14), 0 1px 3px 0 rgba(0, 0, 0, 0.12);
        border-radius: 4px;
    }

    .p-card .p-card-body {
        padding: 1.5rem;
    }

    .p-card .p-card-title {
        font-size: 12px;
        font-weight: 700;
        margin-bottom: 0.5rem;
    }

    .p-card .p-card-subtitle {
        font-weight: 400;
        margin-bottom: 0.5rem;
        color: #6c757d;
    }

    .p-card .p-card-content {
        padding: 1rem 0;
    }

    .p-card .p-card-footer {
        padding: 1rem 0 0 0;
    }

    .p-fieldset {
        border: 1px solid #dee2e6;
        background: #ffffff;
        color: #212529;
        border-radius: 4px;
    }

    .p-fieldset .p-fieldset-legend {
        padding: 0.5rem;
        border: 1px solid #dee2e6;
        color: #212529;
        background: #efefef;
        font-weight: bold;
        border-radius: 4px;
        box-shadow: 0px 0px 8px 1px #c7c9cb;
    }

    .p-fieldset.p-fieldset-toggleable .p-fieldset-legend {
        padding: 0;
        transition: box-shadow 0.15s;
    }

    .p-fieldset.p-fieldset-toggleable .p-fieldset-legend a {
        padding: 1rem 1.25rem;
        color: #212529;
        border-radius: 4px;
        transition: box-shadow 0.15s;
    }

    .p-fieldset.p-fieldset-toggleable .p-fieldset-legend a .p-fieldset-toggler {
        margin-right: 0.5rem;
    }

    .p-fieldset.p-fieldset-toggleable .p-fieldset-legend a:focus-visible {
        outline: 0 none;
        outline-offset: 0;
        box-shadow: 0 0 0 0.2rem rgba(38, 143, 255, 0.5);
    }

    .p-fieldset.p-fieldset-toggleable .p-fieldset-legend:hover {
        background: #e9ecef;
        border-color: #dee2e6;
        color: #212529;
    }

    .p-fieldset .p-fieldset-content {
        padding: 1rem;
    }

    .p-divider .p-divider-content {
        background-color: #ffffff;
    }

    .p-divider.p-divider-horizontal {
        margin: 1rem 0;
        padding: 0 1rem;
    }

    .p-divider.p-divider-horizontal:before {
        border-top: 1px #dee2e6;
    }

    .p-divider.p-divider-horizontal .p-divider-content {
        padding: 0 0.5rem;
    }

    .p-divider.p-divider-vertical {
        margin: 0 1rem;
        padding: 1rem 0;
    }

    .p-divider.p-divider-vertical:before {
        border-left: 1px #dee2e6;
    }

    .p-divider.p-divider-vertical .p-divider-content {
        padding: 0.5rem 0;
    }

    .p-panel .p-panel-header {
        border: 1px solid #dee2e6;
        padding: 1rem 1.25rem;
        background: #efefef;
        color: #212529;
        border-top-right-radius: 4px;
        border-top-left-radius: 4px;
    }

    .p-panel .p-panel-header .p-panel-title {
        font-weight: 600;
    }

    .p-panel .p-panel-header .p-panel-header-icon {
        width: 2rem;
        height: 2rem;
        color: #6c757d;
        border: 0 none;
        background: transparent;
        border-radius: 50%;
        transition: box-shadow 0.15s;
    }

    .p-panel .p-panel-header .p-panel-header-icon:enabled:hover {
        color: #495057;
        border-color: transparent;
        background: transparent;
    }

    .p-panel .p-panel-header .p-panel-header-icon:focus-visible {
        outline: 0 none;
        outline-offset: 0;
        box-shadow: 0 0 0 0.2rem rgba(38, 143, 255, 0.5);
    }

    .p-panel.p-panel-toggleable .p-panel-header {
        padding: 0.5rem 1.25rem;
    }

    .p-panel .p-panel-content {
        padding: 1.25rem;
        border: 1px solid #dee2e6;
        background: #ffffff;
        color: #212529;
        border-bottom-right-radius: 4px;
        border-bottom-left-radius: 4px;
        border-top: 0 none;
    }

    .p-panel .p-panel-footer {
        padding: 0.5rem 1.25rem;
        border: 1px solid #dee2e6;
        background: #ffffff;
        color: #212529;
        border-top: 0 none;
    }

    .p-splitter {
        border: 1px solid #dee2e6;
        background: #ffffff;
        border-radius: 4px;
        color: #212529;
    }

    .p-splitter .p-splitter-gutter {
        transition: box-shadow 0.15s;
        background: #efefef;
    }

    .p-splitter .p-splitter-gutter .p-splitter-gutter-handle {
        background: #dee2e6;
    }

    .p-splitter .p-splitter-gutter .p-splitter-gutter-handle:focus-visible {
        outline: 0 none;
        outline-offset: 0;
        box-shadow: 0 0 0 0.2rem rgba(38, 143, 255, 0.5);
    }

    .p-splitter .p-splitter-gutter-resizing {
        background: #dee2e6;
    }

    .p-scrollpanel .p-scrollpanel-bar {
        background: #efefef;
        border: 0 none;
    }

    .p-scrollpanel .p-scrollpanel-bar:focus-visible {
        outline: 0 none;
        outline-offset: 0;
        box-shadow: 0 0 0 0.2rem rgba(38, 143, 255, 0.5);
    }

    .p-tabview .p-tabview-nav {
        background: transparent;
        /* border: 1px solid #dee2e6; */
        border: 1px solid #cf0000;
        border-width: 0 0 1px 0;
    }

    .p-tabview .p-tabview-nav li {
        margin-right: 2px;
    }

    /* .p-tabview .p-tabview-nav li .p-tabview-nav-link {
        border: solid;
        border-width: 1px;
        border-color: #ffffff #ffffff #dee2e6 #ffffff;
        background: #ffffff;
        color: #6c757d;
        padding: 0.75rem 1rem;
        font-weight: 600;
        border-top-right-radius: 4px;
        border-top-left-radius: 4px;
        transition: box-shadow 0.15s;
        margin: 0 0 -1px 0;
    } */
    .p-tabview .p-tabview-nav li .p-tabview-nav-link {
        border: solid;
        border-width: 1px;
        border-color: #cf0000 #cf0000 #cf0000 #cf0000;
        background: #cf0000;
        color: #ffffff;
        padding: 0.75rem 1rem;
        font-weight: 600;
        border-top-right-radius: 10px;
        border-top-left-radius: 10px;
        transition: box-shadow 0.15s;
        margin: 0 0 -1px 0;
        box-shadow: 0px 1px 8px -1px #dc3545;
    }

    .p-tabview .p-tabview-nav li .p-tabview-nav-link:not(.p-disabled):focus-visible {
        outline: 0 none;
        outline-offset: 0;
        box-shadow: inset 0 0 0 0.2rem rgba(38, 143, 255, 0.5);
    }

    .p-tabview .p-tabview-nav li:not(.p-highlight):not(.p-disabled):hover .p-tabview-nav-link {
        background: #ffffff;
        border-color: #e4717c;
        color: #e4717c;
    }

    /* .p-tabview .p-tabview-nav li.p-highlight .p-tabview-nav-link {
        background: #ffffff;
        border-color: #dee2e6 #dee2e6 #ffffff #dee2e6;
        color: #495057;
    } */

    .p-tabview .p-tabview-nav li.p-highlight .p-tabview-nav-link {
        background: #ffffff;
        border-color: #cf0000 #cf0000 #ffffff #cf0000;
        color: #cf0000;
    }

    .p-tabview .p-tabview-close {
        margin-left: 0.5rem;
    }

    .p-tabview .p-tabview-nav-btn.p-link {
        background: #ffffff;
        color: #495057;
        width: 2.357rem;
        box-shadow: 0 3px 1px -2px rgba(0, 0, 0, 0.2), 0 2px 2px 0 rgba(0, 0, 0, 0.14), 0 1px 5px 0 rgba(0, 0, 0, 0.12);
        border-radius: 0;
    }

    .p-tabview .p-tabview-nav-btn.p-link:focus-visible {
        outline: 0 none;
        outline-offset: 0;
        box-shadow: inset 0 0 0 0.2rem rgba(38, 143, 255, 0.5);
    }

    .p-tabview .p-tabview-panels {
        background: #ffffff;
        padding: 1.25rem;
        /* border: 1px solid #cf0000; */
        border-left: 1px solid #cf0000;
        border-right: 1px solid #cf0000;
        border-bottom: 1px solid #cf0000;
        color: #212529;
        border-bottom-right-radius: 4px;
        border-bottom-left-radius: 4px;
    }

    .p-toolbar {
        background: #efefef;
        border: 1px solid #dee2e6;
        padding: 1rem 1.25rem;
        border-radius: 4px;
        gap: 0.5rem;
    }

    .p-toolbar .p-toolbar-separator {
        margin: 0 0.5rem;
    }

    .p-confirm-popup {
        background: #ffffff;
        color: #212529;
        border: 1px solid rgba(0, 0, 0, 0.2);
        border-radius: 4px;
        box-shadow: none;
    }

    .p-confirm-popup .p-confirm-popup-content {
        padding: 1.25rem;
    }

    .p-confirm-popup .p-confirm-popup-footer {
        text-align: right;
        padding: 0 1.25rem 1.25rem 1.25rem;
    }

    .p-confirm-popup .p-confirm-popup-footer button {
        margin: 0 0.5rem 0 0;
        width: auto;
    }

    .p-confirm-popup .p-confirm-popup-footer button:last-child {
        margin: 0;
    }

    .p-confirm-popup:after {
        border: solid transparent;
        border-color: rgba(255, 255, 255, 0);
        border-bottom-color: #ffffff;
    }

    .p-confirm-popup:before {
        border: solid transparent;
        border-color: rgba(0, 0, 0, 0);
        border-bottom-color: rgba(0, 0, 0, 0.2);
    }

    .p-confirm-popup.p-confirm-popup-flipped:after {
        border-top-color: #ffffff;
    }

    .p-confirm-popup.p-confirm-popup-flipped:before {
        border-top-color: rgba(0, 0, 0, 0.2);
    }

    .p-confirm-popup .p-confirm-popup-icon {
        font-size: 1.5rem;
    }

    .p-confirm-popup .p-confirm-popup-icon.p-icon {
        width: 1.5rem;
        height: 1.5rem;
    }

    .p-confirm-popup .p-confirm-popup-message {
        margin-left: 1rem;
    }

    .p-dialog {
        border-radius: 4px;
        box-shadow: none;
        border: 1px solid rgba(0, 0, 0, 0.2);
    }

    .p-dialog .p-dialog-header {
        border-bottom: 1px solid #e9ecef;
        background: #cf0000;
        color: #ffffff;
        padding: 1em;
        border-top-right-radius: 5px;
        border-top-left-radius: 5px;
        box-shadow: 0px 1px 8px -1px #dc3545;
    }

    .p-dialog .p-dialog-header .p-dialog-title {
        font-weight: 400;
        font-size: 15px;
    }

    .p-dialog .p-dialog-header .p-dialog-header-icon {
        width: 2rem;
        height: 2rem;
        color: #ffffff;
        border: 0 none;
        background: transparent;
        border-radius: 50%;
        transition: box-shadow 0.15s;
        margin-right: 0.5rem;
    }

    .p-dialog .p-dialog-header .p-dialog-header-icon:enabled:hover {
        color: #495057;
        border-color: transparent;
        background: transparent;
    }

    .p-dialog .p-dialog-header .p-dialog-header-icon:focus-visible {
        outline: 0 none;
        outline-offset: 0;
        box-shadow: 0 0 0 0.2rem #e4717c;
    }

    .p-dialog .p-dialog-header .p-dialog-header-icon:last-child {
        margin-right: 0;
    }

    .p-dialog .p-dialog-content {
        background: #ffffff;
        color: #212529;
        padding: 1rem;
    }

    .p-dialog .p-dialog-content:last-of-type {
        border-bottom-right-radius: 4px;
        border-bottom-left-radius: 4px;
    }

    .p-dialog .p-dialog-footer {
        border-top: 1px solid #e9ecef;
        background: #ffffff;
        color: #212529;
        padding: 1em;
        text-align: right;
        border-bottom-right-radius: 5px;
        border-bottom-left-radius: 5px;
    }

    .p-dialog .p-dialog-footer button {
        margin: 0 0.5rem 0 0;
        width: auto;
    }

    .p-dialog.p-dialog-maximized .p-dialog-header,
    .p-dialog.p-dialog-maximized .p-dialog-content:last-of-type {
        border-radius: 0;
    }

    .p-dialog.p-confirm-dialog .p-confirm-dialog-icon {
        font-size: 2rem;
    }

    .p-dialog.p-confirm-dialog .p-confirm-dialog-icon.p-icon {
        width: 2rem;
        height: 2rem;
    }

    .p-dialog.p-confirm-dialog .p-confirm-dialog-message {
        margin-left: 1rem;
    }

    .p-overlaypanel {
        background: #ffffff;
        color: #212529;
        border: 1px solid rgba(0, 0, 0, 0.2);
        border-radius: 5px;
        box-shadow: 0px 0px 8px 1px #c7c9cb;
    }

    .p-overlaypanel .p-overlaypanel-content {
        padding: 1.25rem;
    }

    .p-overlaypanel .p-overlaypanel-close {
        background: #007bff;
        color: #ffffff;
        width: 2rem;
        height: 2rem;
        transition: box-shadow 0.15s;
        border-radius: 50%;
        position: absolute;
        top: -1rem;
        right: -1rem;
    }

    .p-overlaypanel .p-overlaypanel-close:enabled:hover {
        background: #0069d9;
        color: #ffffff;
    }

    .p-overlaypanel:after {
        border: solid transparent;
        border-color: rgba(255, 255, 255, 0);
        border-bottom-color: #ffffff;
    }

    .p-overlaypanel:before {
        border: solid transparent;
        border-color: rgba(0, 0, 0, 0);
        border-bottom-color: rgba(0, 0, 0, 0.2);
    }

    .p-overlaypanel.p-overlaypanel-flipped:after {
        border-top-color: #ffffff;
    }

    .p-overlaypanel.p-overlaypanel-flipped:before {
        border-top-color: rgba(0, 0, 0, 0.2);
    }

    .p-sidebar {
        background: #efefef;
        color: #212529;
        border: 1px solid rgba(0, 0, 0, 0.2);
        box-shadow: none;
    }

    .p-sidebar .p-sidebar-header {
        padding: 1rem 1.25rem;
    }

    .p-sidebar .p-sidebar-header .p-sidebar-close,
    .p-sidebar .p-sidebar-header .p-sidebar-icon {
        width: 2rem;
        height: 2rem;
        color: #6c757d;
        border: 0 none;
        background: transparent;
        border-radius: 50%;
        transition: box-shadow 0.15s;
    }

    .p-sidebar .p-sidebar-header .p-sidebar-close:enabled:hover,
    .p-sidebar .p-sidebar-header .p-sidebar-icon:enabled:hover {
        color: #495057;
        border-color: transparent;
        background: transparent;
    }

    .p-sidebar .p-sidebar-header .p-sidebar-close:focus-visible,
    .p-sidebar .p-sidebar-header .p-sidebar-icon:focus-visible {
        outline: 0 none;
        outline-offset: 0;
        box-shadow: 0 0 0 0.2rem #e4717c;
    }

    .p-sidebar .p-sidebar-header+.p-sidebar-content {
        padding-top: 0;
    }

    .p-sidebar .p-sidebar-content {
        padding: 1.25rem;
    }

    .p-tooltip .p-tooltip-text {
        background: #eb4152;
        color: #efefef;
        /* background: #212529;
        color: #ffffff; */
        padding: 0.5rem 0.75rem;
        box-shadow: 0px 1px 8px -1px #dc3545;
        border-radius: 5px;
    }

    .p-tooltip.p-tooltip-right .p-tooltip-arrow {
        border-right-color: #eb4152;
    }

    .p-tooltip.p-tooltip-left .p-tooltip-arrow {
        border-left-color: #eb4152;
    }

    .p-tooltip.p-tooltip-top .p-tooltip-arrow {
        border-top-color: #eb4152;
    }

    .p-tooltip.p-tooltip-bottom .p-tooltip-arrow {
        border-bottom-color: #eb4152;
    }

    .p-fileupload .p-fileupload-buttonbar {
        background: #efefef;
        padding: 1rem 1.25rem;
        border: 1px solid #dee2e6;
        color: #212529;
        border-bottom: 0 none;
        border-top-right-radius: 4px;
        border-top-left-radius: 4px;
        gap: 0.5rem;
    }

    .p-fileupload .p-fileupload-buttonbar .p-button {
        margin-right: 0.5rem;
    }

    .p-fileupload .p-fileupload-content {
        background: #ffffff;
        /* padding: 2rem 1rem; */
        height: 80px;
        border: 1px solid #dee2e6;
        color: #212529;
        border-bottom-right-radius: 4px;
        border-bottom-left-radius: 4px;
    }

    .p-fileupload .p-progressbar {
        display: none;
        height: 0.25rem;
    }

    .p-fileupload .p-fileupload-row>div {
        padding: 1rem 1rem;
    }

    .p-fileupload.p-fileupload-advanced .p-message {
        margin-top: 0;
    }

    .p-breadcrumb {
        background: #efefef;
        border: 0 none;
        border-radius: 4px;
        padding: 0.5rem;
    }

    .p-breadcrumb .p-breadcrumb-list li .p-menuitem-link {
        transition: box-shadow 0.15s;
        border-radius: 4px;
    }

    .p-breadcrumb .p-breadcrumb-list li .p-menuitem-link:focus-visible {
        outline: 0 none;
        outline-offset: 0;
        box-shadow: 0 0 0 0.2rem rgba(38, 143, 255, 0.5);
    }

    .p-breadcrumb .p-breadcrumb-list li .p-menuitem-link .p-menuitem-text {
        color: #007bff;
    }

    .p-breadcrumb .p-breadcrumb-list li .p-menuitem-link .p-menuitem-icon {
        color: #787a7d;
    }

    .p-breadcrumb .p-breadcrumb-list li.p-menuitem-separator {
        margin: 0 0.5rem 0 0.5rem;
        color: #6c757d;
    }

    .p-breadcrumb .p-breadcrumb-list li:last-child .p-menuitem-text {
        color: #6c757d;
    }

    .p-breadcrumb .p-breadcrumb-list li:last-child .p-menuitem-icon {
        color: #6c757d;
    }

    .p-contextmenu {
        padding: 0.5rem 0;
        background: #ffffff;
        color: #212529;
        border: 1px solid rgba(0, 0, 0, 0.15);
        box-shadow: none;
        border-radius: 4px;
        width: 12.5rem;
    }

    .p-contextmenu .p-contextmenu-root-list {
        outline: 0 none;
    }

    .p-contextmenu .p-submenu-list {
        padding: 0.5rem 0;
        background: #ffffff;
        border: 1px solid rgba(0, 0, 0, 0.15);
        box-shadow: none;
        border-radius: 4px;
    }

    .p-contextmenu .p-menuitem>.p-menuitem-content {
        color: #212529;
        transition: box-shadow 0.15s;
        border-radius: 0;
    }

    .p-contextmenu .p-menuitem>.p-menuitem-content .p-menuitem-link {
        color: #212529;
        padding: 0.75rem 1rem;
        -webkit-user-select: none;
                user-select: none;
    }

    .p-contextmenu .p-menuitem>.p-menuitem-content .p-menuitem-link .p-menuitem-text {
        color: #212529;
    }

    .p-contextmenu .p-menuitem>.p-menuitem-content .p-menuitem-link .p-menuitem-icon {
        color: #212529;
        margin-right: 0.5rem;
    }

    .p-contextmenu .p-menuitem>.p-menuitem-content .p-menuitem-link .p-submenu-icon {
        color: #212529;
    }

    .p-contextmenu .p-menuitem.p-highlight>.p-menuitem-content {
        color: #212529;
        background: #e9ecef;
    }

    .p-contextmenu .p-menuitem.p-highlight>.p-menuitem-content .p-menuitem-link .p-menuitem-text {
        color: #212529;
    }

    .p-contextmenu .p-menuitem.p-highlight>.p-menuitem-content .p-menuitem-link .p-menuitem-icon,
    .p-contextmenu .p-menuitem.p-highlight>.p-menuitem-content .p-menuitem-link .p-submenu-icon {
        color: #212529;
    }

    .p-contextmenu .p-menuitem.p-highlight.p-focus>.p-menuitem-content {
        background: #e9ecef;
    }

    .p-contextmenu .p-menuitem:not(.p-highlight):not(.p-disabled).p-focus>.p-menuitem-content {
        color: #212529;
        background: #dee2e6;
    }

    .p-contextmenu .p-menuitem:not(.p-highlight):not(.p-disabled).p-focus>.p-menuitem-content .p-menuitem-link .p-menuitem-text {
        color: #212529;
    }

    .p-contextmenu .p-menuitem:not(.p-highlight):not(.p-disabled).p-focus>.p-menuitem-content .p-menuitem-link .p-menuitem-icon,
    .p-contextmenu .p-menuitem:not(.p-highlight):not(.p-disabled).p-focus>.p-menuitem-content .p-menuitem-link .p-submenu-icon {
        color: #212529;
    }

    .p-contextmenu .p-menuitem:not(.p-highlight):not(.p-disabled)>.p-menuitem-content:hover {
        color: #212529;
        background: #e9ecef;
    }

    .p-contextmenu .p-menuitem:not(.p-highlight):not(.p-disabled)>.p-menuitem-content:hover .p-menuitem-link .p-menuitem-text {
        color: #212529;
    }

    .p-contextmenu .p-menuitem:not(.p-highlight):not(.p-disabled)>.p-menuitem-content:hover .p-menuitem-link .p-menuitem-icon,
    .p-contextmenu .p-menuitem:not(.p-highlight):not(.p-disabled)>.p-menuitem-content:hover .p-menuitem-link .p-submenu-icon {
        color: #212529;
    }

    .p-contextmenu .p-menuitem-separator {
        border-top: 1px solid #dee2e6;
        margin: 0.5rem 0;
    }

    .p-contextmenu .p-submenu-icon {
        font-size: 0.875rem;
    }

    .p-contextmenu .p-submenu-icon.p-icon {
        width: 0.875rem;
        height: 0.875rem;
    }

    .p-dock .p-dock-list-container {
        background: rgba(255, 255, 255, 0.1);
        border: 1px solid rgba(255, 255, 255, 0.2);
        padding: 0.5rem 0.5rem;
        border-radius: 0.5rem;
    }

    .p-dock .p-dock-list-container .p-dock-list {
        outline: 0 none;
    }

    .p-dock .p-dock-item {
        padding: 0.5rem;
        border-radius: 4px;
    }

    .p-dock .p-dock-item.p-focus {
        outline: 0 none;
        outline-offset: 0;
        box-shadow: inset 0 0 0 0.15rem rgba(38, 143, 255, 0.5);
    }

    .p-dock .p-dock-action {
        width: 4rem;
        height: 4rem;
    }

    .p-dock.p-dock-top .p-dock-item-second-prev,
    .p-dock.p-dock-top .p-dock-item-second-next,
    .p-dock.p-dock-bottom .p-dock-item-second-prev,
    .p-dock.p-dock-bottom .p-dock-item-second-next {
        margin: 0 0.9rem;
    }

    .p-dock.p-dock-top .p-dock-item-prev,
    .p-dock.p-dock-top .p-dock-item-next,
    .p-dock.p-dock-bottom .p-dock-item-prev,
    .p-dock.p-dock-bottom .p-dock-item-next {
        margin: 0 1.3rem;
    }

    .p-dock.p-dock-top .p-dock-item-current,
    .p-dock.p-dock-bottom .p-dock-item-current {
        margin: 0 1.5rem;
    }

    .p-dock.p-dock-left .p-dock-item-second-prev,
    .p-dock.p-dock-left .p-dock-item-second-next,
    .p-dock.p-dock-right .p-dock-item-second-prev,
    .p-dock.p-dock-right .p-dock-item-second-next {
        margin: 0.9rem 0;
    }

    .p-dock.p-dock-left .p-dock-item-prev,
    .p-dock.p-dock-left .p-dock-item-next,
    .p-dock.p-dock-right .p-dock-item-prev,
    .p-dock.p-dock-right .p-dock-item-next {
        margin: 1.3rem 0;
    }

    .p-dock.p-dock-left .p-dock-item-current,
    .p-dock.p-dock-right .p-dock-item-current {
        margin: 1.5rem 0;
    }

    .p-dock.p-dock-mobile.p-dock-top .p-dock-list-container,
    .p-dock.p-dock-mobile.p-dock-bottom .p-dock-list-container {
        overflow-x: auto;
        width: 100%;
    }

    .p-dock.p-dock-mobile.p-dock-top .p-dock-list-container .p-dock-list,
    .p-dock.p-dock-mobile.p-dock-bottom .p-dock-list-container .p-dock-list {
        margin: 0 auto;
    }

    .p-dock.p-dock-mobile.p-dock-left .p-dock-list-container,
    .p-dock.p-dock-mobile.p-dock-right .p-dock-list-container {
        overflow-y: auto;
        height: 100%;
    }

    .p-dock.p-dock-mobile.p-dock-left .p-dock-list-container .p-dock-list,
    .p-dock.p-dock-mobile.p-dock-right .p-dock-list-container .p-dock-list {
        margin: auto 0;
    }

    .p-dock.p-dock-mobile .p-dock-list .p-dock-item {
        transform: none;
        margin: 0;
    }

    .p-dock.p-dock-mobile.p-dock-magnification.p-dock-top .p-dock-item-second-prev,
    .p-dock.p-dock-mobile.p-dock-magnification.p-dock-top .p-dock-item-second-next,
    .p-dock.p-dock-mobile.p-dock-magnification.p-dock-top .p-dock-item-prev,
    .p-dock.p-dock-mobile.p-dock-magnification.p-dock-top .p-dock-item-next,
    .p-dock.p-dock-mobile.p-dock-magnification.p-dock-top .p-dock-item-current,
    .p-dock.p-dock-mobile.p-dock-magnification.p-dock-bottom .p-dock-item-second-prev,
    .p-dock.p-dock-mobile.p-dock-magnification.p-dock-bottom .p-dock-item-second-next,
    .p-dock.p-dock-mobile.p-dock-magnification.p-dock-bottom .p-dock-item-prev,
    .p-dock.p-dock-mobile.p-dock-magnification.p-dock-bottom .p-dock-item-next,
    .p-dock.p-dock-mobile.p-dock-magnification.p-dock-bottom .p-dock-item-current,
    .p-dock.p-dock-mobile.p-dock-magnification.p-dock-left .p-dock-item-second-prev,
    .p-dock.p-dock-mobile.p-dock-magnification.p-dock-left .p-dock-item-second-next,
    .p-dock.p-dock-mobile.p-dock-magnification.p-dock-left .p-dock-item-prev,
    .p-dock.p-dock-mobile.p-dock-magnification.p-dock-left .p-dock-item-next,
    .p-dock.p-dock-mobile.p-dock-magnification.p-dock-left .p-dock-item-current,
    .p-dock.p-dock-mobile.p-dock-magnification.p-dock-right .p-dock-item-second-prev,
    .p-dock.p-dock-mobile.p-dock-magnification.p-dock-right .p-dock-item-second-next,
    .p-dock.p-dock-mobile.p-dock-magnification.p-dock-right .p-dock-item-prev,
    .p-dock.p-dock-mobile.p-dock-magnification.p-dock-right .p-dock-item-next,
    .p-dock.p-dock-mobile.p-dock-magnification.p-dock-right .p-dock-item-current {
        transform: none;
        margin: 0;
    }

    .p-megamenu {
        padding: 0.5rem 1rem;
        background: #efefef;
        color: rgba(0, 0, 0, 0.9);
        border: 0 none;
        border-radius: 4px;
    }

    .p-megamenu .p-megamenu-root-list {
        outline: 0 none;
    }

    .p-megamenu .p-menuitem>.p-menuitem-content {
        color: #212529;
        transition: box-shadow 0.15s;
        border-radius: 0;
    }

    .p-megamenu .p-menuitem>.p-menuitem-content .p-menuitem-link {
        color: #212529;
        padding: 0.75rem 1rem;
        -webkit-user-select: none;
                user-select: none;
    }

    .p-megamenu .p-menuitem>.p-menuitem-content .p-menuitem-link .p-menuitem-text {
        color: #212529;
    }

    .p-megamenu .p-menuitem>.p-menuitem-content .p-menuitem-link .p-menuitem-icon {
        color: #212529;
        margin-right: 0.5rem;
    }

    .p-megamenu .p-menuitem>.p-menuitem-content .p-menuitem-link .p-submenu-icon {
        color: #212529;
    }

    .p-megamenu .p-menuitem.p-highlight>.p-menuitem-content {
        color: #212529;
        background: #e9ecef;
    }

    .p-megamenu .p-menuitem.p-highlight>.p-menuitem-content .p-menuitem-link .p-menuitem-text {
        color: #212529;
    }

    .p-megamenu .p-menuitem.p-highlight>.p-menuitem-content .p-menuitem-link .p-menuitem-icon,
    .p-megamenu .p-menuitem.p-highlight>.p-menuitem-content .p-menuitem-link .p-submenu-icon {
        color: #212529;
    }

    .p-megamenu .p-menuitem.p-highlight.p-focus>.p-menuitem-content {
        background: #e9ecef;
    }

    .p-megamenu .p-menuitem:not(.p-highlight):not(.p-disabled).p-focus>.p-menuitem-content {
        color: #212529;
        background: #dee2e6;
    }

    .p-megamenu .p-menuitem:not(.p-highlight):not(.p-disabled).p-focus>.p-menuitem-content .p-menuitem-link .p-menuitem-text {
        color: #212529;
    }

    .p-megamenu .p-menuitem:not(.p-highlight):not(.p-disabled).p-focus>.p-menuitem-content .p-menuitem-link .p-menuitem-icon,
    .p-megamenu .p-menuitem:not(.p-highlight):not(.p-disabled).p-focus>.p-menuitem-content .p-menuitem-link .p-submenu-icon {
        color: #212529;
    }

    .p-megamenu .p-menuitem:not(.p-highlight):not(.p-disabled)>.p-menuitem-content:hover {
        color: #212529;
        background: #e9ecef;
    }

    .p-megamenu .p-menuitem:not(.p-highlight):not(.p-disabled)>.p-menuitem-content:hover .p-menuitem-link .p-menuitem-text {
        color: #212529;
    }

    .p-megamenu .p-menuitem:not(.p-highlight):not(.p-disabled)>.p-menuitem-content:hover .p-menuitem-link .p-menuitem-icon,
    .p-megamenu .p-menuitem:not(.p-highlight):not(.p-disabled)>.p-menuitem-content:hover .p-menuitem-link .p-submenu-icon {
        color: #212529;
    }

    .p-megamenu .p-megamenu-panel {
        background: #ffffff;
        color: #212529;
        border: 1px solid rgba(0, 0, 0, 0.15);
        box-shadow: none;
    }

    .p-megamenu .p-submenu-header {
        margin: 0;
        padding: 0.75rem 1rem;
        color: #212529;
        background: #ffffff;
        font-weight: 600;
        border-top-right-radius: 4px;
        border-top-left-radius: 4px;
    }

    .p-megamenu .p-submenu-list {
        padding: 0.5rem 0;
        width: 12.5rem;
    }

    .p-megamenu .p-submenu-list .p-menuitem-separator {
        border-top: 1px solid #dee2e6;
        margin: 0.5rem 0;
    }

    .p-megamenu.p-megamenu-vertical {
        width: 12.5rem;
        padding: 0.5rem 0;
    }

    .p-megamenu .p-megamenu-button {
        width: 2rem;
        height: 2rem;
        color: rgba(0, 0, 0, 0.5);
        border-radius: 50%;
        transition: box-shadow 0.15s;
    }

    .p-megamenu .p-megamenu-button:hover {
        color: rgba(0, 0, 0, 0.7);
        background: transparent;
    }

    .p-megamenu .p-megamenu-button:focus {
        outline: 0 none;
        outline-offset: 0;
        box-shadow: 0 0 0 0.2rem rgba(38, 143, 255, 0.5);
    }

    .p-megamenu.p-megamenu-horizontal .p-megamenu-root-list>.p-menuitem>.p-menuitem-content {
        color: rgba(0, 0, 0, 0.5);
        transition: box-shadow 0.15s;
        border-radius: 4px;
    }

    .p-megamenu.p-megamenu-horizontal .p-megamenu-root-list>.p-menuitem>.p-menuitem-content .p-menuitem-link {
        padding: 1rem;
        -webkit-user-select: none;
                user-select: none;
    }

    .p-megamenu.p-megamenu-horizontal .p-megamenu-root-list>.p-menuitem>.p-menuitem-content .p-menuitem-link .p-menuitem-text {
        color: rgba(0, 0, 0, 0.5);
    }

    .p-megamenu.p-megamenu-horizontal .p-megamenu-root-list>.p-menuitem>.p-menuitem-content .p-menuitem-link .p-menuitem-icon {
        color: rgba(0, 0, 0, 0.5);
        margin-right: 0.5rem;
    }

    .p-megamenu.p-megamenu-horizontal .p-megamenu-root-list>.p-menuitem>.p-menuitem-content .p-menuitem-link .p-submenu-icon {
        color: rgba(0, 0, 0, 0.5);
        margin-left: 0.5rem;
    }

    .p-megamenu.p-megamenu-horizontal .p-megamenu-root-list>.p-menuitem:not(.p-highlight):not(.p-disabled)>.p-menuitem-content:hover {
        color: rgba(0, 0, 0, 0.7);
        background: transparent;
    }

    .p-megamenu.p-megamenu-horizontal .p-megamenu-root-list>.p-menuitem:not(.p-highlight):not(.p-disabled)>.p-menuitem-content:hover .p-menuitem-link .p-menuitem-text {
        color: rgba(0, 0, 0, 0.7);
    }

    .p-megamenu.p-megamenu-horizontal .p-megamenu-root-list>.p-menuitem:not(.p-highlight):not(.p-disabled)>.p-menuitem-content:hover .p-menuitem-link .p-menuitem-icon,
    .p-megamenu.p-megamenu-horizontal .p-megamenu-root-list>.p-menuitem:not(.p-highlight):not(.p-disabled)>.p-menuitem-content:hover .p-menuitem-link .p-submenu-icon {
        color: rgba(0, 0, 0, 0.7);
    }

    .p-megamenu.p-megamenu-mobile-active .p-megamenu-root-list {
        padding: 0.5rem 0;
        background: #ffffff;
        border: 1px solid rgba(0, 0, 0, 0.15);
        box-shadow: none;
    }

    .p-megamenu.p-megamenu-mobile-active .p-megamenu-root-list .p-menu-separator {
        border-top: 1px solid #dee2e6;
        margin: 0.5rem 0;
    }

    .p-megamenu.p-megamenu-mobile-active .p-megamenu-root-list .p-submenu-icon {
        font-size: 0.875rem;
    }

    .p-megamenu.p-megamenu-mobile-active .p-megamenu-root-list .p-submenu-icon.p-icon {
        width: 0.875rem;
        height: 0.875rem;
    }

    .p-megamenu.p-megamenu-mobile-active .p-megamenu-root-list>.p-menuitem {
        width: 100%;
        position: static;
    }

    .p-megamenu.p-megamenu-mobile-active .p-megamenu-root-list>.p-menuitem>.p-menuitem-link>.p-menuitem-content {
        color: #212529;
        transition: box-shadow 0.15s;
        border-radius: 0;
    }

    .p-megamenu.p-megamenu-mobile-active .p-megamenu-root-list>.p-menuitem>.p-menuitem-link>.p-menuitem-content .p-menuitem-link {
        color: #212529;
        padding: 0.75rem 1rem;
        -webkit-user-select: none;
                user-select: none;
    }

    .p-megamenu.p-megamenu-mobile-active .p-megamenu-root-list>.p-menuitem>.p-menuitem-link>.p-menuitem-content .p-menuitem-link .p-menuitem-text {
        color: #212529;
    }

    .p-megamenu.p-megamenu-mobile-active .p-megamenu-root-list>.p-menuitem>.p-menuitem-link>.p-menuitem-content .p-menuitem-link .p-menuitem-icon {
        color: #212529;
        margin-right: 0.5rem;
    }

    .p-megamenu.p-megamenu-mobile-active .p-megamenu-root-list>.p-menuitem>.p-menuitem-link>.p-menuitem-content .p-menuitem-link .p-submenu-icon {
        color: #212529;
    }

    .p-megamenu.p-megamenu-mobile-active .p-megamenu-root-list>.p-menuitem>.p-menuitem-link.p-highlight>.p-menuitem-content {
        color: #212529;
        background: #e9ecef;
    }

    .p-megamenu.p-megamenu-mobile-active .p-megamenu-root-list>.p-menuitem>.p-menuitem-link.p-highlight>.p-menuitem-content .p-menuitem-link .p-menuitem-text {
        color: #212529;
    }

    .p-megamenu.p-megamenu-mobile-active .p-megamenu-root-list>.p-menuitem>.p-menuitem-link.p-highlight>.p-menuitem-content .p-menuitem-link .p-menuitem-icon,
    .p-megamenu.p-megamenu-mobile-active .p-megamenu-root-list>.p-menuitem>.p-menuitem-link.p-highlight>.p-menuitem-content .p-menuitem-link .p-submenu-icon {
        color: #212529;
    }

    .p-megamenu.p-megamenu-mobile-active .p-megamenu-root-list>.p-menuitem>.p-menuitem-link.p-highlight.p-focus>.p-menuitem-content {
        background: #e9ecef;
    }

    .p-megamenu.p-megamenu-mobile-active .p-megamenu-root-list>.p-menuitem>.p-menuitem-link:not(.p-highlight):not(.p-disabled).p-focus>.p-menuitem-content {
        color: #212529;
        background: #dee2e6;
    }

    .p-megamenu.p-megamenu-mobile-active .p-megamenu-root-list>.p-menuitem>.p-menuitem-link:not(.p-highlight):not(.p-disabled).p-focus>.p-menuitem-content .p-menuitem-link .p-menuitem-text {
        color: #212529;
    }

    .p-megamenu.p-megamenu-mobile-active .p-megamenu-root-list>.p-menuitem>.p-menuitem-link:not(.p-highlight):not(.p-disabled).p-focus>.p-menuitem-content .p-menuitem-link .p-menuitem-icon,
    .p-megamenu.p-megamenu-mobile-active .p-megamenu-root-list>.p-menuitem>.p-menuitem-link:not(.p-highlight):not(.p-disabled).p-focus>.p-menuitem-content .p-menuitem-link .p-submenu-icon {
        color: #212529;
    }

    .p-megamenu.p-megamenu-mobile-active .p-megamenu-root-list>.p-menuitem>.p-menuitem-link:not(.p-highlight):not(.p-disabled)>.p-menuitem-content:hover {
        color: #212529;
        background: #e9ecef;
    }

    .p-megamenu.p-megamenu-mobile-active .p-megamenu-root-list>.p-menuitem>.p-menuitem-link:not(.p-highlight):not(.p-disabled)>.p-menuitem-content:hover .p-menuitem-link .p-menuitem-text {
        color: #212529;
    }

    .p-megamenu.p-megamenu-mobile-active .p-megamenu-root-list>.p-menuitem>.p-menuitem-link:not(.p-highlight):not(.p-disabled)>.p-menuitem-content:hover .p-menuitem-link .p-menuitem-icon,
    .p-megamenu.p-megamenu-mobile-active .p-megamenu-root-list>.p-menuitem>.p-menuitem-link:not(.p-highlight):not(.p-disabled)>.p-menuitem-content:hover .p-menuitem-link .p-submenu-icon {
        color: #212529;
    }

    .p-megamenu.p-megamenu-mobile-active .p-megamenu-root-list>.p-menuitem>.p-menuitem-link>.p-submenu-icon {
        margin-left: auto;
    }

    .p-megamenu.p-megamenu-mobile-active .p-megamenu-root-list>.p-menuitem.p-menuitem-active>.p-menuitem-link>.p-submenu-icon {
        transform: rotate(-180deg);
    }

    .p-megamenu.p-megamenu-mobile-active .p-megamenu-root-list .p-submenu-list {
        width: 100%;
        position: static;
        box-shadow: none;
        border: 0 none;
    }

    .p-megamenu.p-megamenu-mobile-active .p-megamenu-root-list .p-submenu-list .p-submenu-icon {
        transition: transform 0.15s;
        transform: rotate(90deg);
    }

    .p-megamenu.p-megamenu-mobile-active .p-megamenu-root-list .p-submenu-list .p-menuitem-active>.p-menuitem-link>.p-submenu-icon {
        transform: rotate(-90deg);
    }

    .p-megamenu.p-megamenu-mobile-active .p-megamenu-root-list .p-menuitem {
        width: 100%;
        position: static;
    }

    .p-menu {
        padding: 0.5rem 0;
        background: #efefef;
        color: #212529;
        border: 1px solid #efefef;
        border-radius: 4px;
        width: 12.5rem;
    }

    .p-menu .p-menuitem>.p-menuitem-content {
        color: #212529;
        transition: box-shadow 0.15s;
        border-radius: 0;
    }

    .p-menu .p-menuitem>.p-menuitem-content .p-menuitem-link {
        color: #212529;
        padding: 0.75rem 1rem;
        -webkit-user-select: none;
                user-select: none;
    }

    .p-menu .p-menuitem>.p-menuitem-content .p-menuitem-link .p-menuitem-text {
        color: #212529;
    }

    .p-menu .p-menuitem>.p-menuitem-content .p-menuitem-link .p-menuitem-icon {
        color: #212529;
        margin-right: 0.5rem;
    }

    .p-menu .p-menuitem>.p-menuitem-content .p-menuitem-link .p-submenu-icon {
        color: #212529;
    }

    .p-menu .p-menuitem.p-highlight>.p-menuitem-content {
        color: #212529;
        background: #e9ecef;
    }

    .p-menu .p-menuitem.p-highlight>.p-menuitem-content .p-menuitem-link .p-menuitem-text {
        color: #212529;
    }

    .p-menu .p-menuitem.p-highlight>.p-menuitem-content .p-menuitem-link .p-menuitem-icon,
    .p-menu .p-menuitem.p-highlight>.p-menuitem-content .p-menuitem-link .p-submenu-icon {
        color: #212529;
    }

    .p-menu .p-menuitem.p-highlight.p-focus>.p-menuitem-content {
        background: #e9ecef;
    }

    .p-menu .p-menuitem:not(.p-highlight):not(.p-disabled).p-focus>.p-menuitem-content {
        color: #212529;
        background: #dee2e6;
    }

    .p-menu .p-menuitem:not(.p-highlight):not(.p-disabled).p-focus>.p-menuitem-content .p-menuitem-link .p-menuitem-text {
        color: #212529;
    }

    .p-menu .p-menuitem:not(.p-highlight):not(.p-disabled).p-focus>.p-menuitem-content .p-menuitem-link .p-menuitem-icon,
    .p-menu .p-menuitem:not(.p-highlight):not(.p-disabled).p-focus>.p-menuitem-content .p-menuitem-link .p-submenu-icon {
        color: #212529;
    }

    /* .p-menu .p-menuitem:not(.p-highlight):not(.p-disabled)>.p-menuitem-content:hover {
        color: #212529;
        background: #e9ecef;
    } */
    .p-menu .p-menuitem:not(.p-highlight):not(.p-disabled)>.p-menuitem-content:hover {
        color: #212529;
        background: #efefef;
        box-shadow: 0px 3px 0px -1px #cf0000;
    }

    .p-menu .p-menuitem:not(.p-highlight):not(.p-disabled)>.p-menuitem-content:hover .p-menuitem-link .p-menuitem-text {
        color: #212529;
    }

    .p-menu .p-menuitem:not(.p-highlight):not(.p-disabled)>.p-menuitem-content:hover .p-menuitem-link .p-menuitem-icon,
    .p-menu .p-menuitem:not(.p-highlight):not(.p-disabled)>.p-menuitem-content:hover .p-menuitem-link .p-submenu-icon {
        color: #212529;
    }

    .p-menu.p-menu-overlay {
        background: #ffffff;
        border: 1px solid rgba(0, 0, 0, 0.15);
        box-shadow: none;
    }

    .p-menu .p-submenu-header {
        margin: 0;
        padding: 0.75rem 1rem;
        color: #212529;
        background: #ffffff;
        font-weight: 600;
        border-top-right-radius: 0;
        border-top-left-radius: 0;
    }

    .p-menu .p-menu-separator {
        border-top: 1px solid #dee2e6;
        margin: 0.5rem 0;
    }

    .p-menubar {
        padding: 0.5rem 1rem;
        background: #efefef;
        color: rgba(0, 0, 0, 0.9);
        border: 0 none;
        border-radius: 0px;
    }

    .p-menubar .p-menubar-root-list {
        outline: 0 none;
    }

    .p-menubar .p-menubar-root-list>.p-menuitem>.p-menuitem-content {
        color: rgba(0, 0, 0, 0.5);
        transition: box-shadow 0.15s;
        border-radius: 4px;
    }

    .p-menubar .p-menubar-root-list>.p-menuitem>.p-menuitem-content .p-menuitem-link {
        padding: 1rem;
        -webkit-user-select: none;
                user-select: none;
    }

    .p-menubar .p-menubar-root-list>.p-menuitem>.p-menuitem-content .p-menuitem-link .p-menuitem-text {
        color: rgba(0, 0, 0, 0.5);
    }

    .p-menubar .p-menubar-root-list>.p-menuitem>.p-menuitem-content .p-menuitem-link .p-menuitem-icon {
        color: rgba(0, 0, 0, 0.5);
        margin-right: 0.5rem;
    }

    .p-menubar .p-menubar-root-list>.p-menuitem>.p-menuitem-content .p-menuitem-link .p-submenu-icon {
        color: rgba(0, 0, 0, 0.5);
        margin-left: 0.5rem;
    }

    .p-menubar .p-menubar-root-list>.p-menuitem:not(.p-highlight):not(.p-disabled)>.p-menuitem-content:hover {
        color: rgba(0, 0, 0, 0.7);
        background: transparent;
    }

    .p-menubar .p-menubar-root-list>.p-menuitem:not(.p-highlight):not(.p-disabled)>.p-menuitem-content:hover .p-menuitem-link .p-menuitem-text {
        color: rgba(0, 0, 0, 0.7);
    }

    .p-menubar .p-menubar-root-list>.p-menuitem:not(.p-highlight):not(.p-disabled)>.p-menuitem-content:hover .p-menuitem-link .p-menuitem-icon,
    .p-menubar .p-menubar-root-list>.p-menuitem:not(.p-highlight):not(.p-disabled)>.p-menuitem-content:hover .p-menuitem-link .p-submenu-icon {
        color: rgba(0, 0, 0, 0.7);
    }

    .p-menubar .p-menuitem>.p-menuitem-content {
        color: #212529;
        transition: box-shadow 0.15s;
        border-radius: 0;
    }

    .p-menubar .p-menuitem>.p-menuitem-content .p-menuitem-link {
        color: #212529;
        padding: 0.75rem 1rem;
        -webkit-user-select: none;
                user-select: none;
    }

    .p-menubar .p-menuitem>.p-menuitem-content .p-menuitem-link .p-menuitem-text {
        color: #212529;
    }

    .p-menubar .p-menuitem>.p-menuitem-content .p-menuitem-link .p-menuitem-icon {
        color: #212529;
        margin-right: 0.5rem;
    }

    .p-menubar .p-menuitem>.p-menuitem-content .p-menuitem-link .p-submenu-icon {
        color: #212529;
    }

    .p-menubar .p-menuitem.p-highlight>.p-menuitem-content {
        color: #212529;
        background: #e9ecef;
    }

    .p-menubar .p-menuitem.p-highlight>.p-menuitem-content .p-menuitem-link .p-menuitem-text {
        color: #212529;
    }

    .p-menubar .p-menuitem.p-highlight>.p-menuitem-content .p-menuitem-link .p-menuitem-icon,
    .p-menubar .p-menuitem.p-highlight>.p-menuitem-content .p-menuitem-link .p-submenu-icon {
        color: #212529;
    }

    .p-menubar .p-menuitem.p-highlight.p-focus>.p-menuitem-content {
        background: #e9ecef;
    }

    .p-menubar .p-menuitem:not(.p-highlight):not(.p-disabled).p-focus>.p-menuitem-content {
        color: #212529;
        background: #dee2e6;
    }

    .p-menubar .p-menuitem:not(.p-highlight):not(.p-disabled).p-focus>.p-menuitem-content .p-menuitem-link .p-menuitem-text {
        color: #212529;
    }

    .p-menubar .p-menuitem:not(.p-highlight):not(.p-disabled).p-focus>.p-menuitem-content .p-menuitem-link .p-menuitem-icon,
    .p-menubar .p-menuitem:not(.p-highlight):not(.p-disabled).p-focus>.p-menuitem-content .p-menuitem-link .p-submenu-icon {
        color: #212529;
    }

    .p-menubar .p-menuitem:not(.p-highlight):not(.p-disabled)>.p-menuitem-content:hover {
        color: #212529;
        background: #e9ecef;
    }

    .p-menubar .p-menuitem:not(.p-highlight):not(.p-disabled)>.p-menuitem-content:hover .p-menuitem-link .p-menuitem-text {
        color: #212529;
    }

    .p-menubar .p-menuitem:not(.p-highlight):not(.p-disabled)>.p-menuitem-content:hover .p-menuitem-link .p-menuitem-icon,
    .p-menubar .p-menuitem:not(.p-highlight):not(.p-disabled)>.p-menuitem-content:hover .p-menuitem-link .p-submenu-icon {
        color: #212529;
    }

    .p-menubar .p-submenu-list {
        padding: 0.5rem 0;
        background: #ffffff;
        border: 1px solid rgba(0, 0, 0, 0.15);
        box-shadow: none;
        width: 12.5rem;
    }

    .p-menubar .p-submenu-list .p-menuitem-separator {
        border-top: 1px solid #dee2e6;
        margin: 0.5rem 0;
    }

    .p-menubar .p-submenu-list .p-submenu-icon {
        font-size: 0.875rem;
    }

    .p-menubar.p-menubar-mobile .p-menubar-button {
        width: 2rem;
        height: 2rem;
        color: rgba(0, 0, 0, 0.5);
        border-radius: 50%;
        transition: box-shadow 0.15s;
    }

    .p-menubar.p-menubar-mobile .p-menubar-button:hover {
        color: rgba(0, 0, 0, 0.7);
        background: transparent;
    }

    .p-menubar.p-menubar-mobile .p-menubar-button:focus {
        outline: 0 none;
        outline-offset: 0;
        box-shadow: 0 0 0 0.2rem rgba(38, 143, 255, 0.5);
    }

    .p-menubar.p-menubar-mobile .p-menubar-root-list {
        padding: 0.5rem 0;
        background: #ffffff;
        border: 1px solid rgba(0, 0, 0, 0.15);
        box-shadow: none;
    }

    .p-menubar.p-menubar-mobile .p-menubar-root-list .p-menuitem-separator {
        border-top: 1px solid #dee2e6;
        margin: 0.5rem 0;
    }

    .p-menubar.p-menubar-mobile .p-menubar-root-list .p-submenu-icon {
        font-size: 0.875rem;
    }

    .p-menubar.p-menubar-mobile .p-menubar-root-list .p-menuitem .p-menuitem-content .p-menuitem-link .p-submenu-icon {
        margin-left: auto;
        transition: transform 0.15s;
    }

    .p-menubar.p-menubar-mobile .p-menubar-root-list .p-menuitem.p-menuitem-active>.p-menuitem-content>.p-menuitem-link>.p-submenu-icon {
        transform: rotate(-180deg);
    }

    .p-menubar.p-menubar-mobile .p-menubar-root-list .p-submenu-list .p-submenu-icon {
        transition: transform 0.15s;
        transform: rotate(90deg);
    }

    .p-menubar.p-menubar-mobile .p-menubar-root-list .p-submenu-list .p-menuitem-active>.p-menuitem-content>.p-menuitem-link>.p-submenu-icon {
        transform: rotate(-90deg);
    }

    .p-menubar.p-menubar-mobile .p-menubar-root-list ul li a {
        padding-left: 2.25rem;
    }

    .p-menubar.p-menubar-mobile .p-menubar-root-list ul li ul li a {
        padding-left: 3.75rem;
    }

    .p-menubar.p-menubar-mobile .p-menubar-root-list ul li ul li ul li a {
        padding-left: 5.25rem;
    }

    .p-menubar.p-menubar-mobile .p-menubar-root-list ul li ul li ul li ul li a {
        padding-left: 6.75rem;
    }

    .p-menubar.p-menubar-mobile .p-menubar-root-list ul li ul li ul li ul li ul li a {
        padding-left: 8.25rem;
    }

    @media screen and (max-width: 960px) {
        .p-menubar {
            position: relative;
        }

        /* //navebar button */
        .p-menubar .p-menubar-button {
            display: none;
            width: 2rem;
            height: 2rem;
            color: rgba(0, 0, 0, 0.5);
            border-radius: 50%;
            transition: box-shadow 0.15s;
        }

        .p-menubar .p-menubar-button:hover {
            color: rgba(0, 0, 0, 0.7);
            background: transparent;
        }

        .p-menubar .p-menubar-button:focus {
            outline: 0 none;
            outline-offset: 0;
            box-shadow: 0 0 0 0.2rem rgba(38, 143, 255, 0.5);
        }

        .p-menubar .p-menubar-root-list {
            position: absolute;
            display: none;
            padding: 0.5rem 0;
            background: #ffffff;
            border: 1px solid rgba(0, 0, 0, 0.15);
            box-shadow: none;
            width: 100%;
        }

        .p-menubar .p-menubar-root-list .p-menu-separator {
            border-top: 1px solid #dee2e6;
            margin: 0.5rem 0;
        }

        .p-menubar .p-menubar-root-list .p-submenu-icon {
            font-size: 0.875rem;
        }

        .p-menubar .p-menubar-root-list .p-submenu-icon.p-icon {
            width: 0.875rem;
            height: 0.875rem;
        }

        .p-menubar .p-menubar-root-list>.p-menuitem {
            width: 100%;
            position: static;
        }

        .p-menubar .p-menubar-root-list>.p-menuitem>.p-menuitem-link>.p-menuitem-content {
            color: #212529;
            transition: box-shadow 0.15s;
            border-radius: 0;
        }

        .p-menubar .p-menubar-root-list>.p-menuitem>.p-menuitem-link>.p-menuitem-content .p-menuitem-link {
            color: #212529;
            padding: 0.75rem 1rem;
            -webkit-user-select: none;
                    user-select: none;
        }

        .p-menubar .p-menubar-root-list>.p-menuitem>.p-menuitem-link>.p-menuitem-content .p-menuitem-link .p-menuitem-text {
            color: #212529;
        }

        .p-menubar .p-menubar-root-list>.p-menuitem>.p-menuitem-link>.p-menuitem-content .p-menuitem-link .p-menuitem-icon {
            color: #212529;
            margin-right: 0.5rem;
        }

        .p-menubar .p-menubar-root-list>.p-menuitem>.p-menuitem-link>.p-menuitem-content .p-menuitem-link .p-submenu-icon {
            color: #212529;
        }

        .p-menubar .p-menubar-root-list>.p-menuitem>.p-menuitem-link.p-highlight>.p-menuitem-content {
            color: #212529;
            background: #e9ecef;
        }

        .p-menubar .p-menubar-root-list>.p-menuitem>.p-menuitem-link.p-highlight>.p-menuitem-content .p-menuitem-link .p-menuitem-text {
            color: #212529;
        }

        .p-menubar .p-menubar-root-list>.p-menuitem>.p-menuitem-link.p-highlight>.p-menuitem-content .p-menuitem-link .p-menuitem-icon,
        .p-menubar .p-menubar-root-list>.p-menuitem>.p-menuitem-link.p-highlight>.p-menuitem-content .p-menuitem-link .p-submenu-icon {
            color: #212529;
        }

        .p-menubar .p-menubar-root-list>.p-menuitem>.p-menuitem-link.p-highlight.p-focus>.p-menuitem-content {
            background: #e9ecef;
        }

        .p-menubar .p-menubar-root-list>.p-menuitem>.p-menuitem-link:not(.p-highlight):not(.p-disabled).p-focus>.p-menuitem-content {
            color: #212529;
            background: #dee2e6;
        }

        .p-menubar .p-menubar-root-list>.p-menuitem>.p-menuitem-link:not(.p-highlight):not(.p-disabled).p-focus>.p-menuitem-content .p-menuitem-link .p-menuitem-text {
            color: #212529;
        }

        .p-menubar .p-menubar-root-list>.p-menuitem>.p-menuitem-link:not(.p-highlight):not(.p-disabled).p-focus>.p-menuitem-content .p-menuitem-link .p-menuitem-icon,
        .p-menubar .p-menubar-root-list>.p-menuitem>.p-menuitem-link:not(.p-highlight):not(.p-disabled).p-focus>.p-menuitem-content .p-menuitem-link .p-submenu-icon {
            color: #212529;
        }

        .p-menubar .p-menubar-root-list>.p-menuitem>.p-menuitem-link:not(.p-highlight):not(.p-disabled)>.p-menuitem-content:hover {
            color: #212529;
            background: #e9ecef;
        }

        .p-menubar .p-menubar-root-list>.p-menuitem>.p-menuitem-link:not(.p-highlight):not(.p-disabled)>.p-menuitem-content:hover .p-menuitem-link .p-menuitem-text {
            color: #212529;
        }

        .p-menubar .p-menubar-root-list>.p-menuitem>.p-menuitem-link:not(.p-highlight):not(.p-disabled)>.p-menuitem-content:hover .p-menuitem-link .p-menuitem-icon,
        .p-menubar .p-menubar-root-list>.p-menuitem>.p-menuitem-link:not(.p-highlight):not(.p-disabled)>.p-menuitem-content:hover .p-menuitem-link .p-submenu-icon {
            color: #212529;
        }

        .p-menubar .p-menubar-root-list>.p-menuitem>.p-menuitem-link>.p-submenu-icon {
            margin-left: auto;
            transition: transform 0.15s;
        }

        .p-menubar .p-menubar-root-list>.p-menuitem.p-menuitem-active>.p-menuitem-link>.p-submenu-icon {
            transform: rotate(-180deg);
        }

        .p-menubar .p-menubar-root-list .p-submenu-list {
            width: 100%;
            position: static;
            box-shadow: none;
            border: 0 none;
        }

        .p-menubar .p-menubar-root-list .p-submenu-list .p-submenu-icon {
            transition: transform 0.15s;
            transform: rotate(90deg);
        }

        .p-menubar .p-menubar-root-list .p-submenu-list .p-menuitem-active>.p-menuitem-link>.p-submenu-icon {
            transform: rotate(-90deg);
        }

        .p-menubar .p-menubar-root-list .p-menuitem {
            width: 100%;
            position: static;
        }

        .p-menubar .p-menubar-root-list ul li a {
            padding-left: 2.25rem;
        }

        .p-menubar .p-menubar-root-list ul li ul li a {
            padding-left: 3.75rem;
        }

        .p-menubar .p-menubar-root-list ul li ul li ul li a {
            padding-left: 5.25rem;
        }

        .p-menubar .p-menubar-root-list ul li ul li ul li ul li a {
            padding-left: 6.75rem;
        }

        .p-menubar .p-menubar-root-list ul li ul li ul li ul li ul li a {
            padding-left: 8.25rem;
        }

        .p-menubar.p-menubar-mobile-active .p-menubar-root-list {
            display: flex;
            flex-direction: column;
            top: 100%;
            left: 0;
            z-index: 1;
        }
    }

    .p-panelmenu .p-panelmenu-header {
        outline: 0 none;
    }

    .p-panelmenu .p-panelmenu-header .p-panelmenu-header-content {
        border: 1px solid #dee2e6;
        color: #212529;
        background: #efefef;
        border-radius: 4px;
        transition: box-shadow 0.15s;
    }

    .p-panelmenu .p-panelmenu-header .p-panelmenu-header-content .p-panelmenu-header-link {
        color: #212529;
        padding: 1rem 1.25rem;
        font-weight: 600;
    }

    .p-panelmenu .p-panelmenu-header .p-panelmenu-header-content .p-panelmenu-header-link .p-submenu-icon {
        margin-right: 0.5rem;
    }

    .p-panelmenu .p-panelmenu-header .p-panelmenu-header-content .p-panelmenu-header-link .p-menuitem-icon {
        margin-right: 0.5rem;
    }

    .p-panelmenu .p-panelmenu-header:not(.p-disabled):focus-visible .p-panelmenu-header-content {
        outline: 0 none;
        outline-offset: 0;
        box-shadow: inset 0 0 0 0.2rem rgba(38, 143, 255, 0.5);
    }

    .p-panelmenu .p-panelmenu-header:not(.p-highlight):not(.p-disabled):hover .p-panelmenu-header-content {
        background: #e9ecef;
        border-color: #dee2e6;
        color: #212529;
    }

    .p-panelmenu .p-panelmenu-header:not(.p-disabled).p-highlight .p-panelmenu-header-content {
        background: #efefef;
        border-color: #dee2e6;
        color: #212529;
        border-bottom-right-radius: 0;
        border-bottom-left-radius: 0;
        margin-bottom: 0;
    }

    .p-panelmenu .p-panelmenu-header:not(.p-disabled).p-highlight:hover .p-panelmenu-header-content {
        border-color: #dee2e6;
        background: #e9ecef;
        color: #212529;
    }

    .p-panelmenu .p-panelmenu-content {
        padding: 0.5rem 0;
        border: 1px solid #dee2e6;
        background: #ffffff;
        color: #212529;
        border-top: 0;
        border-top-right-radius: 0;
        border-top-left-radius: 0;
        border-bottom-right-radius: 4px;
        border-bottom-left-radius: 4px;
    }

    .p-panelmenu .p-panelmenu-content .p-panelmenu-root-list {
        outline: 0 none;
    }

    .p-panelmenu .p-panelmenu-content .p-menuitem>.p-menuitem-content {
        color: #212529;
        transition: box-shadow 0.15s;
        border-radius: 0;
    }

    .p-panelmenu .p-panelmenu-content .p-menuitem>.p-menuitem-content .p-menuitem-link {
        color: #212529;
        padding: 0.75rem 1rem;
        -webkit-user-select: none;
                user-select: none;
    }

    .p-panelmenu .p-panelmenu-content .p-menuitem>.p-menuitem-content .p-menuitem-link .p-menuitem-text {
        color: #212529;
    }

    .p-panelmenu .p-panelmenu-content .p-menuitem>.p-menuitem-content .p-menuitem-link .p-menuitem-icon {
        color: #212529;
        margin-right: 0.5rem;
    }

    .p-panelmenu .p-panelmenu-content .p-menuitem>.p-menuitem-content .p-menuitem-link .p-submenu-icon {
        color: #212529;
    }

    .p-panelmenu .p-panelmenu-content .p-menuitem.p-highlight>.p-menuitem-content {
        color: #212529;
        background: #e9ecef;
    }

    .p-panelmenu .p-panelmenu-content .p-menuitem.p-highlight>.p-menuitem-content .p-menuitem-link .p-menuitem-text {
        color: #212529;
    }

    .p-panelmenu .p-panelmenu-content .p-menuitem.p-highlight>.p-menuitem-content .p-menuitem-link .p-menuitem-icon,
    .p-panelmenu .p-panelmenu-content .p-menuitem.p-highlight>.p-menuitem-content .p-menuitem-link .p-submenu-icon {
        color: #212529;
    }

    .p-panelmenu .p-panelmenu-content .p-menuitem.p-highlight.p-focus>.p-menuitem-content {
        background: #e9ecef;
    }

    .p-panelmenu .p-panelmenu-content .p-menuitem:not(.p-highlight):not(.p-disabled).p-focus>.p-menuitem-content {
        color: #212529;
        background: #dee2e6;
    }

    .p-panelmenu .p-panelmenu-content .p-menuitem:not(.p-highlight):not(.p-disabled).p-focus>.p-menuitem-content .p-menuitem-link .p-menuitem-text {
        color: #212529;
    }

    .p-panelmenu .p-panelmenu-content .p-menuitem:not(.p-highlight):not(.p-disabled).p-focus>.p-menuitem-content .p-menuitem-link .p-menuitem-icon,
    .p-panelmenu .p-panelmenu-content .p-menuitem:not(.p-highlight):not(.p-disabled).p-focus>.p-menuitem-content .p-menuitem-link .p-submenu-icon {
        color: #212529;
    }

    .p-panelmenu .p-panelmenu-content .p-menuitem:not(.p-highlight):not(.p-disabled)>.p-menuitem-content:hover {
        color: #212529;
        background: #e9ecef;
    }

    .p-panelmenu .p-panelmenu-content .p-menuitem:not(.p-highlight):not(.p-disabled)>.p-menuitem-content:hover .p-menuitem-link .p-menuitem-text {
        color: #212529;
    }

    .p-panelmenu .p-panelmenu-content .p-menuitem:not(.p-highlight):not(.p-disabled)>.p-menuitem-content:hover .p-menuitem-link .p-menuitem-icon,
    .p-panelmenu .p-panelmenu-content .p-menuitem:not(.p-highlight):not(.p-disabled)>.p-menuitem-content:hover .p-menuitem-link .p-submenu-icon {
        color: #212529;
    }

    .p-panelmenu .p-panelmenu-content .p-menuitem .p-menuitem-content .p-menuitem-link .p-submenu-icon {
        margin-right: 0.5rem;
    }

    .p-panelmenu .p-panelmenu-content .p-menuitem-separator {
        border-top: 1px solid #dee2e6;
        margin: 0.5rem 0;
    }

    .p-panelmenu .p-panelmenu-content .p-submenu-list:not(.p-panelmenu-root-list) {
        padding: 0 0 0 1rem;
    }

    .p-panelmenu .p-panelmenu-panel {
        margin-bottom: 0;
    }

    .p-panelmenu .p-panelmenu-panel .p-panelmenu-header .p-panelmenu-header-content {
        border-radius: 0;
    }

    .p-panelmenu .p-panelmenu-panel .p-panelmenu-content {
        border-radius: 0;
    }

    .p-panelmenu .p-panelmenu-panel:not(:first-child) .p-panelmenu-header .p-panelmenu-header-content {
        border-top: 0 none;
    }

    .p-panelmenu .p-panelmenu-panel:not(:first-child) .p-panelmenu-header:not(.p-highlight):not(.p-disabled):hover .p-panelmenu-header-content,
    .p-panelmenu .p-panelmenu-panel:not(:first-child) .p-panelmenu-header:not(.p-disabled).p-highlight:hover .p-panelmenu-header-content {
        border-top: 0 none;
    }

    .p-panelmenu .p-panelmenu-panel:first-child .p-panelmenu-header .p-panelmenu-header-content {
        border-top-right-radius: 4px;
        border-top-left-radius: 4px;
    }

    .p-panelmenu .p-panelmenu-panel:last-child .p-panelmenu-header:not(.p-highlight) .p-panelmenu-header-content {
        border-bottom-right-radius: 4px;
        border-bottom-left-radius: 4px;
    }

    .p-panelmenu .p-panelmenu-panel:last-child .p-panelmenu-content {
        border-bottom-right-radius: 4px;
        border-bottom-left-radius: 4px;
    }

    .p-slidemenu {
        padding: 0.5rem 0;
        background: #ffffff;
        color: #212529;
        border: 1px solid #dee2e6;
        border-radius: 4px;
        width: 12.5rem;
    }

    .p-slidemenu .p-menuitem-link>.p-menuitem-content {
        color: #212529;
        transition: box-shadow 0.15s;
        border-radius: 0;
    }

    .p-slidemenu .p-menuitem-link>.p-menuitem-content .p-menuitem-link {
        color: #212529;
        padding: 0.75rem 1rem;
        -webkit-user-select: none;
                user-select: none;
    }

    .p-slidemenu .p-menuitem-link>.p-menuitem-content .p-menuitem-link .p-menuitem-text {
        color: #212529;
    }

    .p-slidemenu .p-menuitem-link>.p-menuitem-content .p-menuitem-link .p-menuitem-icon {
        color: #212529;
        margin-right: 0.5rem;
    }

    .p-slidemenu .p-menuitem-link>.p-menuitem-content .p-menuitem-link .p-submenu-icon {
        color: #212529;
    }

    .p-slidemenu .p-menuitem-link.p-highlight>.p-menuitem-content {
        color: #212529;
        background: #e9ecef;
    }

    .p-slidemenu .p-menuitem-link.p-highlight>.p-menuitem-content .p-menuitem-link .p-menuitem-text {
        color: #212529;
    }

    .p-slidemenu .p-menuitem-link.p-highlight>.p-menuitem-content .p-menuitem-link .p-menuitem-icon,
    .p-slidemenu .p-menuitem-link.p-highlight>.p-menuitem-content .p-menuitem-link .p-submenu-icon {
        color: #212529;
    }

    .p-slidemenu .p-menuitem-link.p-highlight.p-focus>.p-menuitem-content {
        background: #e9ecef;
    }

    .p-slidemenu .p-menuitem-link:not(.p-highlight):not(.p-disabled).p-focus>.p-menuitem-content {
        color: #212529;
        background: #dee2e6;
    }

    .p-slidemenu .p-menuitem-link:not(.p-highlight):not(.p-disabled).p-focus>.p-menuitem-content .p-menuitem-link .p-menuitem-text {
        color: #212529;
    }

    .p-slidemenu .p-menuitem-link:not(.p-highlight):not(.p-disabled).p-focus>.p-menuitem-content .p-menuitem-link .p-menuitem-icon,
    .p-slidemenu .p-menuitem-link:not(.p-highlight):not(.p-disabled).p-focus>.p-menuitem-content .p-menuitem-link .p-submenu-icon {
        color: #212529;
    }

    .p-slidemenu .p-menuitem-link:not(.p-highlight):not(.p-disabled)>.p-menuitem-content:hover {
        color: #212529;
        background: #e9ecef;
    }

    .p-slidemenu .p-menuitem-link:not(.p-highlight):not(.p-disabled)>.p-menuitem-content:hover .p-menuitem-link .p-menuitem-text {
        color: #212529;
    }

    .p-slidemenu .p-menuitem-link:not(.p-highlight):not(.p-disabled)>.p-menuitem-content:hover .p-menuitem-link .p-menuitem-icon,
    .p-slidemenu .p-menuitem-link:not(.p-highlight):not(.p-disabled)>.p-menuitem-content:hover .p-menuitem-link .p-submenu-icon {
        color: #212529;
    }

    .p-slidemenu.p-slidemenu-overlay {
        background: #ffffff;
        border: 1px solid rgba(0, 0, 0, 0.15);
        box-shadow: none;
    }

    .p-slidemenu .p-slidemenu-list {
        padding: 0.5rem 0;
        background: #ffffff;
        border: 1px solid rgba(0, 0, 0, 0.15);
        box-shadow: none;
    }

    .p-slidemenu .p-slidemenu.p-slidemenu-active>.p-slidemenu-link {
        background: #e9ecef;
    }

    .p-slidemenu .p-slidemenu.p-slidemenu-active>.p-slidemenu-link .p-slidemenu-text {
        color: #212529;
    }

    .p-slidemenu .p-slidemenu.p-slidemenu-active>.p-slidemenu-link .p-slidemenu-icon,
    .p-slidemenu .p-slidemenu.p-slidemenu-active>.p-slidemenu-link .p-slidemenu-icon {
        color: #212529;
    }

    .p-slidemenu .p-slidemenu-separator {
        border-top: 1px solid #dee2e6;
        margin: 0.5rem 0;
    }

    .p-slidemenu .p-slidemenu-icon {
        font-size: 0.875rem;
    }

    .p-slidemenu .p-slidemenu-icon.p-icon {
        width: 0.875rem;
        height: 0.875rem;
    }

    .p-slidemenu .p-slidemenu-backward {
        padding: 0.75rem 1rem;
        color: #212529;
    }

    .p-steps .p-steps-item .p-menuitem-link {
        background: transparent;
        transition: box-shadow 0.15s;
        border-radius: 4px;
        background: transparent;
    }

    .p-steps .p-steps-item .p-menuitem-link .p-steps-number {
        color: #212529;
        border: 1px solid #dee2e6;
        background: transparent;
        min-width: 2rem;
        height: 2rem;
        line-height: 2rem;
        font-size: 12px;
        z-index: 1;
        border-radius: 4px;
    }

    .p-steps .p-steps-item .p-menuitem-link .p-steps-title {
        margin-top: 0.5rem;
        color: #6c757d;
    }

    .p-steps .p-steps-item .p-menuitem-link:not(.p-disabled):focus-visible {
        outline: 0 none;
        outline-offset: 0;
        box-shadow: 0 0 0 0.2rem rgba(38, 143, 255, 0.5);
    }

    .p-steps .p-steps-item.p-highlight .p-steps-number {
        background: #007bff;
        color: #ffffff;
    }

    .p-steps .p-steps-item.p-highlight .p-steps-title {
        font-weight: 600;
        color: #212529;
    }

    .p-steps .p-steps-item:before {
        content: " ";
        border-top: 1px solid #dee2e6;
        width: 100%;
        top: 50%;
        left: 0;
        display: block;
        position: absolute;
        margin-top: -1rem;
    }

    .p-tabmenu .p-tabmenu-nav {
        background: transparent;
        border: 1px solid #dee2e6;
        border-width: 0 0 1px 0;
    }

    .p-tabmenu .p-tabmenu-nav .p-tabmenuitem {
        margin-right: 0;
    }

    .p-tabmenu .p-tabmenu-nav .p-tabmenuitem .p-menuitem-link {
        border: solid;
        border-width: 1px;
        border-color: #ffffff #ffffff #dee2e6 #ffffff;
        background: #ffffff;
        color: #6c757d;
        padding: 0.75rem 1rem;
        font-weight: 600;
        border-top-right-radius: 4px;
        border-top-left-radius: 4px;
        transition: box-shadow 0.15s;
        margin: 0 0 -1px 0;
        height: calc(100% + 1px);
    }

    .p-tabmenu .p-tabmenu-nav .p-tabmenuitem .p-menuitem-link .p-menuitem-icon {
        margin-right: 0.5rem;
    }

    .p-tabmenu .p-tabmenu-nav .p-tabmenuitem .p-menuitem-link:not(.p-disabled):focus-visible {
        outline: 0 none;
        outline-offset: 0;
        box-shadow: inset 0 0 0 0.2rem rgba(38, 143, 255, 0.5);
    }

    .p-tabmenu .p-tabmenu-nav .p-tabmenuitem:not(.p-highlight):not(.p-disabled):hover .p-menuitem-link {
        background: #ffffff;
        border-color: #dee2e6;
        color: #6c757d;
    }

    .p-tabmenu .p-tabmenu-nav .p-tabmenuitem.p-highlight .p-menuitem-link {
        background: #ffffff;
        border-color: #dee2e6 #dee2e6 #ffffff #dee2e6;
        color: #495057;
    }

    .p-tieredmenu {
        padding: 0.5rem 0;
        background: #ffffff;
        color: #212529;
        border: 1px solid #dee2e6;
        border-radius: 4px;
        width: 12.5rem;
    }

    .p-tieredmenu.p-tieredmenu-overlay {
        background: #ffffff;
        border: 1px solid rgba(0, 0, 0, 0.15);
        box-shadow: none;
    }

    .p-tieredmenu .p-tieredmenu-root-list {
        outline: 0 none;
    }

    .p-tieredmenu .p-submenu-list {
        padding: 0.5rem 0;
        background: #ffffff;
        border: 1px solid rgba(0, 0, 0, 0.15);
        box-shadow: none;
    }

    .p-tieredmenu .p-menuitem>.p-menuitem-content {
        color: #212529;
        transition: box-shadow 0.15s;
        border-radius: 0;
    }

    .p-tieredmenu .p-menuitem>.p-menuitem-content .p-menuitem-link {
        color: #212529;
        padding: 0.75rem 1rem;
        -webkit-user-select: none;
                user-select: none;
    }

    .p-tieredmenu .p-menuitem>.p-menuitem-content .p-menuitem-link .p-menuitem-text {
        color: #212529;
    }

    .p-tieredmenu .p-menuitem>.p-menuitem-content .p-menuitem-link .p-menuitem-icon {
        color: #212529;
        margin-right: 0.5rem;
    }

    .p-tieredmenu .p-menuitem>.p-menuitem-content .p-menuitem-link .p-submenu-icon {
        color: #212529;
    }

    .p-tieredmenu .p-menuitem.p-highlight>.p-menuitem-content {
        color: #212529;
        background: #e9ecef;
    }

    .p-tieredmenu .p-menuitem.p-highlight>.p-menuitem-content .p-menuitem-link .p-menuitem-text {
        color: #212529;
    }

    .p-tieredmenu .p-menuitem.p-highlight>.p-menuitem-content .p-menuitem-link .p-menuitem-icon,
    .p-tieredmenu .p-menuitem.p-highlight>.p-menuitem-content .p-menuitem-link .p-submenu-icon {
        color: #212529;
    }

    .p-tieredmenu .p-menuitem.p-highlight.p-focus>.p-menuitem-content {
        background: #e9ecef;
    }

    .p-tieredmenu .p-menuitem:not(.p-highlight):not(.p-disabled).p-focus>.p-menuitem-content {
        color: #212529;
        background: #dee2e6;
    }

    .p-tieredmenu .p-menuitem:not(.p-highlight):not(.p-disabled).p-focus>.p-menuitem-content .p-menuitem-link .p-menuitem-text {
        color: #212529;
    }

    .p-tieredmenu .p-menuitem:not(.p-highlight):not(.p-disabled).p-focus>.p-menuitem-content .p-menuitem-link .p-menuitem-icon,
    .p-tieredmenu .p-menuitem:not(.p-highlight):not(.p-disabled).p-focus>.p-menuitem-content .p-menuitem-link .p-submenu-icon {
        color: #212529;
    }

    .p-tieredmenu .p-menuitem:not(.p-highlight):not(.p-disabled)>.p-menuitem-content:hover {
        color: #212529;
        background: #e9ecef;
    }

    .p-tieredmenu .p-menuitem:not(.p-highlight):not(.p-disabled)>.p-menuitem-content:hover .p-menuitem-link .p-menuitem-text {
        color: #212529;
    }

    .p-tieredmenu .p-menuitem:not(.p-highlight):not(.p-disabled)>.p-menuitem-content:hover .p-menuitem-link .p-menuitem-icon,
    .p-tieredmenu .p-menuitem:not(.p-highlight):not(.p-disabled)>.p-menuitem-content:hover .p-menuitem-link .p-submenu-icon {
        color: #212529;
    }

    .p-tieredmenu .p-menuitem-separator {
        border-top: 1px solid #dee2e6;
        margin: 0.5rem 0;
    }

    .p-tieredmenu .p-submenu-icon {
        font-size: 0.875rem;
    }

    .p-tieredmenu .p-submenu-icon.p-icon {
        width: 0.875rem;
        height: 0.875rem;
    }

    .p-inline-message {
        padding: 0.5rem 0.75rem;
        margin: 0;
        border-radius: 4px;
    }

    .p-inline-message.p-inline-message-info {
        background: #cce5ff;
        border: solid #b8daff;
        border-width: 0px;
        color: #004085;
    }

    .p-inline-message.p-inline-message-info .p-inline-message-icon {
        color: #004085;
    }

    .p-inline-message.p-inline-message-success {
        background: #d4edda;
        border: solid #c3e6cb;
        border-width: 0px;
        color: #155724;
    }

    .p-inline-message.p-inline-message-success .p-inline-message-icon {
        color: #155724;
    }

    .p-inline-message.p-inline-message-warn {
        background: #fff3cd;
        border: solid #ffeeba;
        border-width: 0px;
        color: #856404;
    }

    .p-inline-message.p-inline-message-warn .p-inline-message-icon {
        color: #856404;
    }

    .p-inline-message.p-inline-message-error {
        background: #f8d7da;
        border: solid #f5c6cb;
        border-width: 0px;
        color: #721c24;
    }

    .p-inline-message.p-inline-message-error .p-inline-message-icon {
        color: #721c24;
    }

    .p-inline-message .p-inline-message-icon {
        font-size: 1rem;
        margin-right: 0.5rem;
    }

    .p-inline-message .p-inline-message-icon.p-icon {
        width: 1rem;
        height: 1rem;
    }

    .p-inline-message .p-inline-message-text {
        font-size: 12px;
    }

    .p-inline-message.p-inline-message-icon-only .p-inline-message-icon {
        margin-right: 0;
    }

    .p-message {
        margin: 1rem 0;
        border-radius: 4px;
    }

    .p-message .p-message-wrapper {
        padding: 1rem 1.25rem;
    }

    .p-message .p-message-close {
        width: 2rem;
        height: 2rem;
        border-radius: 50%;
        background: transparent;
        transition: box-shadow 0.15s;
    }

    .p-message .p-message-close:hover {
        background: rgba(255, 255, 255, 0.5);
    }

    .p-message .p-message-close:focus-visible {
        outline: 0 none;
        outline-offset: 0;
        box-shadow: 0 0 0 0.2rem rgba(38, 143, 255, 0.5);
    }

    .p-message.p-message-info {
        background: #cce5ff;
        border: solid #b8daff;
        border-width: 1px;
        color: #004085;
    }

    .p-message.p-message-info .p-message-icon {
        color: #004085;
    }

    .p-message.p-message-info .p-message-close {
        color: #004085;
    }

    .p-message.p-message-success {
        background: #d4edda;
        border: solid #c3e6cb;
        border-width: 1px;
        color: #155724;
    }

    .p-message.p-message-success .p-message-icon {
        color: #155724;
    }

    .p-message.p-message-success .p-message-close {
        color: #155724;
    }

    .p-message.p-message-warn {
        background: #fff3cd;
        border: solid #ffeeba;
        border-width: 1px;
        color: #856404;
    }

    .p-message.p-message-warn .p-message-icon {
        color: #856404;
    }

    .p-message.p-message-warn .p-message-close {
        color: #856404;
    }

    .p-message.p-message-error {
        background: #f8d7da;
        border: solid #f5c6cb;
        border-width: 1px;
        color: #721c24;
    }

    .p-message.p-message-error .p-message-icon {
        color: #721c24;
    }

    .p-message.p-message-error .p-message-close {
        color: #721c24;
    }

    .p-message .p-message-text {
        font-size: 12px;
        font-weight: 500;
    }

    .p-message .p-message-icon {
        font-size: 1.5rem;
        margin-right: 0.5rem;
    }

    .p-message .p-message-icon.p-icon {
        width: 1.5rem;
        height: 1.5rem;
    }

    .p-message .p-message-summary {
        font-weight: 700;
    }

    .p-message .p-message-detail {
        margin-left: 0.5rem;
    }

    .p-toast {
        opacity: 1;
    }

    .p-toast .p-toast-message {
        margin: 0 0 1rem 0;
        box-shadow: 0 0.25rem 0.75rem rgba(0, 0, 0, 0.1);
        border-radius: 4px;
    }

    .p-toast .p-toast-message .p-toast-message-content {
        padding: 1rem;
        border-width: 0;
    }

    .p-toast .p-toast-message .p-toast-message-content .p-toast-message-text {
        margin: 0 0 0 1rem;
    }

    .p-toast .p-toast-message .p-toast-message-content .p-toast-message-icon {
        font-size: 2rem;
    }

    .p-toast .p-toast-message .p-toast-message-content .p-toast-message-icon.p-icon {
        width: 2rem;
        height: 2rem;
    }

    .p-toast .p-toast-message .p-toast-message-content .p-toast-summary {
        font-weight: 700;
    }

    .p-toast .p-toast-message .p-toast-message-content .p-toast-detail {
        margin: 0.5rem 0 0 0;
    }

    .p-toast .p-toast-message .p-toast-icon-close {
        width: 2rem;
        height: 2rem;
        border-radius: 50%;
        background: transparent;
        transition: box-shadow 0.15s;
    }

    .p-toast .p-toast-message .p-toast-icon-close:hover {
        background: rgba(255, 255, 255, 0.5);
    }

    .p-toast .p-toast-message .p-toast-icon-close:focus-visible {
        outline: 0 none;
        outline-offset: 0;
        box-shadow: 0 0 0 0.2rem rgba(38, 143, 255, 0.5);
    }

    .p-toast .p-toast-message.p-toast-message-info {
        background: #cce5ff;
        border: solid #b8daff;
        border-width: 1px;
        color: #004085;
    }

    .p-toast .p-toast-message.p-toast-message-info .p-toast-message-icon,
    .p-toast .p-toast-message.p-toast-message-info .p-toast-icon-close {
        color: #004085;
    }

    .p-toast .p-toast-message.p-toast-message-success {
        background: #d4edda;
        border: solid #c3e6cb;
        border-width: 1px;
        color: #155724;
    }

    .p-toast .p-toast-message.p-toast-message-success .p-toast-message-icon,
    .p-toast .p-toast-message.p-toast-message-success .p-toast-icon-close {
        color: #155724;
    }

    .p-toast .p-toast-message.p-toast-message-warn {
        background: #fff3cd;
        border: solid #ffeeba;
        border-width: 1px;
        color: #856404;
    }

    .p-toast .p-toast-message.p-toast-message-warn .p-toast-message-icon,
    .p-toast .p-toast-message.p-toast-message-warn .p-toast-icon-close {
        color: #856404;
    }

    .p-toast .p-toast-message.p-toast-message-error {
        background: #f8d7da;
        border: solid #f5c6cb;
        border-width: 1px;
        color: #721c24;
    }

    .p-toast .p-toast-message.p-toast-message-error .p-toast-message-icon,
    .p-toast .p-toast-message.p-toast-message-error .p-toast-icon-close {
        color: #721c24;
    }

    .p-galleria .p-galleria-close {
        margin: 0.5rem;
        background: transparent;
        color: #efefef;
        width: 4rem;
        height: 4rem;
        transition: box-shadow 0.15s;
        border-radius: 4px;
    }

    .p-galleria .p-galleria-close .p-galleria-close-icon {
        font-size: 2rem;
    }

    .p-galleria .p-galleria-close .p-galleria-close-icon.p-icon {
        width: 2rem;
        height: 2rem;
    }

    .p-galleria .p-galleria-close:hover {
        background: rgba(255, 255, 255, 0.1);
        color: #efefef;
    }

    .p-galleria .p-galleria-item-nav {
        background: transparent;
        color: #efefef;
        width: 4rem;
        height: 4rem;
        transition: box-shadow 0.15s;
        border-radius: 4px;
        margin: 0 0.5rem;
    }

    .p-galleria .p-galleria-item-nav .p-galleria-item-prev-icon,
    .p-galleria .p-galleria-item-nav .p-galleria-item-next-icon {
        font-size: 2rem;
    }

    .p-galleria .p-galleria-item-nav .p-galleria-item-prev-icon.p-icon,
    .p-galleria .p-galleria-item-nav .p-galleria-item-next-icon.p-icon {
        width: 2rem;
        height: 2rem;
    }

    .p-galleria .p-galleria-item-nav:not(.p-disabled):hover {
        background: rgba(255, 255, 255, 0.1);
        color: #efefef;
    }

    .p-galleria .p-galleria-caption {
        background: rgba(0, 0, 0, 0.5);
        color: #efefef;
        padding: 1rem;
    }

    .p-galleria .p-galleria-indicators {
        padding: 1rem;
    }

    .p-galleria .p-galleria-indicators .p-galleria-indicator button {
        background-color: #e9ecef;
        width: 1rem;
        height: 1rem;
        transition: box-shadow 0.15s;
        border-radius: 4px;
    }

    .p-galleria .p-galleria-indicators .p-galleria-indicator button:hover {
        background: #dee2e6;
    }

    .p-galleria .p-galleria-indicators .p-galleria-indicator.p-highlight button {
        background: #007bff;
        color: #ffffff;
    }

    .p-galleria.p-galleria-indicators-bottom .p-galleria-indicator,
    .p-galleria.p-galleria-indicators-top .p-galleria-indicator {
        margin-right: 0.5rem;
    }

    .p-galleria.p-galleria-indicators-left .p-galleria-indicator,
    .p-galleria.p-galleria-indicators-right .p-galleria-indicator {
        margin-bottom: 0.5rem;
    }

    .p-galleria.p-galleria-indicator-onitem .p-galleria-indicators {
        background: rgba(0, 0, 0, 0.5);
    }

    .p-galleria.p-galleria-indicator-onitem .p-galleria-indicators .p-galleria-indicator button {
        background: rgba(255, 255, 255, 0.4);
    }

    .p-galleria.p-galleria-indicator-onitem .p-galleria-indicators .p-galleria-indicator button:hover {
        background: rgba(255, 255, 255, 0.6);
    }

    .p-galleria.p-galleria-indicator-onitem .p-galleria-indicators .p-galleria-indicator.p-highlight button {
        background: #007bff;
        color: #ffffff;
    }

    .p-galleria .p-galleria-thumbnail-container {
        background: rgba(0, 0, 0, 0.9);
        padding: 1rem 0.25rem;
    }

    .p-galleria .p-galleria-thumbnail-container .p-galleria-thumbnail-prev,
    .p-galleria .p-galleria-thumbnail-container .p-galleria-thumbnail-next {
        margin: 0.5rem;
        background-color: transparent;
        color: #efefef;
        width: 2rem;
        height: 2rem;
        transition: box-shadow 0.15s;
        border-radius: 4px;
    }

    .p-galleria .p-galleria-thumbnail-container .p-galleria-thumbnail-prev:hover,
    .p-galleria .p-galleria-thumbnail-container .p-galleria-thumbnail-next:hover {
        background: rgba(255, 255, 255, 0.1);
        color: #efefef;
    }

    .p-galleria .p-galleria-thumbnail-container .p-galleria-thumbnail-item-content {
        transition: box-shadow 0.15s;
    }

    .p-galleria .p-galleria-thumbnail-container .p-galleria-thumbnail-item-content:focus-visible {
        outline: 0 none;
        outline-offset: 0;
        box-shadow: 0 0 0 0.2rem rgba(38, 143, 255, 0.5);
    }

    .p-galleria-mask {
        --maskbg: rgba(0, 0, 0, 0.9);
    }

    .p-image-mask {
        --maskbg: rgba(0, 0, 0, 0.9);
    }

    .p-image-preview-indicator {
        background-color: transparent;
        color: #f8f9fa;
        transition: box-shadow 0.15s;
    }

    .p-image-preview-indicator .p-icon {
        width: 1.5rem;
        height: 1.5rem;
    }

    .p-image-preview-container:hover>.p-image-preview-indicator {
        background-color: rgba(0, 0, 0, 0.5);
    }

    .p-image-toolbar {
        padding: 1rem;
    }

    .p-image-action.p-link {
        color: #f8f9fa;
        background-color: transparent;
        width: 3rem;
        height: 3rem;
        border-radius: 50%;
        transition: box-shadow 0.15s;
        margin-right: 0.5rem;
    }

    .p-image-action.p-link:last-child {
        margin-right: 0;
    }

    .p-image-action.p-link:hover {
        color: #f8f9fa;
        background-color: rgba(255, 255, 255, 0.1);
    }

    .p-image-action.p-link span {
        font-size: 12px;
    }

    .p-image-action.p-link .p-icon {
        width: 1.5rem;
        height: 1.5rem;
    }

    .p-avatar {
        background-color: #dee2e6;
        border-radius: 4px;
    }

    .p-avatar.p-avatar-lg {
        width: 3rem;
        height: 3rem;
        font-size: 12px;
    }

    .p-avatar.p-avatar-lg .p-avatar-icon {
        font-size: 1.5rem;
    }

    .p-avatar.p-avatar-xl {
        width: 4rem;
        height: 4rem;
        font-size: 12px;
    }

    .p-avatar.p-avatar-xl .p-avatar-icon {
        font-size: 2rem;
    }

    .p-avatar-circle {
        border-radius: 50%;
    }

    .p-avatar-group .p-avatar {
        border: 2px solid #ffffff;
    }

    .p-chip {
        background-color: #dee2e6;
        color: #212529;
        border-radius: 16px;
        padding: 0 0.75rem;
    }

    .p-chip .p-chip-text {
        line-height: 1.5;
        margin-top: 0.25rem;
        margin-bottom: 0.25rem;
    }

    .p-chip .p-chip-icon {
        margin-right: 0.5rem;
    }

    .p-chip img {
        width: 2rem;
        height: 2rem;
        margin-left: -0.75rem;
        margin-right: 0.5rem;
    }

    .p-chip .p-chip-remove-icon {
        border-radius: 4px;
        transition: box-shadow 0.15s;
        margin-left: 0.5rem;
    }

    .p-chip .p-chip-remove-icon:focus-visible {
        outline: 0 none;
        outline-offset: 0;
        box-shadow: 0 0 0 0.2rem rgba(38, 143, 255, 0.5);
    }

    .p-chip .p-chip-remove-icon:focus {
        outline: 0 none;
    }

    .p-scrolltop {
        width: 3rem;
        height: 3rem;
        border-radius: 4px;
        box-shadow: none;
        transition: box-shadow 0.15s;
    }

    .p-scrolltop.p-link {
        background: rgba(0, 0, 0, 0.7);
    }

    .p-scrolltop.p-link:hover {
        background: rgba(0, 0, 0, 0.8);
    }

    .p-scrolltop .p-scrolltop-icon {
        font-size: 1.5rem;
        color: #efefef;
    }

    .p-scrolltop .p-scrolltop-icon.p-icon {
        width: 1.5rem;
        height: 1.5rem;
    }

    .p-skeleton {
        background-color: #e9ecef;
        border-radius: 4px;
    }

    .p-skeleton:after {
        background: linear-gradient(90deg, rgba(255, 255, 255, 0), rgba(255, 255, 255, 0.4), rgba(255, 255, 255, 0));
    }

    .p-tag {
        background: #cf0000;
        color: #ffffff;
        font-size: 12px;
        font-weight: 700;
        padding: 0.25rem 0.4rem;
        border-radius: 4px;
    }

    .p-tag.p-tag-success {
        background-color: #28a745;
        color: #ffffff;
    }

    .p-tag.p-tag-info {
        background-color: #17a2b8;
        color: #ffffff;
    }

    .p-tag.p-tag-warning {
        background-color: #ffc107;
        color: #212529;
    }

    .p-tag.p-tag-danger {
        background-color: #dc3545;
        color: #ffffff;
    }

    .p-tag .p-tag-icon {
        margin-right: 0.25rem;
        font-size: 0.75rem;
    }

    .p-tag .p-tag-icon.p-icon {
        width: 0.75rem;
        height: 0.75rem;
    }

    .p-inplace .p-inplace-display {
        padding: 0.5rem 0.75rem;
        border-radius: 4px;
        transition: background-color 0.15s, border-color 0.15s, box-shadow 0.15s;
    }

    .p-inplace .p-inplace-display:not(.p-disabled):hover {
        background: #e9ecef;
        color: #212529;
    }

    .p-inplace .p-inplace-display:focus {
        outline: 0 none;
        outline-offset: 0;
        box-shadow: 0 0 0 0.2rem rgba(38, 143, 255, 0.5);
    }

    .p-progressbar {
        border: 0 none;
        height: 1.5rem;
        background: #e9ecef;
        border-radius: 4px;
    }

    .p-progressbar .p-progressbar-value {
        border: 0 none;
        margin: 0;
        background: #cf0000;
    }

    .p-progressbar .p-progressbar-label {
        color: #ffffff;
        line-height: 1.5rem;
    }

    .p-terminal {
        background: #ffffff;
        color: #212529;
        border: 1px solid #dee2e6;
        padding: 1.25rem;
    }

    .p-terminal .p-terminal-input {
        font-family: var(--font-family);
        font-feature-settings: var(--font-feature-settings, normal);
        font-size: 12px;
    }

    .p-badge {
        background: #007bff;
        color: #ffffff;
        font-size: 12px;
        font-weight: 700;
        min-width: 1.5rem;
        height: 1.5rem;
        line-height: 1.5rem;
    }

    .p-badge.p-badge-secondary {
        background-color: #6c757d;
        color: #ffffff;
    }

    .p-badge.p-badge-success {
        background-color: #28a745;
        color: #ffffff;
    }

    .p-badge.p-badge-info {
        background-color: #17a2b8;
        color: #ffffff;
    }

    .p-badge.p-badge-warning {
        background-color: #ffc107;
        color: #212529;
    }

    .p-badge.p-badge-danger {
        background-color: #dc3545;
        color: #ffffff;
    }

    .p-badge.p-badge-lg {
        font-size: 12px;
        min-width: 2.25rem;
        height: 2.25rem;
        line-height: 2.25rem;
    }

    .p-badge.p-badge-xl {
        font-size: 12px;
        min-width: 3rem;
        height: 3rem;
        line-height: 3rem;
    }

    .p-tag {
        background: #cf0000;
        color: #ffffff;
        font-size: 12px;
        font-weight: 700;
        padding: 0.25rem 0.4rem;
        border-radius: 4px;
    }

    .p-tag.p-tag-success {
        background-color: #28a745;
        color: #ffffff;
    }

    .p-tag.p-tag-info {
        background-color: #17a2b8;
        color: #ffffff;
    }

    .p-tag.p-tag-warning {
        background-color: #ffc107;
        color: #212529;
    }

    .p-tag.p-tag-danger {
        background-color: #dc3545;
        color: #ffffff;
    }
}

/* Vendor extensions to the designer enhanced bootstrap compatibility */
@layer primereact {
    .p-breadcrumb .p-breadcrumb-chevron {
        font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Helvetica, Arial, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol";
    }

    .p-breadcrumb .p-breadcrumb-chevron:before {
        content: "/";
    }
}

/* Customizations to the designer theme should be defined here */`, "",{"version":3,"sources":["webpack://./src/LpToolsTheme.css"],"names":[],"mappings":"AAAA;IACI;;;4BAGwB;IACxB,oBAAoB;IACpB,oBAAoB;IACpB,oBAAoB;IACpB,oBAAoB;IACpB,oBAAoB;IACpB,oBAAoB;IACpB,qBAAqB;IACrB,+BAA+B;IAC/B,+BAA+B;IAC/B,6BAA6B;IAC7B,0BAA0B;IAC1B,oBAAoB;IACpB,qBAAqB;IACrB,sBAAsB;IACtB,sBAAsB;IACtB,sBAAsB;IACtB,sBAAsB;IACtB,sBAAsB;IACtB,sBAAsB;IACtB,sBAAsB;IACtB,sBAAsB;IACtB,sBAAsB;IACtB,kBAAkB;IAClB,mBAAmB;IACnB,mBAAmB;IACnB,mBAAmB;IACnB,mBAAmB;IACnB,mBAAmB;IACnB,mBAAmB;IACnB,mBAAmB;IACnB,mBAAmB;IACnB,mBAAmB;IACnB,0BAA0B;IAC1B,wBAAwB;IACxB,oBAAoB;IACpB,yBAAyB;IACzB,0BAA0B;IAC1B,uBAAuB;IACvB,0BAA0B;IAC1B,yBAAyB;IACzB,wBAAwB;IACxB,kCAAkC;IAClC,4BAA4B;IAC5B,uBAAuB;IACvB,+BAA+B;IAC/B,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;IAClB,mBAAmB;IACnB,mBAAmB;IACnB,mBAAmB;IACnB,mBAAmB;IACnB,mBAAmB;IACnB,mBAAmB;IACnB,mBAAmB;IACnB,mBAAmB;IACnB,mBAAmB;IACnB,mBAAmB;IACnB,oBAAoB;IACpB,oBAAoB;IACpB,oBAAoB;IACpB,oBAAoB;IACpB,oBAAoB;IACpB,oBAAoB;IACpB,oBAAoB;IACpB,oBAAoB;IACpB,oBAAoB;IACpB,oBAAoB;IACpB,qBAAqB;IACrB,qBAAqB;IACrB,qBAAqB;IACrB,qBAAqB;IACrB,qBAAqB;IACrB,qBAAqB;IACrB,qBAAqB;IACrB,qBAAqB;IACrB,qBAAqB;IACrB,kBAAkB;IAClB,mBAAmB;IACnB,mBAAmB;IACnB,mBAAmB;IACnB,mBAAmB;IACnB,mBAAmB;IACnB,mBAAmB;IACnB,mBAAmB;IACnB,mBAAmB;IACnB,mBAAmB;IACnB,kBAAkB;IAClB,mBAAmB;IACnB,mBAAmB;IACnB,mBAAmB;IACnB,mBAAmB;IACnB,mBAAmB;IACnB,mBAAmB;IACnB,mBAAmB;IACnB,mBAAmB;IACnB,mBAAmB;IACnB,oBAAoB;IACpB,qBAAqB;IACrB,qBAAqB;IACrB,qBAAqB;IACrB,qBAAqB;IACrB,qBAAqB;IACrB,qBAAqB;IACrB,qBAAqB;IACrB,qBAAqB;IACrB,qBAAqB;IACrB,kBAAkB;IAClB,mBAAmB;IACnB,mBAAmB;IACnB,mBAAmB;IACnB,mBAAmB;IACnB,mBAAmB;IACnB,mBAAmB;IACnB,mBAAmB;IACnB,mBAAmB;IACnB,mBAAmB;IACnB,oBAAoB;IACpB,qBAAqB;IACrB,qBAAqB;IACrB,qBAAqB;IACrB,qBAAqB;IACrB,qBAAqB;IACrB,qBAAqB;IACrB,qBAAqB;IACrB,qBAAqB;IACrB,qBAAqB;IACrB,sBAAsB;IACtB,uBAAuB;IACvB,uBAAuB;IACvB,uBAAuB;IACvB,uBAAuB;IACvB,uBAAuB;IACvB,uBAAuB;IACvB,uBAAuB;IACvB,uBAAuB;IACvB,uBAAuB;IACvB,oBAAoB;IACpB,qBAAqB;IACrB,qBAAqB;IACrB,qBAAqB;IACrB,qBAAqB;IACrB,qBAAqB;IACrB,qBAAqB;IACrB,qBAAqB;IACrB,qBAAqB;IACrB,qBAAqB;IACrB,iBAAiB;IACjB,kBAAkB;IAClB,kBAAkB;IAClB,kBAAkB;IAClB,kBAAkB;IAClB,kBAAkB;IAClB,kBAAkB;IAClB,kBAAkB;IAClB,kBAAkB;IAClB,kBAAkB;IAClB,qBAAqB;IACrB,sBAAsB;IACtB,sBAAsB;IACtB,sBAAsB;IACtB,sBAAsB;IACtB,sBAAsB;IACtB,sBAAsB;IACtB,sBAAsB;IACtB,sBAAsB;IACtB,sBAAsB;AAC1B;;AAEA;IACI,mBAAmB;IACnB,4BAA4B;IAC5B,2BAA2B;AAC/B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,cAAc;IACd,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,mBAAmB;IACnB,qCAAqC;IACrC,gBAAgB;IAChB,kBAAkB;IAClB,iBAAiB;AACrB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,cAAc;IACd,mBAAmB;AACvB;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,+BAA+B;IAC/B,8BAA8B;AAClC;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,mBAAmB;IACnB,cAAc;IACd,+BAA+B;IAC/B,8BAA8B;AAClC;;AAEA;;IAEI,cAAc;AAClB;;AAEA;;IAEI,eAAe;AACnB;;AAEA;;IAEI,aAAa;AACjB;;AAEA;;;IAGI,cAAc;AAClB;;AAEA;;;IAGI,eAAe;AACnB;;AAEA;;;IAGI,aAAa;AACjB;;AAEA;;;IAGI,cAAc;AAClB;;AAEA;IACI;QACI,sBAAsB;IAC1B;;IAEA;QACI,+BAA+B;QAC/B,2DAA2D;QAC3D,eAAe;QACf,mBAAmB;IACvB;;IAEA;QACI,oCAAoC;QACpC,0BAA0B;IAC9B;;IAEA;;QAEI,aAAa;IACjB;;IAEA;QACI,cAAc;IAClB;;IAEA;QACI,cAAc;IAClB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,WAAW;QACX,YAAY;IAChB;;IAEA;QACI,+BAA+B;QAC/B,2DAA2D;QAC3D,eAAe;QACf,kBAAkB;IACtB;;IAEA;QACI,eAAe;QACf,iBAAiB;QACjB,gCAAgC;IACpC;;IAEA;QACI,6DAA6D;IACjE;;IAEA;QACI,6DAA6D;IACjE;;IAEA;QACI;YACI,6BAA6B;QACjC;;QAEA;YACI,+BAA+B;QACnC;IACJ;;IAEA;QACI;YACI,+BAA+B;QACnC;;QAEA;YACI,6BAA6B;QACjC;IACJ;;IAEA;QACI,cAAc;IAClB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,wBAAwB;QACxB,WAAW;IACf;;IAEA;QACI,qBAAqB;IACzB;;IAEA;QACI,eAAe;QACf,iBAAiB;QACjB,gDAAgD;QAChD,qBAAqB;IACzB;;IAEA;QACI,kBAAkB;IACtB;;IAEA;QACI,+BAA+B;QAC/B,2DAA2D;QAC3D,eAAe;QACf,cAAc;QACd,UAAU;QACV,SAAS;IACb;;IAEA;QACI,wBAAwB;QACxB,oBAAoB;QACpB,mBAAmB;QACnB,cAAc;QACd,kBAAkB;IACtB;;IAEA;QACI,mBAAmB;IACvB;;IAEA;QACI,qBAAqB;IACzB;;IAEA;QACI,mBAAmB;QACnB,cAAc;QACd,qCAAqC;QACrC,kBAAkB;QAClB,gBAAgB;IACpB;;IAEA;QACI,iBAAiB;IACrB;;IAEA;QACI,SAAS;QACT,sBAAsB;QACtB,cAAc;QACd,cAAc;QACd,uBAAuB;QACvB,4BAA4B;QAC5B,gBAAgB;IACpB;;IAEA;QACI,cAAc;QACd,mBAAmB;IACvB;;IAEA;QACI,cAAc;QACd,mBAAmB;IACvB;;IAEA;QACI,SAAS;QACT,qBAAqB;QACrB,cAAc;QACd,mBAAmB;QACnB,gBAAgB;IACpB;;IAEA;QACI,qBAAqB;IACzB;;IAEA;QACI,eAAe;QACf,iBAAiB;QACjB,gCAAgC;QAChC;IACJ;;IAEA;QACI,UAAU;QACV,mBAAmB;QACnB,cAAc;QACd,yBAAyB;QACzB,kBAAkB;IACtB;;IAEA;QACI,mBAAmB;QACnB,qCAAqC;QACrC,gBAAgB;IACpB;;IAEA;QACI,mBAAmB;IACvB;;IAEA;QACI,eAAe;QACf,cAAc;QACd,mBAAmB;QACnB,gBAAgB;QAChB,SAAS;QACT,gCAAgC;QAChC,4BAA4B;QAC5B,2BAA2B;IAC/B;;IAEA;;QAEI,WAAW;QACX,YAAY;QACZ,cAAc;QACd,cAAc;QACd,uBAAuB;QACvB,kBAAkB;QAClB,4BAA4B;IAChC;;IAEA;;QAEI,cAAc;QACd,yBAAyB;QACzB,uBAAuB;IAC3B;;IAEA;;QAEI,eAAe;QACf,iBAAiB;QACjB,gDAAgD;IACpD;;IAEA;QACI,iBAAiB;IACrB;;IAEA;;QAEI,cAAc;QACd,4BAA4B;QAC5B,gBAAgB;QAChB,eAAe;IACnB;;IAEA;;QAEI,cAAc;IAClB;;IAEA;QACI,oBAAoB;IACxB;;IAEA;QACI,eAAe;QACf,gBAAgB;IACpB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,aAAa;QACb,cAAc;IAClB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,aAAa;QACb,cAAc;QACd,kBAAkB;QAClB,4BAA4B;QAC5B,6BAA6B;IACjC;;IAEA;QACI,cAAc;QACd,mBAAmB;IACvB;;IAEA;QACI,eAAe;QACf,iBAAiB;QACjB,gDAAgD;IACpD;;IAEA;QACI,mBAAmB;QACnB,cAAc;QACd,yBAAyB;IAC7B;;IAEA;QACI,cAAc;QACd,mBAAmB;IACvB;;IAEA;QACI,eAAe;QACf,6BAA6B;IACjC;;IAEA;QACI,WAAW;IACf;;IAEA;QACI,6BAA6B;QAC7B,eAAe;IACnB;;IAEA;QACI,WAAW;QACX,YAAY;QACZ,cAAc;QACd,cAAc;QACd,uBAAuB;QACvB,kBAAkB;QAClB,4BAA4B;IAChC;;IAEA;QACI,cAAc;QACd,yBAAyB;QACzB,uBAAuB;IAC3B;;IAEA;QACI,eAAe;QACf,iBAAiB;QACjB,gDAAgD;IACpD;;IAEA;QACI,iBAAiB;IACrB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,iBAAiB;IACrB;;IAEA;QACI,kBAAkB;IACtB;;IAEA;QACI,gBAAgB;IACpB;;IAEA;QACI,eAAe;QACf,4BAA4B;QAC5B,kBAAkB;IACtB;;IAEA;QACI,cAAc;QACd,mBAAmB;IACvB;;IAEA;QACI,gBAAgB;IACpB;;IAEA;QACI,eAAe;QACf,4BAA4B;QAC5B,kBAAkB;IACtB;;IAEA;QACI,cAAc;QACd,mBAAmB;IACvB;;IAEA;QACI,8BAA8B;QAC9B,gBAAgB;QAChB,eAAe;QACf,cAAc;QACd,iBAAiB;IACrB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,gBAAgB;QAChB,mBAAmB;IACvB;;IAEA;QACI,mBAAmB;IACvB;;IAEA;QACI,eAAe;QACf,iBAAiB;QACjB,gCAAgC;IACpC;;IAEA;QACI,mBAAmB;IACvB;;IAEA;QACI,eAAe;QACf,iBAAiB;QACjB,gDAAgD;IACpD;;IAEA;QACI,mBAAmB;IACvB;;IAEA;QACI,eAAe;QACf,iBAAiB;QACjB,gDAAgD;IACpD;;IAEA;;QAEI;;YAEI,UAAU;QACd;IACJ;;IAEA;QACI,mBAAmB;QACnB,yBAAyB;QACzB,wEAAwE;QACxE,kBAAkB;IACtB;;IAEA;QACI,qBAAqB;IACzB;;IAEA;QACI,eAAe;QACf,iBAAiB;QACjB,gDAAgD;QAChD,qBAAqB;IACzB;;IAEA;QACI,uBAAuB;QACvB,cAAc;QACd,uBAAuB;IAC3B;;IAEA;QACI,cAAc;IAClB;;IAEA;QACI,eAAe;QACf,gBAAgB;IACpB;;IAEA;QACI,uBAAuB;QACvB,cAAc;QACd,eAAe;QACf,4BAA4B;QAC5B,+BAA+B;IACnC;;IAEA;QACI,qBAAqB;IACzB;;IAEA;QACI,mBAAmB;QACnB,cAAc;QACd,qCAAqC;QACrC,kBAAkB;QAClB,gBAAgB;IACpB;;IAEA;QACI,iBAAiB;IACrB;;IAEA;QACI,SAAS;QACT,cAAc;QACd,cAAc;QACd,uBAAuB;QACvB,4BAA4B;QAC5B,gBAAgB;IACpB;;IAEA;QACI,sBAAsB;IAC1B;;IAEA;QACI,eAAe;QACf,iBAAiB;QACjB,uDAAuD;IAC3D;;IAEA;QACI,cAAc;QACd,mBAAmB;IACvB;;IAEA;QACI,cAAc;QACd,mBAAmB;IACvB;;IAEA;QACI,mBAAmB;IACvB;;IAEA;QACI,eAAe;QACf,gBAAgB;IACpB;;IAEA;QACI,mBAAmB;IACvB;;IAEA;QACI,yBAAyB;IAC7B;;IAEA;QACI,yBAAyB;IAC7B;;IAEA;QACI,WAAW;QACX,YAAY;IAChB;;IAEA;QACI,yBAAyB;QACzB,mBAAmB;QACnB,WAAW;QACX,YAAY;QACZ,cAAc;QACd,kBAAkB;QAClB,wEAAwE;IAC5E;;IAEA;QACI,0BAA0B;QAC1B,cAAc;QACd,eAAe;IACnB;;IAEA;QACI,WAAW;QACX,YAAY;IAChB;;IAEA;QACI,qBAAqB;QACrB,mBAAmB;IACvB;;IAEA;QACI,qBAAqB;QACrB,mBAAmB;QACnB,cAAc;IAClB;;IAEA;QACI,qBAAqB;IACzB;;IAEA;QACI,eAAe;QACf,iBAAiB;QACjB,gCAAgC;QAChC,qBAAqB;IACzB;;IAEA;QACI,qBAAqB;QACrB,mBAAmB;QACnB,cAAc;IAClB;;IAEA;QACI,qBAAqB;IACzB;;IAEA;QACI,yBAAyB;IAC7B;;IAEA;QACI,mBAAmB;IACvB;;IAEA;QACI,yBAAyB;IAC7B;;IAEA;QACI,mBAAmB;IACvB;;IAEA;QACI,qBAAqB;IACzB;;IAEA;QACI,oBAAoB;IACxB;;IAEA;QACI,SAAS;QACT,UAAU;QACV,qBAAqB;QACrB,YAAY;QACZ,gBAAgB;QAChB,aAAa;QACb,mBAAmB;QACnB,eAAe;IACnB;;IAEA;QACI,eAAe;QACf,oBAAoB;QACpB,mBAAmB;QACnB,cAAc;IAClB;;IAEA;QACI,cAAc;QACd,oBAAoB;IACxB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,cAAc;QACd,eAAe;QACf,6BAA6B;QAC7B,SAAS;QACT,UAAU;QACV,gBAAgB;QAChB,gBAAgB;QAChB,WAAW;IACf;;IAEA;QACI,aAAa;IACjB;;IAEA;QACI,qBAAqB;IACzB;;IAEA;QACI,eAAe;QACf,iBAAiB;QACjB,gDAAgD;QAChD,qBAAqB;IACzB;;IAEA;QACI,wBAAwB;QACxB,0BAA0B;IAC9B;;IAEA;QACI,wBAAwB;QACxB,oBAAoB;QACpB,mBAAmB;QACnB,cAAc;QACd,mBAAmB;IACvB;;IAEA;QACI,mBAAmB;QACnB,cAAc;IAClB;;IAEA;QACI,mBAAmB;IACvB;;IAEA;QACI,kBAAkB;IACtB;;IAEA;QACI,+BAA+B;QAC/B,2DAA2D;QAC3D,eAAe;QACf,cAAc;QACd,UAAU;QACV,SAAS;IACb;;IAEA;QACI,qBAAqB;IACzB;;IAEA;QACI,WAAW;QACX,YAAY;IAChB;;IAEA;QACI,mBAAmB;QACnB,yBAAyB;IAC7B;;IAEA;;QAEI,qBAAqB;IACzB;;IAEA;QACI,gBAAgB;IACpB;;IAEA;QACI,oBAAoB;QACpB,eAAe;QACf,kBAAkB;QAClB,yBAAiB;gBAAjB,iBAAiB;IACrB;;IAEA;QACI,kBAAkB;QAClB,QAAQ;QACR,mBAAmB;IACvB;;IAEA;QACI,aAAa;QACb,mBAAmB;QACnB,uBAAuB;QACvB,cAAc;IAClB;;IAEA;QACI,cAAc;QACd,mBAAmB;QACnB,gBAAgB;QAChB,cAAc;QACd,SAAS;QACT,uBAAuB;QACvB,eAAe;IACnB;;IAEA;QACI,gBAAgB;QAChB,UAAU;IACd;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,kBAAkB;QAClB,MAAM;QACN,OAAO;IACX;;IAEA;QACI,cAAc;IAClB;;IAEA;QACI,eAAe;QACf,mBAAmB;QACnB,mBAAmB;QACnB,kBAAkB;QAClB,gBAAgB;QAChB,aAAa;QACb,mBAAmB;IACvB;;IAEA;QACI,YAAY;IAChB;;IAEA;QACI,SAAS;QACT,UAAU;QACV,qBAAqB;IACzB;;IAEA;QACI,WAAW;IACf;;IAEA;QACI,kBAAkB;IACtB;;IAEA;QACI,kBAAkB;QAClB,QAAQ;QACR,mBAAmB;IACvB;;IAEA;QACI,aAAa;IACjB;;IAEA;QACI,SAAS;IACb;;IAEA;QACI,mBAAmB;QACnB,yBAAyB;QACzB,wEAAwE;QACxE,kBAAkB;QAClB,0BAA0B;IAC9B;;IAEA;QACI,qBAAqB;IACzB;;IAEA;QACI,eAAe;QACf,iBAAiB;QACjB,gCAAgC;QAChC,qBAAqB;IACzB;;IAEA;QACI,mBAAmB;IACvB;;IAEA;QACI,yBAAyB;IAC7B;;IAEA;QACI,yBAAyB;IAC7B;;IAEA;QACI,6BAA6B;IACjC;;IAEA;QACI,sBAAsB;IAC1B;;IAEA;QACI,uBAAuB;QACvB,cAAc;IAClB;;IAEA;QACI,cAAc;IAClB;;IAEA;;QAEI,eAAe;QACf,gBAAgB;IACpB;;IAEA;QACI,uBAAuB;QACvB,cAAc;QACd,eAAe;QACf,4BAA4B;QAC5B,+BAA+B;IACnC;;IAEA;QACI,cAAc;QACd,eAAe;IACnB;;IAEA;QACI,qBAAqB;IACzB;;IAEA;QACI,mBAAmB;QACnB,cAAc;QACd,qCAAqC;QACrC,kBAAkB;QAClB,gBAAgB;IACpB;;IAEA;QACI,uBAAuB;QACvB,gCAAgC;QAChC,cAAc;QACd,mBAAmB;QACnB,SAAS;QACT,4BAA4B;QAC5B,2BAA2B;IAC/B;;IAEA;QACI,sBAAsB;QACtB,sBAAsB;IAC1B;;IAEA;QACI,cAAc;QACd,cAAc;IAClB;;IAEA;QACI,iBAAiB;IACrB;;IAEA;QACI,SAAS;QACT,sBAAsB;QACtB,cAAc;QACd,cAAc;QACd,uBAAuB;QACvB,4BAA4B;QAC5B,gBAAgB;IACpB;;IAEA;QACI,aAAa;IACjB;;IAEA;QACI,gBAAgB;IACpB;;IAEA;QACI,cAAc;QACd,mBAAmB;IACvB;;IAEA;QACI,mBAAmB;IACvB;;IAEA;QACI,cAAc;QACd,mBAAmB;IACvB;;IAEA;QACI,kBAAkB;QAClB,oBAAoB;QACpB,oBAAoB;IACxB;;IAEA;QACI,SAAS;QACT,qBAAqB;QACrB,cAAc;QACd,mBAAmB;QACnB,gBAAgB;IACpB;;IAEA;QACI,sBAAsB;QACtB,cAAc;QACd,uBAAuB;IAC3B;;IAEA;QACI,mBAAmB;QACnB,cAAc;QACd,6BAA6B;QAC7B,8BAA8B;QAC9B,gCAAgC;QAChC,uBAAuB;QACvB,mBAAmB;IACvB;;IAEA;QACI,+BAA+B;IACnC;;IAEA;;;QAGI,gBAAgB;QAChB,SAAS;IACb;;IAEA;;;QAGI,mBAAmB;IACvB;;IAEA;;;QAGI,UAAU;IACd;;IAEA;;;QAGI,UAAU;IACd;;IAEA;;;;;QAKI,2BAA2B;QAC3B,8BAA8B;IAClC;;IAEA;QACI,2BAA2B;QAC3B,8BAA8B;IAClC;;IAEA;;;;;QAKI,4BAA4B;QAC5B,+BAA+B;IACnC;;IAEA;QACI,4BAA4B;QAC5B,+BAA+B;IACnC;;IAEA;QACI,WAAW;IACf;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,qBAAqB;IACzB;;IAEA;QACI,WAAW;QACX,eAAe;IACnB;;IAEA;QACI,mBAAmB;QACnB,wEAAwE;QACxE,mBAAmB;IACvB;;IAEA;QACI,mBAAmB;QACnB,cAAc;QACd,eAAe;QACf,aAAa;QACb,qBAAqB;QACrB,mBAAmB;QACnB,0BAA0B;IAC9B;;IAEA;QACI,8BAA8B;IAClC;;IAEA;QACI,eAAe;QACf,iBAAiB;QACjB,gCAAgC;IACpC;;IAEA;QACI,mBAAmB;IACvB;;IAEA;QACI,mBAAmB;QACnB,oCAAoC;IACxC;;IAEA;QACI,mBAAmB;IACvB;;IAEA;QACI,mBAAmB;IACvB;;IAEA;QACI,qBAAqB;IACzB;;IAEA;QACI,+BAA+B;QAC/B,2DAA2D;QAC3D,eAAe;QACf,cAAc;QACd,mBAAmB;QACnB,uBAAuB;QACvB,yBAAyB;QACzB,wEAAwE;QACxE,gBAAgB;QAChB,kBAAkB;IACtB;;IAEA;QACI,qBAAqB;IACzB;;IAEA;QACI,eAAe;QACf,iBAAiB;QACjB,gCAAgC;QAChC,qBAAqB;IACzB;;IAEA;QACI,qBAAqB;IACzB;;IAEA;QACI,eAAe;QACf,6BAA6B;IACjC;;IAEA;QACI,eAAe;QACf,2BAA2B;IAC/B;;IAEA;QACI,aAAa;QACb,cAAc;QACd,0BAA0B;IAC9B;;IAEA;QACI,cAAc;IAClB;;IAEA;;;QAGI,aAAa;QACb,cAAc;IAClB;;IAEA;QACI,oBAAoB;IACxB;;IAEA;QACI,YAAY;IAChB;;IAEA;;;QAGI,cAAc;QACd,cAAc;IAClB;;IAEA;QACI,qBAAqB;IACzB;;IAEA;QACI,cAAc;IAClB;;IAEA;QACI,cAAc;IAClB;;IAEA;QACI,cAAc;IAClB;;IAEA;QACI,cAAc;IAClB;;IAEA;QACI,yBAAyB;IAC7B;;IAEA;QACI,yBAAyB;IAC7B;;IAEA;QACI,yBAAyB;IAC7B;;IAEA;QACI,eAAe;QACf,6BAA6B;IACjC;;IAEA;QACI,eAAe;QACf,2BAA2B;IAC/B;;IAEA;QACI,cAAc;IAClB;;IAEA;QACI,qBAAqB;QACrB,SAAS;QACT,UAAU;IACd;;IAEA;QACI,eAAe;QACf,kBAAkB;QAClB,gBAAgB;IACpB;;IAEA;QACI,YAAY;IAChB;;IAEA;QACI,kBAAkB;IACtB;;IAEA;QACI,kBAAkB;QAClB,QAAQ;QACR,mBAAmB;IACvB;;IAEA;QACI,WAAW;IACf;;IAEA;QACI,mBAAmB;QACnB,cAAc;QACd,yBAAyB;QACzB,kBAAkB;QAClB,wEAAwE;QACxE,0BAA0B;IAC9B;;IAEA;QACI,uBAAuB;QACvB,gCAAgC;QAChC,cAAc;QACd,mBAAmB;QACnB,SAAS;QACT,4BAA4B;QAC5B,2BAA2B;IAC/B;;IAEA;QACI,sBAAsB;IAC1B;;IAEA;QACI,cAAc;QACd,cAAc;IAClB;;IAEA;QACI,iBAAiB;QACjB,eAAe;IACnB;;IAEA;QACI,SAAS;QACT,sBAAsB;QACtB,cAAc;QACd,cAAc;QACd,4BAA4B;QAC5B,gBAAgB;IACpB;;IAEA;QACI,aAAa;IACjB;;IAEA;QACI,gBAAgB;IACpB;;IAEA;QACI,cAAc;QACd,mBAAmB;IACvB;;IAEA;QACI,SAAS;QACT,qBAAqB;QACrB,cAAc;QACd,mBAAmB;QACnB,gBAAgB;IACpB;;IAEA;QACI,sBAAsB;QACtB,cAAc;QACd,uBAAuB;IAC3B;;IAEA;QACI,mBAAmB;IACvB;;IAEA;QACI,cAAc;QACd,mBAAmB;IACvB;;IAEA;QACI,cAAc;QACd,mBAAmB;IACvB;;IAEA;QACI,cAAc;QACd,mBAAmB;IACvB;;IAEA;QACI,eAAe;QACf,iBAAiB;QACjB,gDAAgD;QAChD,qBAAqB;IACzB;;IAEA;QACI,qBAAqB;IACzB;;IAEA;QACI,mBAAmB;QACnB,cAAc;QACd,qCAAqC;QACrC,kBAAkB;QAClB,gBAAgB;IACpB;;IAEA;QACI,iBAAiB;IACrB;;IAEA;QACI,SAAS;QACT,sBAAsB;QACtB,cAAc;QACd,cAAc;QACd,uBAAuB;QACvB,4BAA4B;QAC5B,gBAAgB;IACpB;;IAEA;QACI,cAAc;QACd,mBAAmB;IACvB;;IAEA;QACI,cAAc;QACd,mBAAmB;IACvB;;IAEA;QACI,oBAAoB;QACpB,eAAe;QACf,yBAAiB;gBAAjB,iBAAiB;IACrB;;IAEA;QACI,aAAa;QACb,mBAAmB;QACnB,uBAAuB;QACvB,cAAc;IAClB;;IAEA;QACI,gBAAgB;QAChB,cAAc;QACd,eAAe;IACnB;;IAEA;QACI,cAAc;QACd,mBAAmB;QACnB,eAAe;QACf,gBAAgB;QAChB,uBAAuB;IAC3B;;IAEA;QACI,gBAAgB;QAChB,kBAAkB;IACtB;;IAEA;QACI,eAAe;QACf,oBAAoB;QACpB,mBAAmB;QACnB,cAAc;IAClB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,cAAc;IAClB;;IAEA;QACI,SAAS;QACT,UAAU;QACV,qBAAqB;IACzB;;IAEA;QACI,eAAe;QACf,aAAa;QACb,mBAAmB;QACnB,mBAAmB;QACnB,mBAAmB;QACnB,kBAAkB;QAClB,gBAAgB;IACpB;;IAEA;QACI,YAAY;IAChB;;IAEA;QACI,aAAa;QACb,mBAAmB;QACnB,8BAA8B;IAClC;;IAEA;QACI,kBAAkB;QAClB,cAAc;IAClB;;IAEA;QACI,kBAAkB;QAClB,QAAQ;QACR,mBAAmB;IACvB;;IAEA;QACI,WAAW;IACf;;IAEA;QACI,aAAa;QACb,mBAAmB;QACnB,uBAAuB;QACvB,cAAc;QACd,gBAAgB;QAChB,kBAAkB;QAClB,iBAAiB;IACrB;;IAEA;QACI,aAAa;IACjB;;IAEA;QACI,mBAAmB;QACnB,yBAAyB;QACzB,wEAAwE;QACxE,kBAAkB;QAClB,0BAA0B;IAC9B;;IAEA;QACI,qBAAqB;IACzB;;IAEA;QACI,eAAe;QACf,iBAAiB;QACjB,gCAAgC;QAChC,qBAAqB;IACzB;;IAEA;QACI,mBAAmB;IACvB;;IAEA;QACI,yBAAyB;IAC7B;;IAEA;QACI,yBAAyB;IAC7B;;IAEA;QACI,uBAAuB;QACvB,wEAAwE;IAC5E;;IAEA;QACI,cAAc;IAClB;;IAEA;QACI,wBAAwB;QACxB,oBAAoB;QACpB,mBAAmB;QACnB,cAAc;QACd,mBAAmB;IACvB;;IAEA;QACI,mBAAmB;IACvB;;IAEA;QACI,uBAAuB;QACvB,cAAc;QACd,eAAe;QACf,4BAA4B;QAC5B,+BAA+B;IACnC;;IAEA;QACI,qBAAqB;IACzB;;IAEA;QACI,wBAAwB;IAC5B;;IAEA;QACI,mBAAmB;QACnB,cAAc;QACd,qCAAqC;QACrC,kBAAkB;QAClB,gBAAgB;IACpB;;IAEA;QACI,uBAAuB;QACvB,gCAAgC;QAChC,cAAc;QACd,mBAAmB;QACnB,SAAS;QACT,4BAA4B;QAC5B,2BAA2B;IAC/B;;IAEA;QACI,sBAAsB;IAC1B;;IAEA;QACI,cAAc;QACd,cAAc;IAClB;;IAEA;QACI,oBAAoB;IACxB;;IAEA;QACI,mBAAmB;QACnB,WAAW;QACX,YAAY;QACZ,cAAc;QACd,cAAc;QACd,uBAAuB;QACvB,kBAAkB;QAClB,4BAA4B;IAChC;;IAEA;QACI,cAAc;QACd,yBAAyB;QACzB,uBAAuB;IAC3B;;IAEA;QACI,eAAe;QACf,iBAAiB;QACjB,gDAAgD;IACpD;;IAEA;QACI,iBAAiB;IACrB;;IAEA;QACI,SAAS;QACT,sBAAsB;QACtB,cAAc;QACd,cAAc;QACd,uBAAuB;QACvB,4BAA4B;QAC5B,gBAAgB;IACpB;;IAEA;QACI,aAAa;IACjB;;IAEA;QACI,gBAAgB;IACpB;;IAEA;QACI,cAAc;QACd,mBAAmB;IACvB;;IAEA;QACI,mBAAmB;IACvB;;IAEA;QACI,cAAc;QACd,mBAAmB;IACvB;;IAEA;QACI,oBAAoB;IACxB;;IAEA;QACI,SAAS;QACT,qBAAqB;QACrB,cAAc;QACd,mBAAmB;QACnB,gBAAgB;IACpB;;IAEA;QACI,sBAAsB;QACtB,cAAc;QACd,uBAAuB;IAC3B;;IAEA;QACI,qBAAqB;IACzB;;IAEA;QACI,gBAAgB;QAChB,mBAAmB;QACnB,cAAc;QACd,oCAAoC;QACpC,gBAAgB;QAChB,kBAAkB;IACtB;;IAEA;QACI,qBAAqB;QACrB,mBAAmB;IACvB;;IAEA;QACI,mBAAmB;IACvB;;IAEA;QACI,mBAAmB;IACvB;;IAEA;QACI,mBAAmB;IACvB;;IAEA;QACI,WAAW;QACX,YAAY;IAChB;;IAEA;QACI,yBAAyB;QACzB,mBAAmB;QACnB,WAAW;QACX,YAAY;QACZ,cAAc;QACd,kBAAkB;QAClB,wEAAwE;IAC5E;;IAEA;QACI,qBAAqB;IACzB;;IAEA;QACI,eAAe;QACf,iBAAiB;QACjB,iDAAiD;QACjD,qBAAqB;IACzB;;IAEA;QACI,WAAW;QACX,YAAY;QACZ,0BAA0B;QAC1B,yBAAyB;IAC7B;;IAEA;QACI,qBAAqB;QACrB,mBAAmB;IACvB;;IAEA;QACI,qBAAqB;QACrB,mBAAmB;QACnB;8BACsB;QACtB,cAAc;IAClB;;IAEA;QACI,qBAAqB;IACzB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,yBAAyB;IAC7B;;IAEA;QACI,yBAAyB;IAC7B;;IAEA;QACI,mBAAmB;IACvB;;IAEA;QACI,mBAAmB;IACvB;;IAEA;QACI,qBAAqB;IACzB;;IAEA;QACI,WAAW;IACf;;IAEA;QACI,cAAc;QACd,wEAAwE;QACxE,mBAAmB;IACvB;;IAEA;QACI,eAAe;QACf,gBAAgB;IACpB;;IAEA;QACI,cAAc;IAClB;;IAEA;QACI,eAAe;QACf,iBAAiB;QACjB,gDAAgD;IACpD;;IAEA;QACI,cAAc;IAClB;;IAEA;QACI,cAAc;IAClB;;IAEA;QACI,cAAc;IAClB;;IAEA;QACI,cAAc;IAClB;;IAEA;QACI,mBAAmB;QACnB,yBAAyB;QACzB,cAAc;QACd,wEAAwE;IAC5E;;IAEA;;QAEI,cAAc;IAClB;;IAEA;QACI,mBAAmB;QACnB,qBAAqB;QACrB,cAAc;IAClB;;IAEA;;QAEI,cAAc;IAClB;;IAEA;QACI,mBAAmB;QACnB,qBAAqB;QACrB,cAAc;IAClB;;IAEA;;QAEI,cAAc;IAClB;;IAEA;QACI,mBAAmB;QACnB,qBAAqB;QACrB,cAAc;IAClB;;IAEA;;QAEI,cAAc;IAClB;;IAEA;QACI,qBAAqB;IACzB;;IAEA;QACI,mBAAmB;QACnB,cAAc;QACd,kBAAkB;IACtB;;IAEA;QACI,gBAAgB;IACpB;;IAEA;QACI,sBAAsB;QACtB,uBAAuB;IAC3B;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,uBAAuB;QACvB,yBAAyB;IAC7B;;IAEA;QACI,gBAAgB;QAChB,eAAe;QACf,mBAAmB;QACnB,yBAAyB;QACzB,kBAAkB;QAClB,wEAAwE;IAC5E;;IAEA;QACI,eAAe;QACf,iBAAiB;QACjB,gDAAgD;IACpD;;IAEA;QACI,mBAAmB;IACvB;;IAEA;QACI,mBAAmB;QACnB,qBAAqB;IACzB;;IAEA;QACI,mBAAmB;QACnB,yBAAyB;QACzB,wEAAwE;QACxE,kBAAkB;IACtB;;IAEA;QACI,qBAAqB;IACzB;;IAEA;QACI,eAAe;QACf,iBAAiB;QACjB,gDAAgD;QAChD,qBAAqB;IACzB;;IAEA;QACI,sBAAsB;IAC1B;;IAEA;QACI,uBAAuB;QACvB,wEAAwE;IAC5E;;IAEA;QACI,cAAc;IAClB;;IAEA;QACI,wBAAwB;QACxB,oBAAoB;QACpB,mBAAmB;QACnB,cAAc;QACd,mBAAmB;IACvB;;IAEA;QACI,uBAAuB;QACvB,cAAc;QACd,eAAe;QACf,4BAA4B;QAC5B,+BAA+B;IACnC;;IAEA;QACI,cAAc;QACd,eAAe;IACnB;;IAEA;QACI,qBAAqB;IACzB;;IAEA;QACI,wBAAwB;IAC5B;;IAEA;QACI,mBAAmB;QACnB,cAAc;QACd,qCAAqC;QACrC,kBAAkB;QAClB,gBAAgB;IACpB;;IAEA;QACI,uBAAuB;QACvB,gCAAgC;QAChC,cAAc;QACd,mBAAmB;QACnB,SAAS;QACT,4BAA4B;QAC5B,2BAA2B;IAC/B;;IAEA;QACI,oBAAoB;IACxB;;IAEA;QACI,sBAAsB;IAC1B;;IAEA;QACI,cAAc;QACd,cAAc;IAClB;;IAEA;QACI,qBAAqB;IACzB;;IAEA;QACI,aAAa;IACjB;;IAEA;QACI,WAAW;QACX,YAAY;QACZ,cAAc;QACd,cAAc;QACd,uBAAuB;QACvB,kBAAkB;QAClB,4BAA4B;IAChC;;IAEA;QACI,cAAc;QACd,yBAAyB;QACzB,uBAAuB;IAC3B;;IAEA;QACI,eAAe;QACf,iBAAiB;QACjB,gDAAgD;IACpD;;IAEA;QACI,cAAc;IAClB;;IAEA;QACI,sBAAsB;QACtB,cAAc;QACd,uBAAuB;IAC3B;;IAEA;QACI,mBAAmB;IACvB;;IAEA;QACI,yBAAyB;IAC7B;;IAEA;QACI,yBAAyB;IAC7B;;IAEA;QACI,mBAAmB;QACnB,yBAAyB;QACzB,cAAc;QACd,wEAAwE;IAC5E;;IAEA;;QAEI,cAAc;IAClB;;IAEA;QACI,mBAAmB;QACnB,qBAAqB;QACrB,cAAc;IAClB;;IAEA;;QAEI,cAAc;IAClB;;IAEA;QACI,mBAAmB;QACnB,qBAAqB;QACrB,cAAc;IAClB;;IAEA;;QAEI,cAAc;IAClB;;IAEA;QACI,mBAAmB;QACnB,qBAAqB;QACrB,cAAc;IAClB;;IAEA;;QAEI,cAAc;IAClB;;IAEA;QACI,qBAAqB;IACzB;;IAEA;QACI,cAAc;QACd,mBAAmB;QACnB,yBAAyB;QACzB,uBAAuB;QACvB,eAAe;QACf,wEAAwE;QACxE,kBAAkB;QAClB,oCAAoC;IACxC;;IAEA;QACI,mBAAmB;QACnB,cAAc;QACd,qBAAqB;IACzB;;IAEA;QACI,mBAAmB;QACnB,cAAc;QACd,qBAAqB;IACzB;;IAEA;QACI,6BAA6B;QAC7B,cAAc;QACd,iBAAiB;IACrB;;IAEA;QACI,mCAAmC;QACnC,cAAc;;QAEd,iBAAiB;IACrB;;IAEA;QACI,mCAAmC;QACnC,cAAc;QACd,iBAAiB;IACrB;;IAEA;QACI,cAAc;QACd,qBAAqB;IACzB;;IAEA;QACI,mBAAmB;QACnB,cAAc;IAClB;;IAEA;QACI,mBAAmB;QACnB,cAAc;IAClB;;IAEA;QACI,6BAA6B;QAC7B,cAAc;QACd,yBAAyB;IAC7B;;IAEA;QACI,mCAAmC;QACnC,cAAc;QACd,yBAAyB;IAC7B;;IAEA;QACI,mCAAmC;QACnC,cAAc;QACd,yBAAyB;IAC7B;;IAEA;QACI,cAAc;IAClB;;IAEA;QACI,mBAAmB;QACnB,cAAc;IAClB;;IAEA;QACI,mBAAmB;QACnB,cAAc;IAClB;;IAEA;QACI,eAAe;QACf,iBAAiB;QACjB,gCAAgC;IACpC;;IAEA;QACI,0BAA0B;IAC9B;;IAEA;QACI,oBAAoB;IACxB;;IAEA;QACI,mBAAmB;IACvB;;IAEA;QACI,kBAAkB;IACtB;;IAEA;QACI,qBAAqB;IACzB;;IAEA;QACI,mBAAmB;QACnB,eAAe;QACf,YAAY;QACZ,iBAAiB;QACjB,cAAc;QACd,yBAAyB;IAC7B;;IAEA;QACI,+GAA+G;IACnH;;IAEA;QACI,mBAAmB;IACvB;;IAEA;QACI,eAAe;QACf,iBAAiB;IACrB;;IAEA;;QAEI,SAAS;IACb;;IAEA;QACI,kBAAkB;QAClB,gBAAgB;IACpB;;IAEA;QACI,eAAe;QACf,6BAA6B;IACjC;;IAEA;QACI,mBAAmB;IACvB;;IAEA;QACI,eAAe;QACf,2BAA2B;IAC/B;;IAEA;QACI,kBAAkB;IACtB;;IAEA;QACI,mBAAmB;IACvB;;IAEA;QACI,oBAAoB;IACxB;;IAEA;QACI,kBAAkB;IACtB;;IAEA;QACI,qBAAqB;IACzB;;IAEA;QACI,SAAS;IACb;;IAEA;QACI,WAAW;IACf;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,aAAa;IACjB;;IAEA;QACI,SAAO;IACX;;IAEA;;;;QAII,cAAc;QACd,mBAAmB;QACnB,yBAAyB;IAC7B;;IAEA;;;;QAII,mBAAmB;QACnB,cAAc;QACd,qBAAqB;IACzB;;IAEA;;;;QAII,iDAAiD;IACrD;;IAEA;;;;QAII,mBAAmB;QACnB,cAAc;QACd,qBAAqB;IACzB;;IAEA;;;;QAII,6BAA6B;QAC7B,cAAc;QACd,iBAAiB;IACrB;;IAEA;;;;QAII,qCAAqC;QACrC,cAAc;QACd,iBAAiB;IACrB;;IAEA;;;;QAII,qCAAqC;QACrC,cAAc;QACd,iBAAiB;IACrB;;IAEA;;;;QAII,6BAA6B;QAC7B,cAAc;QACd,yBAAyB;IAC7B;;IAEA;;;;QAII,qCAAqC;QACrC,yBAAyB;QACzB,cAAc;IAClB;;IAEA;;;;QAII,qCAAqC;QACrC,yBAAyB;QACzB,cAAc;IAClB;;IAEA;;;;QAII,cAAc;QACd,mBAAmB;QACnB,yBAAyB;IAC7B;;IAEA;;;;QAII,mBAAmB;QACnB,cAAc;QACd,qBAAqB;IACzB;;IAEA;;;;QAII,gDAAgD;IACpD;;IAEA;;;;QAII,mBAAmB;QACnB,cAAc;QACd,qBAAqB;IACzB;;IAEA;;;;QAII,6BAA6B;QAC7B,cAAc;QACd,iBAAiB;IACrB;;IAEA;;;;QAII,oCAAoC;QACpC,cAAc;QACd,iBAAiB;IACrB;;IAEA;;;;QAII,oCAAoC;QACpC,cAAc;QACd,iBAAiB;IACrB;;IAEA;;;;QAII,6BAA6B;QAC7B,cAAc;QACd,yBAAyB;IAC7B;;IAEA;;;;QAII,oCAAoC;QACpC,yBAAyB;QACzB,cAAc;IAClB;;IAEA;;;;QAII,oCAAoC;QACpC,yBAAyB;QACzB,cAAc;IAClB;;IAEA;;;;QAII,cAAc;QACd,mBAAmB;QACnB,yBAAyB;IAC7B;;IAEA;;;;QAII,mBAAmB;QACnB,cAAc;QACd,qBAAqB;IACzB;;IAEA;;;;QAII,+CAA+C;IACnD;;IAEA;;;;QAII,mBAAmB;QACnB,cAAc;QACd,qBAAqB;IACzB;;IAEA;;;;QAII,6BAA6B;QAC7B,cAAc;QACd,iBAAiB;IACrB;;IAEA;;;;QAII,mCAAmC;QACnC,cAAc;QACd,iBAAiB;IACrB;;IAEA;;;;QAII,mCAAmC;QACnC,cAAc;QACd,iBAAiB;IACrB;;IAEA;;;;QAII,6BAA6B;QAC7B,cAAc;QACd,yBAAyB;IAC7B;;IAEA;;;;QAII,mCAAmC;QACnC,yBAAyB;QACzB,cAAc;IAClB;;IAEA;;;;QAII,mCAAmC;QACnC,yBAAyB;QACzB,cAAc;IAClB;;IAEA;;;;QAII,cAAc;QACd,mBAAmB;QACnB,yBAAyB;IAC7B;;IAEA;;;;QAII,mBAAmB;QACnB,cAAc;QACd,qBAAqB;IACzB;;IAEA;;;;QAII,gDAAgD;IACpD;;IAEA;;;;QAII,mBAAmB;QACnB,cAAc;QACd,qBAAqB;IACzB;;IAEA;;;;QAII,6BAA6B;QAC7B,cAAc;QACd,iBAAiB;IACrB;;IAEA;;;;QAII,mCAAmC;QACnC,cAAc;QACd,iBAAiB;IACrB;;IAEA;;;;QAII,mCAAmC;QACnC,cAAc;QACd,iBAAiB;IACrB;;IAEA;;;;QAII,6BAA6B;QAC7B,cAAc;QACd,yBAAyB;IAC7B;;IAEA;;;;QAII,mCAAmC;QACnC,yBAAyB;QACzB,cAAc;IAClB;;IAEA;;;;QAII,mCAAmC;QACnC,yBAAyB;QACzB,cAAc;IAClB;;IAEA;;;;QAII,cAAc;QACd,mBAAmB;QACnB,yBAAyB;IAC7B;;IAEA;;;;QAII,mBAAmB;QACnB,cAAc;QACd,qBAAqB;IACzB;;IAEA;;;;QAII,gCAAgC;IACpC;;IAEA;;;;QAII,mBAAmB;QACnB,cAAc;QACd,qBAAqB;IACzB;;IAEA;;;;QAII,6BAA6B;QAC7B,cAAc;QACd,iBAAiB;IACrB;;IAEA;;;;QAII,oCAAoC;QACpC,cAAc;QACd,iBAAiB;IACrB;;IAEA;;;;QAII,oCAAoC;QACpC,cAAc;QACd,iBAAiB;IACrB;;IAEA;;;;QAII,6BAA6B;QAC7B,cAAc;QACd,yBAAyB;IAC7B;;IAEA;;;;QAII,oCAAoC;QACpC,yBAAyB;QACzB,cAAc;IAClB;;IAEA;;;;QAII,oCAAoC;QACpC,yBAAyB;QACzB,cAAc;IAClB;;IAEA;;;;QAII,cAAc;QACd,mBAAmB;QACnB,yBAAyB;IAC7B;;IAEA;;;;QAII,mBAAmB;QACnB,cAAc;QACd,qBAAqB;IACzB;;IAEA;;;;QAII,+CAA+C;IACnD;;IAEA;;;;QAII,mBAAmB;QACnB,cAAc;QACd,qBAAqB;IACzB;;IAEA;;;;QAII,6BAA6B;QAC7B,cAAc;QACd,iBAAiB;IACrB;;IAEA;;;;QAII,mCAAmC;QACnC,cAAc;QACd,iBAAiB;IACrB;;IAEA;;;;QAII,mCAAmC;QACnC,cAAc;QACd,iBAAiB;IACrB;;IAEA;;;;QAII,6BAA6B;QAC7B,cAAc;QACd,yBAAyB;IAC7B;;IAEA;;;;QAII,mCAAmC;QACnC,yBAAyB;QACzB,cAAc;IAClB;;IAEA;;;;QAII,mCAAmC;QACnC,yBAAyB;QACzB,cAAc;IAClB;;IAEA;QACI,cAAc;QACd,uBAAuB;QACvB,mBAAmB;IACvB;;IAEA;QACI,uBAAuB;QACvB,cAAc;QACd,yBAAyB;IAC7B;;IAEA;QACI,0BAA0B;IAC9B;;IAEA;QACI,uBAAuB;QACvB,gDAAgD;QAChD,yBAAyB;IAC7B;;IAEA;QACI,uBAAuB;QACvB,cAAc;QACd,yBAAyB;IAC7B;;IAEA;QACI,kBAAkB;IACtB;;IAEA;QACI,6BAA6B;QAC7B,cAAc;QACd,iBAAiB;IACrB;;IAEA;QACI,mCAAmC;QACnC,cAAc;IAClB;;IAEA;QACI,mCAAmC;QACnC,cAAc;IAClB;;IAEA;QACI,cAAc;QACd,qBAAqB;IACzB;;IAEA;QACI,mBAAmB;QACnB,cAAc;IAClB;;IAEA;QACI,mBAAmB;QACnB,cAAc;IAClB;;IAEA;QACI,6BAA6B;QAC7B,cAAc;QACd,yBAAyB;IAC7B;;IAEA;QACI,mCAAmC;QACnC,cAAc;QACd,yBAAyB;IAC7B;;IAEA;QACI,mCAAmC;QACnC,cAAc;QACd,yBAAyB;IAC7B;;IAEA;QACI,cAAc;IAClB;;IAEA;QACI,mBAAmB;QACnB,cAAc;IAClB;;IAEA;QACI,mBAAmB;QACnB,cAAc;IAClB;;IAEA;QACI,+GAA+G;IACnH;;IAEA;QACI,mBAAmB;IACvB;;IAEA;QACI,mBAAmB;IACvB;;IAEA;QACI,eAAe;QACf,6BAA6B;IACjC;;IAEA;QACI,mBAAmB;IACvB;;IAEA;QACI,eAAe;QACf,2BAA2B;IAC/B;;IAEA;QACI,WAAW;IACf;;IAEA;QACI,kBAAkB;IACtB;;IAEA;;;QAGI,yBAAyB;QACzB,4BAA4B;IAChC;;IAEA;QACI,6BAA6B;QAC7B,cAAc;QACd,iBAAiB;IACrB;;IAEA;QACI,qCAAqC;QACrC,cAAc;IAClB;;IAEA;QACI,qCAAqC;QACrC,cAAc;IAClB;;IAEA;QACI,6BAA6B;QAC7B,cAAc;QACd,yBAAyB;IAC7B;;IAEA;QACI,qCAAqC;QACrC,yBAAyB;QACzB,cAAc;IAClB;;IAEA;QACI,qCAAqC;QACrC,yBAAyB;QACzB,cAAc;IAClB;;IAEA;QACI,6BAA6B;QAC7B,cAAc;QACd,iBAAiB;IACrB;;IAEA;QACI,oCAAoC;QACpC,cAAc;IAClB;;IAEA;QACI,oCAAoC;QACpC,cAAc;IAClB;;IAEA;QACI,6BAA6B;QAC7B,cAAc;QACd,yBAAyB;IAC7B;;IAEA;QACI,oCAAoC;QACpC,yBAAyB;QACzB,cAAc;IAClB;;IAEA;QACI,oCAAoC;QACpC,yBAAyB;QACzB,cAAc;IAClB;;IAEA;QACI,6BAA6B;QAC7B,cAAc;QACd,iBAAiB;IACrB;;IAEA;QACI,mCAAmC;QACnC,cAAc;IAClB;;IAEA;QACI,mCAAmC;QACnC,cAAc;IAClB;;IAEA;QACI,6BAA6B;QAC7B,cAAc;QACd,yBAAyB;IAC7B;;IAEA;QACI,mCAAmC;QACnC,yBAAyB;QACzB,cAAc;IAClB;;IAEA;QACI,mCAAmC;QACnC,yBAAyB;QACzB,cAAc;IAClB;;IAEA;QACI,6BAA6B;QAC7B,cAAc;QACd,iBAAiB;IACrB;;IAEA;QACI,mCAAmC;QACnC,cAAc;IAClB;;IAEA;QACI,mCAAmC;QACnC,cAAc;IAClB;;IAEA;QACI,6BAA6B;QAC7B,cAAc;QACd,yBAAyB;IAC7B;;IAEA;QACI,mCAAmC;QACnC,yBAAyB;QACzB,cAAc;IAClB;;IAEA;QACI,mCAAmC;QACnC,yBAAyB;QACzB,cAAc;IAClB;;IAEA;QACI,6BAA6B;QAC7B,cAAc;QACd,iBAAiB;IACrB;;IAEA;QACI,oCAAoC;QACpC,cAAc;IAClB;;IAEA;QACI,oCAAoC;QACpC,cAAc;IAClB;;IAEA;QACI,6BAA6B;QAC7B,cAAc;QACd,yBAAyB;IAC7B;;IAEA;QACI,oCAAoC;QACpC,yBAAyB;QACzB,cAAc;IAClB;;IAEA;QACI,oCAAoC;QACpC,yBAAyB;QACzB,cAAc;IAClB;;IAEA;QACI,6BAA6B;QAC7B,cAAc;QACd,iBAAiB;IACrB;;IAEA;QACI,mCAAmC;QACnC,cAAc;IAClB;;IAEA;QACI,mCAAmC;QACnC,cAAc;IAClB;;IAEA;QACI,6BAA6B;QAC7B,cAAc;QACd,yBAAyB;IAC7B;;IAEA;QACI,mCAAmC;QACnC,yBAAyB;QACzB,cAAc;IAClB;;IAEA;QACI,mCAAmC;QACnC,yBAAyB;QACzB,cAAc;IAClB;;IAEA;QACI,WAAW;QACX,YAAY;IAChB;;IAEA;QACI,iBAAiB;IACrB;;IAEA;QACI,aAAa;QACb,cAAc;IAClB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,WAAW;QACX,YAAY;QACZ,mBAAmB;QACnB,WAAW;IACf;;IAEA;QACI,mBAAmB;QACnB,WAAW;IACf;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,qBAAqB;IACzB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,kBAAkB;IACtB;;IAEA;QACI,iBAAiB;IACrB;;IAEA;QACI,oBAAoB;IACxB;;IAEA;QACI,iBAAiB;IACrB;;IAEA;QACI,mBAAmB;IACvB;;IAEA;;;QAGI,SAAS;IACb;;IAEA;;;;;;QAMI,SAAS;IACb;;IAEA;QACI,oCAAoC;QACpC,kBAAkB;IACtB;;IAEA;;QAEI,WAAW;QACX,YAAY;QACZ,cAAc;QACd,cAAc;QACd,uBAAuB;QACvB,kBAAkB;QAClB,4BAA4B;QAC5B,cAAc;IAClB;;IAEA;;QAEI,cAAc;QACd,yBAAyB;QACzB,uBAAuB;IAC3B;;IAEA;;QAEI,eAAe;QACf,iBAAiB;QACjB,gDAAgD;IACpD;;IAEA;QACI,aAAa;IACjB;;IAEA;QACI,oBAAoB;QACpB,qBAAqB;IACzB;;IAEA;QACI,yBAAyB;QACzB,WAAW;QACX,cAAc;QACd,4BAA4B;QAC5B,gBAAgB;IACpB;;IAEA;QACI,mBAAmB;IACvB;;IAEA;QACI,mBAAmB;QACnB,cAAc;IAClB;;IAEA;QACI,uBAAuB;QACvB,gBAAgB;IACpB;;IAEA;QACI,uBAAuB;QACvB,+BAA+B;QAC/B,8BAA8B;IAClC;;IAEA;QACI,mBAAmB;QACnB,cAAc;QACd,qBAAqB;QACrB,uBAAuB;QACvB,wBAAwB;QACxB,gBAAgB;IACpB;;IAEA;QACI,mBAAmB;QACnB,cAAc;QACd,yBAAyB;QACzB,yBAAyB;QACzB,kBAAkB;QAClB,gBAAgB;IACpB;;IAEA;QACI,gBAAgB;QAChB,sBAAsB;QACtB,yBAAyB;QACzB,yBAAyB;QACzB,gBAAgB;QAChB,cAAc;QACd,mBAAmB;QACnB,4BAA4B;IAChC;;IAEA;QACI,gBAAgB;QAChB,kBAAkB;QAClB,yBAAyB;QACzB,yBAAyB;QACzB,gBAAgB;QAChB,cAAc;QACd,mBAAmB;IACvB;;IAEA;QACI,cAAc;QACd,mBAAmB;IACvB;;IAEA;QACI,kBAAkB;QAClB,gBAAgB;QAChB,mBAAmB;QACnB,qBAAqB;QACrB,cAAc;QACd,mBAAmB;QACnB,mBAAmB;IACvB;;IAEA;QACI,mBAAmB;QACnB,cAAc;IAClB;;IAEA;QACI,cAAc;IAClB;;IAEA;QACI,mBAAmB;QACnB,cAAc;IAClB;;IAEA;QACI,cAAc;IAClB;;IAEA;QACI,mBAAmB;QACnB,cAAc;IAClB;;IAEA;QACI,cAAc;IAClB;;IAEA;QACI,uDAAuD;QACvD,eAAe;IACnB;;IAEA;QACI,mBAAmB;QACnB,cAAc;QACd,4BAA4B;IAChC;;IAEA;QACI,gBAAgB;QAChB,yBAAyB;QACzB,uBAAuB;QACvB,sBAAsB;IAC1B;;IAEA;;;;QAII,WAAW;QACX,YAAY;QACZ,cAAc;QACd,cAAc;QACd,uBAAuB;QACvB,kBAAkB;QAClB,4BAA4B;IAChC;;IAEA;;;;QAII,cAAc;QACd,yBAAyB;QACzB,uBAAuB;IAC3B;;IAEA;;;;QAII,eAAe;QACf,iBAAiB;QACjB,gDAAgD;IACpD;;IAEA;QACI,oBAAoB;IACxB;;IAEA;QACI,gBAAgB;IACpB;;IAEA;QACI,mBAAmB;QACnB,cAAc;IAClB;;IAEA;QACI,mBAAmB;QACnB,cAAc;IAClB;;IAEA;QACI,8CAA8C;QAC9C,wBAAwB;IAC5B;;IAEA;QACI,mCAAmC;IACvC;;IAEA;QACI,oCAAoC;IACxC;;IAEA;QACI,mBAAmB;QACnB,cAAc;IAClB;;IAEA;QACI,8CAA8C;QAC9C,wBAAwB;IAC5B;;IAEA;QACI,mBAAmB;QACnB,cAAc;IAClB;;IAEA;QACI,8CAA8C;QAC9C,wBAAwB;IAC5B;;IAEA;QACI,mBAAmB;QACnB,cAAc;IAClB;;IAEA;QACI,mBAAmB;IACvB;;IAEA;;QAEI,mBAAmB;IACvB;;IAEA;;;;QAII,yBAAyB;IAC7B;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,WAAW;QACX,YAAY;IAChB;;IAEA;QACI,2BAA2B;QAC3B,4BAA4B;QAC5B,2BAA2B;IAC/B;;IAEA;QACI,2BAA2B;IAC/B;;IAEA;QACI,yBAAyB;IAC7B;;IAEA;QACI,2BAA2B;IAC/B;;IAEA;QACI,2BAA2B;IAC/B;;IAEA;QACI,iBAAiB;IACrB;;IAEA;QACI,yBAAyB;IAC7B;;IAEA;QACI,2BAA2B;IAC/B;;IAEA;QACI,2BAA2B;IAC/B;;IAEA;QACI,iBAAiB;IACrB;;IAEA;QACI,2BAA2B;IAC/B;;IAEA;QACI,6BAA6B;IACjC;;IAEA;QACI,yBAAyB;IAC7B;;IAEA;QACI,2BAA2B;IAC/B;;IAEA;QACI,yBAAyB;IAC7B;;IAEA;QACI,2BAA2B;IAC/B;;IAEA;QACI,uBAAuB;IAC3B;;IAEA;QACI,yBAAyB;IAC7B;;IAEA;QACI,+BAA+B;IACnC;;IAEA;QACI,mBAAmB;QACnB,cAAc;IAClB;;IAEA;QACI,cAAc;IAClB;;IAEA;QACI,cAAc;IAClB;;IAEA;QACI,+BAA+B;IACnC;;IAEA;QACI,sBAAsB;IAC1B;;IAEA;QACI,sBAAsB;IAC1B;;IAEA;QACI,sBAAsB;IAC1B;;IAEA;QACI,sBAAsB;IAC1B;;IAEA;QACI,sBAAsB;IAC1B;;IAEA;QACI,wBAAwB;IAC5B;;IAEA;QACI,wBAAwB;IAC5B;;IAEA;QACI,wBAAwB;IAC5B;;IAEA;QACI,wBAAwB;IAC5B;;IAEA;QACI,wBAAwB;IAC5B;;IAEA;QACI,mCAAmC;IACvC;;IAEA;QACI,uBAAuB;QACvB,gBAAgB;IACpB;;IAEA;QACI,uBAAuB;QACvB,gBAAgB;IACpB;;IAEA;QACI,mBAAmB;QACnB,cAAc;QACd,qBAAqB;QACrB,uBAAuB;QACvB,kBAAkB;QAClB,gBAAgB;IACpB;;IAEA;QACI,mBAAmB;QACnB,cAAc;QACd,cAAc;QACd,UAAU;IACd;;IAEA;QACI,mBAAmB;QACnB,cAAc;QACd,yBAAyB;QACzB,yBAAyB;QACzB,kBAAkB;QAClB,gBAAgB;QAChB,8BAA8B;QAC9B,+BAA+B;IACnC;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,WAAW;QACX,YAAY;IAChB;;IAEA;QACI,uBAAuB;QACvB,gBAAgB;IACpB;;IAEA;QACI,uBAAuB;QACvB,gBAAgB;IACpB;;IAEA;QACI,mBAAmB;QACnB,cAAc;QACd,qBAAqB;QACrB,uBAAuB;QACvB,kBAAkB;QAClB,gBAAgB;IACpB;;IAEA;QACI,mBAAmB;QACnB,cAAc;QACd,cAAc;QACd,UAAU;IACd;;IAEA;QACI,yBAAyB;QACzB,uBAAuB;IAC3B;;IAEA;QACI,mBAAmB;QACnB,cAAc;QACd,yBAAyB;QACzB,yBAAyB;QACzB,kBAAkB;QAClB,gBAAgB;QAChB,8BAA8B;QAC9B,+BAA+B;IACnC;;IAEA;;QAEI,mBAAmB;IACvB;;IAEA;QACI,WAAW;QACX,YAAY;QACZ,cAAc;QACd,cAAc;QACd,uBAAuB;QACvB,kBAAkB;QAClB,4BAA4B;IAChC;;IAEA;QACI,cAAc;QACd,yBAAyB;QACzB,uBAAuB;IAC3B;;IAEA;;QAEI,uBAAuB;QACvB,cAAc;IAClB;;IAEA;;QAEI,mBAAmB;QACnB,cAAc;IAClB;;IAEA;QACI,eAAe;QACf,iBAAiB;QACjB,gDAAgD;IACpD;;IAEA;QACI,WAAW;QACX,YAAY;QACZ,cAAc;QACd,cAAc;QACd,uBAAuB;QACvB,kBAAkB;QAClB,4BAA4B;IAChC;;IAEA;QACI,cAAc;QACd,yBAAyB;QACzB,uBAAuB;IAC3B;;IAEA;QACI,eAAe;QACf,iBAAiB;QACjB,gDAAgD;IACpD;;IAEA;QACI,mBAAmB;QACnB,cAAc;QACd,qCAAqC;QACrC,kBAAkB;QAClB,gBAAgB;QAChB,kBAAkB;IACtB;;IAEA;QACI,iBAAiB;IACrB;;IAEA;QACI,SAAS;QACT,sBAAsB;QACtB,cAAc;QACd,cAAc;QACd,uBAAuB;QACvB,4BAA4B;QAC5B,gBAAgB;IACpB;;IAEA;QACI,cAAc;QACd,mBAAmB;IACvB;;IAEA;QACI,cAAc;QACd,mBAAmB;IACvB;;IAEA;QACI,eAAe;QACf,iBAAiB;QACjB,uDAAuD;IAC3D;;IAEA;QACI,6BAA6B;QAC7B,gBAAgB;IACpB;;IAEA;QACI,uBAAuB;QACvB,gCAAgC;QAChC,cAAc;QACd,mBAAmB;QACnB,SAAS;QACT,4BAA4B;QAC5B,2BAA2B;IAC/B;;IAEA;QACI,gBAAgB;QAChB,gCAAgC;IACpC;;IAEA;QACI,qBAAqB;IACzB;;IAEA;QACI,kBAAkB;IACtB;;IAEA;QACI,qBAAqB;IACzB;;IAEA;QACI,uBAAuB;IAC3B;;IAEA;QACI,gBAAgB;IACpB;;IAEA;QACI,gBAAgB;IACpB;;IAEA;QACI,qBAAqB;IACzB;;IAEA;QACI,mBAAmB;QACnB,cAAc;QACd,yBAAyB;QACzB,qBAAqB;QACrB,gBAAgB;QAChB,qBAAqB;QACrB,4BAA4B;QAC5B,2BAA2B;IAC/B;;IAEA;QACI,qBAAqB;QACrB,mBAAmB;QACnB,yBAAyB;QACzB,qBAAqB;IACzB;;IAEA;QACI,sBAAsB;IAC1B;;IAEA;QACI,cAAc;QACd,cAAc;IAClB;;IAEA;QACI,yBAAyB;QACzB,mBAAmB;QACnB,cAAc;QACd,iBAAiB;QACjB,+BAA+B;QAC/B,8BAA8B;QAC9B,eAAe;IACnB;;IAEA;QACI,sBAAsB;QACtB,SAAS;QACT,cAAc;QACd,cAAc;QACd,uBAAuB;QACvB,6CAA6C;IACjD;;IAEA;QACI,mBAAmB;QACnB,cAAc;IAClB;;IAEA;QACI,cAAc;QACd,mBAAmB;IACvB;;IAEA;QACI,cAAc;QACd,mBAAmB;IACvB;;IAEA;QACI,mBAAmB;IACvB;;IAEA;QACI,+BAA+B;IACnC;;IAEA;QACI,mBAAmB;IACvB;;IAEA;QACI,mBAAmB;QACnB,cAAc;IAClB;;IAEA;QACI,mBAAmB;QACnB,cAAc;IAClB;;IAEA;QACI,cAAc;IAClB;;IAEA;QACI,mBAAmB;IACvB;;IAEA;QACI,+BAA+B;QAC/B,qBAAqB;IACzB;;IAEA;QACI,6BAA6B;QAC7B,qBAAqB;IACzB;;IAEA;QACI,yBAAyB;QACzB,mBAAmB;QACnB,cAAc;QACd,gBAAgB;IACpB;;IAEA;QACI,mBAAmB;QACnB,cAAc;QACd,kBAAkB;IACtB;;IAEA;QACI,eAAe;QACf,iBAAiB;QACjB,gDAAgD;IACpD;;IAEA;QACI,mBAAmB;QACnB,cAAc;QACd,qBAAqB;QACrB,eAAe;QACf,eAAe;QACf,kBAAkB;IACtB;;IAEA;;;;QAII,yBAAyB;QACzB,yBAAyB;QACzB,cAAc;QACd,mBAAmB;QACnB,gBAAgB;QAChB,kBAAkB;QAClB,4BAA4B;QAC5B,gBAAgB;IACpB;;IAEA;;;;QAII,mBAAmB;QACnB,qBAAqB;QACrB,cAAc;IAClB;;IAEA;QACI,4BAA4B;QAC5B,+BAA+B;IACnC;;IAEA;QACI,6BAA6B;QAC7B,gCAAgC;IACpC;;IAEA;QACI,mBAAmB;QACnB,gBAAgB;IACpB;;IAEA;QACI,gBAAgB;QAChB,cAAc;IAClB;;IAEA;QACI,mBAAmB;QACnB,oBAAoB;IACxB;;IAEA;QACI,mBAAmB;IACvB;;IAEA;QACI,yBAAyB;QACzB,yBAAyB;QACzB,cAAc;QACd,mBAAmB;QACnB,gBAAgB;QAChB,kBAAkB;QAClB,iBAAiB;IACrB;;IAEA;QACI,yBAAyB;QACzB,yBAAyB;QACzB,cAAc;QACd,mBAAmB;QACnB,gBAAgB;QAChB,kBAAkB;QAClB,4BAA4B;QAC5B,gBAAgB;IACpB;;IAEA;QACI,mBAAmB;QACnB,qBAAqB;QACrB,cAAc;IAClB;;IAEA;QACI,mBAAmB;QACnB,qBAAqB;QACrB,cAAc;IAClB;;IAEA;QACI,gBAAgB;IACpB;;IAEA;QACI,qBAAqB;IACzB;;IAEA;QACI,mBAAmB;QACnB,cAAc;QACd,yBAAyB;QACzB,qBAAqB;QACrB,gBAAgB;QAChB,qBAAqB;QACrB,4BAA4B;QAC5B,2BAA2B;IAC/B;;IAEA;QACI,qBAAqB;QACrB,mBAAmB;QACnB,yBAAyB;QACzB,qBAAqB;IACzB;;IAEA;QACI,sBAAsB;IAC1B;;IAEA;QACI,cAAc;QACd,cAAc;IAClB;;IAEA;QACI,yBAAyB;QACzB,mBAAmB;QACnB,cAAc;QACd,iBAAiB;QACjB,+BAA+B;QAC/B,8BAA8B;QAC9B,eAAe;IACnB;;IAEA;QACI,sBAAsB;QACtB,SAAS;QACT,cAAc;QACd,cAAc;QACd,uBAAuB;QACvB,6CAA6C;IACjD;;IAEA;QACI,mBAAmB;QACnB,cAAc;IAClB;;IAEA;QACI,cAAc;QACd,mBAAmB;IACvB;;IAEA;QACI,cAAc;QACd,mBAAmB;IACvB;;IAEA;QACI,mBAAmB;IACvB;;IAEA;QACI,yBAAyB;QACzB,mBAAmB;QACnB,cAAc;QACd,gBAAgB;QAChB,kBAAkB;IACtB;;IAEA;QACI,iBAAiB;QACjB,eAAe;IACnB;;IAEA;QACI,eAAe;QACf,iBAAiB;QACjB,uDAAuD;IAC3D;;IAEA;QACI,kBAAkB;QAClB,4BAA4B;QAC5B,iBAAiB;IACrB;;IAEA;QACI,oBAAoB;QACpB,WAAW;QACX,YAAY;QACZ,cAAc;QACd,cAAc;QACd,uBAAuB;QACvB,kBAAkB;QAClB,4BAA4B;IAChC;;IAEA;QACI,cAAc;QACd,yBAAyB;QACzB,uBAAuB;IAC3B;;IAEA;QACI,eAAe;QACf,iBAAiB;QACjB,gDAAgD;IACpD;;IAEA;QACI,oBAAoB;QACpB,cAAc;IAClB;;IAEA;QACI,oBAAoB;IACxB;;IAEA;QACI,cAAc;IAClB;;IAEA;QACI,mBAAmB;QACnB,cAAc;IAClB;;IAEA;;QAEI,cAAc;IAClB;;IAEA;;QAEI,cAAc;IAClB;;IAEA;QACI,mBAAmB;QACnB,cAAc;IAClB;;IAEA;QACI,mBAAmB;QACnB,cAAc;IAClB;;IAEA;QACI,qBAAqB;IACzB;;IAEA;QACI,WAAW;QACX,sBAAsB;IAC1B;;IAEA;QACI,cAAc;QACd,cAAc;IAClB;;IAEA;QACI,mBAAmB;IACvB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,WAAW;QACX,YAAY;IAChB;;IAEA;QACI,cAAc;IAClB;;IAEA;QACI,mBAAmB;IACvB;;IAEA;QACI,uBAAuB;QACvB,gBAAgB;IACpB;;IAEA;QACI,uBAAuB;QACvB,gBAAgB;IACpB;;IAEA;QACI,mBAAmB;QACnB,cAAc;QACd,qBAAqB;QACrB,uBAAuB;QACvB,kBAAkB;QAClB,gBAAgB;IACpB;;IAEA;QACI,mBAAmB;QACnB,cAAc;QACd,yBAAyB;QACzB,yBAAyB;QACzB,kBAAkB;QAClB,gBAAgB;IACpB;;IAEA;QACI,gBAAgB;QAChB,kBAAkB;QAClB,yBAAyB;QACzB,yBAAyB;QACzB,gBAAgB;QAChB,cAAc;QACd,mBAAmB;QACnB,4BAA4B;IAChC;;IAEA;QACI,gBAAgB;QAChB,kBAAkB;QAClB,yBAAyB;QACzB,yBAAyB;QACzB,gBAAgB;QAChB,cAAc;QACd,mBAAmB;IACvB;;IAEA;QACI,sCAAsC;IAC1C;;IAEA;QACI,cAAc;QACd,mBAAmB;IACvB;;IAEA;QACI,kBAAkB;QAClB,gBAAgB;QAChB,mBAAmB;QACnB,qBAAqB;QACrB,cAAc;QACd,mBAAmB;QACnB,mBAAmB;IACvB;;IAEA;QACI,mBAAmB;QACnB,cAAc;IAClB;;IAEA;QACI,cAAc;IAClB;;IAEA;QACI,mBAAmB;QACnB,cAAc;IAClB;;IAEA;QACI,cAAc;IAClB;;IAEA;QACI,mBAAmB;QACnB,cAAc;QACd,4BAA4B;IAChC;;IAEA;QACI,gBAAgB;QAChB,yBAAyB;QACzB,uBAAuB;QACvB,kBAAkB;IACtB;;IAEA;QACI,WAAW;QACX,YAAY;QACZ,cAAc;QACd,cAAc;QACd,uBAAuB;QACvB,kBAAkB;QAClB,4BAA4B;QAC5B,oBAAoB;IACxB;;IAEA;QACI,cAAc;QACd,yBAAyB;QACzB,uBAAuB;IAC3B;;IAEA;QACI,eAAe;QACf,iBAAiB;QACjB,gDAAgD;IACpD;;IAEA;QACI,oBAAoB;IACxB;;IAEA;QACI,cAAc;IAClB;;IAEA;QACI,8CAA8C;QAC9C,wBAAwB;IAC5B;;IAEA;QACI,mBAAmB;QACnB,cAAc;IAClB;;IAEA;QACI,cAAc;IAClB;;IAEA;QACI,cAAc;IAClB;;IAEA;;QAEI,mBAAmB;QACnB,cAAc;IAClB;;IAEA;;QAEI,cAAc;IAClB;;IAEA;QACI,mBAAmB;IACvB;;IAEA;;QAEI,mBAAmB;IACvB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,WAAW;QACX,YAAY;IAChB;;IAEA;QACI,2BAA2B;IAC/B;;IAEA;QACI,2BAA2B;IAC/B;;IAEA;QACI,yBAAyB;IAC7B;;IAEA;QACI,2BAA2B;IAC/B;;IAEA;QACI,iBAAiB;IACrB;;IAEA;QACI,iBAAiB;IACrB;;IAEA;QACI,iBAAiB;IACrB;;IAEA;QACI,+BAA+B;IACnC;;IAEA;QACI,mBAAmB;QACnB,cAAc;IAClB;;IAEA;QACI,cAAc;IAClB;;IAEA;QACI,cAAc;IAClB;;IAEA;QACI,+BAA+B;IACnC;;IAEA;QACI,0BAA0B;IAC9B;;IAEA;QACI,sBAAsB;IAC1B;;IAEA;QACI,sBAAsB;IAC1B;;IAEA;QACI,sBAAsB;IAC1B;;IAEA;QACI,sBAAsB;IAC1B;;IAEA;QACI,wBAAwB;IAC5B;;IAEA;QACI,wBAAwB;IAC5B;;IAEA;QACI,wBAAwB;IAC5B;;IAEA;QACI,wBAAwB;IAC5B;;IAEA;QACI,wBAAwB;IAC5B;;IAEA;QACI,cAAc;QACd,kBAAkB;QAClB,WAAW;QACX,YAAY;QACZ,yBAAyB;IAC7B;;IAEA;QACI,yBAAyB;IAC7B;;IAEA;;QAEI,eAAe;IACnB;;IAEA;QACI,UAAU;IACd;;IAEA;;QAEI,eAAe;IACnB;;IAEA;QACI,WAAW;IACf;;IAEA;QACI,qBAAqB;QACrB,yBAAyB;QACzB,cAAc;QACd,mBAAmB;QACnB,gBAAgB;QAChB,kBAAkB;QAClB,4BAA4B;IAChC;;IAEA;QACI,oBAAoB;IACxB;;IAEA;QACI,eAAe;QACf,iBAAiB;QACjB,gDAAgD;IACpD;;IAEA;QACI,mBAAmB;QACnB,qBAAqB;QACrB,cAAc;IAClB;;IAEA;QACI,mBAAmB;QACnB,qBAAqB;QACrB,cAAc;QACd,6BAA6B;QAC7B,4BAA4B;IAChC;;IAEA;QACI,qBAAqB;QACrB,mBAAmB;QACnB,cAAc;IAClB;;IAEA;QACI,gBAAgB;QAChB,yBAAyB;QACzB,mBAAmB;QACnB,cAAc;QACd,aAAa;QACb,0BAA0B;QAC1B,yBAAyB;QACzB,+BAA+B;QAC/B,8BAA8B;IAClC;;IAEA;QACI,gBAAgB;IACpB;;IAEA;QACI,gBAAgB;IACpB;;IAEA;QACI,6BAA6B;QAC7B,4BAA4B;IAChC;;IAEA;QACI,kBAAkB;IACtB;;IAEA;;QAEI,kBAAkB;IACtB;;IAEA;QACI,4BAA4B;QAC5B,2BAA2B;IAC/B;;IAEA;QACI,+BAA+B;QAC/B,8BAA8B;IAClC;;IAEA;QACI,+BAA+B;QAC/B,8BAA8B;IAClC;;IAEA;QACI,mBAAmB;QACnB,cAAc;QACd,+GAA+G;QAC/G,kBAAkB;IACtB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,eAAe;QACf,gBAAgB;QAChB,qBAAqB;IACzB;;IAEA;QACI,gBAAgB;QAChB,qBAAqB;QACrB,cAAc;IAClB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,mBAAmB;IACvB;;IAEA;QACI,yBAAyB;QACzB,mBAAmB;QACnB,cAAc;QACd,kBAAkB;IACtB;;IAEA;QACI,eAAe;QACf,yBAAyB;QACzB,cAAc;QACd,mBAAmB;QACnB,iBAAiB;QACjB,kBAAkB;QAClB,mCAAmC;IACvC;;IAEA;QACI,UAAU;QACV,4BAA4B;IAChC;;IAEA;QACI,qBAAqB;QACrB,cAAc;QACd,kBAAkB;QAClB,4BAA4B;IAChC;;IAEA;QACI,oBAAoB;IACxB;;IAEA;QACI,eAAe;QACf,iBAAiB;QACjB,gDAAgD;IACpD;;IAEA;QACI,mBAAmB;QACnB,qBAAqB;QACrB,cAAc;IAClB;;IAEA;QACI,aAAa;IACjB;;IAEA;QACI,yBAAyB;IAC7B;;IAEA;QACI,cAAc;QACd,eAAe;IACnB;;IAEA;QACI,uBAAuB;IAC3B;;IAEA;QACI,iBAAiB;IACrB;;IAEA;QACI,cAAc;QACd,eAAe;IACnB;;IAEA;QACI,wBAAwB;IAC5B;;IAEA;QACI,iBAAiB;IACrB;;IAEA;QACI,yBAAyB;QACzB,qBAAqB;QACrB,mBAAmB;QACnB,cAAc;QACd,4BAA4B;QAC5B,2BAA2B;IAC/B;;IAEA;QACI,gBAAgB;IACpB;;IAEA;QACI,WAAW;QACX,YAAY;QACZ,cAAc;QACd,cAAc;QACd,uBAAuB;QACvB,kBAAkB;QAClB,4BAA4B;IAChC;;IAEA;QACI,cAAc;QACd,yBAAyB;QACzB,uBAAuB;IAC3B;;IAEA;QACI,eAAe;QACf,iBAAiB;QACjB,gDAAgD;IACpD;;IAEA;QACI,uBAAuB;IAC3B;;IAEA;QACI,gBAAgB;QAChB,yBAAyB;QACzB,mBAAmB;QACnB,cAAc;QACd,+BAA+B;QAC/B,8BAA8B;QAC9B,kBAAkB;IACtB;;IAEA;QACI,uBAAuB;QACvB,yBAAyB;QACzB,mBAAmB;QACnB,cAAc;QACd,kBAAkB;IACtB;;IAEA;QACI,yBAAyB;QACzB,mBAAmB;QACnB,kBAAkB;QAClB,cAAc;IAClB;;IAEA;QACI,4BAA4B;QAC5B,mBAAmB;IACvB;;IAEA;QACI,mBAAmB;IACvB;;IAEA;QACI,eAAe;QACf,iBAAiB;QACjB,gDAAgD;IACpD;;IAEA;QACI,mBAAmB;IACvB;;IAEA;QACI,mBAAmB;QACnB,cAAc;IAClB;;IAEA;QACI,eAAe;QACf,iBAAiB;QACjB,gDAAgD;IACpD;;IAEA;QACI,uBAAuB;QACvB,+BAA+B;QAC/B,yBAAyB;QACzB,uBAAuB;IAC3B;;IAEA;QACI,iBAAiB;IACrB;;IAEA;;;;;;;;;;;;OAYG;IACH;QACI,aAAa;QACb,iBAAiB;QACjB,6CAA6C;QAC7C,mBAAmB;QACnB,cAAc;QACd,qBAAqB;QACrB,gBAAgB;QAChB,6BAA6B;QAC7B,4BAA4B;QAC5B,4BAA4B;QAC5B,kBAAkB;QAClB,oCAAoC;IACxC;;IAEA;QACI,eAAe;QACf,iBAAiB;QACjB,sDAAsD;IAC1D;;IAEA;QACI,mBAAmB;QACnB,qBAAqB;QACrB,cAAc;IAClB;;IAEA;;;;OAIG;;IAEH;QACI,mBAAmB;QACnB,6CAA6C;QAC7C,cAAc;IAClB;;IAEA;QACI,mBAAmB;IACvB;;IAEA;QACI,mBAAmB;QACnB,cAAc;QACd,eAAe;QACf,+GAA+G;QAC/G,gBAAgB;IACpB;;IAEA;QACI,eAAe;QACf,iBAAiB;QACjB,sDAAsD;IAC1D;;IAEA;QACI,mBAAmB;QACnB,gBAAgB;QAChB,+BAA+B;QAC/B,8BAA8B;QAC9B,+BAA+B;QAC/B,gCAAgC;QAChC,cAAc;QACd,+BAA+B;QAC/B,8BAA8B;IAClC;;IAEA;QACI,mBAAmB;QACnB,yBAAyB;QACzB,qBAAqB;QACrB,kBAAkB;QAClB,WAAW;IACf;;IAEA;QACI,gBAAgB;IACpB;;IAEA;QACI,mBAAmB;QACnB,cAAc;QACd,oCAAoC;QACpC,kBAAkB;QAClB,gBAAgB;IACpB;;IAEA;QACI,gBAAgB;IACpB;;IAEA;QACI,iBAAiB;QACjB,kCAAkC;IACtC;;IAEA;QACI,oBAAoB;QACpB,WAAW;IACf;;IAEA;QACI,SAAS;IACb;;IAEA;QACI,yBAAyB;QACzB,oCAAoC;QACpC,4BAA4B;IAChC;;IAEA;QACI,yBAAyB;QACzB,8BAA8B;QAC9B,uCAAuC;IAC3C;;IAEA;QACI,yBAAyB;IAC7B;;IAEA;QACI,oCAAoC;IACxC;;IAEA;QACI,iBAAiB;IACrB;;IAEA;QACI,aAAa;QACb,cAAc;IAClB;;IAEA;QACI,iBAAiB;IACrB;;IAEA;QACI,kBAAkB;QAClB,gBAAgB;QAChB,oCAAoC;IACxC;;IAEA;QACI,gCAAgC;QAChC,mBAAmB;QACnB,cAAc;QACd,YAAY;QACZ,4BAA4B;QAC5B,2BAA2B;QAC3B,oCAAoC;IACxC;;IAEA;QACI,gBAAgB;QAChB,eAAe;IACnB;;IAEA;QACI,WAAW;QACX,YAAY;QACZ,cAAc;QACd,cAAc;QACd,uBAAuB;QACvB,kBAAkB;QAClB,4BAA4B;QAC5B,oBAAoB;IACxB;;IAEA;QACI,cAAc;QACd,yBAAyB;QACzB,uBAAuB;IAC3B;;IAEA;QACI,eAAe;QACf,iBAAiB;QACjB,gCAAgC;IACpC;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,mBAAmB;QACnB,cAAc;QACd,aAAa;IACjB;;IAEA;QACI,+BAA+B;QAC/B,8BAA8B;IAClC;;IAEA;QACI,6BAA6B;QAC7B,mBAAmB;QACnB,cAAc;QACd,YAAY;QACZ,iBAAiB;QACjB,+BAA+B;QAC/B,8BAA8B;IAClC;;IAEA;QACI,oBAAoB;QACpB,WAAW;IACf;;IAEA;;QAEI,gBAAgB;IACpB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,WAAW;QACX,YAAY;IAChB;;IAEA;QACI,iBAAiB;IACrB;;IAEA;QACI,mBAAmB;QACnB,cAAc;QACd,oCAAoC;QACpC,kBAAkB;QAClB,mCAAmC;IACvC;;IAEA;QACI,gBAAgB;IACpB;;IAEA;QACI,mBAAmB;QACnB,cAAc;QACd,WAAW;QACX,YAAY;QACZ,4BAA4B;QAC5B,kBAAkB;QAClB,kBAAkB;QAClB,UAAU;QACV,YAAY;IAChB;;IAEA;QACI,mBAAmB;QACnB,cAAc;IAClB;;IAEA;QACI,yBAAyB;QACzB,oCAAoC;QACpC,4BAA4B;IAChC;;IAEA;QACI,yBAAyB;QACzB,8BAA8B;QAC9B,uCAAuC;IAC3C;;IAEA;QACI,yBAAyB;IAC7B;;IAEA;QACI,oCAAoC;IACxC;;IAEA;QACI,mBAAmB;QACnB,cAAc;QACd,oCAAoC;QACpC,gBAAgB;IACpB;;IAEA;QACI,qBAAqB;IACzB;;IAEA;;QAEI,WAAW;QACX,YAAY;QACZ,cAAc;QACd,cAAc;QACd,uBAAuB;QACvB,kBAAkB;QAClB,4BAA4B;IAChC;;IAEA;;QAEI,cAAc;QACd,yBAAyB;QACzB,uBAAuB;IAC3B;;IAEA;;QAEI,eAAe;QACf,iBAAiB;QACjB,gCAAgC;IACpC;;IAEA;QACI,cAAc;IAClB;;IAEA;QACI,gBAAgB;IACpB;;IAEA;QACI,mBAAmB;QACnB,cAAc;QACd;yBACiB;QACjB,uBAAuB;QACvB,oCAAoC;QACpC,kBAAkB;IACtB;;IAEA;QACI,2BAA2B;IAC/B;;IAEA;QACI,0BAA0B;IAC9B;;IAEA;QACI,yBAAyB;IAC7B;;IAEA;QACI,4BAA4B;IAChC;;IAEA;QACI,mBAAmB;QACnB,qBAAqB;QACrB,yBAAyB;QACzB,cAAc;QACd,qBAAqB;QACrB,4BAA4B;QAC5B,2BAA2B;QAC3B,WAAW;IACf;;IAEA;QACI,oBAAoB;IACxB;;IAEA;QACI,mBAAmB;QACnB,wBAAwB;QACxB,YAAY;QACZ,yBAAyB;QACzB,cAAc;QACd,+BAA+B;QAC/B,8BAA8B;IAClC;;IAEA;QACI,aAAa;QACb,eAAe;IACnB;;IAEA;QACI,kBAAkB;IACtB;;IAEA;QACI,aAAa;IACjB;;IAEA;QACI,mBAAmB;QACnB,cAAc;QACd,kBAAkB;QAClB,eAAe;IACnB;;IAEA;QACI,4BAA4B;QAC5B,kBAAkB;IACtB;;IAEA;QACI,eAAe;QACf,iBAAiB;QACjB,gDAAgD;IACpD;;IAEA;QACI,cAAc;IAClB;;IAEA;QACI,cAAc;IAClB;;IAEA;QACI,yBAAyB;QACzB,cAAc;IAClB;;IAEA;QACI,cAAc;IAClB;;IAEA;QACI,cAAc;IAClB;;IAEA;QACI,iBAAiB;QACjB,mBAAmB;QACnB,cAAc;QACd,qCAAqC;QACrC,gBAAgB;QAChB,kBAAkB;QAClB,cAAc;IAClB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,iBAAiB;QACjB,mBAAmB;QACnB,qCAAqC;QACrC,gBAAgB;QAChB,kBAAkB;IACtB;;IAEA;QACI,cAAc;QACd,4BAA4B;QAC5B,gBAAgB;IACpB;;IAEA;QACI,cAAc;QACd,qBAAqB;QACrB,yBAAiB;gBAAjB,iBAAiB;IACrB;;IAEA;QACI,cAAc;IAClB;;IAEA;QACI,cAAc;QACd,oBAAoB;IACxB;;IAEA;QACI,cAAc;IAClB;;IAEA;QACI,cAAc;QACd,mBAAmB;IACvB;;IAEA;QACI,cAAc;IAClB;;IAEA;;QAEI,cAAc;IAClB;;IAEA;QACI,mBAAmB;IACvB;;IAEA;QACI,cAAc;QACd,mBAAmB;IACvB;;IAEA;QACI,cAAc;IAClB;;IAEA;;QAEI,cAAc;IAClB;;IAEA;QACI,cAAc;QACd,mBAAmB;IACvB;;IAEA;QACI,cAAc;IAClB;;IAEA;;QAEI,cAAc;IAClB;;IAEA;QACI,6BAA6B;QAC7B,gBAAgB;IACpB;;IAEA;QACI,mBAAmB;IACvB;;IAEA;QACI,eAAe;QACf,gBAAgB;IACpB;;IAEA;QACI,oCAAoC;QACpC,0CAA0C;QAC1C,sBAAsB;QACtB,qBAAqB;IACzB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,eAAe;QACf,kBAAkB;IACtB;;IAEA;QACI,eAAe;QACf,iBAAiB;QACjB,uDAAuD;IAC3D;;IAEA;QACI,WAAW;QACX,YAAY;IAChB;;IAEA;;;;QAII,gBAAgB;IACpB;;IAEA;;;;QAII,gBAAgB;IACpB;;IAEA;;QAEI,gBAAgB;IACpB;;IAEA;;;;QAII,gBAAgB;IACpB;;IAEA;;;;QAII,gBAAgB;IACpB;;IAEA;;QAEI,gBAAgB;IACpB;;IAEA;;QAEI,gBAAgB;QAChB,WAAW;IACf;;IAEA;;QAEI,cAAc;IAClB;;IAEA;;QAEI,gBAAgB;QAChB,YAAY;IAChB;;IAEA;;QAEI,cAAc;IAClB;;IAEA;QACI,eAAe;QACf,SAAS;IACb;;IAEA;;;;;;;;;;;;;;;;;;;;QAoBI,eAAe;QACf,SAAS;IACb;;IAEA;QACI,oBAAoB;QACpB,mBAAmB;QACnB,yBAAyB;QACzB,cAAc;QACd,kBAAkB;IACtB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,cAAc;QACd,4BAA4B;QAC5B,gBAAgB;IACpB;;IAEA;QACI,cAAc;QACd,qBAAqB;QACrB,yBAAiB;gBAAjB,iBAAiB;IACrB;;IAEA;QACI,cAAc;IAClB;;IAEA;QACI,cAAc;QACd,oBAAoB;IACxB;;IAEA;QACI,cAAc;IAClB;;IAEA;QACI,cAAc;QACd,mBAAmB;IACvB;;IAEA;QACI,cAAc;IAClB;;IAEA;;QAEI,cAAc;IAClB;;IAEA;QACI,mBAAmB;IACvB;;IAEA;QACI,cAAc;QACd,mBAAmB;IACvB;;IAEA;QACI,cAAc;IAClB;;IAEA;;QAEI,cAAc;IAClB;;IAEA;QACI,cAAc;QACd,mBAAmB;IACvB;;IAEA;QACI,cAAc;IAClB;;IAEA;;QAEI,cAAc;IAClB;;IAEA;QACI,mBAAmB;QACnB,cAAc;QACd,qCAAqC;QACrC,gBAAgB;IACpB;;IAEA;QACI,SAAS;QACT,qBAAqB;QACrB,cAAc;QACd,mBAAmB;QACnB,gBAAgB;QAChB,4BAA4B;QAC5B,2BAA2B;IAC/B;;IAEA;QACI,iBAAiB;QACjB,cAAc;IAClB;;IAEA;QACI,6BAA6B;QAC7B,gBAAgB;IACpB;;IAEA;QACI,cAAc;QACd,iBAAiB;IACrB;;IAEA;QACI,WAAW;QACX,YAAY;QACZ,yBAAyB;QACzB,kBAAkB;QAClB,4BAA4B;IAChC;;IAEA;QACI,yBAAyB;QACzB,uBAAuB;IAC3B;;IAEA;QACI,eAAe;QACf,iBAAiB;QACjB,gDAAgD;IACpD;;IAEA;QACI,yBAAyB;QACzB,4BAA4B;QAC5B,kBAAkB;IACtB;;IAEA;QACI,aAAa;QACb,yBAAiB;gBAAjB,iBAAiB;IACrB;;IAEA;QACI,yBAAyB;IAC7B;;IAEA;QACI,yBAAyB;QACzB,oBAAoB;IACxB;;IAEA;QACI,yBAAyB;QACzB,mBAAmB;IACvB;;IAEA;QACI,yBAAyB;QACzB,uBAAuB;IAC3B;;IAEA;QACI,yBAAyB;IAC7B;;IAEA;;QAEI,yBAAyB;IAC7B;;IAEA;QACI,iBAAiB;QACjB,mBAAmB;QACnB,qCAAqC;QACrC,gBAAgB;IACpB;;IAEA;QACI,6BAA6B;QAC7B,gBAAgB;IACpB;;IAEA;QACI,mBAAmB;IACvB;;IAEA;QACI,eAAe;QACf,gBAAgB;IACpB;;IAEA;QACI,WAAW;QACX,gBAAgB;IACpB;;IAEA;QACI,cAAc;QACd,4BAA4B;QAC5B,gBAAgB;IACpB;;IAEA;QACI,cAAc;QACd,qBAAqB;QACrB,yBAAiB;gBAAjB,iBAAiB;IACrB;;IAEA;QACI,cAAc;IAClB;;IAEA;QACI,cAAc;QACd,oBAAoB;IACxB;;IAEA;QACI,cAAc;IAClB;;IAEA;QACI,cAAc;QACd,mBAAmB;IACvB;;IAEA;QACI,cAAc;IAClB;;IAEA;;QAEI,cAAc;IAClB;;IAEA;QACI,mBAAmB;IACvB;;IAEA;QACI,cAAc;QACd,mBAAmB;IACvB;;IAEA;QACI,cAAc;IAClB;;IAEA;;QAEI,cAAc;IAClB;;IAEA;QACI,cAAc;QACd,mBAAmB;IACvB;;IAEA;QACI,cAAc;IAClB;;IAEA;;QAEI,cAAc;IAClB;;IAEA;QACI,iBAAiB;IACrB;;IAEA;QACI,0BAA0B;IAC9B;;IAEA;QACI,WAAW;QACX,gBAAgB;QAChB,gBAAgB;QAChB,cAAc;IAClB;;IAEA;QACI,2BAA2B;QAC3B,wBAAwB;IAC5B;;IAEA;QACI,yBAAyB;IAC7B;;IAEA;QACI,WAAW;QACX,gBAAgB;IACpB;;IAEA;QACI,iBAAiB;QACjB,mBAAmB;QACnB,cAAc;QACd,yBAAyB;QACzB,kBAAkB;QAClB,cAAc;IAClB;;IAEA;QACI,cAAc;QACd,4BAA4B;QAC5B,gBAAgB;IACpB;;IAEA;QACI,cAAc;QACd,qBAAqB;QACrB,yBAAiB;gBAAjB,iBAAiB;IACrB;;IAEA;QACI,cAAc;IAClB;;IAEA;QACI,cAAc;QACd,oBAAoB;IACxB;;IAEA;QACI,cAAc;IAClB;;IAEA;QACI,cAAc;QACd,mBAAmB;IACvB;;IAEA;QACI,cAAc;IAClB;;IAEA;;QAEI,cAAc;IAClB;;IAEA;QACI,mBAAmB;IACvB;;IAEA;QACI,cAAc;QACd,mBAAmB;IACvB;;IAEA;QACI,cAAc;IAClB;;IAEA;;QAEI,cAAc;IAClB;;IAEA;;;OAGG;IACH;QACI,cAAc;QACd,mBAAmB;QACnB,oCAAoC;IACxC;;IAEA;QACI,cAAc;IAClB;;IAEA;;QAEI,cAAc;IAClB;;IAEA;QACI,mBAAmB;QACnB,qCAAqC;QACrC,gBAAgB;IACpB;;IAEA;QACI,SAAS;QACT,qBAAqB;QACrB,cAAc;QACd,mBAAmB;QACnB,gBAAgB;QAChB,0BAA0B;QAC1B,yBAAyB;IAC7B;;IAEA;QACI,6BAA6B;QAC7B,gBAAgB;IACpB;;IAEA;QACI,oBAAoB;QACpB,mBAAmB;QACnB,yBAAyB;QACzB,cAAc;QACd,kBAAkB;IACtB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,yBAAyB;QACzB,4BAA4B;QAC5B,kBAAkB;IACtB;;IAEA;QACI,aAAa;QACb,yBAAiB;gBAAjB,iBAAiB;IACrB;;IAEA;QACI,yBAAyB;IAC7B;;IAEA;QACI,yBAAyB;QACzB,oBAAoB;IACxB;;IAEA;QACI,yBAAyB;QACzB,mBAAmB;IACvB;;IAEA;QACI,yBAAyB;QACzB,uBAAuB;IAC3B;;IAEA;QACI,yBAAyB;IAC7B;;IAEA;;QAEI,yBAAyB;IAC7B;;IAEA;QACI,cAAc;QACd,4BAA4B;QAC5B,gBAAgB;IACpB;;IAEA;QACI,cAAc;QACd,qBAAqB;QACrB,yBAAiB;gBAAjB,iBAAiB;IACrB;;IAEA;QACI,cAAc;IAClB;;IAEA;QACI,cAAc;QACd,oBAAoB;IACxB;;IAEA;QACI,cAAc;IAClB;;IAEA;QACI,cAAc;QACd,mBAAmB;IACvB;;IAEA;QACI,cAAc;IAClB;;IAEA;;QAEI,cAAc;IAClB;;IAEA;QACI,mBAAmB;IACvB;;IAEA;QACI,cAAc;QACd,mBAAmB;IACvB;;IAEA;QACI,cAAc;IAClB;;IAEA;;QAEI,cAAc;IAClB;;IAEA;QACI,cAAc;QACd,mBAAmB;IACvB;;IAEA;QACI,cAAc;IAClB;;IAEA;;QAEI,cAAc;IAClB;;IAEA;QACI,iBAAiB;QACjB,mBAAmB;QACnB,qCAAqC;QACrC,gBAAgB;QAChB,cAAc;IAClB;;IAEA;QACI,6BAA6B;QAC7B,gBAAgB;IACpB;;IAEA;QACI,mBAAmB;IACvB;;IAEA;QACI,WAAW;QACX,YAAY;QACZ,yBAAyB;QACzB,kBAAkB;QAClB,4BAA4B;IAChC;;IAEA;QACI,yBAAyB;QACzB,uBAAuB;IAC3B;;IAEA;QACI,eAAe;QACf,iBAAiB;QACjB,gDAAgD;IACpD;;IAEA;QACI,iBAAiB;QACjB,mBAAmB;QACnB,qCAAqC;QACrC,gBAAgB;IACpB;;IAEA;QACI,6BAA6B;QAC7B,gBAAgB;IACpB;;IAEA;QACI,mBAAmB;IACvB;;IAEA;QACI,iBAAiB;QACjB,2BAA2B;IAC/B;;IAEA;QACI,0BAA0B;IAC9B;;IAEA;QACI,2BAA2B;QAC3B,wBAAwB;IAC5B;;IAEA;QACI,yBAAyB;IAC7B;;IAEA;QACI,qBAAqB;IACzB;;IAEA;QACI,qBAAqB;IACzB;;IAEA;QACI,qBAAqB;IACzB;;IAEA;QACI,qBAAqB;IACzB;;IAEA;QACI,qBAAqB;IACzB;;IAEA;QACI;YACI,kBAAkB;QACtB;;QAEA,qBAAqB;QACrB;YACI,aAAa;YACb,WAAW;YACX,YAAY;YACZ,yBAAyB;YACzB,kBAAkB;YAClB,4BAA4B;QAChC;;QAEA;YACI,yBAAyB;YACzB,uBAAuB;QAC3B;;QAEA;YACI,eAAe;YACf,iBAAiB;YACjB,gDAAgD;QACpD;;QAEA;YACI,kBAAkB;YAClB,aAAa;YACb,iBAAiB;YACjB,mBAAmB;YACnB,qCAAqC;YACrC,gBAAgB;YAChB,WAAW;QACf;;QAEA;YACI,6BAA6B;YAC7B,gBAAgB;QACpB;;QAEA;YACI,mBAAmB;QACvB;;QAEA;YACI,eAAe;YACf,gBAAgB;QACpB;;QAEA;YACI,WAAW;YACX,gBAAgB;QACpB;;QAEA;YACI,cAAc;YACd,4BAA4B;YAC5B,gBAAgB;QACpB;;QAEA;YACI,cAAc;YACd,qBAAqB;YACrB,yBAAiB;oBAAjB,iBAAiB;QACrB;;QAEA;YACI,cAAc;QAClB;;QAEA;YACI,cAAc;YACd,oBAAoB;QACxB;;QAEA;YACI,cAAc;QAClB;;QAEA;YACI,cAAc;YACd,mBAAmB;QACvB;;QAEA;YACI,cAAc;QAClB;;QAEA;;YAEI,cAAc;QAClB;;QAEA;YACI,mBAAmB;QACvB;;QAEA;YACI,cAAc;YACd,mBAAmB;QACvB;;QAEA;YACI,cAAc;QAClB;;QAEA;;YAEI,cAAc;QAClB;;QAEA;YACI,cAAc;YACd,mBAAmB;QACvB;;QAEA;YACI,cAAc;QAClB;;QAEA;;YAEI,cAAc;QAClB;;QAEA;YACI,iBAAiB;YACjB,2BAA2B;QAC/B;;QAEA;YACI,0BAA0B;QAC9B;;QAEA;YACI,WAAW;YACX,gBAAgB;YAChB,gBAAgB;YAChB,cAAc;QAClB;;QAEA;YACI,2BAA2B;YAC3B,wBAAwB;QAC5B;;QAEA;YACI,yBAAyB;QAC7B;;QAEA;YACI,WAAW;YACX,gBAAgB;QACpB;;QAEA;YACI,qBAAqB;QACzB;;QAEA;YACI,qBAAqB;QACzB;;QAEA;YACI,qBAAqB;QACzB;;QAEA;YACI,qBAAqB;QACzB;;QAEA;YACI,qBAAqB;QACzB;;QAEA;YACI,aAAa;YACb,sBAAsB;YACtB,SAAS;YACT,OAAO;YACP,UAAU;QACd;IACJ;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,yBAAyB;QACzB,cAAc;QACd,mBAAmB;QACnB,kBAAkB;QAClB,4BAA4B;IAChC;;IAEA;QACI,cAAc;QACd,qBAAqB;QACrB,gBAAgB;IACpB;;IAEA;QACI,oBAAoB;IACxB;;IAEA;QACI,oBAAoB;IACxB;;IAEA;QACI,eAAe;QACf,iBAAiB;QACjB,sDAAsD;IAC1D;;IAEA;QACI,mBAAmB;QACnB,qBAAqB;QACrB,cAAc;IAClB;;IAEA;QACI,mBAAmB;QACnB,qBAAqB;QACrB,cAAc;QACd,6BAA6B;QAC7B,4BAA4B;QAC5B,gBAAgB;IACpB;;IAEA;QACI,qBAAqB;QACrB,mBAAmB;QACnB,cAAc;IAClB;;IAEA;QACI,iBAAiB;QACjB,yBAAyB;QACzB,mBAAmB;QACnB,cAAc;QACd,aAAa;QACb,0BAA0B;QAC1B,yBAAyB;QACzB,+BAA+B;QAC/B,8BAA8B;IAClC;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,cAAc;QACd,4BAA4B;QAC5B,gBAAgB;IACpB;;IAEA;QACI,cAAc;QACd,qBAAqB;QACrB,yBAAiB;gBAAjB,iBAAiB;IACrB;;IAEA;QACI,cAAc;IAClB;;IAEA;QACI,cAAc;QACd,oBAAoB;IACxB;;IAEA;QACI,cAAc;IAClB;;IAEA;QACI,cAAc;QACd,mBAAmB;IACvB;;IAEA;QACI,cAAc;IAClB;;IAEA;;QAEI,cAAc;IAClB;;IAEA;QACI,mBAAmB;IACvB;;IAEA;QACI,cAAc;QACd,mBAAmB;IACvB;;IAEA;QACI,cAAc;IAClB;;IAEA;;QAEI,cAAc;IAClB;;IAEA;QACI,cAAc;QACd,mBAAmB;IACvB;;IAEA;QACI,cAAc;IAClB;;IAEA;;QAEI,cAAc;IAClB;;IAEA;QACI,oBAAoB;IACxB;;IAEA;QACI,6BAA6B;QAC7B,gBAAgB;IACpB;;IAEA;QACI,mBAAmB;IACvB;;IAEA;QACI,gBAAgB;IACpB;;IAEA;QACI,gBAAgB;IACpB;;IAEA;QACI,gBAAgB;IACpB;;IAEA;QACI,kBAAkB;IACtB;;IAEA;;QAEI,kBAAkB;IACtB;;IAEA;QACI,4BAA4B;QAC5B,2BAA2B;IAC/B;;IAEA;QACI,+BAA+B;QAC/B,8BAA8B;IAClC;;IAEA;QACI,+BAA+B;QAC/B,8BAA8B;IAClC;;IAEA;QACI,iBAAiB;QACjB,mBAAmB;QACnB,cAAc;QACd,yBAAyB;QACzB,kBAAkB;QAClB,cAAc;IAClB;;IAEA;QACI,cAAc;QACd,4BAA4B;QAC5B,gBAAgB;IACpB;;IAEA;QACI,cAAc;QACd,qBAAqB;QACrB,yBAAiB;gBAAjB,iBAAiB;IACrB;;IAEA;QACI,cAAc;IAClB;;IAEA;QACI,cAAc;QACd,oBAAoB;IACxB;;IAEA;QACI,cAAc;IAClB;;IAEA;QACI,cAAc;QACd,mBAAmB;IACvB;;IAEA;QACI,cAAc;IAClB;;IAEA;;QAEI,cAAc;IAClB;;IAEA;QACI,mBAAmB;IACvB;;IAEA;QACI,cAAc;QACd,mBAAmB;IACvB;;IAEA;QACI,cAAc;IAClB;;IAEA;;QAEI,cAAc;IAClB;;IAEA;QACI,cAAc;QACd,mBAAmB;IACvB;;IAEA;QACI,cAAc;IAClB;;IAEA;;QAEI,cAAc;IAClB;;IAEA;QACI,mBAAmB;QACnB,qCAAqC;QACrC,gBAAgB;IACpB;;IAEA;QACI,iBAAiB;QACjB,mBAAmB;QACnB,qCAAqC;QACrC,gBAAgB;IACpB;;IAEA;QACI,mBAAmB;IACvB;;IAEA;QACI,cAAc;IAClB;;IAEA;;QAEI,cAAc;IAClB;;IAEA;QACI,6BAA6B;QAC7B,gBAAgB;IACpB;;IAEA;QACI,mBAAmB;IACvB;;IAEA;QACI,eAAe;QACf,gBAAgB;IACpB;;IAEA;QACI,qBAAqB;QACrB,cAAc;IAClB;;IAEA;QACI,uBAAuB;QACvB,4BAA4B;QAC5B,kBAAkB;QAClB,uBAAuB;IAC3B;;IAEA;QACI,cAAc;QACd,yBAAyB;QACzB,uBAAuB;QACvB,eAAe;QACf,YAAY;QACZ,iBAAiB;QACjB,eAAe;QACf,UAAU;QACV,kBAAkB;IACtB;;IAEA;QACI,kBAAkB;QAClB,cAAc;IAClB;;IAEA;QACI,eAAe;QACf,iBAAiB;QACjB,gDAAgD;IACpD;;IAEA;QACI,mBAAmB;QACnB,cAAc;IAClB;;IAEA;QACI,gBAAgB;QAChB,cAAc;IAClB;;IAEA;QACI,YAAY;QACZ,6BAA6B;QAC7B,WAAW;QACX,QAAQ;QACR,OAAO;QACP,cAAc;QACd,kBAAkB;QAClB,iBAAiB;IACrB;;IAEA;QACI,uBAAuB;QACvB,yBAAyB;QACzB,uBAAuB;IAC3B;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,aAAa;QACb,iBAAiB;QACjB,6CAA6C;QAC7C,mBAAmB;QACnB,cAAc;QACd,qBAAqB;QACrB,gBAAgB;QAChB,4BAA4B;QAC5B,2BAA2B;QAC3B,4BAA4B;QAC5B,kBAAkB;QAClB,wBAAwB;IAC5B;;IAEA;QACI,oBAAoB;IACxB;;IAEA;QACI,eAAe;QACf,iBAAiB;QACjB,sDAAsD;IAC1D;;IAEA;QACI,mBAAmB;QACnB,qBAAqB;QACrB,cAAc;IAClB;;IAEA;QACI,mBAAmB;QACnB,6CAA6C;QAC7C,cAAc;IAClB;;IAEA;QACI,iBAAiB;QACjB,mBAAmB;QACnB,cAAc;QACd,yBAAyB;QACzB,kBAAkB;QAClB,cAAc;IAClB;;IAEA;QACI,mBAAmB;QACnB,qCAAqC;QACrC,gBAAgB;IACpB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,iBAAiB;QACjB,mBAAmB;QACnB,qCAAqC;QACrC,gBAAgB;IACpB;;IAEA;QACI,cAAc;QACd,4BAA4B;QAC5B,gBAAgB;IACpB;;IAEA;QACI,cAAc;QACd,qBAAqB;QACrB,yBAAiB;gBAAjB,iBAAiB;IACrB;;IAEA;QACI,cAAc;IAClB;;IAEA;QACI,cAAc;QACd,oBAAoB;IACxB;;IAEA;QACI,cAAc;IAClB;;IAEA;QACI,cAAc;QACd,mBAAmB;IACvB;;IAEA;QACI,cAAc;IAClB;;IAEA;;QAEI,cAAc;IAClB;;IAEA;QACI,mBAAmB;IACvB;;IAEA;QACI,cAAc;QACd,mBAAmB;IACvB;;IAEA;QACI,cAAc;IAClB;;IAEA;;QAEI,cAAc;IAClB;;IAEA;QACI,cAAc;QACd,mBAAmB;IACvB;;IAEA;QACI,cAAc;IAClB;;IAEA;;QAEI,cAAc;IAClB;;IAEA;QACI,6BAA6B;QAC7B,gBAAgB;IACpB;;IAEA;QACI,mBAAmB;IACvB;;IAEA;QACI,eAAe;QACf,gBAAgB;IACpB;;IAEA;QACI,uBAAuB;QACvB,SAAS;QACT,kBAAkB;IACtB;;IAEA;QACI,mBAAmB;QACnB,qBAAqB;QACrB,iBAAiB;QACjB,cAAc;IAClB;;IAEA;QACI,cAAc;IAClB;;IAEA;QACI,mBAAmB;QACnB,qBAAqB;QACrB,iBAAiB;QACjB,cAAc;IAClB;;IAEA;QACI,cAAc;IAClB;;IAEA;QACI,mBAAmB;QACnB,qBAAqB;QACrB,iBAAiB;QACjB,cAAc;IAClB;;IAEA;QACI,cAAc;IAClB;;IAEA;QACI,mBAAmB;QACnB,qBAAqB;QACrB,iBAAiB;QACjB,cAAc;IAClB;;IAEA;QACI,cAAc;IAClB;;IAEA;QACI,eAAe;QACf,oBAAoB;IACxB;;IAEA;QACI,WAAW;QACX,YAAY;IAChB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,cAAc;QACd,kBAAkB;IACtB;;IAEA;QACI,qBAAqB;IACzB;;IAEA;QACI,WAAW;QACX,YAAY;QACZ,kBAAkB;QAClB,uBAAuB;QACvB,4BAA4B;IAChC;;IAEA;QACI,oCAAoC;IACxC;;IAEA;QACI,eAAe;QACf,iBAAiB;QACjB,gDAAgD;IACpD;;IAEA;QACI,mBAAmB;QACnB,qBAAqB;QACrB,iBAAiB;QACjB,cAAc;IAClB;;IAEA;QACI,cAAc;IAClB;;IAEA;QACI,cAAc;IAClB;;IAEA;QACI,mBAAmB;QACnB,qBAAqB;QACrB,iBAAiB;QACjB,cAAc;IAClB;;IAEA;QACI,cAAc;IAClB;;IAEA;QACI,cAAc;IAClB;;IAEA;QACI,mBAAmB;QACnB,qBAAqB;QACrB,iBAAiB;QACjB,cAAc;IAClB;;IAEA;QACI,cAAc;IAClB;;IAEA;QACI,cAAc;IAClB;;IAEA;QACI,mBAAmB;QACnB,qBAAqB;QACrB,iBAAiB;QACjB,cAAc;IAClB;;IAEA;QACI,cAAc;IAClB;;IAEA;QACI,cAAc;IAClB;;IAEA;QACI,eAAe;QACf,gBAAgB;IACpB;;IAEA;QACI,iBAAiB;QACjB,oBAAoB;IACxB;;IAEA;QACI,aAAa;QACb,cAAc;IAClB;;IAEA;QACI,gBAAgB;IACpB;;IAEA;QACI,mBAAmB;IACvB;;IAEA;QACI,UAAU;IACd;;IAEA;QACI,kBAAkB;QAClB,gDAAgD;QAChD,kBAAkB;IACtB;;IAEA;QACI,aAAa;QACb,eAAe;IACnB;;IAEA;QACI,kBAAkB;IACtB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,WAAW;QACX,YAAY;IAChB;;IAEA;QACI,gBAAgB;IACpB;;IAEA;QACI,oBAAoB;IACxB;;IAEA;QACI,WAAW;QACX,YAAY;QACZ,kBAAkB;QAClB,uBAAuB;QACvB,4BAA4B;IAChC;;IAEA;QACI,oCAAoC;IACxC;;IAEA;QACI,eAAe;QACf,iBAAiB;QACjB,gDAAgD;IACpD;;IAEA;QACI,mBAAmB;QACnB,qBAAqB;QACrB,iBAAiB;QACjB,cAAc;IAClB;;IAEA;;QAEI,cAAc;IAClB;;IAEA;QACI,mBAAmB;QACnB,qBAAqB;QACrB,iBAAiB;QACjB,cAAc;IAClB;;IAEA;;QAEI,cAAc;IAClB;;IAEA;QACI,mBAAmB;QACnB,qBAAqB;QACrB,iBAAiB;QACjB,cAAc;IAClB;;IAEA;;QAEI,cAAc;IAClB;;IAEA;QACI,mBAAmB;QACnB,qBAAqB;QACrB,iBAAiB;QACjB,cAAc;IAClB;;IAEA;;QAEI,cAAc;IAClB;;IAEA;QACI,cAAc;QACd,uBAAuB;QACvB,cAAc;QACd,WAAW;QACX,YAAY;QACZ,4BAA4B;QAC5B,kBAAkB;IACtB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,WAAW;QACX,YAAY;IAChB;;IAEA;QACI,oCAAoC;QACpC,cAAc;IAClB;;IAEA;QACI,uBAAuB;QACvB,cAAc;QACd,WAAW;QACX,YAAY;QACZ,4BAA4B;QAC5B,kBAAkB;QAClB,gBAAgB;IACpB;;IAEA;;QAEI,eAAe;IACnB;;IAEA;;QAEI,WAAW;QACX,YAAY;IAChB;;IAEA;QACI,oCAAoC;QACpC,cAAc;IAClB;;IAEA;QACI,8BAA8B;QAC9B,cAAc;QACd,aAAa;IACjB;;IAEA;QACI,aAAa;IACjB;;IAEA;QACI,yBAAyB;QACzB,WAAW;QACX,YAAY;QACZ,4BAA4B;QAC5B,kBAAkB;IACtB;;IAEA;QACI,mBAAmB;IACvB;;IAEA;QACI,mBAAmB;QACnB,cAAc;IAClB;;IAEA;;QAEI,oBAAoB;IACxB;;IAEA;;QAEI,qBAAqB;IACzB;;IAEA;QACI,8BAA8B;IAClC;;IAEA;QACI,oCAAoC;IACxC;;IAEA;QACI,oCAAoC;IACxC;;IAEA;QACI,mBAAmB;QACnB,cAAc;IAClB;;IAEA;QACI,8BAA8B;QAC9B,qBAAqB;IACzB;;IAEA;;QAEI,cAAc;QACd,6BAA6B;QAC7B,cAAc;QACd,WAAW;QACX,YAAY;QACZ,4BAA4B;QAC5B,kBAAkB;IACtB;;IAEA;;QAEI,oCAAoC;QACpC,cAAc;IAClB;;IAEA;QACI,4BAA4B;IAChC;;IAEA;QACI,eAAe;QACf,iBAAiB;QACjB,gDAAgD;IACpD;;IAEA;QACI,4BAA4B;IAChC;;IAEA;QACI,4BAA4B;IAChC;;IAEA;QACI,6BAA6B;QAC7B,cAAc;QACd,4BAA4B;IAChC;;IAEA;QACI,aAAa;QACb,cAAc;IAClB;;IAEA;QACI,oCAAoC;IACxC;;IAEA;QACI,aAAa;IACjB;;IAEA;QACI,cAAc;QACd,6BAA6B;QAC7B,WAAW;QACX,YAAY;QACZ,kBAAkB;QAClB,4BAA4B;QAC5B,oBAAoB;IACxB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,cAAc;QACd,0CAA0C;IAC9C;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,aAAa;QACb,cAAc;IAClB;;IAEA;QACI,yBAAyB;QACzB,kBAAkB;IACtB;;IAEA;QACI,WAAW;QACX,YAAY;QACZ,eAAe;IACnB;;IAEA;QACI,iBAAiB;IACrB;;IAEA;QACI,WAAW;QACX,YAAY;QACZ,eAAe;IACnB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,kBAAkB;IACtB;;IAEA;QACI,yBAAyB;IAC7B;;IAEA;QACI,yBAAyB;QACzB,cAAc;QACd,mBAAmB;QACnB,kBAAkB;IACtB;;IAEA;QACI,gBAAgB;QAChB,mBAAmB;QACnB,sBAAsB;IAC1B;;IAEA;QACI,oBAAoB;IACxB;;IAEA;QACI,WAAW;QACX,YAAY;QACZ,qBAAqB;QACrB,oBAAoB;IACxB;;IAEA;QACI,kBAAkB;QAClB,4BAA4B;QAC5B,mBAAmB;IACvB;;IAEA;QACI,eAAe;QACf,iBAAiB;QACjB,gDAAgD;IACpD;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,WAAW;QACX,YAAY;QACZ,kBAAkB;QAClB,gBAAgB;QAChB,4BAA4B;IAChC;;IAEA;QACI,8BAA8B;IAClC;;IAEA;QACI,8BAA8B;IAClC;;IAEA;QACI,iBAAiB;QACjB,cAAc;IAClB;;IAEA;QACI,aAAa;QACb,cAAc;IAClB;;IAEA;QACI,yBAAyB;QACzB,kBAAkB;IACtB;;IAEA;QACI,4GAA4G;IAChH;;IAEA;QACI,mBAAmB;QACnB,cAAc;QACd,eAAe;QACf,gBAAgB;QAChB,uBAAuB;QACvB,kBAAkB;IACtB;;IAEA;QACI,yBAAyB;QACzB,cAAc;IAClB;;IAEA;QACI,yBAAyB;QACzB,cAAc;IAClB;;IAEA;QACI,yBAAyB;QACzB,cAAc;IAClB;;IAEA;QACI,yBAAyB;QACzB,cAAc;IAClB;;IAEA;QACI,qBAAqB;QACrB,kBAAkB;IACtB;;IAEA;QACI,cAAc;QACd,eAAe;IACnB;;IAEA;QACI,uBAAuB;QACvB,kBAAkB;QAClB,wEAAwE;IAC5E;;IAEA;QACI,mBAAmB;QACnB,cAAc;IAClB;;IAEA;QACI,eAAe;QACf,iBAAiB;QACjB,gDAAgD;IACpD;;IAEA;QACI,cAAc;QACd,cAAc;QACd,mBAAmB;QACnB,kBAAkB;IACtB;;IAEA;QACI,cAAc;QACd,SAAS;QACT,mBAAmB;IACvB;;IAEA;QACI,cAAc;QACd,mBAAmB;IACvB;;IAEA;QACI,mBAAmB;QACnB,cAAc;QACd,yBAAyB;QACzB,gBAAgB;IACpB;;IAEA;QACI,+BAA+B;QAC/B,2DAA2D;QAC3D,eAAe;IACnB;;IAEA;QACI,mBAAmB;QACnB,cAAc;QACd,eAAe;QACf,gBAAgB;QAChB,iBAAiB;QACjB,cAAc;QACd,mBAAmB;IACvB;;IAEA;QACI,yBAAyB;QACzB,cAAc;IAClB;;IAEA;QACI,yBAAyB;QACzB,cAAc;IAClB;;IAEA;QACI,yBAAyB;QACzB,cAAc;IAClB;;IAEA;QACI,yBAAyB;QACzB,cAAc;IAClB;;IAEA;QACI,yBAAyB;QACzB,cAAc;IAClB;;IAEA;QACI,eAAe;QACf,kBAAkB;QAClB,eAAe;QACf,oBAAoB;IACxB;;IAEA;QACI,eAAe;QACf,eAAe;QACf,YAAY;QACZ,iBAAiB;IACrB;;IAEA;QACI,mBAAmB;QACnB,cAAc;QACd,eAAe;QACf,gBAAgB;QAChB,uBAAuB;QACvB,kBAAkB;IACtB;;IAEA;QACI,yBAAyB;QACzB,cAAc;IAClB;;IAEA;QACI,yBAAyB;QACzB,cAAc;IAClB;;IAEA;QACI,yBAAyB;QACzB,cAAc;IAClB;;IAEA;QACI,yBAAyB;QACzB,cAAc;IAClB;AACJ;;AAEA,uEAAuE;AACvE;IACI;QACI,0JAA0J;IAC9J;;IAEA;QACI,YAAY;IAChB;AACJ;;AAEA,gEAAgE","sourcesContent":[":root {\n    /* font-family: -apple-system, BlinkMacSystemFont, \"Segoe UI\", Roboto, Helvetica, Arial, sans-serif, \"Apple Color Emoji\", \"Segoe UI Emoji\", \"Segoe UI Symbol\";\n    --font-family: -apple-system, BlinkMacSystemFont, \"Segoe UI\", Roboto,\n        Helvetica, Arial, sans-serif, \"Apple Color Emoji\", \"Segoe UI Emoji\",\n        \"Segoe UI Symbol\"; */\n    --surface-a: #ffffff;\n    --surface-b: #efefef;\n    --surface-c: #e9ecef;\n    --surface-d: #dee2e6;\n    --surface-e: #ffffff;\n    --surface-f: #ffffff;\n    --text-color: #212529;\n    --text-color-secondary: #6c757d;\n    --primary-color: rgb(207, 0, 0);\n    --primary-color-text: #ffffff;\n    --secondary-color: #efefef;\n    --surface-0: #ffffff;\n    --surface-50: #f9fafb;\n    --surface-100: #f8f9fa;\n    --surface-200: #e9ecef;\n    --surface-300: #dee2e6;\n    --surface-400: #ced4da;\n    --surface-500: #adb5bd;\n    --surface-600: #6c757d;\n    --surface-700: #495057;\n    --surface-800: #343a40;\n    --surface-900: #212529;\n    --gray-50: #f9fafb;\n    --gray-100: #f8f9fa;\n    --gray-200: #e9ecef;\n    --gray-300: #dee2e6;\n    --gray-400: #ced4da;\n    --gray-500: #adb5bd;\n    --gray-600: #6c757d;\n    --gray-700: #495057;\n    --gray-800: #343a40;\n    --gray-900: #212529;\n    --content-padding: 1.25rem;\n    --inline-spacing: 0.5rem;\n    --border-radius: 5px;\n    --surface-ground: #efefef;\n    --surface-section: #ffffff;\n    --surface-card: #ffffff;\n    --surface-overlay: #ffffff;\n    --surface-border: #dee2e6;\n    --surface-hover: #e9ecef;\n    --focus-ring: 0 0 0 0.2rem #f7979b;\n    --maskbg: rgba(0, 0, 0, 0.4);\n    --highlight-bg: #007bff;\n    --highlight-text-color: #ffffff;\n    color-scheme: light;\n}\n\n:root {\n    --blue-50: #f3f8ff;\n    --blue-100: #c5dcff;\n    --blue-200: #97c1fe;\n    --blue-300: #69a5fe;\n    --blue-400: #3b8afd;\n    --blue-500: #0d6efd;\n    --blue-600: #0b5ed7;\n    --blue-700: #094db1;\n    --blue-800: #073d8b;\n    --blue-900: #052c65;\n    --green-50: #f4f9f6;\n    --green-100: #c8e2d6;\n    --green-200: #9ccbb5;\n    --green-300: #70b595;\n    --green-400: #459e74;\n    --green-500: #198754;\n    --green-600: #157347;\n    --green-700: #125f3b;\n    --green-800: #0e4a2e;\n    --green-900: #0a3622;\n    --yellow-50: #fffcf3;\n    --yellow-100: #fff0c3;\n    --yellow-200: #ffe494;\n    --yellow-300: #ffd965;\n    --yellow-400: #ffcd36;\n    --yellow-500: #ffc107;\n    --yellow-600: #d9a406;\n    --yellow-700: #b38705;\n    --yellow-800: #8c6a04;\n    --yellow-900: #664d03;\n    --cyan-50: #f3fcfe;\n    --cyan-100: #c5f2fb;\n    --cyan-200: #97e8f9;\n    --cyan-300: #69def6;\n    --cyan-400: #3bd4f3;\n    --cyan-500: #0dcaf0;\n    --cyan-600: #0baccc;\n    --cyan-700: #098da8;\n    --cyan-800: #076f84;\n    --cyan-900: #055160;\n    --pink-50: #fdf5f9;\n    --pink-100: #f5cee1;\n    --pink-200: #eda7ca;\n    --pink-300: #e681b3;\n    --pink-400: #de5a9b;\n    --pink-500: #d63384;\n    --pink-600: #b62b70;\n    --pink-700: #96245c;\n    --pink-800: #761c49;\n    --pink-900: #561435;\n    --indigo-50: #f7f3fe;\n    --indigo-100: #dac6fc;\n    --indigo-200: #bd98f9;\n    --indigo-300: #a06bf7;\n    --indigo-400: #833df4;\n    --indigo-500: #6610f2;\n    --indigo-600: #570ece;\n    --indigo-700: #470ba9;\n    --indigo-800: #380985;\n    --indigo-900: #290661;\n    --teal-50: #f4fcfa;\n    --teal-100: #c9f2e6;\n    --teal-200: #9fe8d2;\n    --teal-300: #75debf;\n    --teal-400: #4ad3ab;\n    --teal-500: #20c997;\n    --teal-600: #1bab80;\n    --teal-700: #168d6a;\n    --teal-800: #126f53;\n    --teal-900: #0d503c;\n    --orange-50: #fff9f3;\n    --orange-100: #ffe0c7;\n    --orange-200: #fec89a;\n    --orange-300: #feaf6d;\n    --orange-400: #fd9741;\n    --orange-500: #fd7e14;\n    --orange-600: #d76b11;\n    --orange-700: #b1580e;\n    --orange-800: #8b450b;\n    --orange-900: #653208;\n    --bluegray-50: #f8f9fb;\n    --bluegray-100: #e0e4ea;\n    --bluegray-200: #c7ced9;\n    --bluegray-300: #aeb9c8;\n    --bluegray-400: #95a3b8;\n    --bluegray-500: #7c8ea7;\n    --bluegray-600: #69798e;\n    --bluegray-700: #576375;\n    --bluegray-800: #444e5c;\n    --bluegray-900: #323943;\n    --purple-50: #f8f6fc;\n    --purple-100: #dcd2f0;\n    --purple-200: #c1aee4;\n    --purple-300: #a68ad9;\n    --purple-400: #8a66cd;\n    --purple-500: #6f42c1;\n    --purple-600: #5e38a4;\n    --purple-700: #4e2e87;\n    --purple-800: #3d246a;\n    --purple-900: #2c1a4d;\n    --red-50: #fdf5f6;\n    --red-100: #f7cfd2;\n    --red-200: #f0a8af;\n    --red-300: #e9828c;\n    --red-400: #e35b68;\n    --red-500: #dc3545;\n    --red-600: #bb2d3b;\n    --red-700: #9a2530;\n    --red-800: #791d26;\n    --red-900: #58151c;\n    --primary-50: #f2f8ff;\n    --primary-100: #c2dfff;\n    --primary-200: #91c6ff;\n    --primary-300: #61adff;\n    --primary-400: #3094ff;\n    --primary-500: #007bff;\n    --primary-600: #0069d9;\n    --primary-700: #0056b3;\n    --primary-800: #00448c;\n    --primary-900: #003166;\n}\n\n.p-editor-container .p-editor-toolbar {\n    background: #efefef;\n    border-top-right-radius: 4px;\n    border-top-left-radius: 4px;\n}\n\n.p-editor-container .p-editor-toolbar.ql-snow {\n    border: 1px solid #dee2e6;\n}\n\n.p-editor-container .p-editor-toolbar.ql-snow .ql-stroke {\n    stroke: #6c757d;\n}\n\n.p-editor-container .p-editor-toolbar.ql-snow .ql-fill {\n    fill: #6c757d;\n}\n\n.p-editor-container .p-editor-toolbar.ql-snow .ql-picker .ql-picker-label {\n    border: 0 none;\n    color: #6c757d;\n}\n\n.p-editor-container .p-editor-toolbar.ql-snow .ql-picker .ql-picker-label:hover {\n    color: #212529;\n}\n\n.p-editor-container .p-editor-toolbar.ql-snow .ql-picker .ql-picker-label:hover .ql-stroke {\n    stroke: #212529;\n}\n\n.p-editor-container .p-editor-toolbar.ql-snow .ql-picker .ql-picker-label:hover .ql-fill {\n    fill: #212529;\n}\n\n.p-editor-container .p-editor-toolbar.ql-snow .ql-picker.ql-expanded .ql-picker-label {\n    color: #212529;\n}\n\n.p-editor-container .p-editor-toolbar.ql-snow .ql-picker.ql-expanded .ql-picker-label .ql-stroke {\n    stroke: #212529;\n}\n\n.p-editor-container .p-editor-toolbar.ql-snow .ql-picker.ql-expanded .ql-picker-label .ql-fill {\n    fill: #212529;\n}\n\n.p-editor-container .p-editor-toolbar.ql-snow .ql-picker.ql-expanded .ql-picker-options {\n    background: #ffffff;\n    border: 1px solid rgba(0, 0, 0, 0.15);\n    box-shadow: none;\n    border-radius: 4px;\n    padding: 0.5rem 0;\n}\n\n.p-editor-container .p-editor-toolbar.ql-snow .ql-picker.ql-expanded .ql-picker-options .ql-picker-item {\n    color: #212529;\n}\n\n.p-editor-container .p-editor-toolbar.ql-snow .ql-picker.ql-expanded .ql-picker-options .ql-picker-item:hover {\n    color: #212529;\n    background: #e9ecef;\n}\n\n.p-editor-container .p-editor-toolbar.ql-snow .ql-picker.ql-expanded:not(.ql-icon-picker) .ql-picker-item {\n    padding: 0.5rem 1.5rem;\n}\n\n.p-editor-container .p-editor-content {\n    border-bottom-right-radius: 4px;\n    border-bottom-left-radius: 4px;\n}\n\n.p-editor-container .p-editor-content.ql-snow {\n    border: 1px solid #dee2e6;\n}\n\n.p-editor-container .p-editor-content .ql-editor {\n    background: #ffffff;\n    color: #495057;\n    border-bottom-right-radius: 4px;\n    border-bottom-left-radius: 4px;\n}\n\n.p-editor-container .ql-snow.ql-toolbar button:hover,\n.p-editor-container .ql-snow.ql-toolbar button:focus {\n    color: #212529;\n}\n\n.p-editor-container .ql-snow.ql-toolbar button:hover .ql-stroke,\n.p-editor-container .ql-snow.ql-toolbar button:focus .ql-stroke {\n    stroke: #212529;\n}\n\n.p-editor-container .ql-snow.ql-toolbar button:hover .ql-fill,\n.p-editor-container .ql-snow.ql-toolbar button:focus .ql-fill {\n    fill: #212529;\n}\n\n.p-editor-container .ql-snow.ql-toolbar button.ql-active,\n.p-editor-container .ql-snow.ql-toolbar .ql-picker-label.ql-active,\n.p-editor-container .ql-snow.ql-toolbar .ql-picker-item.ql-selected {\n    color: #007bff;\n}\n\n.p-editor-container .ql-snow.ql-toolbar button.ql-active .ql-stroke,\n.p-editor-container .ql-snow.ql-toolbar .ql-picker-label.ql-active .ql-stroke,\n.p-editor-container .ql-snow.ql-toolbar .ql-picker-item.ql-selected .ql-stroke {\n    stroke: #007bff;\n}\n\n.p-editor-container .ql-snow.ql-toolbar button.ql-active .ql-fill,\n.p-editor-container .ql-snow.ql-toolbar .ql-picker-label.ql-active .ql-fill,\n.p-editor-container .ql-snow.ql-toolbar .ql-picker-item.ql-selected .ql-fill {\n    fill: #007bff;\n}\n\n.p-editor-container .ql-snow.ql-toolbar button.ql-active .ql-picker-label,\n.p-editor-container .ql-snow.ql-toolbar .ql-picker-label.ql-active .ql-picker-label,\n.p-editor-container .ql-snow.ql-toolbar .ql-picker-item.ql-selected .ql-picker-label {\n    color: #007bff;\n}\n\n@layer primereact {\n    * {\n        box-sizing: border-box;\n    }\n\n    .p-component {\n        font-family: var(--font-family);\n        font-feature-settings: var(--font-feature-settings, normal);\n        font-size: 12px;\n        font-weight: normal;\n    }\n\n    .p-component-overlay {\n        background-color: rgba(0, 0, 0, 0.4);\n        transition-duration: 0.15s;\n    }\n\n    .p-disabled,\n    .p-component:disabled {\n        opacity: 0.65;\n    }\n\n    .p-error {\n        color: #dc3545;\n    }\n\n    .p-text-secondary {\n        color: #6c757d;\n    }\n\n    .pi {\n        font-size: 12px;\n    }\n\n    .p-icon {\n        width: 1rem;\n        height: 1rem;\n    }\n\n    .p-link {\n        font-family: var(--font-family);\n        font-feature-settings: var(--font-feature-settings, normal);\n        font-size: 12px;\n        border-radius: 4px;\n    }\n\n    .p-link:focus-visible {\n        outline: 0 none;\n        outline-offset: 0;\n        box-shadow: 0 0 0 0.2rem #e4717c;\n    }\n\n    .p-component-overlay-enter {\n        animation: p-component-overlay-enter-animation 150ms forwards;\n    }\n\n    .p-component-overlay-leave {\n        animation: p-component-overlay-leave-animation 150ms forwards;\n    }\n\n    @keyframes p-component-overlay-enter-animation {\n        from {\n            background-color: transparent;\n        }\n\n        to {\n            background-color: var(--maskbg);\n        }\n    }\n\n    @keyframes p-component-overlay-leave-animation {\n        from {\n            background-color: var(--maskbg);\n        }\n\n        to {\n            background-color: transparent;\n        }\n    }\n\n    .p-autocomplete .p-autocomplete-loader {\n        right: 0.75rem;\n    }\n\n    .p-autocomplete.p-autocomplete-dd .p-autocomplete-loader {\n        right: 3.107rem;\n    }\n\n    .p-autocomplete .p-autocomplete-multiple-container {\n        padding: 0.25rem 0.75rem;\n        gap: 0.5rem;\n    }\n\n    .p-autocomplete .p-autocomplete-multiple-container:not(.p-disabled):hover {\n        border-color: #ced4da;\n    }\n\n    .p-autocomplete .p-autocomplete-multiple-container:not(.p-disabled).p-focus {\n        outline: 0 none;\n        outline-offset: 0;\n        box-shadow: 0 0 0 0.2rem rgba(38, 143, 255, 0.5);\n        border-color: #007bff;\n    }\n\n    .p-autocomplete .p-autocomplete-multiple-container .p-autocomplete-input-token {\n        padding: 0.25rem 0;\n    }\n\n    .p-autocomplete .p-autocomplete-multiple-container .p-autocomplete-input-token input {\n        font-family: var(--font-family);\n        font-feature-settings: var(--font-feature-settings, normal);\n        font-size: 12px;\n        color: #212529;\n        padding: 0;\n        margin: 0;\n    }\n\n    .p-autocomplete .p-autocomplete-multiple-container .p-autocomplete-token {\n        padding: 0.25rem 0.75rem;\n        margin-right: 0.5rem;\n        background: #007bff;\n        color: #ffffff;\n        border-radius: 4px;\n    }\n\n    .p-autocomplete .p-autocomplete-multiple-container .p-autocomplete-token .p-autocomplete-token-icon {\n        margin-left: 0.5rem;\n    }\n\n    .p-autocomplete.p-invalid.p-component>.p-inputtext {\n        border-color: #dc3545;\n    }\n\n    .p-autocomplete-panel {\n        background: #ffffff;\n        color: #212529;\n        border: 1px solid rgba(0, 0, 0, 0.15);\n        border-radius: 4px;\n        box-shadow: none;\n    }\n\n    .p-autocomplete-panel .p-autocomplete-items {\n        padding: 0.5rem 0;\n    }\n\n    .p-autocomplete-panel .p-autocomplete-items .p-autocomplete-item {\n        margin: 0;\n        padding: 0.5rem 1.5rem;\n        border: 0 none;\n        color: #212529;\n        background: transparent;\n        transition: box-shadow 0.15s;\n        border-radius: 0;\n    }\n\n    .p-autocomplete-panel .p-autocomplete-items .p-autocomplete-item:hover {\n        color: #212529;\n        background: #e9ecef;\n    }\n\n    .p-autocomplete-panel .p-autocomplete-items .p-autocomplete-item.p-highlight {\n        color: #ffffff;\n        background: #007bff;\n    }\n\n    .p-autocomplete-panel .p-autocomplete-items .p-autocomplete-item-group {\n        margin: 0;\n        padding: 0.75rem 1rem;\n        color: #212529;\n        background: #ffffff;\n        font-weight: 600;\n    }\n\n    .p-calendar.p-invalid.p-component>.p-inputtext {\n        border-color: #dc3545;\n    }\n\n    .p-calendar:not(.p-calendar-disabled).p-focus>.p-inputtext {\n        outline: 0 none;\n        outline-offset: 0;\n        box-shadow: 0 0 0 0.2rem #e4717c;\n        border-color: #e4717c\n    }\n\n    .p-datepicker {\n        padding: 0;\n        background: #ffffff;\n        color: #212529;\n        border: 1px solid #ced4da;\n        border-radius: 4px;\n    }\n\n    .p-datepicker:not(.p-datepicker-inline) {\n        background: #ffffff;\n        border: 1px solid rgba(0, 0, 0, 0.15);\n        box-shadow: none;\n    }\n\n    .p-datepicker:not(.p-datepicker-inline) .p-datepicker-header {\n        background: #efefef;\n    }\n\n    .p-datepicker .p-datepicker-header {\n        padding: 0.5rem;\n        color: #212529;\n        background: #ffffff;\n        font-weight: 600;\n        margin: 0;\n        border-bottom: 1px solid #dee2e6;\n        border-top-right-radius: 4px;\n        border-top-left-radius: 4px;\n    }\n\n    .p-datepicker .p-datepicker-header .p-datepicker-prev,\n    .p-datepicker .p-datepicker-header .p-datepicker-next {\n        width: 2rem;\n        height: 2rem;\n        color: #6c757d;\n        border: 0 none;\n        background: transparent;\n        border-radius: 50%;\n        transition: box-shadow 0.15s;\n    }\n\n    .p-datepicker .p-datepicker-header .p-datepicker-prev:enabled:hover,\n    .p-datepicker .p-datepicker-header .p-datepicker-next:enabled:hover {\n        color: #495057;\n        border-color: transparent;\n        background: transparent;\n    }\n\n    .p-datepicker .p-datepicker-header .p-datepicker-prev:focus-visible,\n    .p-datepicker .p-datepicker-header .p-datepicker-next:focus-visible {\n        outline: 0 none;\n        outline-offset: 0;\n        box-shadow: 0 0 0 0.2rem rgba(38, 143, 255, 0.5);\n    }\n\n    .p-datepicker .p-datepicker-header .p-datepicker-title {\n        line-height: 2rem;\n    }\n\n    .p-datepicker .p-datepicker-header .p-datepicker-title .p-datepicker-year,\n    .p-datepicker .p-datepicker-header .p-datepicker-title .p-datepicker-month {\n        color: #212529;\n        transition: box-shadow 0.15s;\n        font-weight: 600;\n        padding: 0.5rem;\n    }\n\n    .p-datepicker .p-datepicker-header .p-datepicker-title .p-datepicker-year:enabled:hover,\n    .p-datepicker .p-datepicker-header .p-datepicker-title .p-datepicker-month:enabled:hover {\n        color: #007bff;\n    }\n\n    .p-datepicker .p-datepicker-header .p-datepicker-title .p-datepicker-month {\n        margin-right: 0.5rem;\n    }\n\n    .p-datepicker table {\n        font-size: 12px;\n        margin: 0.5rem 0;\n    }\n\n    .p-datepicker table th {\n        padding: 0.5rem;\n    }\n\n    .p-datepicker table th>span {\n        width: 2.5rem;\n        height: 2.5rem;\n    }\n\n    .p-datepicker table td {\n        padding: 0.5rem;\n    }\n\n    .p-datepicker table td>span {\n        width: 2.5rem;\n        height: 2.5rem;\n        border-radius: 4px;\n        transition: box-shadow 0.15s;\n        border: 1px solid transparent;\n    }\n\n    .p-datepicker table td>span.p-highlight {\n        color: #ffffff;\n        background: #cf0000;\n    }\n\n    .p-datepicker table td>span:focus {\n        outline: 0 none;\n        outline-offset: 0;\n        box-shadow: 0 0 0 0.2rem rgba(38, 143, 255, 0.5);\n    }\n\n    .p-datepicker table td.p-datepicker-today>span {\n        background: #ced4da;\n        color: #212529;\n        border-color: transparent;\n    }\n\n    .p-datepicker table td.p-datepicker-today>span.p-highlight {\n        color: #ffffff;\n        background: #080808;\n    }\n\n    .p-datepicker .p-datepicker-buttonbar {\n        padding: 1rem 0;\n        border-top: 1px solid #dee2e6;\n    }\n\n    .p-datepicker .p-datepicker-buttonbar .p-button {\n        width: auto;\n    }\n\n    .p-datepicker .p-timepicker {\n        border-top: 1px solid #dee2e6;\n        padding: 0.5rem;\n    }\n\n    .p-datepicker .p-timepicker button {\n        width: 2rem;\n        height: 2rem;\n        color: #6c757d;\n        border: 0 none;\n        background: transparent;\n        border-radius: 50%;\n        transition: box-shadow 0.15s;\n    }\n\n    .p-datepicker .p-timepicker button:enabled:hover {\n        color: #495057;\n        border-color: transparent;\n        background: transparent;\n    }\n\n    .p-datepicker .p-timepicker button:focus-visible {\n        outline: 0 none;\n        outline-offset: 0;\n        box-shadow: 0 0 0 0.2rem rgba(38, 143, 255, 0.5);\n    }\n\n    .p-datepicker .p-timepicker button:last-child {\n        margin-top: 0.2em;\n    }\n\n    .p-datepicker .p-timepicker span {\n        font-size: 12px;\n    }\n\n    .p-datepicker .p-timepicker>div {\n        padding: 0 0.5rem;\n    }\n\n    .p-datepicker.p-datepicker-timeonly .p-timepicker {\n        border-top: 0 none;\n    }\n\n    .p-datepicker .p-monthpicker {\n        margin: 0.5rem 0;\n    }\n\n    .p-datepicker .p-monthpicker .p-monthpicker-month {\n        padding: 0.5rem;\n        transition: box-shadow 0.15s;\n        border-radius: 4px;\n    }\n\n    .p-datepicker .p-monthpicker .p-monthpicker-month.p-highlight {\n        color: #ffffff;\n        background: #007bff;\n    }\n\n    .p-datepicker .p-yearpicker {\n        margin: 0.5rem 0;\n    }\n\n    .p-datepicker .p-yearpicker .p-yearpicker-year {\n        padding: 0.5rem;\n        transition: box-shadow 0.15s;\n        border-radius: 4px;\n    }\n\n    .p-datepicker .p-yearpicker .p-yearpicker-year.p-highlight {\n        color: #ffffff;\n        background: #007bff;\n    }\n\n    .p-datepicker.p-datepicker-multiple-month .p-datepicker-group {\n        border-left: 1px solid #dee2e6;\n        padding-right: 0;\n        padding-left: 0;\n        padding-top: 0;\n        padding-bottom: 0;\n    }\n\n    .p-datepicker.p-datepicker-multiple-month .p-datepicker-group:first-child {\n        padding-left: 0;\n    }\n\n    .p-datepicker.p-datepicker-multiple-month .p-datepicker-group:last-child {\n        padding-right: 0;\n        border-left: 0 none;\n    }\n\n    .p-datepicker:not(.p-disabled) table td span:not(.p-highlight):not(.p-disabled):hover {\n        background: #e9ecef;\n    }\n\n    .p-datepicker:not(.p-disabled) table td span:not(.p-highlight):not(.p-disabled):focus {\n        outline: 0 none;\n        outline-offset: 0;\n        box-shadow: 0 0 0 0.2rem #e4717c;\n    }\n\n    .p-datepicker:not(.p-disabled) .p-monthpicker .p-monthpicker-month:not(.p-disabled):not(.p-highlight):hover {\n        background: #e9ecef;\n    }\n\n    .p-datepicker:not(.p-disabled) .p-monthpicker .p-monthpicker-month:not(.p-disabled):focus {\n        outline: 0 none;\n        outline-offset: 0;\n        box-shadow: 0 0 0 0.2rem rgba(38, 143, 255, 0.5);\n    }\n\n    .p-datepicker:not(.p-disabled) .p-yearpicker .p-yearpicker-year:not(.p-disabled):not(.p-highlight):hover {\n        background: #e9ecef;\n    }\n\n    .p-datepicker:not(.p-disabled) .p-yearpicker .p-yearpicker-year:not(.p-disabled):focus {\n        outline: 0 none;\n        outline-offset: 0;\n        box-shadow: 0 0 0 0.2rem rgba(38, 143, 255, 0.5);\n    }\n\n    @media screen and (max-width: 769px) {\n\n        .p-datepicker table th,\n        .p-datepicker table td {\n            padding: 0;\n        }\n    }\n\n    .p-cascadeselect {\n        background: #ffffff;\n        border: 1px solid #ced4da;\n        transition: background-color 0.15s, border-color 0.15s, box-shadow 0.15s;\n        border-radius: 4px;\n    }\n\n    .p-cascadeselect:not(.p-disabled):hover {\n        border-color: #ced4da;\n    }\n\n    .p-cascadeselect:not(.p-disabled).p-focus {\n        outline: 0 none;\n        outline-offset: 0;\n        box-shadow: 0 0 0 0.2rem rgba(38, 143, 255, 0.5);\n        border-color: #007bff;\n    }\n\n    .p-cascadeselect .p-cascadeselect-label {\n        background: transparent;\n        border: 0 none;\n        padding: 0.5rem 0.75rem;\n    }\n\n    .p-cascadeselect .p-cascadeselect-label.p-placeholder {\n        color: #6c757d;\n    }\n\n    .p-cascadeselect .p-cascadeselect-label:enabled:focus {\n        outline: 0 none;\n        box-shadow: none;\n    }\n\n    .p-cascadeselect .p-cascadeselect-trigger {\n        background: transparent;\n        color: #495057;\n        width: 2.357rem;\n        border-top-right-radius: 4px;\n        border-bottom-right-radius: 4px;\n    }\n\n    .p-cascadeselect.p-invalid.p-component {\n        border-color: #dc3545;\n    }\n\n    .p-cascadeselect-panel {\n        background: #ffffff;\n        color: #212529;\n        border: 1px solid rgba(0, 0, 0, 0.15);\n        border-radius: 4px;\n        box-shadow: none;\n    }\n\n    .p-cascadeselect-panel .p-cascadeselect-items {\n        padding: 0.5rem 0;\n    }\n\n    .p-cascadeselect-panel .p-cascadeselect-items .p-cascadeselect-item {\n        margin: 0;\n        border: 0 none;\n        color: #212529;\n        background: transparent;\n        transition: box-shadow 0.15s;\n        border-radius: 0;\n    }\n\n    .p-cascadeselect-panel .p-cascadeselect-items .p-cascadeselect-item .p-cascadeselect-item-content {\n        padding: 0.5rem 1.5rem;\n    }\n\n    .p-cascadeselect-panel .p-cascadeselect-items .p-cascadeselect-item .p-cascadeselect-item-content:focus {\n        outline: 0 none;\n        outline-offset: 0;\n        box-shadow: inset 0 0 0 0.15rem rgba(38, 143, 255, 0.5);\n    }\n\n    .p-cascadeselect-panel .p-cascadeselect-items .p-cascadeselect-item.p-highlight {\n        color: #ffffff;\n        background: #007bff;\n    }\n\n    .p-cascadeselect-panel .p-cascadeselect-items .p-cascadeselect-item:not(.p-highlight):not(.p-disabled):hover {\n        color: #212529;\n        background: #e9ecef;\n    }\n\n    .p-cascadeselect-panel .p-cascadeselect-items .p-cascadeselect-item .p-cascadeselect-group-icon {\n        font-size: 0.875rem;\n    }\n\n    .p-cascadeselect-panel .p-cascadeselect-items .p-cascadeselect-item .p-cascadeselect-group-icon.p-icon {\n        width: 0.875rem;\n        height: 0.875rem;\n    }\n\n    .p-input-filled .p-cascadeselect {\n        background: #efefef;\n    }\n\n    .p-input-filled .p-cascadeselect:not(.p-disabled):hover {\n        background-color: #efefef;\n    }\n\n    .p-input-filled .p-cascadeselect:not(.p-disabled).p-focus {\n        background-color: #efefef;\n    }\n\n    .p-checkbox {\n        width: 20px;\n        height: 20px;\n    }\n\n    .p-checkbox .p-checkbox-box {\n        border: 2px solid #ced4da;\n        background: #ffffff;\n        width: 20px;\n        height: 20px;\n        color: #212529;\n        border-radius: 4px;\n        transition: background-color 0.15s, border-color 0.15s, box-shadow 0.15s;\n    }\n\n    .p-checkbox .p-checkbox-box .p-checkbox-icon {\n        transition-duration: 0.15s;\n        color: #ffffff;\n        font-size: 14px;\n    }\n\n    .p-checkbox .p-checkbox-box .p-checkbox-icon.p-icon {\n        width: 14px;\n        height: 14px;\n    }\n\n    .p-checkbox .p-checkbox-box.p-highlight {\n        border-color: #cf0000;\n        background: #cf0000;\n    }\n\n    .p-checkbox .p-checkbox-box.p-highlight:not(.p-disabled):hover {\n        border-color: #0062cc;\n        background: #0062cc;\n        color: #ffffff;\n    }\n\n    .p-checkbox:not(.p-checkbox-disabled) .p-checkbox-box:hover {\n        border-color: #ced4da;\n    }\n\n    .p-checkbox:not(.p-checkbox-disabled) .p-checkbox-box.p-focus {\n        outline: 0 none;\n        outline-offset: 0;\n        box-shadow: 0 0 0 0.2rem #e4717c;\n        border-color: #e4717c;\n    }\n\n    .p-checkbox:not(.p-checkbox-disabled) .p-checkbox-box.p-highlight:hover {\n        border-color: #a60622;\n        background: #a60622;\n        color: #ffffff;\n    }\n\n    .p-checkbox.p-invalid>.p-checkbox-box {\n        border-color: #dc3545;\n    }\n\n    .p-input-filled .p-checkbox .p-checkbox-box {\n        background-color: #efefef;\n    }\n\n    .p-input-filled .p-checkbox .p-checkbox-box.p-highlight {\n        background: #ff0404;\n    }\n\n    .p-input-filled .p-checkbox:not(.p-checkbox-disabled) .p-checkbox-box:hover {\n        background-color: #efefef;\n    }\n\n    .p-input-filled .p-checkbox:not(.p-checkbox-disabled) .p-checkbox-box.p-highlight:hover {\n        background: #0062cc;\n    }\n\n    .p-highlight .p-checkbox .p-checkbox-box {\n        border-color: #ffffff;\n    }\n\n    .p-chips {\n        display: inline-flex;\n    }\n\n    .p-chips-multiple-container {\n        margin: 0;\n        padding: 0;\n        list-style-type: none;\n        cursor: text;\n        overflow: hidden;\n        display: flex;\n        align-items: center;\n        flex-wrap: wrap;\n    }\n\n    .p-chips-token {\n        cursor: default;\n        display: inline-flex;\n        align-items: center;\n        flex: 0 0 auto;\n    }\n\n    .p-chips-input-token {\n        flex: 1 1 auto;\n        display: inline-flex;\n    }\n\n    .p-chips-token-icon {\n        cursor: pointer;\n    }\n\n    .p-chips-input-token input {\n        border: 0 none;\n        outline: 0 none;\n        background-color: transparent;\n        margin: 0;\n        padding: 0;\n        box-shadow: none;\n        border-radius: 0;\n        width: 100%;\n    }\n\n    .p-fluid .p-chips {\n        display: flex;\n    }\n\n    .p-chips:not(.p-disabled):hover .p-chips-multiple-container {\n        border-color: #ced4da;\n    }\n\n    .p-chips:not(.p-disabled).p-focus .p-chips-multiple-container {\n        outline: 0 none;\n        outline-offset: 0;\n        box-shadow: 0 0 0 0.2rem rgba(38, 143, 255, 0.5);\n        border-color: #007bff;\n    }\n\n    .p-chips .p-chips-multiple-container {\n        padding: 0.25rem 0.75rem;\n        outline-color: transparent;\n    }\n\n    .p-chips .p-chips-multiple-container .p-chips-token {\n        padding: 0.25rem 0.75rem;\n        margin-right: 0.5rem;\n        background: #dee2e6;\n        color: #212529;\n        border-radius: 16px;\n    }\n\n    .p-chips .p-chips-multiple-container .p-chips-token.p-focus {\n        background: #ced4da;\n        color: #212529;\n    }\n\n    .p-chips .p-chips-multiple-container .p-chips-token .p-chips-token-icon {\n        margin-left: 0.5rem;\n    }\n\n    .p-chips .p-chips-multiple-container .p-chips-input-token {\n        padding: 0.25rem 0;\n    }\n\n    .p-chips .p-chips-multiple-container .p-chips-input-token input {\n        font-family: var(--font-family);\n        font-feature-settings: var(--font-feature-settings, normal);\n        font-size: 12px;\n        color: #212529;\n        padding: 0;\n        margin: 0;\n    }\n\n    .p-chips.p-invalid.p-component>.p-inputtext {\n        border-color: #dc3545;\n    }\n\n    .p-colorpicker-preview {\n        width: 2rem;\n        height: 2rem;\n    }\n\n    .p-colorpicker-panel {\n        background: #212529;\n        border: 1px solid #212529;\n    }\n\n    .p-colorpicker-panel .p-colorpicker-color-handle,\n    .p-colorpicker-panel .p-colorpicker-hue-handle {\n        border-color: #ffffff;\n    }\n\n    .p-colorpicker-overlay-panel {\n        box-shadow: none;\n    }\n\n    .p-dropdown {\n        display: inline-flex;\n        cursor: pointer;\n        position: relative;\n        user-select: none;\n    }\n\n    .p-dropdown-clear-icon {\n        position: absolute;\n        top: 50%;\n        margin-top: -0.5rem;\n    }\n\n    .p-dropdown-trigger {\n        display: flex;\n        align-items: center;\n        justify-content: center;\n        flex-shrink: 0;\n    }\n\n    .p-dropdown-label {\n        display: block;\n        white-space: nowrap;\n        overflow: hidden;\n        flex: 1 1 auto;\n        width: 1%;\n        text-overflow: ellipsis;\n        cursor: pointer;\n    }\n\n    .p-dropdown-label-empty {\n        overflow: hidden;\n        opacity: 0;\n    }\n\n    input.p-dropdown-label {\n        cursor: default;\n    }\n\n    .p-dropdown .p-dropdown-panel {\n        min-width: 100%;\n    }\n\n    .p-dropdown-panel {\n        position: absolute;\n        top: 0;\n        left: 0;\n    }\n\n    .p-dropdown-items-wrapper {\n        overflow: auto;\n    }\n\n    .p-dropdown-item {\n        cursor: pointer;\n        font-weight: normal;\n        white-space: nowrap;\n        position: relative;\n        overflow: hidden;\n        display: flex;\n        align-items: center;\n    }\n\n    .p-dropdown-item-group {\n        cursor: auto;\n    }\n\n    .p-dropdown-items {\n        margin: 0;\n        padding: 0;\n        list-style-type: none;\n    }\n\n    .p-dropdown-filter {\n        width: 100%;\n    }\n\n    .p-dropdown-filter-container {\n        position: relative;\n    }\n\n    .p-dropdown-filter-icon {\n        position: absolute;\n        top: 50%;\n        margin-top: -0.5rem;\n    }\n\n    .p-fluid .p-dropdown {\n        display: flex;\n    }\n\n    .p-fluid .p-dropdown .p-dropdown-label {\n        width: 1%;\n    }\n\n    .p-dropdown {\n        background: #ffffff;\n        border: 1px solid #ced4da;\n        transition: background-color 0.15s, border-color 0.15s, box-shadow 0.15s;\n        border-radius: 4px;\n        outline-color: transparent;\n    }\n\n    .p-dropdown:not(.p-disabled):hover {\n        border-color: #ced4da;\n    }\n\n    .p-dropdown:not(.p-disabled).p-focus {\n        outline: 0 none;\n        outline-offset: 0;\n        box-shadow: 0 0 0 0.2rem #e4717c;\n        border-color: #e4717c;\n    }\n\n    .p-dropdown.p-variant-filled {\n        background: #efefef;\n    }\n\n    .p-dropdown.p-variant-filled:not(.p-disabled):hover {\n        background-color: #efefef;\n    }\n\n    .p-dropdown.p-variant-filled:not(.p-disabled).p-focus {\n        background-color: #efefef;\n    }\n\n    .p-dropdown.p-variant-filled:not(.p-disabled).p-focus .p-inputtext {\n        background-color: transparent;\n    }\n\n    .p-dropdown.p-dropdown-clearable .p-dropdown-label {\n        padding-right: 1.75rem;\n    }\n\n    .p-dropdown .p-dropdown-label {\n        background: transparent;\n        border: 0 none;\n    }\n\n    .p-dropdown .p-dropdown-label.p-placeholder {\n        color: #6c757d;\n    }\n\n    .p-dropdown .p-dropdown-label:focus,\n    .p-dropdown .p-dropdown-label:enabled:focus {\n        outline: 0 none;\n        box-shadow: none;\n    }\n\n    .p-dropdown .p-dropdown-trigger {\n        background: transparent;\n        color: #cf0000;\n        width: 2.357rem;\n        border-top-right-radius: 4px;\n        border-bottom-right-radius: 4px;\n    }\n\n    .p-dropdown .p-dropdown-clear-icon {\n        color: #495057;\n        right: 2.357rem;\n    }\n\n    .p-dropdown.p-invalid.p-component {\n        border-color: #dc3545;\n    }\n\n    .p-dropdown-panel {\n        background: #ffffff;\n        color: #212529;\n        border: 1px solid rgba(0, 0, 0, 0.15);\n        border-radius: 4px;\n        box-shadow: none;\n    }\n\n    .p-dropdown-panel .p-dropdown-header {\n        padding: 0.75rem 1.5rem;\n        border-bottom: 1px solid #dee2e6;\n        color: #212529;\n        background: #efefef;\n        margin: 0;\n        border-top-right-radius: 4px;\n        border-top-left-radius: 4px;\n    }\n\n    .p-dropdown-panel .p-dropdown-header .p-dropdown-filter {\n        padding-right: 1.75rem;\n        margin-right: -1.75rem;\n    }\n\n    .p-dropdown-panel .p-dropdown-header .p-dropdown-filter-icon {\n        right: 0.75rem;\n        color: #495057;\n    }\n\n    .p-dropdown-panel .p-dropdown-items {\n        padding: 0.5rem 0;\n    }\n\n    .p-dropdown-panel .p-dropdown-items .p-dropdown-item {\n        margin: 0;\n        padding: 0.5rem 1.5rem;\n        border: 0 none;\n        color: #212529;\n        background: transparent;\n        transition: box-shadow 0.15s;\n        border-radius: 0;\n    }\n\n    .p-dropdown-panel .p-dropdown-items .p-dropdown-item:first-child {\n        margin-top: 0;\n    }\n\n    .p-dropdown-panel .p-dropdown-items .p-dropdown-item:last-child {\n        margin-bottom: 0;\n    }\n\n    .p-dropdown-panel .p-dropdown-items .p-dropdown-item.p-highlight {\n        color: #ffffff;\n        background: #cf0000;\n    }\n\n    .p-dropdown-panel .p-dropdown-items .p-dropdown-item.p-highlight.p-focus {\n        background: #cf0000;\n    }\n\n    .p-dropdown-panel .p-dropdown-items .p-dropdown-item:not(.p-highlight):not(.p-disabled).p-focus {\n        color: #212529;\n        background: #e9ecef;\n    }\n\n    .p-dropdown-panel .p-dropdown-items .p-dropdown-item .p-dropdown-check-icon {\n        position: relative;\n        margin-left: -0.5rem;\n        margin-right: 0.5rem;\n    }\n\n    .p-dropdown-panel .p-dropdown-items .p-dropdown-item-group {\n        margin: 0;\n        padding: 0.75rem 1rem;\n        color: #212529;\n        background: #ffffff;\n        font-weight: 600;\n    }\n\n    .p-dropdown-panel .p-dropdown-items .p-dropdown-empty-message {\n        padding: 0.5rem 1.5rem;\n        color: #212529;\n        background: transparent;\n    }\n\n    .p-inputgroup-addon {\n        background: #e9ecef;\n        color: #495057;\n        border-top: 1px solid #ced4da;\n        border-left: 1px solid #ced4da;\n        border-bottom: 1px solid #ced4da;\n        padding: 0.5rem 0.75rem;\n        min-width: 2.357rem;\n    }\n\n    .p-inputgroup-addon:last-child {\n        border-right: 1px solid #ced4da;\n    }\n\n    .p-inputgroup>.p-component,\n    .p-inputgroup>.p-inputwrapper>.p-inputtext,\n    .p-inputgroup>.p-float-label>.p-component {\n        border-radius: 0;\n        margin: 0;\n    }\n\n    .p-inputgroup>.p-component+.p-inputgroup-addon,\n    .p-inputgroup>.p-inputwrapper>.p-inputtext+.p-inputgroup-addon,\n    .p-inputgroup>.p-float-label>.p-component+.p-inputgroup-addon {\n        border-left: 0 none;\n    }\n\n    .p-inputgroup>.p-component:focus,\n    .p-inputgroup>.p-inputwrapper>.p-inputtext:focus,\n    .p-inputgroup>.p-float-label>.p-component:focus {\n        z-index: 1;\n    }\n\n    .p-inputgroup>.p-component:focus~label,\n    .p-inputgroup>.p-inputwrapper>.p-inputtext:focus~label,\n    .p-inputgroup>.p-float-label>.p-component:focus~label {\n        z-index: 1;\n    }\n\n    .p-inputgroup-addon:first-child,\n    .p-inputgroup button:first-child,\n    .p-inputgroup input:first-child,\n    .p-inputgroup>.p-inputwrapper:first-child,\n    .p-inputgroup>.p-inputwrapper:first-child>.p-inputtext {\n        border-top-left-radius: 4px;\n        border-bottom-left-radius: 4px;\n    }\n\n    .p-inputgroup .p-float-label:first-child input {\n        border-top-left-radius: 4px;\n        border-bottom-left-radius: 4px;\n    }\n\n    .p-inputgroup-addon:last-child,\n    .p-inputgroup button:last-child,\n    .p-inputgroup input:last-child,\n    .p-inputgroup>.p-inputwrapper:last-child,\n    .p-inputgroup>.p-inputwrapper:last-child>.p-inputtext {\n        border-top-right-radius: 4px;\n        border-bottom-right-radius: 4px;\n    }\n\n    .p-inputgroup .p-float-label:last-child input {\n        border-top-right-radius: 4px;\n        border-bottom-right-radius: 4px;\n    }\n\n    .p-fluid .p-inputgroup .p-button {\n        width: auto;\n    }\n\n    .p-fluid .p-inputgroup .p-button.p-button-icon-only {\n        width: 2.357rem;\n    }\n\n    .p-inputnumber.p-invalid.p-component>.p-inputtext {\n        border-color: #dc3545;\n    }\n\n    .p-inputswitch {\n        width: 3rem;\n        height: 1.75rem;\n    }\n\n    .p-inputswitch .p-inputswitch-slider {\n        background: #ced4da;\n        transition: background-color 0.15s, border-color 0.15s, box-shadow 0.15s;\n        border-radius: 30px;\n    }\n\n    .p-inputswitch .p-inputswitch-slider:before {\n        background: #ffffff;\n        width: 1.25rem;\n        height: 1.25rem;\n        left: 0.25rem;\n        margin-top: -0.625rem;\n        border-radius: 30px;\n        transition-duration: 0.15s;\n    }\n\n    .p-inputswitch.p-inputswitch-checked .p-inputswitch-slider:before {\n        transform: translateX(1.25rem);\n    }\n\n    .p-inputswitch.p-focus .p-inputswitch-slider {\n        outline: 0 none;\n        outline-offset: 0;\n        box-shadow: 0 0 0 0.2rem #e4717c;\n    }\n\n    .p-inputswitch:not(.p-disabled):hover .p-inputswitch-slider {\n        background: #ced4da;\n    }\n\n    .p-inputswitch.p-inputswitch-checked .p-inputswitch-slider {\n        background: #cf0000;\n        box-shadow: 0px 1px 8px -1px #dc3545;\n    }\n\n    .p-inputswitch.p-inputswitch-checked .p-inputswitch-slider:before {\n        background: #ffffff;\n    }\n\n    .p-inputswitch.p-inputswitch-checked:not(.p-disabled):hover .p-inputswitch-slider {\n        background: #a60622;\n    }\n\n    .p-inputswitch.p-invalid .p-inputswitch-slider {\n        border-color: #dc3545;\n    }\n\n    .p-inputtext {\n        font-family: var(--font-family);\n        font-feature-settings: var(--font-feature-settings, normal);\n        font-size: 12px;\n        color: #495057;\n        background: #ffffff;\n        padding: 0.5rem 0.75rem;\n        border: 1px solid #ced4da;\n        transition: background-color 0.15s, border-color 0.15s, box-shadow 0.15s;\n        appearance: none;\n        border-radius: 4px;\n    }\n\n    .p-inputtext:enabled:hover {\n        border-color: #ced4da;\n    }\n\n    .p-inputtext:enabled:focus {\n        outline: 0 none;\n        outline-offset: 0;\n        box-shadow: 0 0 0 0.2rem #e4717c;\n        border-color: #e4717c;\n    }\n\n    .p-inputtext.p-invalid.p-component {\n        border-color: #dc3545;\n    }\n\n    .p-inputtext.p-inputtext-sm {\n        font-size: 12px;\n        padding: 0.4375rem 0.65625rem;\n    }\n\n    .p-inputtext.p-inputtext-lg {\n        font-size: 12px;\n        padding: 0.625rem 0.9375rem;\n    }\n\n    .p-float-label>label {\n        left: 0.75rem;\n        color: #6c757d;\n        transition-duration: 0.15s;\n    }\n\n    .p-float-label>label.p-error {\n        color: #dc3545;\n    }\n\n    .p-input-icon-left>i:first-of-type,\n    .p-input-icon-left>svg:first-of-type,\n    .p-input-icon-left>.p-input-prefix {\n        left: 0.75rem;\n        color: #495057;\n    }\n\n    .p-input-icon-left>.p-inputtext {\n        padding-left: 2.5rem;\n    }\n\n    .p-input-icon-left.p-float-label>label {\n        left: 2.5rem;\n    }\n\n    .p-input-icon-right>i:last-of-type,\n    .p-input-icon-right>svg:last-of-type,\n    .p-input-icon-right>.p-input-suffix {\n        right: 0.75rem;\n        color: #495057;\n    }\n\n    .p-input-icon-right>.p-inputtext {\n        padding-right: 2.5rem;\n    }\n\n    ::-webkit-input-placeholder {\n        color: #6c757d;\n    }\n\n    :-moz-placeholder {\n        color: #6c757d;\n    }\n\n    ::-moz-placeholder {\n        color: #6c757d;\n    }\n\n    :-ms-input-placeholder {\n        color: #6c757d;\n    }\n\n    .p-input-filled .p-inputtext {\n        background-color: #efefef;\n    }\n\n    .p-input-filled .p-inputtext:enabled:hover {\n        background-color: #efefef;\n    }\n\n    .p-input-filled .p-inputtext:enabled:focus {\n        background-color: #efefef;\n    }\n\n    .p-inputtext-sm .p-inputtext {\n        font-size: 12px;\n        padding: 0.4375rem 0.65625rem;\n    }\n\n    .p-inputtext-lg .p-inputtext {\n        font-size: 12px;\n        padding: 0.625rem 0.9375rem;\n    }\n\n    .p-listbox-list-wrapper {\n        overflow: auto;\n    }\n\n    .p-listbox-list {\n        list-style-type: none;\n        margin: 0;\n        padding: 0;\n    }\n\n    .p-listbox-item {\n        cursor: pointer;\n        position: relative;\n        overflow: hidden;\n    }\n\n    .p-listbox-item-group {\n        cursor: auto;\n    }\n\n    .p-listbox-filter-container {\n        position: relative;\n    }\n\n    .p-listbox-filter-icon {\n        position: absolute;\n        top: 50%;\n        margin-top: -0.5rem;\n    }\n\n    .p-listbox-filter {\n        width: 100%;\n    }\n\n    .p-listbox {\n        background: #ffffff;\n        color: #212529;\n        border: 1px solid #ced4da;\n        border-radius: 4px;\n        transition: background-color 0.15s, border-color 0.15s, box-shadow 0.15s;\n        outline-color: transparent;\n    }\n\n    .p-listbox .p-listbox-header {\n        padding: 0.75rem 1.5rem;\n        border-bottom: 1px solid #dee2e6;\n        color: #212529;\n        background: #efefef;\n        margin: 0;\n        border-top-right-radius: 4px;\n        border-top-left-radius: 4px;\n    }\n\n    .p-listbox .p-listbox-header .p-listbox-filter {\n        padding-right: 1.75rem;\n    }\n\n    .p-listbox .p-listbox-header .p-listbox-filter-icon {\n        right: 0.75rem;\n        color: #495057;\n    }\n\n    .p-listbox .p-listbox-list {\n        padding: 0.5rem 0;\n        outline: 0 none;\n    }\n\n    .p-listbox .p-listbox-list .p-listbox-item {\n        margin: 0;\n        padding: 0.5rem 1.5rem;\n        border: 0 none;\n        color: #212529;\n        transition: box-shadow 0.15s;\n        border-radius: 0;\n    }\n\n    .p-listbox .p-listbox-list .p-listbox-item:first-child {\n        margin-top: 0;\n    }\n\n    .p-listbox .p-listbox-list .p-listbox-item:last-child {\n        margin-bottom: 0;\n    }\n\n    .p-listbox .p-listbox-list .p-listbox-item.p-highlight {\n        color: #ffffff;\n        background: #007bff;\n    }\n\n    .p-listbox .p-listbox-list .p-listbox-item-group {\n        margin: 0;\n        padding: 0.75rem 1rem;\n        color: #212529;\n        background: #ffffff;\n        font-weight: 600;\n    }\n\n    .p-listbox .p-listbox-list .p-listbox-empty-message {\n        padding: 0.5rem 1.5rem;\n        color: #212529;\n        background: transparent;\n    }\n\n    .p-listbox:not(.p-disabled) .p-listbox-item.p-highlight.p-focus {\n        background: #0067d6;\n    }\n\n    .p-listbox:not(.p-disabled) .p-listbox-item:not(.p-highlight):not(.p-disabled).p-focus {\n        color: #212529;\n        background: #e9ecef;\n    }\n\n    .p-listbox:not(.p-disabled) .p-listbox-item:not(.p-highlight):not(.p-disabled):hover {\n        color: #212529;\n        background: #e9ecef;\n    }\n\n    .p-listbox:not(.p-disabled) .p-listbox-item:not(.p-highlight):not(.p-disabled):hover.p-focus {\n        color: #212529;\n        background: #e9ecef;\n    }\n\n    .p-listbox.p-focus {\n        outline: 0 none;\n        outline-offset: 0;\n        box-shadow: 0 0 0 0.2rem rgba(38, 143, 255, 0.5);\n        border-color: #007bff;\n    }\n\n    .p-listbox.p-invalid {\n        border-color: #dc3545;\n    }\n\n    .p-mention-panel {\n        background: #ffffff;\n        color: #212529;\n        border: 1px solid rgba(0, 0, 0, 0.15);\n        border-radius: 4px;\n        box-shadow: none;\n    }\n\n    .p-mention-panel .p-mention-items {\n        padding: 0.5rem 0;\n    }\n\n    .p-mention-panel .p-mention-items .p-mention-item {\n        margin: 0;\n        padding: 0.5rem 1.5rem;\n        border: 0 none;\n        color: #212529;\n        background: transparent;\n        transition: box-shadow 0.15s;\n        border-radius: 0;\n    }\n\n    .p-mention-panel .p-mention-items .p-mention-item:hover {\n        color: #212529;\n        background: #e9ecef;\n    }\n\n    .p-mention-panel .p-mention-items .p-mention-item.p-highlight {\n        color: #ffffff;\n        background: #007bff;\n    }\n\n    .p-multiselect {\n        display: inline-flex;\n        cursor: pointer;\n        user-select: none;\n    }\n\n    .p-multiselect-trigger {\n        display: flex;\n        align-items: center;\n        justify-content: center;\n        flex-shrink: 0;\n    }\n\n    .p-multiselect-label-container {\n        overflow: hidden;\n        flex: 1 1 auto;\n        cursor: pointer;\n    }\n\n    .p-multiselect-label {\n        display: block;\n        white-space: nowrap;\n        cursor: pointer;\n        overflow: hidden;\n        text-overflow: ellipsis;\n    }\n\n    .p-multiselect-label-empty {\n        overflow: hidden;\n        visibility: hidden;\n    }\n\n    .p-multiselect-token {\n        cursor: default;\n        display: inline-flex;\n        align-items: center;\n        flex: 0 0 auto;\n    }\n\n    .p-multiselect-token-icon {\n        cursor: pointer;\n    }\n\n    .p-multiselect .p-multiselect-panel {\n        min-width: 100%;\n    }\n\n    .p-multiselect-items-wrapper {\n        overflow: auto;\n    }\n\n    .p-multiselect-items {\n        margin: 0;\n        padding: 0;\n        list-style-type: none;\n    }\n\n    .p-multiselect-item {\n        cursor: pointer;\n        display: flex;\n        align-items: center;\n        font-weight: normal;\n        white-space: nowrap;\n        position: relative;\n        overflow: hidden;\n    }\n\n    .p-multiselect-item-group {\n        cursor: auto;\n    }\n\n    .p-multiselect-header {\n        display: flex;\n        align-items: center;\n        justify-content: space-between;\n    }\n\n    .p-multiselect-filter-container {\n        position: relative;\n        flex: 1 1 auto;\n    }\n\n    .p-multiselect-filter-icon {\n        position: absolute;\n        top: 50%;\n        margin-top: -0.5rem;\n    }\n\n    .p-multiselect-filter-container .p-inputtext {\n        width: 100%;\n    }\n\n    .p-multiselect-close {\n        display: flex;\n        align-items: center;\n        justify-content: center;\n        flex-shrink: 0;\n        overflow: hidden;\n        position: relative;\n        margin-left: auto;\n    }\n\n    .p-fluid .p-multiselect {\n        display: flex;\n    }\n\n    .p-multiselect {\n        background: #ffffff;\n        border: 1px solid #ced4da;\n        transition: background-color 0.15s, border-color 0.15s, box-shadow 0.15s;\n        border-radius: 4px;\n        outline-color: transparent;\n    }\n\n    .p-multiselect:not(.p-disabled):hover {\n        border-color: #ced4da;\n    }\n\n    .p-multiselect:not(.p-disabled).p-focus {\n        outline: 0 none;\n        outline-offset: 0;\n        box-shadow: 0 0 0 0.2rem #e4717c;\n        border-color: #e4717c;\n    }\n\n    .p-multiselect.p-variant-filled {\n        background: #efefef;\n    }\n\n    .p-multiselect.p-variant-filled:not(.p-disabled):hover {\n        background-color: #efefef;\n    }\n\n    .p-multiselect.p-variant-filled:not(.p-disabled).p-focus {\n        background-color: #efefef;\n    }\n\n    .p-multiselect .p-multiselect-label {\n        padding: 0.5rem 0.75rem;\n        transition: background-color 0.15s, border-color 0.15s, box-shadow 0.15s;\n    }\n\n    .p-multiselect .p-multiselect-label.p-placeholder {\n        color: #6c757d;\n    }\n\n    .p-multiselect.p-multiselect-chip .p-multiselect-token {\n        padding: 0.25rem 0.75rem;\n        margin-right: 0.5rem;\n        background: #dee2e6;\n        color: #212529;\n        border-radius: 16px;\n    }\n\n    .p-multiselect.p-multiselect-chip .p-multiselect-token .p-multiselect-token-icon {\n        margin-left: 0.5rem;\n    }\n\n    .p-multiselect .p-multiselect-trigger {\n        background: transparent;\n        color: #cf0000;\n        width: 2.357rem;\n        border-top-right-radius: 4px;\n        border-bottom-right-radius: 4px;\n    }\n\n    .p-multiselect.p-invalid.p-component {\n        border-color: #dc3545;\n    }\n\n    .p-inputwrapper-filled.p-multiselect.p-multiselect-chip .p-multiselect-label {\n        padding: 0.25rem 0.75rem;\n    }\n\n    .p-multiselect-panel {\n        background: #ffffff;\n        color: #212529;\n        border: 1px solid rgba(0, 0, 0, 0.15);\n        border-radius: 4px;\n        box-shadow: none;\n    }\n\n    .p-multiselect-panel .p-multiselect-header {\n        padding: 0.75rem 1.5rem;\n        border-bottom: 1px solid #dee2e6;\n        color: #212529;\n        background: #efefef;\n        margin: 0;\n        border-top-right-radius: 4px;\n        border-top-left-radius: 4px;\n    }\n\n    .p-multiselect-panel .p-multiselect-header .p-multiselect-filter-container .p-inputtext {\n        padding-right: 1.75rem;\n    }\n\n    .p-multiselect-panel .p-multiselect-header .p-multiselect-filter-container .p-multiselect-filter-icon {\n        right: 0.75rem;\n        color: #495057;\n    }\n\n    .p-multiselect-panel .p-multiselect-header .p-checkbox {\n        margin-right: 0.5rem;\n    }\n\n    .p-multiselect-panel .p-multiselect-header .p-multiselect-close {\n        margin-left: 0.5rem;\n        width: 2rem;\n        height: 2rem;\n        color: #6c757d;\n        border: 0 none;\n        background: transparent;\n        border-radius: 50%;\n        transition: box-shadow 0.15s;\n    }\n\n    .p-multiselect-panel .p-multiselect-header .p-multiselect-close:enabled:hover {\n        color: #495057;\n        border-color: transparent;\n        background: transparent;\n    }\n\n    .p-multiselect-panel .p-multiselect-header .p-multiselect-close:focus-visible {\n        outline: 0 none;\n        outline-offset: 0;\n        box-shadow: 0 0 0 0.2rem rgba(38, 143, 255, 0.5);\n    }\n\n    .p-multiselect-panel .p-multiselect-items {\n        padding: 0.5rem 0;\n    }\n\n    .p-multiselect-panel .p-multiselect-items .p-multiselect-item {\n        margin: 0;\n        padding: 0.5rem 1.5rem;\n        border: 0 none;\n        color: #212529;\n        background: transparent;\n        transition: box-shadow 0.15s;\n        border-radius: 0;\n    }\n\n    .p-multiselect-panel .p-multiselect-items .p-multiselect-item:first-child {\n        margin-top: 0;\n    }\n\n    .p-multiselect-panel .p-multiselect-items .p-multiselect-item:last-child {\n        margin-bottom: 0;\n    }\n\n    .p-multiselect-panel .p-multiselect-items .p-multiselect-item.p-highlight {\n        color: #ffffff;\n        background: #cf0000;\n    }\n\n    .p-multiselect-panel .p-multiselect-items .p-multiselect-item.p-highlight.p-focus {\n        background: #cf0000;\n    }\n\n    .p-multiselect-panel .p-multiselect-items .p-multiselect-item:not(.p-highlight):not(.p-disabled).p-focus {\n        color: #212529;\n        background: #e9ecef;\n    }\n\n    .p-multiselect-panel .p-multiselect-items .p-multiselect-item .p-checkbox {\n        margin-right: 0.5rem;\n    }\n\n    .p-multiselect-panel .p-multiselect-items .p-multiselect-item-group {\n        margin: 0;\n        padding: 0.75rem 1rem;\n        color: #212529;\n        background: #ffffff;\n        font-weight: 600;\n    }\n\n    .p-multiselect-panel .p-multiselect-items .p-multiselect-empty-message {\n        padding: 0.5rem 1.5rem;\n        color: #212529;\n        background: transparent;\n    }\n\n    .p-password.p-invalid.p-component>.p-inputtext {\n        border-color: #dc3545;\n    }\n\n    .p-password-panel {\n        padding: 1.25rem;\n        background: #ffffff;\n        color: #212529;\n        border: 1px solid rgba(0, 0, 0, 0.2);\n        box-shadow: none;\n        border-radius: 4px;\n    }\n\n    .p-password-panel .p-password-meter {\n        margin-bottom: 0.5rem;\n        background: #e9ecef;\n    }\n\n    .p-password-panel .p-password-meter .p-password-strength.weak {\n        background: #dc3545;\n    }\n\n    .p-password-panel .p-password-meter .p-password-strength.medium {\n        background: #ffc107;\n    }\n\n    .p-password-panel .p-password-meter .p-password-strength.strong {\n        background: #28a745;\n    }\n\n    .p-radiobutton {\n        width: 20px;\n        height: 20px;\n    }\n\n    .p-radiobutton .p-radiobutton-box {\n        border: 2px solid #ced4da;\n        background: #ffffff;\n        width: 20px;\n        height: 20px;\n        color: #212529;\n        border-radius: 50%;\n        transition: background-color 0.15s, border-color 0.15s, box-shadow 0.15s;\n    }\n\n    .p-radiobutton .p-radiobutton-box:not(.p-disabled):not(.p-highlight):hover {\n        border-color: #ced4da;\n    }\n\n    .p-radiobutton .p-radiobutton-box:not(.p-disabled).p-focus {\n        outline: 0 none;\n        outline-offset: 0;\n        box-shadow: 0 0 0 0.2rem rgba(228, 113, 124, 0.5);\n        border-color: #e4717c;\n    }\n\n    .p-radiobutton .p-radiobutton-box .p-radiobutton-icon {\n        width: 12px;\n        height: 12px;\n        transition-duration: 0.15s;\n        background-color: #e83636;\n    }\n\n    .p-radiobutton .p-radiobutton-box.p-highlight {\n        border-color: #e4717c;\n        background: #a60622;\n    }\n\n    .p-radiobutton .p-radiobutton-box.p-highlight:not(.p-disabled):hover {\n        border-color: #a60622;\n        background: #a60622;\n        /* border-color: #0062cc;\n        background: #0062cc; */\n        color: #ffffff;\n    }\n\n    .p-radiobutton.p-invalid>.p-radiobutton-box {\n        border-color: #dc3545;\n    }\n\n    .p-radiobutton:focus {\n        outline: 0 none;\n    }\n\n    .p-input-filled .p-radiobutton .p-radiobutton-box {\n        background-color: #efefef;\n    }\n\n    .p-input-filled .p-radiobutton .p-radiobutton-box:not(.p-disabled):hover {\n        background-color: #efefef;\n    }\n\n    .p-input-filled .p-radiobutton .p-radiobutton-box.p-highlight {\n        background: #007bff;\n    }\n\n    .p-input-filled .p-radiobutton .p-radiobutton-box.p-highlight:not(.p-disabled):hover {\n        background: #0062cc;\n    }\n\n    .p-highlight .p-radiobutton .p-radiobutton-box {\n        border-color: #ffffff;\n    }\n\n    .p-rating {\n        gap: 0.5rem;\n    }\n\n    .p-rating .p-rating-item .p-rating-icon {\n        color: #495057;\n        transition: background-color 0.15s, border-color 0.15s, box-shadow 0.15s;\n        font-size: 1.143rem;\n    }\n\n    .p-rating .p-rating-item .p-rating-icon.p-icon {\n        width: 1.143rem;\n        height: 1.143rem;\n    }\n\n    .p-rating .p-rating-item .p-rating-icon.p-rating-cancel {\n        color: #dc3545;\n    }\n\n    .p-rating .p-rating-item:focus {\n        outline: 0 none;\n        outline-offset: 0;\n        box-shadow: 0 0 0 0.2rem rgba(38, 143, 255, 0.5);\n    }\n\n    .p-rating .p-rating-item.p-rating-item-active .p-rating-icon {\n        color: #007bff;\n    }\n\n    .p-rating:not(.p-disabled):not(.p-readonly) .p-rating-item:hover .p-rating-icon {\n        color: #007bff;\n    }\n\n    .p-rating:not(.p-disabled):not(.p-readonly) .p-rating-item:hover .p-rating-icon.p-rating-cancel {\n        color: #dc3545;\n    }\n\n    .p-highlight .p-rating .p-rating-item.p-rating-item-active .p-rating-icon {\n        color: #ffffff;\n    }\n\n    .p-selectbutton .p-button {\n        background: #ffffff;\n        border: 1px solid #cf0000;\n        color: #cf0000;\n        transition: background-color 0.15s, border-color 0.15s, box-shadow 0.15s;\n    }\n\n    .p-selectbutton .p-button .p-button-icon-left,\n    .p-selectbutton .p-button .p-button-icon-right {\n        color: #ffffff;\n    }\n\n    .p-selectbutton .p-button:not(.p-disabled):not(.p-highlight):hover {\n        background: #e4717c;\n        border-color: #e4717c;\n        color: #ffffff;\n    }\n\n    .p-selectbutton .p-button:not(.p-disabled):not(.p-highlight):hover .p-button-icon-left,\n    .p-selectbutton .p-button:not(.p-disabled):not(.p-highlight):hover .p-button-icon-right {\n        color: #ffffff;\n    }\n\n    .p-selectbutton .p-button.p-highlight {\n        background: #cf0000;\n        border-color: #cf0000;\n        color: #ffffff;\n    }\n\n    .p-selectbutton .p-button.p-highlight .p-button-icon-left,\n    .p-selectbutton .p-button.p-highlight .p-button-icon-right {\n        color: #ffffff;\n    }\n\n    .p-selectbutton .p-button.p-highlight:hover {\n        background: #a60622;\n        border-color: #a60622;\n        color: #ffffff;\n    }\n\n    .p-selectbutton .p-button.p-highlight:hover .p-button-icon-left,\n    .p-selectbutton .p-button.p-highlight:hover .p-button-icon-right {\n        color: #ffffff;\n    }\n\n    .p-selectbutton.p-invalid>.p-button {\n        border-color: #dc3545;\n    }\n\n    .p-slider {\n        background: #e9ecef;\n        border: 0 none;\n        border-radius: 4px;\n    }\n\n    .p-slider.p-slider-horizontal {\n        height: 0.286rem;\n    }\n\n    .p-slider.p-slider-horizontal .p-slider-handle {\n        margin-top: -0.5715rem;\n        margin-left: -0.5715rem;\n    }\n\n    .p-slider.p-slider-vertical {\n        width: 0.286rem;\n    }\n\n    .p-slider.p-slider-vertical .p-slider-handle {\n        margin-left: -0.5715rem;\n        margin-bottom: -0.5715rem;\n    }\n\n    .p-slider .p-slider-handle {\n        height: 1.143rem;\n        width: 1.143rem;\n        background: #007bff;\n        border: 2px solid #007bff;\n        border-radius: 4px;\n        transition: background-color 0.15s, border-color 0.15s, box-shadow 0.15s;\n    }\n\n    .p-slider .p-slider-handle:focus {\n        outline: 0 none;\n        outline-offset: 0;\n        box-shadow: 0 0 0 0.2rem rgba(38, 143, 255, 0.5);\n    }\n\n    .p-slider .p-slider-range {\n        background: #007bff;\n    }\n\n    .p-slider:not(.p-disabled) .p-slider-handle:hover {\n        background: #0069d9;\n        border-color: #0069d9;\n    }\n\n    .p-treeselect {\n        background: #ffffff;\n        border: 1px solid #ced4da;\n        transition: background-color 0.15s, border-color 0.15s, box-shadow 0.15s;\n        border-radius: 4px;\n    }\n\n    .p-treeselect:not(.p-disabled):hover {\n        border-color: #ced4da;\n    }\n\n    .p-treeselect:not(.p-disabled).p-focus {\n        outline: 0 none;\n        outline-offset: 0;\n        box-shadow: 0 0 0 0.2rem rgba(38, 143, 255, 0.5);\n        border-color: #007bff;\n    }\n\n    .p-treeselect.p-treeselect-clearable .p-treeselect-label {\n        padding-right: 1.75rem;\n    }\n\n    .p-treeselect .p-treeselect-label {\n        padding: 0.5rem 0.75rem;\n        transition: background-color 0.15s, border-color 0.15s, box-shadow 0.15s;\n    }\n\n    .p-treeselect .p-treeselect-label.p-placeholder {\n        color: #6c757d;\n    }\n\n    .p-treeselect.p-treeselect-chip .p-treeselect-token {\n        padding: 0.25rem 0.75rem;\n        margin-right: 0.5rem;\n        background: #dee2e6;\n        color: #212529;\n        border-radius: 16px;\n    }\n\n    .p-treeselect .p-treeselect-trigger {\n        background: transparent;\n        color: #495057;\n        width: 2.357rem;\n        border-top-right-radius: 4px;\n        border-bottom-right-radius: 4px;\n    }\n\n    .p-treeselect .p-treeselect-clear-icon {\n        color: #495057;\n        right: 2.357rem;\n    }\n\n    .p-treeselect.p-invalid.p-component {\n        border-color: #dc3545;\n    }\n\n    .p-inputwrapper-filled.p-treeselect.p-treeselect-chip .p-treeselect-label {\n        padding: 0.25rem 0.75rem;\n    }\n\n    .p-treeselect-panel {\n        background: #ffffff;\n        color: #212529;\n        border: 1px solid rgba(0, 0, 0, 0.15);\n        border-radius: 4px;\n        box-shadow: none;\n    }\n\n    .p-treeselect-panel .p-treeselect-header {\n        padding: 0.75rem 1.5rem;\n        border-bottom: 1px solid #dee2e6;\n        color: #212529;\n        background: #efefef;\n        margin: 0;\n        border-top-right-radius: 4px;\n        border-top-left-radius: 4px;\n    }\n\n    .p-treeselect-panel .p-treeselect-header .p-treeselect-filter-container {\n        margin-right: 0.5rem;\n    }\n\n    .p-treeselect-panel .p-treeselect-header .p-treeselect-filter-container .p-treeselect-filter {\n        padding-right: 1.75rem;\n    }\n\n    .p-treeselect-panel .p-treeselect-header .p-treeselect-filter-container .p-treeselect-filter-icon {\n        right: 0.75rem;\n        color: #495057;\n    }\n\n    .p-treeselect-panel .p-treeselect-header .p-treeselect-filter-container.p-treeselect-clearable-filter .p-treeselect-filter {\n        padding-right: 3.5rem;\n    }\n\n    .p-treeselect-panel .p-treeselect-header .p-treeselect-filter-container.p-treeselect-clearable-filter .p-treeselect-filter-clear-icon {\n        right: 2.5rem;\n    }\n\n    .p-treeselect-panel .p-treeselect-header .p-treeselect-close {\n        width: 2rem;\n        height: 2rem;\n        color: #6c757d;\n        border: 0 none;\n        background: transparent;\n        border-radius: 50%;\n        transition: box-shadow 0.15s;\n    }\n\n    .p-treeselect-panel .p-treeselect-header .p-treeselect-close:enabled:hover {\n        color: #495057;\n        border-color: transparent;\n        background: transparent;\n    }\n\n    .p-treeselect-panel .p-treeselect-header .p-treeselect-close:focus-visible {\n        outline: 0 none;\n        outline-offset: 0;\n        box-shadow: 0 0 0 0.2rem rgba(38, 143, 255, 0.5);\n    }\n\n    .p-treeselect-panel .p-treeselect-items-wrapper .p-tree {\n        border: 0 none;\n    }\n\n    .p-treeselect-panel .p-treeselect-items-wrapper .p-treeselect-empty-message {\n        padding: 0.5rem 1.5rem;\n        color: #212529;\n        background: transparent;\n    }\n\n    .p-input-filled .p-treeselect {\n        background: #efefef;\n    }\n\n    .p-input-filled .p-treeselect:not(.p-disabled):hover {\n        background-color: #efefef;\n    }\n\n    .p-input-filled .p-treeselect:not(.p-disabled).p-focus {\n        background-color: #efefef;\n    }\n\n    .p-togglebutton.p-button {\n        background: #6c757d;\n        border: 1px solid #6c757d;\n        color: #ffffff;\n        transition: background-color 0.15s, border-color 0.15s, box-shadow 0.15s;\n    }\n\n    .p-togglebutton.p-button .p-button-icon-left,\n    .p-togglebutton.p-button .p-button-icon-right {\n        color: #ffffff;\n    }\n\n    .p-togglebutton.p-button:not(.p-disabled):not(.p-highlight):hover {\n        background: #5a6268;\n        border-color: #545b62;\n        color: #ffffff;\n    }\n\n    .p-togglebutton.p-button:not(.p-disabled):not(.p-highlight):hover .p-button-icon-left,\n    .p-togglebutton.p-button:not(.p-disabled):not(.p-highlight):hover .p-button-icon-right {\n        color: #ffffff;\n    }\n\n    .p-togglebutton.p-button.p-highlight {\n        background: #545b62;\n        border-color: #4e555b;\n        color: #ffffff;\n    }\n\n    .p-togglebutton.p-button.p-highlight .p-button-icon-left,\n    .p-togglebutton.p-button.p-highlight .p-button-icon-right {\n        color: #ffffff;\n    }\n\n    .p-togglebutton.p-button.p-highlight:hover {\n        background: #545b62;\n        border-color: #4e555b;\n        color: #ffffff;\n    }\n\n    .p-togglebutton.p-button.p-highlight:hover .p-button-icon-left,\n    .p-togglebutton.p-button.p-highlight:hover .p-button-icon-right {\n        color: #ffffff;\n    }\n\n    .p-togglebutton.p-button.p-invalid>.p-button {\n        border-color: #dc3545;\n    }\n\n    .p-button {\n        color: #ffffff;\n        background: #cf0000;\n        border: 1px solid #cf0000;\n        padding: 0.5rem 0.75rem;\n        font-size: 12px;\n        transition: background-color 0.15s, border-color 0.15s, box-shadow 0.15s;\n        border-radius: 4px;\n        box-shadow: 0px 1px 8px -1px #dc3545;\n    }\n\n    .p-button:not(:disabled):hover {\n        background: #a60622;\n        color: #ffffff;\n        border-color: #959aa0;\n    }\n\n    .p-button:not(:disabled):active {\n        background: #a60622;\n        color: #ffffff;\n        border-color: #959aa0;\n    }\n\n    .p-button.p-button-outlined {\n        background-color: transparent;\n        color: #cf0000;\n        border: 1px solid;\n    }\n\n    .p-button.p-button-outlined:not(:disabled):hover {\n        background: rgba(0, 123, 255, 0.04);\n        color: #a60622;\n        ;\n        border: 1px solid;\n    }\n\n    .p-button.p-button-outlined:not(:disabled):active {\n        background: rgba(0, 123, 255, 0.16);\n        color: #a60622;\n        border: 1px solid;\n    }\n\n    .p-button.p-button-outlined.p-button-plain {\n        color: #6c757d;\n        border-color: #6c757d;\n    }\n\n    .p-button.p-button-outlined.p-button-plain:not(:disabled):hover {\n        background: #e9ecef;\n        color: #6c757d;\n    }\n\n    .p-button.p-button-outlined.p-button-plain:not(:disabled):active {\n        background: #dee2e6;\n        color: #6c757d;\n    }\n\n    .p-button.p-button-text {\n        background-color: transparent;\n        color: #007bff;\n        border-color: transparent;\n    }\n\n    .p-button.p-button-text:not(:disabled):hover {\n        background: rgba(0, 123, 255, 0.04);\n        color: #007bff;\n        border-color: transparent;\n    }\n\n    .p-button.p-button-text:not(:disabled):active {\n        background: rgba(0, 123, 255, 0.16);\n        color: #007bff;\n        border-color: transparent;\n    }\n\n    .p-button.p-button-text.p-button-plain {\n        color: #6c757d;\n    }\n\n    .p-button.p-button-text.p-button-plain:not(:disabled):hover {\n        background: #e9ecef;\n        color: #6c757d;\n    }\n\n    .p-button.p-button-text.p-button-plain:not(:disabled):active {\n        background: #dee2e6;\n        color: #6c757d;\n    }\n\n    .p-button:focus {\n        outline: 0 none;\n        outline-offset: 0;\n        box-shadow: 0 0 0 0.2rem #e4717c;\n    }\n\n    .p-button .p-button-label {\n        transition-duration: 0.15s;\n    }\n\n    .p-button .p-button-icon-left {\n        margin-right: 0.5rem;\n    }\n\n    .p-button .p-button-icon-right {\n        margin-left: 0.5rem;\n    }\n\n    .p-button .p-button-icon-bottom {\n        margin-top: 0.5rem;\n    }\n\n    .p-button .p-button-icon-top {\n        margin-bottom: 0.5rem;\n    }\n\n    .p-button .p-badge {\n        margin-left: 0.5rem;\n        min-width: 1rem;\n        height: 1rem;\n        line-height: 1rem;\n        color: #007bff;\n        background-color: #ffffff;\n    }\n\n    .p-button.p-button-raised {\n        box-shadow: 0 3px 1px -2px rgba(0, 0, 0, 0.2), 0 2px 2px 0 rgba(0, 0, 0, 0.14), 0 1px 5px 0 rgba(0, 0, 0, 0.12);\n    }\n\n    .p-button.p-button-rounded {\n        border-radius: 2rem;\n    }\n\n    .p-button.p-button-icon-only {\n        width: 2.357rem;\n        padding: 0.5rem 0;\n    }\n\n    .p-button.p-button-icon-only .p-button-icon-left,\n    .p-button.p-button-icon-only .p-button-icon-right {\n        margin: 0;\n    }\n\n    .p-button.p-button-icon-only.p-button-rounded {\n        border-radius: 50%;\n        height: 2.357rem;\n    }\n\n    .p-button.p-button-sm {\n        font-size: 12px;\n        padding: 0.4375rem 0.65625rem;\n    }\n\n    .p-button.p-button-sm .p-button-icon {\n        font-size: 0.875rem;\n    }\n\n    .p-button.p-button-lg {\n        font-size: 12px;\n        padding: 0.625rem 0.9375rem;\n    }\n\n    .p-button.p-button-lg .p-button-icon {\n        font-size: 1.25rem;\n    }\n\n    .p-button.p-button-loading-label-only.p-button-loading-left .p-button-label {\n        margin-left: 0.5rem;\n    }\n\n    .p-button.p-button-loading-label-only.p-button-loading-right .p-button-label {\n        margin-right: 0.5rem;\n    }\n\n    .p-button.p-button-loading-label-only.p-button-loading-top .p-button-label {\n        margin-top: 0.5rem;\n    }\n\n    .p-button.p-button-loading-label-only.p-button-loading-bottom .p-button-label {\n        margin-bottom: 0.5rem;\n    }\n\n    .p-button.p-button-loading-label-only .p-button-loading-icon {\n        margin: 0;\n    }\n\n    .p-fluid .p-button {\n        width: 100%;\n    }\n\n    .p-fluid .p-button-icon-only {\n        width: 2.357rem;\n    }\n\n    .p-fluid .p-buttonset {\n        display: flex;\n    }\n\n    .p-fluid .p-buttonset .p-button {\n        flex: 1;\n    }\n\n    .p-button.p-button-secondary,\n    .p-buttonset.p-button-secondary>.p-button,\n    .p-splitbutton.p-button-secondary>.p-button,\n    .p-fileupload-choose.p-button-secondary {\n        color: #000000;\n        background: #bcbcbc;\n        border: 1px solid #bcbcbc;\n    }\n\n    .p-button.p-button-secondary:not(:disabled):hover,\n    .p-buttonset.p-button-secondary>.p-button:not(:disabled):hover,\n    .p-splitbutton.p-button-secondary>.p-button:not(:disabled):hover,\n    .p-fileupload-choose.p-button-secondary:not(:disabled):hover {\n        background: #5a6268;\n        color: #ffffff;\n        border-color: #5a6268;\n    }\n\n    .p-button.p-button-secondary:not(:disabled):focus,\n    .p-buttonset.p-button-secondary>.p-button:not(:disabled):focus,\n    .p-splitbutton.p-button-secondary>.p-button:not(:disabled):focus,\n    .p-fileupload-choose.p-button-secondary:not(:disabled):focus {\n        box-shadow: 0 0 0 0.2rem rgba(130, 138, 145, 0.5);\n    }\n\n    .p-button.p-button-secondary:not(:disabled):active,\n    .p-buttonset.p-button-secondary>.p-button:not(:disabled):active,\n    .p-splitbutton.p-button-secondary>.p-button:not(:disabled):active,\n    .p-fileupload-choose.p-button-secondary:not(:disabled):active {\n        background: #545b62;\n        color: #ffffff;\n        border-color: #4e555b;\n    }\n\n    .p-button.p-button-secondary.p-button-outlined,\n    .p-buttonset.p-button-secondary>.p-button.p-button-outlined,\n    .p-splitbutton.p-button-secondary>.p-button.p-button-outlined,\n    .p-fileupload-choose.p-button-secondary.p-button-outlined {\n        background-color: transparent;\n        color: #6c757d;\n        border: 1px solid;\n    }\n\n    .p-button.p-button-secondary.p-button-outlined:not(:disabled):hover,\n    .p-buttonset.p-button-secondary>.p-button.p-button-outlined:not(:disabled):hover,\n    .p-splitbutton.p-button-secondary>.p-button.p-button-outlined:not(:disabled):hover,\n    .p-fileupload-choose.p-button-secondary.p-button-outlined:not(:disabled):hover {\n        background: rgba(108, 117, 125, 0.04);\n        color: #6c757d;\n        border: 1px solid;\n    }\n\n    .p-button.p-button-secondary.p-button-outlined:not(:disabled):active,\n    .p-buttonset.p-button-secondary>.p-button.p-button-outlined:not(:disabled):active,\n    .p-splitbutton.p-button-secondary>.p-button.p-button-outlined:not(:disabled):active,\n    .p-fileupload-choose.p-button-secondary.p-button-outlined:not(:disabled):active {\n        background: rgba(108, 117, 125, 0.16);\n        color: #6c757d;\n        border: 1px solid;\n    }\n\n    .p-button.p-button-secondary.p-button-text,\n    .p-buttonset.p-button-secondary>.p-button.p-button-text,\n    .p-splitbutton.p-button-secondary>.p-button.p-button-text,\n    .p-fileupload-choose.p-button-secondary.p-button-text {\n        background-color: transparent;\n        color: #6c757d;\n        border-color: transparent;\n    }\n\n    .p-button.p-button-secondary.p-button-text:not(:disabled):hover,\n    .p-buttonset.p-button-secondary>.p-button.p-button-text:not(:disabled):hover,\n    .p-splitbutton.p-button-secondary>.p-button.p-button-text:not(:disabled):hover,\n    .p-fileupload-choose.p-button-secondary.p-button-text:not(:disabled):hover {\n        background: rgba(108, 117, 125, 0.04);\n        border-color: transparent;\n        color: #6c757d;\n    }\n\n    .p-button.p-button-secondary.p-button-text:not(:disabled):active,\n    .p-buttonset.p-button-secondary>.p-button.p-button-text:not(:disabled):active,\n    .p-splitbutton.p-button-secondary>.p-button.p-button-text:not(:disabled):active,\n    .p-fileupload-choose.p-button-secondary.p-button-text:not(:disabled):active {\n        background: rgba(108, 117, 125, 0.16);\n        border-color: transparent;\n        color: #6c757d;\n    }\n\n    .p-button.p-button-info,\n    .p-buttonset.p-button-info>.p-button,\n    .p-splitbutton.p-button-info>.p-button,\n    .p-fileupload-choose.p-button-info {\n        color: #ffffff;\n        background: #17a2b8;\n        border: 1px solid #17a2b8;\n    }\n\n    .p-button.p-button-info:not(:disabled):hover,\n    .p-buttonset.p-button-info>.p-button:not(:disabled):hover,\n    .p-splitbutton.p-button-info>.p-button:not(:disabled):hover,\n    .p-fileupload-choose.p-button-info:not(:disabled):hover {\n        background: #138496;\n        color: #ffffff;\n        border-color: #117a8b;\n    }\n\n    .p-button.p-button-info:not(:disabled):focus,\n    .p-buttonset.p-button-info>.p-button:not(:disabled):focus,\n    .p-splitbutton.p-button-info>.p-button:not(:disabled):focus,\n    .p-fileupload-choose.p-button-info:not(:disabled):focus {\n        box-shadow: 0 0 0 0.2rem rgba(58, 176, 195, 0.5);\n    }\n\n    .p-button.p-button-info:not(:disabled):active,\n    .p-buttonset.p-button-info>.p-button:not(:disabled):active,\n    .p-splitbutton.p-button-info>.p-button:not(:disabled):active,\n    .p-fileupload-choose.p-button-info:not(:disabled):active {\n        background: #138496;\n        color: #ffffff;\n        border-color: #117a8b;\n    }\n\n    .p-button.p-button-info.p-button-outlined,\n    .p-buttonset.p-button-info>.p-button.p-button-outlined,\n    .p-splitbutton.p-button-info>.p-button.p-button-outlined,\n    .p-fileupload-choose.p-button-info.p-button-outlined {\n        background-color: transparent;\n        color: #17a2b8;\n        border: 1px solid;\n    }\n\n    .p-button.p-button-info.p-button-outlined:not(:disabled):hover,\n    .p-buttonset.p-button-info>.p-button.p-button-outlined:not(:disabled):hover,\n    .p-splitbutton.p-button-info>.p-button.p-button-outlined:not(:disabled):hover,\n    .p-fileupload-choose.p-button-info.p-button-outlined:not(:disabled):hover {\n        background: rgba(23, 162, 184, 0.04);\n        color: #17a2b8;\n        border: 1px solid;\n    }\n\n    .p-button.p-button-info.p-button-outlined:not(:disabled):active,\n    .p-buttonset.p-button-info>.p-button.p-button-outlined:not(:disabled):active,\n    .p-splitbutton.p-button-info>.p-button.p-button-outlined:not(:disabled):active,\n    .p-fileupload-choose.p-button-info.p-button-outlined:not(:disabled):active {\n        background: rgba(23, 162, 184, 0.16);\n        color: #17a2b8;\n        border: 1px solid;\n    }\n\n    .p-button.p-button-info.p-button-text,\n    .p-buttonset.p-button-info>.p-button.p-button-text,\n    .p-splitbutton.p-button-info>.p-button.p-button-text,\n    .p-fileupload-choose.p-button-info.p-button-text {\n        background-color: transparent;\n        color: #17a2b8;\n        border-color: transparent;\n    }\n\n    .p-button.p-button-info.p-button-text:not(:disabled):hover,\n    .p-buttonset.p-button-info>.p-button.p-button-text:not(:disabled):hover,\n    .p-splitbutton.p-button-info>.p-button.p-button-text:not(:disabled):hover,\n    .p-fileupload-choose.p-button-info.p-button-text:not(:disabled):hover {\n        background: rgba(23, 162, 184, 0.04);\n        border-color: transparent;\n        color: #17a2b8;\n    }\n\n    .p-button.p-button-info.p-button-text:not(:disabled):active,\n    .p-buttonset.p-button-info>.p-button.p-button-text:not(:disabled):active,\n    .p-splitbutton.p-button-info>.p-button.p-button-text:not(:disabled):active,\n    .p-fileupload-choose.p-button-info.p-button-text:not(:disabled):active {\n        background: rgba(23, 162, 184, 0.16);\n        border-color: transparent;\n        color: #17a2b8;\n    }\n\n    .p-button.p-button-success,\n    .p-buttonset.p-button-success>.p-button,\n    .p-splitbutton.p-button-success>.p-button,\n    .p-fileupload-choose.p-button-success {\n        color: #ffffff;\n        background: #28a745;\n        border: 1px solid #28a745;\n    }\n\n    .p-button.p-button-success:not(:disabled):hover,\n    .p-buttonset.p-button-success>.p-button:not(:disabled):hover,\n    .p-splitbutton.p-button-success>.p-button:not(:disabled):hover,\n    .p-fileupload-choose.p-button-success:not(:disabled):hover {\n        background: #218838;\n        color: #ffffff;\n        border-color: #1e7e34;\n    }\n\n    .p-button.p-button-success:not(:disabled):focus,\n    .p-buttonset.p-button-success>.p-button:not(:disabled):focus,\n    .p-splitbutton.p-button-success>.p-button:not(:disabled):focus,\n    .p-fileupload-choose.p-button-success:not(:disabled):focus {\n        box-shadow: 0 0 0 0.2rem rgba(72, 180, 97, 0.5);\n    }\n\n    .p-button.p-button-success:not(:disabled):active,\n    .p-buttonset.p-button-success>.p-button:not(:disabled):active,\n    .p-splitbutton.p-button-success>.p-button:not(:disabled):active,\n    .p-fileupload-choose.p-button-success:not(:disabled):active {\n        background: #1e7e34;\n        color: #ffffff;\n        border-color: #1c7430;\n    }\n\n    .p-button.p-button-success.p-button-outlined,\n    .p-buttonset.p-button-success>.p-button.p-button-outlined,\n    .p-splitbutton.p-button-success>.p-button.p-button-outlined,\n    .p-fileupload-choose.p-button-success.p-button-outlined {\n        background-color: transparent;\n        color: #28a745;\n        border: 1px solid;\n    }\n\n    .p-button.p-button-success.p-button-outlined:not(:disabled):hover,\n    .p-buttonset.p-button-success>.p-button.p-button-outlined:not(:disabled):hover,\n    .p-splitbutton.p-button-success>.p-button.p-button-outlined:not(:disabled):hover,\n    .p-fileupload-choose.p-button-success.p-button-outlined:not(:disabled):hover {\n        background: rgba(40, 167, 69, 0.04);\n        color: #28a745;\n        border: 1px solid;\n    }\n\n    .p-button.p-button-success.p-button-outlined:not(:disabled):active,\n    .p-buttonset.p-button-success>.p-button.p-button-outlined:not(:disabled):active,\n    .p-splitbutton.p-button-success>.p-button.p-button-outlined:not(:disabled):active,\n    .p-fileupload-choose.p-button-success.p-button-outlined:not(:disabled):active {\n        background: rgba(40, 167, 69, 0.16);\n        color: #28a745;\n        border: 1px solid;\n    }\n\n    .p-button.p-button-success.p-button-text,\n    .p-buttonset.p-button-success>.p-button.p-button-text,\n    .p-splitbutton.p-button-success>.p-button.p-button-text,\n    .p-fileupload-choose.p-button-success.p-button-text {\n        background-color: transparent;\n        color: #28a745;\n        border-color: transparent;\n    }\n\n    .p-button.p-button-success.p-button-text:not(:disabled):hover,\n    .p-buttonset.p-button-success>.p-button.p-button-text:not(:disabled):hover,\n    .p-splitbutton.p-button-success>.p-button.p-button-text:not(:disabled):hover,\n    .p-fileupload-choose.p-button-success.p-button-text:not(:disabled):hover {\n        background: rgba(40, 167, 69, 0.04);\n        border-color: transparent;\n        color: #28a745;\n    }\n\n    .p-button.p-button-success.p-button-text:not(:disabled):active,\n    .p-buttonset.p-button-success>.p-button.p-button-text:not(:disabled):active,\n    .p-splitbutton.p-button-success>.p-button.p-button-text:not(:disabled):active,\n    .p-fileupload-choose.p-button-success.p-button-text:not(:disabled):active {\n        background: rgba(40, 167, 69, 0.16);\n        border-color: transparent;\n        color: #28a745;\n    }\n\n    .p-button.p-button-warning,\n    .p-buttonset.p-button-warning>.p-button,\n    .p-splitbutton.p-button-warning>.p-button,\n    .p-fileupload-choose.p-button-warning {\n        color: #212529;\n        background: #ffc107;\n        border: 1px solid #ffc107;\n    }\n\n    .p-button.p-button-warning:not(:disabled):hover,\n    .p-buttonset.p-button-warning>.p-button:not(:disabled):hover,\n    .p-splitbutton.p-button-warning>.p-button:not(:disabled):hover,\n    .p-fileupload-choose.p-button-warning:not(:disabled):hover {\n        background: #e0a800;\n        color: #212529;\n        border-color: #d39e00;\n    }\n\n    .p-button.p-button-warning:not(:disabled):focus,\n    .p-buttonset.p-button-warning>.p-button:not(:disabled):focus,\n    .p-splitbutton.p-button-warning>.p-button:not(:disabled):focus,\n    .p-fileupload-choose.p-button-warning:not(:disabled):focus {\n        box-shadow: 0 0 0 0.2rem rgba(222, 170, 12, 0.5);\n    }\n\n    .p-button.p-button-warning:not(:disabled):active,\n    .p-buttonset.p-button-warning>.p-button:not(:disabled):active,\n    .p-splitbutton.p-button-warning>.p-button:not(:disabled):active,\n    .p-fileupload-choose.p-button-warning:not(:disabled):active {\n        background: #d39e00;\n        color: #212529;\n        border-color: #c69500;\n    }\n\n    .p-button.p-button-warning.p-button-outlined,\n    .p-buttonset.p-button-warning>.p-button.p-button-outlined,\n    .p-splitbutton.p-button-warning>.p-button.p-button-outlined,\n    .p-fileupload-choose.p-button-warning.p-button-outlined {\n        background-color: transparent;\n        color: #ffc107;\n        border: 1px solid;\n    }\n\n    .p-button.p-button-warning.p-button-outlined:not(:disabled):hover,\n    .p-buttonset.p-button-warning>.p-button.p-button-outlined:not(:disabled):hover,\n    .p-splitbutton.p-button-warning>.p-button.p-button-outlined:not(:disabled):hover,\n    .p-fileupload-choose.p-button-warning.p-button-outlined:not(:disabled):hover {\n        background: rgba(255, 193, 7, 0.04);\n        color: #ffc107;\n        border: 1px solid;\n    }\n\n    .p-button.p-button-warning.p-button-outlined:not(:disabled):active,\n    .p-buttonset.p-button-warning>.p-button.p-button-outlined:not(:disabled):active,\n    .p-splitbutton.p-button-warning>.p-button.p-button-outlined:not(:disabled):active,\n    .p-fileupload-choose.p-button-warning.p-button-outlined:not(:disabled):active {\n        background: rgba(255, 193, 7, 0.16);\n        color: #ffc107;\n        border: 1px solid;\n    }\n\n    .p-button.p-button-warning.p-button-text,\n    .p-buttonset.p-button-warning>.p-button.p-button-text,\n    .p-splitbutton.p-button-warning>.p-button.p-button-text,\n    .p-fileupload-choose.p-button-warning.p-button-text {\n        background-color: transparent;\n        color: #ffc107;\n        border-color: transparent;\n    }\n\n    .p-button.p-button-warning.p-button-text:not(:disabled):hover,\n    .p-buttonset.p-button-warning>.p-button.p-button-text:not(:disabled):hover,\n    .p-splitbutton.p-button-warning>.p-button.p-button-text:not(:disabled):hover,\n    .p-fileupload-choose.p-button-warning.p-button-text:not(:disabled):hover {\n        background: rgba(255, 193, 7, 0.04);\n        border-color: transparent;\n        color: #ffc107;\n    }\n\n    .p-button.p-button-warning.p-button-text:not(:disabled):active,\n    .p-buttonset.p-button-warning>.p-button.p-button-text:not(:disabled):active,\n    .p-splitbutton.p-button-warning>.p-button.p-button-text:not(:disabled):active,\n    .p-fileupload-choose.p-button-warning.p-button-text:not(:disabled):active {\n        background: rgba(255, 193, 7, 0.16);\n        border-color: transparent;\n        color: #ffc107;\n    }\n\n    .p-button.p-button-help,\n    .p-buttonset.p-button-help>.p-button,\n    .p-splitbutton.p-button-help>.p-button,\n    .p-fileupload-choose.p-button-help {\n        color: #ffffff;\n        background: #6f42c1;\n        border: 1px solid #6f42c1;\n    }\n\n    .p-button.p-button-help:not(:disabled):hover,\n    .p-buttonset.p-button-help>.p-button:not(:disabled):hover,\n    .p-splitbutton.p-button-help>.p-button:not(:disabled):hover,\n    .p-fileupload-choose.p-button-help:not(:disabled):hover {\n        background: #633bad;\n        color: #ffffff;\n        border-color: #58349a;\n    }\n\n    .p-button.p-button-help:not(:disabled):focus,\n    .p-buttonset.p-button-help>.p-button:not(:disabled):focus,\n    .p-splitbutton.p-button-help>.p-button:not(:disabled):focus,\n    .p-fileupload-choose.p-button-help:not(:disabled):focus {\n        box-shadow: 0 0 0 0.2rem #d3c6ec;\n    }\n\n    .p-button.p-button-help:not(:disabled):active,\n    .p-buttonset.p-button-help>.p-button:not(:disabled):active,\n    .p-splitbutton.p-button-help>.p-button:not(:disabled):active,\n    .p-fileupload-choose.p-button-help:not(:disabled):active {\n        background: #58349a;\n        color: #ffffff;\n        border-color: #4d2e87;\n    }\n\n    .p-button.p-button-help.p-button-outlined,\n    .p-buttonset.p-button-help>.p-button.p-button-outlined,\n    .p-splitbutton.p-button-help>.p-button.p-button-outlined,\n    .p-fileupload-choose.p-button-help.p-button-outlined {\n        background-color: transparent;\n        color: #6f42c1;\n        border: 1px solid;\n    }\n\n    .p-button.p-button-help.p-button-outlined:not(:disabled):hover,\n    .p-buttonset.p-button-help>.p-button.p-button-outlined:not(:disabled):hover,\n    .p-splitbutton.p-button-help>.p-button.p-button-outlined:not(:disabled):hover,\n    .p-fileupload-choose.p-button-help.p-button-outlined:not(:disabled):hover {\n        background: rgba(111, 66, 193, 0.04);\n        color: #6f42c1;\n        border: 1px solid;\n    }\n\n    .p-button.p-button-help.p-button-outlined:not(:disabled):active,\n    .p-buttonset.p-button-help>.p-button.p-button-outlined:not(:disabled):active,\n    .p-splitbutton.p-button-help>.p-button.p-button-outlined:not(:disabled):active,\n    .p-fileupload-choose.p-button-help.p-button-outlined:not(:disabled):active {\n        background: rgba(111, 66, 193, 0.16);\n        color: #6f42c1;\n        border: 1px solid;\n    }\n\n    .p-button.p-button-help.p-button-text,\n    .p-buttonset.p-button-help>.p-button.p-button-text,\n    .p-splitbutton.p-button-help>.p-button.p-button-text,\n    .p-fileupload-choose.p-button-help.p-button-text {\n        background-color: transparent;\n        color: #6f42c1;\n        border-color: transparent;\n    }\n\n    .p-button.p-button-help.p-button-text:not(:disabled):hover,\n    .p-buttonset.p-button-help>.p-button.p-button-text:not(:disabled):hover,\n    .p-splitbutton.p-button-help>.p-button.p-button-text:not(:disabled):hover,\n    .p-fileupload-choose.p-button-help.p-button-text:not(:disabled):hover {\n        background: rgba(111, 66, 193, 0.04);\n        border-color: transparent;\n        color: #6f42c1;\n    }\n\n    .p-button.p-button-help.p-button-text:not(:disabled):active,\n    .p-buttonset.p-button-help>.p-button.p-button-text:not(:disabled):active,\n    .p-splitbutton.p-button-help>.p-button.p-button-text:not(:disabled):active,\n    .p-fileupload-choose.p-button-help.p-button-text:not(:disabled):active {\n        background: rgba(111, 66, 193, 0.16);\n        border-color: transparent;\n        color: #6f42c1;\n    }\n\n    .p-button.p-button-danger,\n    .p-buttonset.p-button-danger>.p-button,\n    .p-splitbutton.p-button-danger>.p-button,\n    .p-fileupload-choose.p-button-danger {\n        color: #ffffff;\n        background: #dc3545;\n        border: 1px solid #dc3545;\n    }\n\n    .p-button.p-button-danger:not(:disabled):hover,\n    .p-buttonset.p-button-danger>.p-button:not(:disabled):hover,\n    .p-splitbutton.p-button-danger>.p-button:not(:disabled):hover,\n    .p-fileupload-choose.p-button-danger:not(:disabled):hover {\n        background: #c82333;\n        color: #ffffff;\n        border-color: #bd2130;\n    }\n\n    .p-button.p-button-danger:not(:disabled):focus,\n    .p-buttonset.p-button-danger>.p-button:not(:disabled):focus,\n    .p-splitbutton.p-button-danger>.p-button:not(:disabled):focus,\n    .p-fileupload-choose.p-button-danger:not(:disabled):focus {\n        box-shadow: 0 0 0 0.2rem rgba(225, 83, 97, 0.5);\n    }\n\n    .p-button.p-button-danger:not(:disabled):active,\n    .p-buttonset.p-button-danger>.p-button:not(:disabled):active,\n    .p-splitbutton.p-button-danger>.p-button:not(:disabled):active,\n    .p-fileupload-choose.p-button-danger:not(:disabled):active {\n        background: #bd2130;\n        color: #ffffff;\n        border-color: #b21f2d;\n    }\n\n    .p-button.p-button-danger.p-button-outlined,\n    .p-buttonset.p-button-danger>.p-button.p-button-outlined,\n    .p-splitbutton.p-button-danger>.p-button.p-button-outlined,\n    .p-fileupload-choose.p-button-danger.p-button-outlined {\n        background-color: transparent;\n        color: #dc3545;\n        border: 1px solid;\n    }\n\n    .p-button.p-button-danger.p-button-outlined:not(:disabled):hover,\n    .p-buttonset.p-button-danger>.p-button.p-button-outlined:not(:disabled):hover,\n    .p-splitbutton.p-button-danger>.p-button.p-button-outlined:not(:disabled):hover,\n    .p-fileupload-choose.p-button-danger.p-button-outlined:not(:disabled):hover {\n        background: rgba(220, 53, 69, 0.04);\n        color: #dc3545;\n        border: 1px solid;\n    }\n\n    .p-button.p-button-danger.p-button-outlined:not(:disabled):active,\n    .p-buttonset.p-button-danger>.p-button.p-button-outlined:not(:disabled):active,\n    .p-splitbutton.p-button-danger>.p-button.p-button-outlined:not(:disabled):active,\n    .p-fileupload-choose.p-button-danger.p-button-outlined:not(:disabled):active {\n        background: rgba(220, 53, 69, 0.16);\n        color: #dc3545;\n        border: 1px solid;\n    }\n\n    .p-button.p-button-danger.p-button-text,\n    .p-buttonset.p-button-danger>.p-button.p-button-text,\n    .p-splitbutton.p-button-danger>.p-button.p-button-text,\n    .p-fileupload-choose.p-button-danger.p-button-text {\n        background-color: transparent;\n        color: #dc3545;\n        border-color: transparent;\n    }\n\n    .p-button.p-button-danger.p-button-text:not(:disabled):hover,\n    .p-buttonset.p-button-danger>.p-button.p-button-text:not(:disabled):hover,\n    .p-splitbutton.p-button-danger>.p-button.p-button-text:not(:disabled):hover,\n    .p-fileupload-choose.p-button-danger.p-button-text:not(:disabled):hover {\n        background: rgba(220, 53, 69, 0.04);\n        border-color: transparent;\n        color: #dc3545;\n    }\n\n    .p-button.p-button-danger.p-button-text:not(:disabled):active,\n    .p-buttonset.p-button-danger>.p-button.p-button-text:not(:disabled):active,\n    .p-splitbutton.p-button-danger>.p-button.p-button-text:not(:disabled):active,\n    .p-fileupload-choose.p-button-danger.p-button-text:not(:disabled):active {\n        background: rgba(220, 53, 69, 0.16);\n        border-color: transparent;\n        color: #dc3545;\n    }\n\n    .p-button.p-button-link {\n        color: #007bff;\n        background: transparent;\n        border: transparent;\n    }\n\n    .p-button.p-button-link:not(:disabled):hover {\n        background: transparent;\n        color: #0069d9;\n        border-color: transparent;\n    }\n\n    .p-button.p-button-link:not(:disabled):hover .p-button-label {\n        text-decoration: underline;\n    }\n\n    .p-button.p-button-link:not(:disabled):focus {\n        background: transparent;\n        box-shadow: 0 0 0 0.2rem rgba(38, 143, 255, 0.5);\n        border-color: transparent;\n    }\n\n    .p-button.p-button-link:not(:disabled):active {\n        background: transparent;\n        color: #007bff;\n        border-color: transparent;\n    }\n\n    .p-splitbutton {\n        border-radius: 4px;\n    }\n\n    .p-splitbutton.p-button-outlined>.p-button {\n        background-color: transparent;\n        color: #007bff;\n        border: 1px solid;\n    }\n\n    .p-splitbutton.p-button-outlined>.p-button:not(:disabled):hover {\n        background: rgba(0, 123, 255, 0.04);\n        color: #007bff;\n    }\n\n    .p-splitbutton.p-button-outlined>.p-button:not(:disabled):active {\n        background: rgba(0, 123, 255, 0.16);\n        color: #007bff;\n    }\n\n    .p-splitbutton.p-button-outlined.p-button-plain>.p-button {\n        color: #6c757d;\n        border-color: #6c757d;\n    }\n\n    .p-splitbutton.p-button-outlined.p-button-plain>.p-button:not(:disabled):hover {\n        background: #e9ecef;\n        color: #6c757d;\n    }\n\n    .p-splitbutton.p-button-outlined.p-button-plain>.p-button:not(:disabled):active {\n        background: #dee2e6;\n        color: #6c757d;\n    }\n\n    .p-splitbutton.p-button-text>.p-button {\n        background-color: transparent;\n        color: #007bff;\n        border-color: transparent;\n    }\n\n    .p-splitbutton.p-button-text>.p-button:not(:disabled):hover {\n        background: rgba(0, 123, 255, 0.04);\n        color: #007bff;\n        border-color: transparent;\n    }\n\n    .p-splitbutton.p-button-text>.p-button:not(:disabled):active {\n        background: rgba(0, 123, 255, 0.16);\n        color: #007bff;\n        border-color: transparent;\n    }\n\n    .p-splitbutton.p-button-text.p-button-plain>.p-button {\n        color: #6c757d;\n    }\n\n    .p-splitbutton.p-button-text.p-button-plain>.p-button:not(:disabled):hover {\n        background: #e9ecef;\n        color: #6c757d;\n    }\n\n    .p-splitbutton.p-button-text.p-button-plain>.p-button:not(:disabled):active {\n        background: #dee2e6;\n        color: #6c757d;\n    }\n\n    .p-splitbutton.p-button-raised {\n        box-shadow: 0 3px 1px -2px rgba(0, 0, 0, 0.2), 0 2px 2px 0 rgba(0, 0, 0, 0.14), 0 1px 5px 0 rgba(0, 0, 0, 0.12);\n    }\n\n    .p-splitbutton.p-button-rounded {\n        border-radius: 2rem;\n    }\n\n    .p-splitbutton.p-button-rounded>.p-button {\n        border-radius: 2rem;\n    }\n\n    .p-splitbutton.p-button-sm>.p-button {\n        font-size: 12px;\n        padding: 0.4375rem 0.65625rem;\n    }\n\n    .p-splitbutton.p-button-sm>.p-button .p-button-icon {\n        font-size: 0.875rem;\n    }\n\n    .p-splitbutton.p-button-lg>.p-button {\n        font-size: 12px;\n        padding: 0.625rem 0.9375rem;\n    }\n\n    .p-splitbutton.p-button-lg>.p-button.p-button-icon-only {\n        width: auto;\n    }\n\n    .p-splitbutton.p-button-lg>.p-button .p-button-icon {\n        font-size: 1.25rem;\n    }\n\n    .p-splitbutton .p-splitbutton-menubutton,\n    .p-splitbutton .p-splitbutton.p-button-rounded>.p-splitbutton-menubutton.p-button,\n    .p-splitbutton .p-splitbutton.p-button-outlined>.p-splitbutton-menubutton.p-button {\n        border-top-left-radius: 0;\n        border-bottom-left-radius: 0;\n    }\n\n    .p-splitbutton.p-button-secondary.p-button-outlined>.p-button {\n        background-color: transparent;\n        color: #6c757d;\n        border: 1px solid;\n    }\n\n    .p-splitbutton.p-button-secondary.p-button-outlined>.p-button:not(:disabled):hover {\n        background: rgba(108, 117, 125, 0.04);\n        color: #6c757d;\n    }\n\n    .p-splitbutton.p-button-secondary.p-button-outlined>.p-button:not(:disabled):active {\n        background: rgba(108, 117, 125, 0.16);\n        color: #6c757d;\n    }\n\n    .p-splitbutton.p-button-secondary.p-button-text>.p-button {\n        background-color: transparent;\n        color: #6c757d;\n        border-color: transparent;\n    }\n\n    .p-splitbutton.p-button-secondary.p-button-text>.p-button:not(:disabled):hover {\n        background: rgba(108, 117, 125, 0.04);\n        border-color: transparent;\n        color: #6c757d;\n    }\n\n    .p-splitbutton.p-button-secondary.p-button-text>.p-button:not(:disabled):active {\n        background: rgba(108, 117, 125, 0.16);\n        border-color: transparent;\n        color: #6c757d;\n    }\n\n    .p-splitbutton.p-button-info.p-button-outlined>.p-button {\n        background-color: transparent;\n        color: #17a2b8;\n        border: 1px solid;\n    }\n\n    .p-splitbutton.p-button-info.p-button-outlined>.p-button:not(:disabled):hover {\n        background: rgba(23, 162, 184, 0.04);\n        color: #17a2b8;\n    }\n\n    .p-splitbutton.p-button-info.p-button-outlined>.p-button:not(:disabled):active {\n        background: rgba(23, 162, 184, 0.16);\n        color: #17a2b8;\n    }\n\n    .p-splitbutton.p-button-info.p-button-text>.p-button {\n        background-color: transparent;\n        color: #17a2b8;\n        border-color: transparent;\n    }\n\n    .p-splitbutton.p-button-info.p-button-text>.p-button:not(:disabled):hover {\n        background: rgba(23, 162, 184, 0.04);\n        border-color: transparent;\n        color: #17a2b8;\n    }\n\n    .p-splitbutton.p-button-info.p-button-text>.p-button:not(:disabled):active {\n        background: rgba(23, 162, 184, 0.16);\n        border-color: transparent;\n        color: #17a2b8;\n    }\n\n    .p-splitbutton.p-button-success.p-button-outlined>.p-button {\n        background-color: transparent;\n        color: #28a745;\n        border: 1px solid;\n    }\n\n    .p-splitbutton.p-button-success.p-button-outlined>.p-button:not(:disabled):hover {\n        background: rgba(40, 167, 69, 0.04);\n        color: #28a745;\n    }\n\n    .p-splitbutton.p-button-success.p-button-outlined>.p-button:not(:disabled):active {\n        background: rgba(40, 167, 69, 0.16);\n        color: #28a745;\n    }\n\n    .p-splitbutton.p-button-success.p-button-text>.p-button {\n        background-color: transparent;\n        color: #28a745;\n        border-color: transparent;\n    }\n\n    .p-splitbutton.p-button-success.p-button-text>.p-button:not(:disabled):hover {\n        background: rgba(40, 167, 69, 0.04);\n        border-color: transparent;\n        color: #28a745;\n    }\n\n    .p-splitbutton.p-button-success.p-button-text>.p-button:not(:disabled):active {\n        background: rgba(40, 167, 69, 0.16);\n        border-color: transparent;\n        color: #28a745;\n    }\n\n    .p-splitbutton.p-button-warning.p-button-outlined>.p-button {\n        background-color: transparent;\n        color: #ffc107;\n        border: 1px solid;\n    }\n\n    .p-splitbutton.p-button-warning.p-button-outlined>.p-button:not(:disabled):hover {\n        background: rgba(255, 193, 7, 0.04);\n        color: #ffc107;\n    }\n\n    .p-splitbutton.p-button-warning.p-button-outlined>.p-button:not(:disabled):active {\n        background: rgba(255, 193, 7, 0.16);\n        color: #ffc107;\n    }\n\n    .p-splitbutton.p-button-warning.p-button-text>.p-button {\n        background-color: transparent;\n        color: #ffc107;\n        border-color: transparent;\n    }\n\n    .p-splitbutton.p-button-warning.p-button-text>.p-button:not(:disabled):hover {\n        background: rgba(255, 193, 7, 0.04);\n        border-color: transparent;\n        color: #ffc107;\n    }\n\n    .p-splitbutton.p-button-warning.p-button-text>.p-button:not(:disabled):active {\n        background: rgba(255, 193, 7, 0.16);\n        border-color: transparent;\n        color: #ffc107;\n    }\n\n    .p-splitbutton.p-button-help.p-button-outlined>.p-button {\n        background-color: transparent;\n        color: #6f42c1;\n        border: 1px solid;\n    }\n\n    .p-splitbutton.p-button-help.p-button-outlined>.p-button:not(:disabled):hover {\n        background: rgba(111, 66, 193, 0.04);\n        color: #6f42c1;\n    }\n\n    .p-splitbutton.p-button-help.p-button-outlined>.p-button:not(:disabled):active {\n        background: rgba(111, 66, 193, 0.16);\n        color: #6f42c1;\n    }\n\n    .p-splitbutton.p-button-help.p-button-text>.p-button {\n        background-color: transparent;\n        color: #6f42c1;\n        border-color: transparent;\n    }\n\n    .p-splitbutton.p-button-help.p-button-text>.p-button:not(:disabled):hover {\n        background: rgba(111, 66, 193, 0.04);\n        border-color: transparent;\n        color: #6f42c1;\n    }\n\n    .p-splitbutton.p-button-help.p-button-text>.p-button:not(:disabled):active {\n        background: rgba(111, 66, 193, 0.16);\n        border-color: transparent;\n        color: #6f42c1;\n    }\n\n    .p-splitbutton.p-button-danger.p-button-outlined>.p-button {\n        background-color: transparent;\n        color: #dc3545;\n        border: 1px solid;\n    }\n\n    .p-splitbutton.p-button-danger.p-button-outlined>.p-button:not(:disabled):hover {\n        background: rgba(220, 53, 69, 0.04);\n        color: #dc3545;\n    }\n\n    .p-splitbutton.p-button-danger.p-button-outlined>.p-button:not(:disabled):active {\n        background: rgba(220, 53, 69, 0.16);\n        color: #dc3545;\n    }\n\n    .p-splitbutton.p-button-danger.p-button-text>.p-button {\n        background-color: transparent;\n        color: #dc3545;\n        border-color: transparent;\n    }\n\n    .p-splitbutton.p-button-danger.p-button-text>.p-button:not(:disabled):hover {\n        background: rgba(220, 53, 69, 0.04);\n        border-color: transparent;\n        color: #dc3545;\n    }\n\n    .p-splitbutton.p-button-danger.p-button-text>.p-button:not(:disabled):active {\n        background: rgba(220, 53, 69, 0.16);\n        border-color: transparent;\n        color: #dc3545;\n    }\n\n    .p-speeddial-button.p-button.p-button-icon-only {\n        width: 4rem;\n        height: 4rem;\n    }\n\n    .p-speeddial-button.p-button.p-button-icon-only .p-button-icon {\n        font-size: 1.3rem;\n    }\n\n    .p-speeddial-button.p-button.p-button-icon-only .p-button-icon.p-icon {\n        width: 1.3rem;\n        height: 1.3rem;\n    }\n\n    .p-speeddial-list {\n        outline: 0 none;\n    }\n\n    .p-speeddial-action {\n        width: 3rem;\n        height: 3rem;\n        background: #495057;\n        color: #fff;\n    }\n\n    .p-speeddial-action:hover {\n        background: #343a40;\n        color: #fff;\n    }\n\n    .p-speeddial-direction-up .p-speeddial-item {\n        margin: 0.25rem;\n    }\n\n    .p-speeddial-direction-up .p-speeddial-item:first-child {\n        margin-bottom: 0.5rem;\n    }\n\n    .p-speeddial-direction-down .p-speeddial-item {\n        margin: 0.25rem;\n    }\n\n    .p-speeddial-direction-down .p-speeddial-item:first-child {\n        margin-top: 0.5rem;\n    }\n\n    .p-speeddial-direction-left .p-speeddial-item {\n        margin: 0 0.25rem;\n    }\n\n    .p-speeddial-direction-left .p-speeddial-item:first-child {\n        margin-right: 0.5rem;\n    }\n\n    .p-speeddial-direction-right .p-speeddial-item {\n        margin: 0 0.25rem;\n    }\n\n    .p-speeddial-direction-right .p-speeddial-item:first-child {\n        margin-left: 0.5rem;\n    }\n\n    .p-speeddial-circle .p-speeddial-item,\n    .p-speeddial-semi-circle .p-speeddial-item,\n    .p-speeddial-quarter-circle .p-speeddial-item {\n        margin: 0;\n    }\n\n    .p-speeddial-circle .p-speeddial-item:first-child,\n    .p-speeddial-circle .p-speeddial-item:last-child,\n    .p-speeddial-semi-circle .p-speeddial-item:first-child,\n    .p-speeddial-semi-circle .p-speeddial-item:last-child,\n    .p-speeddial-quarter-circle .p-speeddial-item:first-child,\n    .p-speeddial-quarter-circle .p-speeddial-item:last-child {\n        margin: 0;\n    }\n\n    .p-speeddial-mask {\n        background-color: rgba(0, 0, 0, 0.4);\n        border-radius: 4px;\n    }\n\n    .p-carousel .p-carousel-content .p-carousel-prev,\n    .p-carousel .p-carousel-content .p-carousel-next {\n        width: 2rem;\n        height: 2rem;\n        color: #6c757d;\n        border: 0 none;\n        background: transparent;\n        border-radius: 50%;\n        transition: box-shadow 0.15s;\n        margin: 0.5rem;\n    }\n\n    .p-carousel .p-carousel-content .p-carousel-prev:enabled:hover,\n    .p-carousel .p-carousel-content .p-carousel-next:enabled:hover {\n        color: #495057;\n        border-color: transparent;\n        background: transparent;\n    }\n\n    .p-carousel .p-carousel-content .p-carousel-prev:focus-visible,\n    .p-carousel .p-carousel-content .p-carousel-next:focus-visible {\n        outline: 0 none;\n        outline-offset: 0;\n        box-shadow: 0 0 0 0.2rem rgba(38, 143, 255, 0.5);\n    }\n\n    .p-carousel .p-carousel-indicators {\n        padding: 1rem;\n    }\n\n    .p-carousel .p-carousel-indicators .p-carousel-indicator {\n        margin-right: 0.5rem;\n        margin-bottom: 0.5rem;\n    }\n\n    .p-carousel .p-carousel-indicators .p-carousel-indicator button {\n        background-color: #e9ecef;\n        width: 2rem;\n        height: 0.5rem;\n        transition: box-shadow 0.15s;\n        border-radius: 0;\n    }\n\n    .p-carousel .p-carousel-indicators .p-carousel-indicator button:hover {\n        background: #dee2e6;\n    }\n\n    .p-carousel .p-carousel-indicators .p-carousel-indicator.p-highlight button {\n        background: #007bff;\n        color: #ffffff;\n    }\n\n    .p-datatable .p-paginator-top {\n        border-width: 1px 0 0 0;\n        border-radius: 0;\n    }\n\n    .p-datatable .p-paginator-bottom {\n        border-width: 1px 0 0 0;\n        border-bottom-right-radius: 5px;\n        border-bottom-left-radius: 5px;\n    }\n\n    .p-datatable .p-datatable-header {\n        background: #efefef;\n        color: #212529;\n        border: solid #dee2e6;\n        border-width: 1px 0 0 0;\n        padding: 0.75rem 0.75rem;\n        font-weight: 600;\n    }\n\n    .p-datatable .p-datatable-footer {\n        background: #efefef;\n        color: #212529;\n        border: 1px solid #dee2e6;\n        border-width: 1px 0 1px 0;\n        padding: 1rem 1rem;\n        font-weight: 600;\n    }\n\n    .p-datatable .p-datatable-thead>tr>th {\n        text-align: left;\n        padding: 0.5rem 0.5rem;\n        border: 1px solid #dee2e6;\n        border-width: 1px 0 2px 0;\n        font-weight: 600;\n        color: #212529;\n        background: #ffffff;\n        transition: box-shadow 0.15s;\n    }\n\n    .p-datatable .p-datatable-tfoot>tr>td {\n        text-align: left;\n        padding: 1rem 1rem;\n        border: 1px solid #dee2e6;\n        border-width: 1px 0 1px 0;\n        font-weight: 600;\n        color: #212529;\n        background: #ffffff;\n    }\n\n    .p-datatable .p-sortable-column .p-sortable-column-icon {\n        color: #6c757d;\n        margin-left: 0.5rem;\n    }\n\n    .p-datatable .p-sortable-column .p-sortable-column-badge {\n        border-radius: 50%;\n        height: 1.143rem;\n        min-width: 1.143rem;\n        line-height: 1.143rem;\n        color: #ffffff;\n        background: #007bff;\n        margin-left: 0.5rem;\n    }\n\n    .p-datatable .p-sortable-column:not(.p-highlight):not(.p-sortable-disabled):hover {\n        background: #e9ecef;\n        color: #212529;\n    }\n\n    .p-datatable .p-sortable-column:not(.p-highlight):not(.p-sortable-disabled):hover .p-sortable-column-icon {\n        color: #6c757d;\n    }\n\n    .p-datatable .p-sortable-column.p-highlight {\n        background: #ffffff;\n        color: #cf0000;\n    }\n\n    .p-datatable .p-sortable-column.p-highlight .p-sortable-column-icon {\n        color: #cf0000;\n    }\n\n    .p-datatable .p-sortable-column.p-highlight:not(.p-sortable-disabled):hover {\n        background: #e9ecef;\n        color: #cf0000;\n    }\n\n    .p-datatable .p-sortable-column.p-highlight:not(.p-sortable-disabled):hover .p-sortable-column-icon {\n        color: #cf0000;\n    }\n\n    .p-datatable .p-sortable-column:focus-visible {\n        box-shadow: inset 0 0 0 0.15rem rgba(38, 143, 255, 0.5);\n        outline: 0 none;\n    }\n\n    .p-datatable .p-datatable-tbody>tr {\n        background: #ffffff;\n        color: #212529;\n        transition: box-shadow 0.15s;\n    }\n\n    .p-datatable .p-datatable-tbody>tr>td {\n        text-align: left;\n        border: 1px solid #dee2e6;\n        border-width: 1px 0 0 0;\n        padding: 0.5rem 0.5rem;\n    }\n\n    .p-datatable .p-datatable-tbody>tr>td .p-row-toggler,\n    .p-datatable .p-datatable-tbody>tr>td .p-row-editor-init,\n    .p-datatable .p-datatable-tbody>tr>td .p-row-editor-save,\n    .p-datatable .p-datatable-tbody>tr>td .p-row-editor-cancel {\n        width: 2rem;\n        height: 2rem;\n        color: #6c757d;\n        border: 0 none;\n        background: transparent;\n        border-radius: 50%;\n        transition: box-shadow 0.15s;\n    }\n\n    .p-datatable .p-datatable-tbody>tr>td .p-row-toggler:enabled:hover,\n    .p-datatable .p-datatable-tbody>tr>td .p-row-editor-init:enabled:hover,\n    .p-datatable .p-datatable-tbody>tr>td .p-row-editor-save:enabled:hover,\n    .p-datatable .p-datatable-tbody>tr>td .p-row-editor-cancel:enabled:hover {\n        color: #495057;\n        border-color: transparent;\n        background: transparent;\n    }\n\n    .p-datatable .p-datatable-tbody>tr>td .p-row-toggler:focus-visible,\n    .p-datatable .p-datatable-tbody>tr>td .p-row-editor-init:focus-visible,\n    .p-datatable .p-datatable-tbody>tr>td .p-row-editor-save:focus-visible,\n    .p-datatable .p-datatable-tbody>tr>td .p-row-editor-cancel:focus-visible {\n        outline: 0 none;\n        outline-offset: 0;\n        box-shadow: 0 0 0 0.2rem rgba(38, 143, 255, 0.5);\n    }\n\n    .p-datatable .p-datatable-tbody>tr>td .p-row-editor-save {\n        margin-right: 0.5rem;\n    }\n\n    .p-datatable .p-datatable-tbody>tr>td>.p-column-title {\n        font-weight: 600;\n    }\n\n    .p-datatable .p-datatable-tbody>tr>td.p-highlight {\n        background: #007bff;\n        color: #ffffff;\n    }\n\n    .p-datatable .p-datatable-tbody>tr.p-highlight {\n        background: #cf0000;\n        color: #ffffff;\n    }\n\n    .p-datatable .p-datatable-tbody>tr.p-highlight-contextmenu {\n        outline: 0.15rem solid rgba(38, 143, 255, 0.5);\n        outline-offset: -0.15rem;\n    }\n\n    .p-datatable .p-datatable-tbody>tr.p-datatable-dragpoint-top>td {\n        box-shadow: inset 0 2px 0 0 #007bff;\n    }\n\n    .p-datatable .p-datatable-tbody>tr.p-datatable-dragpoint-bottom>td {\n        box-shadow: inset 0 -2px 0 0 #007bff;\n    }\n\n    .p-datatable.p-datatable-selectable .p-datatable-tbody>tr.p-selectable-row:not(.p-highlight):not(.p-datatable-emptymessage):hover {\n        background: #e9ecef;\n        color: #212529;\n    }\n\n    .p-datatable.p-datatable-selectable .p-datatable-tbody>tr.p-selectable-row:focus-visible {\n        outline: 0.15rem solid rgba(38, 143, 255, 0.5);\n        outline-offset: -0.15rem;\n    }\n\n    .p-datatable.p-datatable-selectable-cell .p-datatable-tbody>tr.p-selectable-row>td.p-selectable-cell:not(.p-highlight):hover {\n        background: #e9ecef;\n        color: #212529;\n    }\n\n    .p-datatable.p-datatable-selectable-cell .p-datatable-tbody>tr.p-selectable-row>td.p-selectable-cell:focus-visible {\n        outline: 0.15rem solid rgba(38, 143, 255, 0.5);\n        outline-offset: -0.15rem;\n    }\n\n    .p-datatable.p-datatable-hoverable-rows .p-datatable-tbody>tr:not(.p-highlight):not(.p-datatable-emptymessage):hover {\n        background: #e9ecef;\n        color: #212529;\n    }\n\n    .p-datatable .p-column-resizer-helper {\n        background: #007bff;\n    }\n\n    .p-datatable .p-datatable-scrollable-header,\n    .p-datatable .p-datatable-scrollable-footer {\n        background: #efefef;\n    }\n\n    .p-datatable.p-datatable-scrollable>.p-datatable-wrapper>.p-datatable-table>.p-datatable-thead,\n    .p-datatable.p-datatable-scrollable>.p-datatable-wrapper>.p-datatable-table>.p-datatable-tfoot,\n    .p-datatable.p-datatable-scrollable>.p-datatable-wrapper>.p-virtualscroller>.p-datatable-table>.p-datatable-thead,\n    .p-datatable.p-datatable-scrollable>.p-datatable-wrapper>.p-virtualscroller>.p-datatable-table>.p-datatable-tfoot {\n        background-color: #ffffff;\n    }\n\n    .p-datatable .p-datatable-loading-icon {\n        font-size: 2rem;\n    }\n\n    .p-datatable .p-datatable-loading-icon.p-icon {\n        width: 2rem;\n        height: 2rem;\n    }\n\n    .p-datatable.p-datatable-gridlines .p-datatable-header {\n        border-width: 1px 1px 0 1px;\n        border-top-right-radius: 5px;\n        border-top-left-radius: 5px;\n    }\n\n    .p-datatable.p-datatable-gridlines .p-datatable-footer {\n        border-width: 0 1px 1px 1px;\n    }\n\n    .p-datatable.p-datatable-gridlines .p-paginator-top {\n        border-width: 0 1px 0 1px;\n    }\n\n    .p-datatable.p-datatable-gridlines .p-paginator-bottom {\n        border-width: 0 1px 1px 1px;\n    }\n\n    .p-datatable.p-datatable-gridlines .p-datatable-thead>tr>th {\n        border-width: 1px 0 1px 1px;\n    }\n\n    .p-datatable.p-datatable-gridlines .p-datatable-thead>tr>th:last-child {\n        border-width: 1px;\n    }\n\n    .p-datatable.p-datatable-gridlines .p-datatable-tbody>tr>td {\n        border-width: 1px 0 0 1px;\n    }\n\n    .p-datatable.p-datatable-gridlines .p-datatable-tbody>tr>td:last-child {\n        border-width: 1px 1px 0 1px;\n    }\n\n    .p-datatable.p-datatable-gridlines .p-datatable-tbody>tr:last-child>td {\n        border-width: 1px 0 1px 1px;\n    }\n\n    .p-datatable.p-datatable-gridlines .p-datatable-tbody>tr:last-child>td:last-child {\n        border-width: 1px;\n    }\n\n    .p-datatable.p-datatable-gridlines .p-datatable-tfoot>tr>td {\n        border-width: 1px 0 1px 1px;\n    }\n\n    .p-datatable.p-datatable-gridlines .p-datatable-tfoot>tr>td:last-child {\n        border-width: 1px 1px 1px 1px;\n    }\n\n    .p-datatable.p-datatable-gridlines .p-datatable-thead+.p-datatable-tfoot>tr>td {\n        border-width: 0 0 1px 1px;\n    }\n\n    .p-datatable.p-datatable-gridlines .p-datatable-thead+.p-datatable-tfoot>tr>td:last-child {\n        border-width: 0 1px 1px 1px;\n    }\n\n    .p-datatable.p-datatable-gridlines:has(.p-datatable-thead):has(.p-datatable-tbody) .p-datatable-tbody>tr>td {\n        border-width: 0 0 1px 1px;\n    }\n\n    .p-datatable.p-datatable-gridlines:has(.p-datatable-thead):has(.p-datatable-tbody) .p-datatable-tbody>tr>td:last-child {\n        border-width: 0 1px 1px 1px;\n    }\n\n    .p-datatable.p-datatable-gridlines:has(.p-datatable-tbody):has(.p-datatable-tfoot) .p-datatable-tbody>tr:last-child>td {\n        border-width: 0 0 0 1px;\n    }\n\n    .p-datatable.p-datatable-gridlines:has(.p-datatable-tbody):has(.p-datatable-tfoot) .p-datatable-tbody>tr:last-child>td:last-child {\n        border-width: 0 1px 0 1px;\n    }\n\n    .p-datatable.p-datatable-striped .p-datatable-tbody>tr.p-row-odd {\n        background: rgba(0, 0, 0, 0.05);\n    }\n\n    .p-datatable.p-datatable-striped .p-datatable-tbody>tr.p-row-odd.p-highlight {\n        background: #cf0000;\n        color: #ffffff;\n    }\n\n    .p-datatable.p-datatable-striped .p-datatable-tbody>tr.p-row-odd.p-highlight .p-row-toggler {\n        color: #ffffff;\n    }\n\n    .p-datatable.p-datatable-striped .p-datatable-tbody>tr.p-row-odd.p-highlight .p-row-toggler:hover {\n        color: #ffffff;\n    }\n\n    .p-datatable.p-datatable-striped .p-datatable-tbody>tr.p-row-odd+.p-row-expanded {\n        background: rgba(0, 0, 0, 0.05);\n    }\n\n    .p-datatable.p-datatable-sm .p-datatable-header {\n        padding: 0.5rem 0.5rem;\n    }\n\n    .p-datatable.p-datatable-sm .p-datatable-thead>tr>th {\n        padding: 0.5rem 0.5rem;\n    }\n\n    .p-datatable.p-datatable-sm .p-datatable-tbody>tr>td {\n        padding: 0.5rem 0.5rem;\n    }\n\n    .p-datatable.p-datatable-sm .p-datatable-tfoot>tr>td {\n        padding: 0.5rem 0.5rem;\n    }\n\n    .p-datatable.p-datatable-sm .p-datatable-footer {\n        padding: 0.5rem 0.5rem;\n    }\n\n    .p-datatable.p-datatable-lg .p-datatable-header {\n        padding: 1.25rem 1.25rem;\n    }\n\n    .p-datatable.p-datatable-lg .p-datatable-thead>tr>th {\n        padding: 1.25rem 1.25rem;\n    }\n\n    .p-datatable.p-datatable-lg .p-datatable-tbody>tr>td {\n        padding: 1.25rem 1.25rem;\n    }\n\n    .p-datatable.p-datatable-lg .p-datatable-tfoot>tr>td {\n        padding: 1.25rem 1.25rem;\n    }\n\n    .p-datatable.p-datatable-lg .p-datatable-footer {\n        padding: 1.25rem 1.25rem;\n    }\n\n    .p-datatable-drag-selection-helper {\n        background: rgba(0, 123, 255, 0.16);\n    }\n\n    .p-dataview .p-paginator-top {\n        border-width: 1px 0 0 0;\n        border-radius: 0;\n    }\n\n    .p-dataview .p-paginator-bottom {\n        border-width: 1px 0 0 0;\n        border-radius: 0;\n    }\n\n    .p-dataview .p-dataview-header {\n        background: #efefef;\n        color: #212529;\n        border: solid #dee2e6;\n        border-width: 1px 0 0 0;\n        padding: 1rem 1rem;\n        font-weight: 600;\n    }\n\n    .p-dataview .p-dataview-content {\n        background: #ffffff;\n        color: #212529;\n        border: 0 none;\n        padding: 0;\n    }\n\n    .p-dataview .p-dataview-footer {\n        background: #efefef;\n        color: #212529;\n        border: 1px solid #dee2e6;\n        border-width: 1px 0 1px 0;\n        padding: 1rem 1rem;\n        font-weight: 600;\n        border-bottom-left-radius: 4px;\n        border-bottom-right-radius: 4px;\n    }\n\n    .p-dataview .p-dataview-loading-icon {\n        font-size: 2rem;\n    }\n\n    .p-dataview .p-dataview-loading-icon.p-icon {\n        width: 2rem;\n        height: 2rem;\n    }\n\n    .p-datascroller .p-paginator-top {\n        border-width: 1px 0 0 0;\n        border-radius: 0;\n    }\n\n    .p-datascroller .p-paginator-bottom {\n        border-width: 1px 0 0 0;\n        border-radius: 0;\n    }\n\n    .p-datascroller .p-datascroller-header {\n        background: #efefef;\n        color: #212529;\n        border: solid #dee2e6;\n        border-width: 1px 0 0 0;\n        padding: 1rem 1rem;\n        font-weight: 600;\n    }\n\n    .p-datascroller .p-datascroller-content {\n        background: #ffffff;\n        color: #212529;\n        border: 0 none;\n        padding: 0;\n    }\n\n    .p-datascroller.p-datascroller-inline .p-datascroller-list>li {\n        border: 1px solid #dee2e6;\n        border-width: 1px 0 0 0;\n    }\n\n    .p-datascroller .p-datascroller-footer {\n        background: #efefef;\n        color: #212529;\n        border: 1px solid #dee2e6;\n        border-width: 1px 0 1px 0;\n        padding: 1rem 1rem;\n        font-weight: 600;\n        border-bottom-left-radius: 4px;\n        border-bottom-right-radius: 4px;\n    }\n\n    .p-column-filter-row .p-column-filter-menu-button,\n    .p-column-filter-row .p-column-filter-clear-button {\n        margin-left: 0.5rem;\n    }\n\n    .p-column-filter-menu-button {\n        width: 2rem;\n        height: 2rem;\n        color: #6c757d;\n        border: 0 none;\n        background: transparent;\n        border-radius: 50%;\n        transition: box-shadow 0.15s;\n    }\n\n    .p-column-filter-menu-button:hover {\n        color: #495057;\n        border-color: transparent;\n        background: transparent;\n    }\n\n    .p-column-filter-menu-button.p-column-filter-menu-button-open,\n    .p-column-filter-menu-button.p-column-filter-menu-button-open:hover {\n        background: transparent;\n        color: #495057;\n    }\n\n    .p-column-filter-menu-button.p-column-filter-menu-button-active,\n    .p-column-filter-menu-button.p-column-filter-menu-button-active:hover {\n        background: #007bff;\n        color: #ffffff;\n    }\n\n    .p-column-filter-menu-button:focus-visible {\n        outline: 0 none;\n        outline-offset: 0;\n        box-shadow: 0 0 0 0.2rem rgba(38, 143, 255, 0.5);\n    }\n\n    .p-column-filter-clear-button {\n        width: 2rem;\n        height: 2rem;\n        color: #6c757d;\n        border: 0 none;\n        background: transparent;\n        border-radius: 50%;\n        transition: box-shadow 0.15s;\n    }\n\n    .p-column-filter-clear-button:hover {\n        color: #495057;\n        border-color: transparent;\n        background: transparent;\n    }\n\n    .p-column-filter-clear-button:focus-visible {\n        outline: 0 none;\n        outline-offset: 0;\n        box-shadow: 0 0 0 0.2rem rgba(38, 143, 255, 0.5);\n    }\n\n    .p-column-filter-overlay {\n        background: #ffffff;\n        color: #212529;\n        border: 1px solid rgba(0, 0, 0, 0.15);\n        border-radius: 4px;\n        box-shadow: none;\n        min-width: 12.5rem;\n    }\n\n    .p-column-filter-overlay .p-column-filter-row-items {\n        padding: 0.5rem 0;\n    }\n\n    .p-column-filter-overlay .p-column-filter-row-items .p-column-filter-row-item {\n        margin: 0;\n        padding: 0.5rem 1.5rem;\n        border: 0 none;\n        color: #212529;\n        background: transparent;\n        transition: box-shadow 0.15s;\n        border-radius: 0;\n    }\n\n    .p-column-filter-overlay .p-column-filter-row-items .p-column-filter-row-item.p-highlight {\n        color: #ffffff;\n        background: #007bff;\n    }\n\n    .p-column-filter-overlay .p-column-filter-row-items .p-column-filter-row-item:not(.p-highlight):not(.p-disabled):hover {\n        color: #212529;\n        background: #e9ecef;\n    }\n\n    .p-column-filter-overlay .p-column-filter-row-items .p-column-filter-row-item:focus-visible {\n        outline: 0 none;\n        outline-offset: 0;\n        box-shadow: inset 0 0 0 0.15rem rgba(38, 143, 255, 0.5);\n    }\n\n    .p-column-filter-overlay .p-column-filter-row-items .p-column-filter-separator {\n        border-top: 1px solid #dee2e6;\n        margin: 0.5rem 0;\n    }\n\n    .p-column-filter-overlay-menu .p-column-filter-operator {\n        padding: 0.75rem 1.5rem;\n        border-bottom: 1px solid #dee2e6;\n        color: #212529;\n        background: #efefef;\n        margin: 0;\n        border-top-right-radius: 4px;\n        border-top-left-radius: 4px;\n    }\n\n    .p-column-filter-overlay-menu .p-column-filter-constraint {\n        padding: 1.25rem;\n        border-bottom: 1px solid #dee2e6;\n    }\n\n    .p-column-filter-overlay-menu .p-column-filter-constraint .p-column-filter-matchmode-dropdown {\n        margin-bottom: 0.5rem;\n    }\n\n    .p-column-filter-overlay-menu .p-column-filter-constraint .p-column-filter-remove-button {\n        margin-top: 0.5rem;\n    }\n\n    .p-column-filter-overlay-menu .p-column-filter-constraint:last-child {\n        border-bottom: 0 none;\n    }\n\n    .p-column-filter-overlay-menu .p-column-filter-add-rule {\n        padding: 0.5rem 1.25rem;\n    }\n\n    .p-column-filter-overlay-menu .p-column-filter-buttonbar {\n        padding: 1.25rem;\n    }\n\n    .p-orderlist .p-orderlist-controls {\n        padding: 1.25rem;\n    }\n\n    .p-orderlist .p-orderlist-controls .p-button {\n        margin-bottom: 0.5rem;\n    }\n\n    .p-orderlist .p-orderlist-header {\n        background: #efefef;\n        color: #212529;\n        border: 1px solid #dee2e6;\n        padding: 1rem 1.25rem;\n        font-weight: 600;\n        border-bottom: 0 none;\n        border-top-right-radius: 4px;\n        border-top-left-radius: 4px;\n    }\n\n    .p-orderlist .p-orderlist-filter-container {\n        padding: 1rem 1.25rem;\n        background: #ffffff;\n        border: 1px solid #dee2e6;\n        border-bottom: 0 none;\n    }\n\n    .p-orderlist .p-orderlist-filter-container .p-orderlist-filter-input {\n        padding-right: 1.75rem;\n    }\n\n    .p-orderlist .p-orderlist-filter-container .p-orderlist-filter-icon {\n        right: 0.75rem;\n        color: #495057;\n    }\n\n    .p-orderlist .p-orderlist-list {\n        border: 1px solid #dee2e6;\n        background: #ffffff;\n        color: #212529;\n        padding: 0.5rem 0;\n        border-bottom-right-radius: 4px;\n        border-bottom-left-radius: 4px;\n        outline: 0 none;\n    }\n\n    .p-orderlist .p-orderlist-list .p-orderlist-item {\n        padding: 0.5rem 1.5rem;\n        margin: 0;\n        border: 0 none;\n        color: #212529;\n        background: transparent;\n        transition: transform 0.15s, box-shadow 0.15s;\n    }\n\n    .p-orderlist .p-orderlist-list .p-orderlist-item:not(.p-highlight):hover {\n        background: #e9ecef;\n        color: #212529;\n    }\n\n    .p-orderlist .p-orderlist-list .p-orderlist-item.p-focus {\n        color: #212529;\n        background: #dee2e6;\n    }\n\n    .p-orderlist .p-orderlist-list .p-orderlist-item.p-highlight {\n        color: #ffffff;\n        background: #007bff;\n    }\n\n    .p-orderlist .p-orderlist-list .p-orderlist-item.p-highlight.p-focus {\n        background: #0067d6;\n    }\n\n    .p-orderlist.p-orderlist-striped .p-orderlist-list .p-orderlist-item:nth-child(even) {\n        background: rgba(0, 0, 0, 0.05);\n    }\n\n    .p-orderlist.p-orderlist-striped .p-orderlist-list .p-orderlist-item:nth-child(even):hover {\n        background: #e9ecef;\n    }\n\n    .p-organizationchart .p-organizationchart-node-content.p-organizationchart-selectable-node:not(.p-highlight):hover {\n        background: #e9ecef;\n        color: #212529;\n    }\n\n    .p-organizationchart .p-organizationchart-node-content.p-highlight {\n        background: #007bff;\n        color: #ffffff;\n    }\n\n    .p-organizationchart .p-organizationchart-node-content.p-highlight .p-node-toggler i {\n        color: #003e80;\n    }\n\n    .p-organizationchart .p-organizationchart-line-down {\n        background: #dee2e6;\n    }\n\n    .p-organizationchart .p-organizationchart-line-left {\n        border-right: 1px solid #dee2e6;\n        border-color: #dee2e6;\n    }\n\n    .p-organizationchart .p-organizationchart-line-top {\n        border-top: 1px solid #dee2e6;\n        border-color: #dee2e6;\n    }\n\n    .p-organizationchart .p-organizationchart-node-content {\n        border: 1px solid #dee2e6;\n        background: #ffffff;\n        color: #212529;\n        padding: 1.25rem;\n    }\n\n    .p-organizationchart .p-organizationchart-node-content .p-node-toggler {\n        background: inherit;\n        color: inherit;\n        border-radius: 50%;\n    }\n\n    .p-organizationchart .p-organizationchart-node-content .p-node-toggler:focus-visible {\n        outline: 0 none;\n        outline-offset: 0;\n        box-shadow: 0 0 0 0.2rem rgba(38, 143, 255, 0.5);\n    }\n\n    .p-paginator {\n        background: #ffffff;\n        color: #007bff;\n        border: solid #dee2e6;\n        border-width: 0;\n        padding: 0.5rem;\n        border-radius: 4px;\n    }\n\n    .p-paginator .p-paginator-first,\n    .p-paginator .p-paginator-prev,\n    .p-paginator .p-paginator-next,\n    .p-paginator .p-paginator-last {\n        background-color: #ffffff;\n        border: 1px solid #dee2e6;\n        color: #cf0000;\n        min-width: 2.357rem;\n        height: 2.357rem;\n        margin: 0 0 0 -1px;\n        transition: box-shadow 0.15s;\n        border-radius: 0;\n    }\n\n    .p-paginator .p-paginator-first:not(.p-disabled):not(.p-highlight):hover,\n    .p-paginator .p-paginator-prev:not(.p-disabled):not(.p-highlight):hover,\n    .p-paginator .p-paginator-next:not(.p-disabled):not(.p-highlight):hover,\n    .p-paginator .p-paginator-last:not(.p-disabled):not(.p-highlight):hover {\n        background: #e9ecef;\n        border-color: #dee2e6;\n        color: #cf0000;\n    }\n\n    .p-paginator .p-paginator-first {\n        border-top-left-radius: 10px;\n        border-bottom-left-radius: 10px;\n    }\n\n    .p-paginator .p-paginator-last {\n        border-top-right-radius: 10px;\n        border-bottom-right-radius: 10px;\n    }\n\n    .p-paginator .p-dropdown {\n        margin-left: 0.5rem;\n        height: 2.357rem;\n    }\n\n    .p-paginator .p-dropdown .p-dropdown-label {\n        padding-right: 0;\n        color: #cf0000;\n    }\n\n    .p-paginator .p-paginator-page-input {\n        margin-left: 0.5rem;\n        margin-right: 0.5rem;\n    }\n\n    .p-paginator .p-paginator-page-input .p-inputtext {\n        max-width: 2.357rem;\n    }\n\n    .p-paginator .p-paginator-current {\n        background-color: #ffffff;\n        border: 1px solid #dee2e6;\n        color: #cf0000;\n        min-width: 2.357rem;\n        height: 2.357rem;\n        margin: 0 0 0 -1px;\n        padding: 0 0.5rem;\n    }\n\n    .p-paginator .p-paginator-pages .p-paginator-page {\n        background-color: #ffffff;\n        border: 1px solid #dee2e6;\n        color: #cf0000;\n        min-width: 2.357rem;\n        height: 2.357rem;\n        margin: 0 0 0 -1px;\n        transition: box-shadow 0.15s;\n        border-radius: 0;\n    }\n\n    .p-paginator .p-paginator-pages .p-paginator-page.p-highlight {\n        background: #ffffff;\n        border-color: #cf0000;\n        color: #cf0000;\n    }\n\n    .p-paginator .p-paginator-pages .p-paginator-page:not(.p-highlight):hover {\n        background: #e9ecef;\n        border-color: #dee2e6;\n        color: #cf0000;\n    }\n\n    .p-picklist .p-picklist-buttons {\n        padding: 1.25rem;\n    }\n\n    .p-picklist .p-picklist-buttons .p-button {\n        margin-bottom: 0.5rem;\n    }\n\n    .p-picklist .p-picklist-header {\n        background: #efefef;\n        color: #212529;\n        border: 1px solid #dee2e6;\n        padding: 1rem 1.25rem;\n        font-weight: 600;\n        border-bottom: 0 none;\n        border-top-right-radius: 4px;\n        border-top-left-radius: 4px;\n    }\n\n    .p-picklist .p-picklist-filter-container {\n        padding: 1rem 1.25rem;\n        background: #ffffff;\n        border: 1px solid #dee2e6;\n        border-bottom: 0 none;\n    }\n\n    .p-picklist .p-picklist-filter-container .p-picklist-filter-input {\n        padding-right: 1.75rem;\n    }\n\n    .p-picklist .p-picklist-filter-container .p-picklist-filter-icon {\n        right: 0.75rem;\n        color: #495057;\n    }\n\n    .p-picklist .p-picklist-list {\n        border: 1px solid #dee2e6;\n        background: #ffffff;\n        color: #212529;\n        padding: 0.5rem 0;\n        border-bottom-right-radius: 4px;\n        border-bottom-left-radius: 4px;\n        outline: 0 none;\n    }\n\n    .p-picklist .p-picklist-list .p-picklist-item {\n        padding: 0.5rem 1.5rem;\n        margin: 0;\n        border: 0 none;\n        color: #212529;\n        background: transparent;\n        transition: transform 0.15s, box-shadow 0.15s;\n    }\n\n    .p-picklist .p-picklist-list .p-picklist-item:not(.p-highlight):hover {\n        background: #e9ecef;\n        color: #212529;\n    }\n\n    .p-picklist .p-picklist-list .p-picklist-item.p-focus {\n        color: #212529;\n        background: #dee2e6;\n    }\n\n    .p-picklist .p-picklist-list .p-picklist-item.p-highlight {\n        color: #ffffff;\n        background: #007bff;\n    }\n\n    .p-picklist .p-picklist-list .p-picklist-item.p-highlight.p-focus {\n        background: #0067d6;\n    }\n\n    .p-tree {\n        border: 1px solid #dee2e6;\n        background: #ffffff;\n        color: #212529;\n        padding: 1.25rem;\n        border-radius: 4px;\n    }\n\n    .p-tree .p-tree-container .p-treenode {\n        padding: 0.143rem;\n        outline: 0 none;\n    }\n\n    .p-tree .p-tree-container .p-treenode:focus>.p-treenode-content {\n        outline: 0 none;\n        outline-offset: 0;\n        box-shadow: inset 0 0 0 0.15rem rgba(38, 143, 255, 0.5);\n    }\n\n    .p-tree .p-tree-container .p-treenode .p-treenode-content {\n        border-radius: 4px;\n        transition: box-shadow 0.15s;\n        padding: 0.286rem;\n    }\n\n    .p-tree .p-tree-container .p-treenode .p-treenode-content .p-tree-toggler {\n        margin-right: 0.5rem;\n        width: 2rem;\n        height: 2rem;\n        color: #6c757d;\n        border: 0 none;\n        background: transparent;\n        border-radius: 50%;\n        transition: box-shadow 0.15s;\n    }\n\n    .p-tree .p-tree-container .p-treenode .p-treenode-content .p-tree-toggler:enabled:hover {\n        color: #495057;\n        border-color: transparent;\n        background: transparent;\n    }\n\n    .p-tree .p-tree-container .p-treenode .p-treenode-content .p-tree-toggler:focus-visible {\n        outline: 0 none;\n        outline-offset: 0;\n        box-shadow: 0 0 0 0.2rem rgba(38, 143, 255, 0.5);\n    }\n\n    .p-tree .p-tree-container .p-treenode .p-treenode-content .p-treenode-icon {\n        margin-right: 0.5rem;\n        color: #6c757d;\n    }\n\n    .p-tree .p-tree-container .p-treenode .p-treenode-content .p-checkbox {\n        margin-right: 0.5rem;\n    }\n\n    .p-tree .p-tree-container .p-treenode .p-treenode-content .p-checkbox .p-indeterminate .p-checkbox-icon {\n        color: #212529;\n    }\n\n    .p-tree .p-tree-container .p-treenode .p-treenode-content.p-highlight {\n        background: #007bff;\n        color: #ffffff;\n    }\n\n    .p-tree .p-tree-container .p-treenode .p-treenode-content.p-highlight .p-tree-toggler,\n    .p-tree .p-tree-container .p-treenode .p-treenode-content.p-highlight .p-treenode-icon {\n        color: #ffffff;\n    }\n\n    .p-tree .p-tree-container .p-treenode .p-treenode-content.p-highlight .p-tree-toggler:hover,\n    .p-tree .p-tree-container .p-treenode .p-treenode-content.p-highlight .p-treenode-icon:hover {\n        color: #ffffff;\n    }\n\n    .p-tree .p-tree-container .p-treenode .p-treenode-content.p-treenode-selectable:not(.p-highlight):hover {\n        background: #e9ecef;\n        color: #212529;\n    }\n\n    .p-tree .p-tree-container .p-treenode .p-treenode-content.p-treenode-dragover {\n        background: #e9ecef;\n        color: #212529;\n    }\n\n    .p-tree .p-tree-filter-container {\n        margin-bottom: 0.5rem;\n    }\n\n    .p-tree .p-tree-filter-container .p-tree-filter {\n        width: 100%;\n        padding-right: 1.75rem;\n    }\n\n    .p-tree .p-tree-filter-container .p-tree-filter-icon {\n        right: 0.75rem;\n        color: #495057;\n    }\n\n    .p-tree .p-treenode-children {\n        padding: 0 0 0 1rem;\n    }\n\n    .p-tree .p-tree-loading-icon {\n        font-size: 2rem;\n    }\n\n    .p-tree .p-tree-loading-icon.p-icon {\n        width: 2rem;\n        height: 2rem;\n    }\n\n    .p-tree .p-treenode-droppoint {\n        height: 0.5rem;\n    }\n\n    .p-tree .p-treenode-droppoint.p-treenode-droppoint-active {\n        background: #0062cc;\n    }\n\n    .p-treetable .p-paginator-top {\n        border-width: 1px 0 0 0;\n        border-radius: 0;\n    }\n\n    .p-treetable .p-paginator-bottom {\n        border-width: 1px 0 0 0;\n        border-radius: 0;\n    }\n\n    .p-treetable .p-treetable-header {\n        background: #efefef;\n        color: #212529;\n        border: solid #dee2e6;\n        border-width: 1px 0 0 0;\n        padding: 1rem 1rem;\n        font-weight: 600;\n    }\n\n    .p-treetable .p-treetable-footer {\n        background: #efefef;\n        color: #212529;\n        border: 1px solid #dee2e6;\n        border-width: 1px 0 1px 0;\n        padding: 1rem 1rem;\n        font-weight: 600;\n    }\n\n    .p-treetable .p-treetable-thead>tr>th {\n        text-align: left;\n        padding: 1rem 1rem;\n        border: 1px solid #dee2e6;\n        border-width: 1px 0 2px 0;\n        font-weight: 600;\n        color: #212529;\n        background: #ffffff;\n        transition: box-shadow 0.15s;\n    }\n\n    .p-treetable .p-treetable-tfoot>tr>td {\n        text-align: left;\n        padding: 1rem 1rem;\n        border: 1px solid #dee2e6;\n        border-width: 1px 0 1px 0;\n        font-weight: 600;\n        color: #212529;\n        background: #ffffff;\n    }\n\n    .p-treetable .p-sortable-column {\n        outline-color: rgba(38, 143, 255, 0.5);\n    }\n\n    .p-treetable .p-sortable-column .p-sortable-column-icon {\n        color: #6c757d;\n        margin-left: 0.5rem;\n    }\n\n    .p-treetable .p-sortable-column .p-sortable-column-badge {\n        border-radius: 50%;\n        height: 1.143rem;\n        min-width: 1.143rem;\n        line-height: 1.143rem;\n        color: #ffffff;\n        background: #007bff;\n        margin-left: 0.5rem;\n    }\n\n    .p-treetable .p-sortable-column:not(.p-highlight):hover {\n        background: #e9ecef;\n        color: #212529;\n    }\n\n    .p-treetable .p-sortable-column:not(.p-highlight):hover .p-sortable-column-icon {\n        color: #6c757d;\n    }\n\n    .p-treetable .p-sortable-column.p-highlight {\n        background: #ffffff;\n        color: #007bff;\n    }\n\n    .p-treetable .p-sortable-column.p-highlight .p-sortable-column-icon {\n        color: #007bff;\n    }\n\n    .p-treetable .p-treetable-tbody>tr {\n        background: #ffffff;\n        color: #212529;\n        transition: box-shadow 0.15s;\n    }\n\n    .p-treetable .p-treetable-tbody>tr>td {\n        text-align: left;\n        border: 1px solid #dee2e6;\n        border-width: 1px 0 0 0;\n        padding: 1rem 1rem;\n    }\n\n    .p-treetable .p-treetable-tbody>tr>td .p-treetable-toggler {\n        width: 2rem;\n        height: 2rem;\n        color: #6c757d;\n        border: 0 none;\n        background: transparent;\n        border-radius: 50%;\n        transition: box-shadow 0.15s;\n        margin-right: 0.5rem;\n    }\n\n    .p-treetable .p-treetable-tbody>tr>td .p-treetable-toggler:enabled:hover {\n        color: #495057;\n        border-color: transparent;\n        background: transparent;\n    }\n\n    .p-treetable .p-treetable-tbody>tr>td .p-treetable-toggler:focus-visible {\n        outline: 0 none;\n        outline-offset: 0;\n        box-shadow: 0 0 0 0.2rem rgba(38, 143, 255, 0.5);\n    }\n\n    .p-treetable .p-treetable-tbody>tr>td .p-treetable-toggler+.p-checkbox {\n        margin-right: 0.5rem;\n    }\n\n    .p-treetable .p-treetable-tbody>tr>td .p-treetable-toggler+.p-checkbox .p-indeterminate .p-checkbox-icon {\n        color: #212529;\n    }\n\n    .p-treetable .p-treetable-tbody>tr:focus-visible {\n        outline: 0.15rem solid rgba(38, 143, 255, 0.5);\n        outline-offset: -0.15rem;\n    }\n\n    .p-treetable .p-treetable-tbody>tr.p-highlight {\n        background: #007bff;\n        color: #ffffff;\n    }\n\n    .p-treetable .p-treetable-tbody>tr.p-highlight .p-treetable-toggler {\n        color: #ffffff;\n    }\n\n    .p-treetable .p-treetable-tbody>tr.p-highlight .p-treetable-toggler:hover {\n        color: #ffffff;\n    }\n\n    .p-treetable.p-treetable-selectable .p-treetable-tbody>tr:not(.p-highlight):hover,\n    .p-treetable.p-treetable-hoverable-rows .p-treetable-tbody>tr:not(.p-highlight):hover {\n        background: #e9ecef;\n        color: #212529;\n    }\n\n    .p-treetable.p-treetable-selectable .p-treetable-tbody>tr:not(.p-highlight):hover .p-treetable-toggler,\n    .p-treetable.p-treetable-hoverable-rows .p-treetable-tbody>tr:not(.p-highlight):hover .p-treetable-toggler {\n        color: #212529;\n    }\n\n    .p-treetable .p-column-resizer-helper {\n        background: #007bff;\n    }\n\n    .p-treetable .p-treetable-scrollable-header,\n    .p-treetable .p-treetable-scrollable-footer {\n        background: #efefef;\n    }\n\n    .p-treetable .p-treetable-loading-icon {\n        font-size: 2rem;\n    }\n\n    .p-treetable .p-treetable-loading-icon.p-icon {\n        width: 2rem;\n        height: 2rem;\n    }\n\n    .p-treetable.p-treetable-gridlines .p-treetable-header {\n        border-width: 1px 1px 0 1px;\n    }\n\n    .p-treetable.p-treetable-gridlines .p-treetable-footer {\n        border-width: 0 1px 1px 1px;\n    }\n\n    .p-treetable.p-treetable-gridlines .p-treetable-top {\n        border-width: 0 1px 0 1px;\n    }\n\n    .p-treetable.p-treetable-gridlines .p-treetable-bottom {\n        border-width: 0 1px 1px 1px;\n    }\n\n    .p-treetable.p-treetable-gridlines .p-treetable-thead>tr>th {\n        border-width: 1px;\n    }\n\n    .p-treetable.p-treetable-gridlines .p-treetable-tbody>tr>td {\n        border-width: 1px;\n    }\n\n    .p-treetable.p-treetable-gridlines .p-treetable-tfoot>tr>td {\n        border-width: 1px;\n    }\n\n    .p-treetable.p-treetable-striped .p-treetable-tbody>tr.p-row-odd {\n        background: rgba(0, 0, 0, 0.05);\n    }\n\n    .p-treetable.p-treetable-striped .p-treetable-tbody>tr.p-row-odd.p-highlight {\n        background: #007bff;\n        color: #ffffff;\n    }\n\n    .p-treetable.p-treetable-striped .p-treetable-tbody>tr.p-row-odd.p-highlight .p-row-toggler {\n        color: #ffffff;\n    }\n\n    .p-treetable.p-treetable-striped .p-treetable-tbody>tr.p-row-odd.p-highlight .p-row-toggler:hover {\n        color: #ffffff;\n    }\n\n    .p-treetable.p-treetable-striped .p-treetable-tbody>tr.p-row-odd+.p-row-expanded {\n        background: rgba(0, 0, 0, 0.05);\n    }\n\n    .p-treetable.p-treetable-sm .p-treetable-header {\n        padding: 0.875rem 0.875rem;\n    }\n\n    .p-treetable.p-treetable-sm .p-treetable-thead>tr>th {\n        padding: 0.5rem 0.5rem;\n    }\n\n    .p-treetable.p-treetable-sm .p-treetable-tbody>tr>td {\n        padding: 0.5rem 0.5rem;\n    }\n\n    .p-treetable.p-treetable-sm .p-treetable-tfoot>tr>td {\n        padding: 0.5rem 0.5rem;\n    }\n\n    .p-treetable.p-treetable-sm .p-treetable-footer {\n        padding: 0.5rem 0.5rem;\n    }\n\n    .p-treetable.p-treetable-lg .p-treetable-header {\n        padding: 1.25rem 1.25rem;\n    }\n\n    .p-treetable.p-treetable-lg .p-treetable-thead>tr>th {\n        padding: 1.25rem 1.25rem;\n    }\n\n    .p-treetable.p-treetable-lg .p-treetable-tbody>tr>td {\n        padding: 1.25rem 1.25rem;\n    }\n\n    .p-treetable.p-treetable-lg .p-treetable-tfoot>tr>td {\n        padding: 1.25rem 1.25rem;\n    }\n\n    .p-treetable.p-treetable-lg .p-treetable-footer {\n        padding: 1.25rem 1.25rem;\n    }\n\n    .p-timeline .p-timeline-event-marker {\n        border: 0 none;\n        border-radius: 50%;\n        width: 1rem;\n        height: 1rem;\n        background-color: #007bff;\n    }\n\n    .p-timeline .p-timeline-event-connector {\n        background-color: #dee2e6;\n    }\n\n    .p-timeline.p-timeline-vertical .p-timeline-event-opposite,\n    .p-timeline.p-timeline-vertical .p-timeline-event-content {\n        padding: 0 1rem;\n    }\n\n    .p-timeline.p-timeline-vertical .p-timeline-event-connector {\n        width: 2px;\n    }\n\n    .p-timeline.p-timeline-horizontal .p-timeline-event-opposite,\n    .p-timeline.p-timeline-horizontal .p-timeline-event-content {\n        padding: 1rem 0;\n    }\n\n    .p-timeline.p-timeline-horizontal .p-timeline-event-connector {\n        height: 2px;\n    }\n\n    .p-accordion .p-accordion-header .p-accordion-header-link {\n        padding: 1rem 1.25rem;\n        border: 1px solid #dee2e6;\n        color: #212529;\n        background: #efefef;\n        font-weight: 600;\n        border-radius: 4px;\n        transition: box-shadow 0.15s;\n    }\n\n    .p-accordion .p-accordion-header .p-accordion-header-link .p-accordion-toggle-icon {\n        margin-right: 0.5rem;\n    }\n\n    .p-accordion .p-accordion-header:not(.p-disabled) .p-accordion-header-link:focus-visible {\n        outline: 0 none;\n        outline-offset: 0;\n        box-shadow: 0 0 0 0.2rem rgba(38, 143, 255, 0.5);\n    }\n\n    .p-accordion .p-accordion-header:not(.p-highlight):not(.p-disabled):hover .p-accordion-header-link {\n        background: #e9ecef;\n        border-color: #dee2e6;\n        color: #212529;\n    }\n\n    .p-accordion .p-accordion-header:not(.p-disabled).p-highlight .p-accordion-header-link {\n        background: #efefef;\n        border-color: #dee2e6;\n        color: #212529;\n        border-bottom-right-radius: 0;\n        border-bottom-left-radius: 0;\n    }\n\n    .p-accordion .p-accordion-header:not(.p-disabled).p-highlight:hover .p-accordion-header-link {\n        border-color: #dee2e6;\n        background: #e9ecef;\n        color: #212529;\n    }\n\n    .p-accordion .p-accordion-content {\n        padding: 1.25rem;\n        border: 1px solid #dee2e6;\n        background: #ffffff;\n        color: #212529;\n        border-top: 0;\n        border-top-right-radius: 0;\n        border-top-left-radius: 0;\n        border-bottom-right-radius: 4px;\n        border-bottom-left-radius: 4px;\n    }\n\n    .p-accordion .p-accordion-tab {\n        margin-bottom: 0;\n    }\n\n    .p-accordion .p-accordion-tab .p-accordion-header .p-accordion-header-link {\n        border-radius: 0;\n    }\n\n    .p-accordion .p-accordion-tab .p-accordion-content {\n        border-bottom-right-radius: 0;\n        border-bottom-left-radius: 0;\n    }\n\n    .p-accordion .p-accordion-tab:not(:first-child) .p-accordion-header .p-accordion-header-link {\n        border-top: 0 none;\n    }\n\n    .p-accordion .p-accordion-tab:not(:first-child) .p-accordion-header:not(.p-highlight):not(.p-disabled):hover .p-accordion-header-link,\n    .p-accordion .p-accordion-tab:not(:first-child) .p-accordion-header:not(.p-disabled).p-highlight:hover .p-accordion-header-link {\n        border-top: 0 none;\n    }\n\n    .p-accordion .p-accordion-tab:first-child .p-accordion-header .p-accordion-header-link {\n        border-top-right-radius: 4px;\n        border-top-left-radius: 4px;\n    }\n\n    .p-accordion .p-accordion-tab:last-child .p-accordion-header:not(.p-highlight) .p-accordion-header-link {\n        border-bottom-right-radius: 4px;\n        border-bottom-left-radius: 4px;\n    }\n\n    .p-accordion .p-accordion-tab:last-child .p-accordion-header:not(.p-highlight) .p-accordion-content {\n        border-bottom-right-radius: 4px;\n        border-bottom-left-radius: 4px;\n    }\n\n    .p-card {\n        background: #ffffff;\n        color: #212529;\n        box-shadow: 0 2px 1px -1px rgba(0, 0, 0, 0.2), 0 1px 1px 0 rgba(0, 0, 0, 0.14), 0 1px 3px 0 rgba(0, 0, 0, 0.12);\n        border-radius: 4px;\n    }\n\n    .p-card .p-card-body {\n        padding: 1.5rem;\n    }\n\n    .p-card .p-card-title {\n        font-size: 12px;\n        font-weight: 700;\n        margin-bottom: 0.5rem;\n    }\n\n    .p-card .p-card-subtitle {\n        font-weight: 400;\n        margin-bottom: 0.5rem;\n        color: #6c757d;\n    }\n\n    .p-card .p-card-content {\n        padding: 1rem 0;\n    }\n\n    .p-card .p-card-footer {\n        padding: 1rem 0 0 0;\n    }\n\n    .p-fieldset {\n        border: 1px solid #dee2e6;\n        background: #ffffff;\n        color: #212529;\n        border-radius: 4px;\n    }\n\n    .p-fieldset .p-fieldset-legend {\n        padding: 0.5rem;\n        border: 1px solid #dee2e6;\n        color: #212529;\n        background: #efefef;\n        font-weight: bold;\n        border-radius: 4px;\n        box-shadow: 0px 0px 8px 1px #c7c9cb;\n    }\n\n    .p-fieldset.p-fieldset-toggleable .p-fieldset-legend {\n        padding: 0;\n        transition: box-shadow 0.15s;\n    }\n\n    .p-fieldset.p-fieldset-toggleable .p-fieldset-legend a {\n        padding: 1rem 1.25rem;\n        color: #212529;\n        border-radius: 4px;\n        transition: box-shadow 0.15s;\n    }\n\n    .p-fieldset.p-fieldset-toggleable .p-fieldset-legend a .p-fieldset-toggler {\n        margin-right: 0.5rem;\n    }\n\n    .p-fieldset.p-fieldset-toggleable .p-fieldset-legend a:focus-visible {\n        outline: 0 none;\n        outline-offset: 0;\n        box-shadow: 0 0 0 0.2rem rgba(38, 143, 255, 0.5);\n    }\n\n    .p-fieldset.p-fieldset-toggleable .p-fieldset-legend:hover {\n        background: #e9ecef;\n        border-color: #dee2e6;\n        color: #212529;\n    }\n\n    .p-fieldset .p-fieldset-content {\n        padding: 1rem;\n    }\n\n    .p-divider .p-divider-content {\n        background-color: #ffffff;\n    }\n\n    .p-divider.p-divider-horizontal {\n        margin: 1rem 0;\n        padding: 0 1rem;\n    }\n\n    .p-divider.p-divider-horizontal:before {\n        border-top: 1px #dee2e6;\n    }\n\n    .p-divider.p-divider-horizontal .p-divider-content {\n        padding: 0 0.5rem;\n    }\n\n    .p-divider.p-divider-vertical {\n        margin: 0 1rem;\n        padding: 1rem 0;\n    }\n\n    .p-divider.p-divider-vertical:before {\n        border-left: 1px #dee2e6;\n    }\n\n    .p-divider.p-divider-vertical .p-divider-content {\n        padding: 0.5rem 0;\n    }\n\n    .p-panel .p-panel-header {\n        border: 1px solid #dee2e6;\n        padding: 1rem 1.25rem;\n        background: #efefef;\n        color: #212529;\n        border-top-right-radius: 4px;\n        border-top-left-radius: 4px;\n    }\n\n    .p-panel .p-panel-header .p-panel-title {\n        font-weight: 600;\n    }\n\n    .p-panel .p-panel-header .p-panel-header-icon {\n        width: 2rem;\n        height: 2rem;\n        color: #6c757d;\n        border: 0 none;\n        background: transparent;\n        border-radius: 50%;\n        transition: box-shadow 0.15s;\n    }\n\n    .p-panel .p-panel-header .p-panel-header-icon:enabled:hover {\n        color: #495057;\n        border-color: transparent;\n        background: transparent;\n    }\n\n    .p-panel .p-panel-header .p-panel-header-icon:focus-visible {\n        outline: 0 none;\n        outline-offset: 0;\n        box-shadow: 0 0 0 0.2rem rgba(38, 143, 255, 0.5);\n    }\n\n    .p-panel.p-panel-toggleable .p-panel-header {\n        padding: 0.5rem 1.25rem;\n    }\n\n    .p-panel .p-panel-content {\n        padding: 1.25rem;\n        border: 1px solid #dee2e6;\n        background: #ffffff;\n        color: #212529;\n        border-bottom-right-radius: 4px;\n        border-bottom-left-radius: 4px;\n        border-top: 0 none;\n    }\n\n    .p-panel .p-panel-footer {\n        padding: 0.5rem 1.25rem;\n        border: 1px solid #dee2e6;\n        background: #ffffff;\n        color: #212529;\n        border-top: 0 none;\n    }\n\n    .p-splitter {\n        border: 1px solid #dee2e6;\n        background: #ffffff;\n        border-radius: 4px;\n        color: #212529;\n    }\n\n    .p-splitter .p-splitter-gutter {\n        transition: box-shadow 0.15s;\n        background: #efefef;\n    }\n\n    .p-splitter .p-splitter-gutter .p-splitter-gutter-handle {\n        background: #dee2e6;\n    }\n\n    .p-splitter .p-splitter-gutter .p-splitter-gutter-handle:focus-visible {\n        outline: 0 none;\n        outline-offset: 0;\n        box-shadow: 0 0 0 0.2rem rgba(38, 143, 255, 0.5);\n    }\n\n    .p-splitter .p-splitter-gutter-resizing {\n        background: #dee2e6;\n    }\n\n    .p-scrollpanel .p-scrollpanel-bar {\n        background: #efefef;\n        border: 0 none;\n    }\n\n    .p-scrollpanel .p-scrollpanel-bar:focus-visible {\n        outline: 0 none;\n        outline-offset: 0;\n        box-shadow: 0 0 0 0.2rem rgba(38, 143, 255, 0.5);\n    }\n\n    .p-tabview .p-tabview-nav {\n        background: transparent;\n        /* border: 1px solid #dee2e6; */\n        border: 1px solid #cf0000;\n        border-width: 0 0 1px 0;\n    }\n\n    .p-tabview .p-tabview-nav li {\n        margin-right: 2px;\n    }\n\n    /* .p-tabview .p-tabview-nav li .p-tabview-nav-link {\n        border: solid;\n        border-width: 1px;\n        border-color: #ffffff #ffffff #dee2e6 #ffffff;\n        background: #ffffff;\n        color: #6c757d;\n        padding: 0.75rem 1rem;\n        font-weight: 600;\n        border-top-right-radius: 4px;\n        border-top-left-radius: 4px;\n        transition: box-shadow 0.15s;\n        margin: 0 0 -1px 0;\n    } */\n    .p-tabview .p-tabview-nav li .p-tabview-nav-link {\n        border: solid;\n        border-width: 1px;\n        border-color: #cf0000 #cf0000 #cf0000 #cf0000;\n        background: #cf0000;\n        color: #ffffff;\n        padding: 0.75rem 1rem;\n        font-weight: 600;\n        border-top-right-radius: 10px;\n        border-top-left-radius: 10px;\n        transition: box-shadow 0.15s;\n        margin: 0 0 -1px 0;\n        box-shadow: 0px 1px 8px -1px #dc3545;\n    }\n\n    .p-tabview .p-tabview-nav li .p-tabview-nav-link:not(.p-disabled):focus-visible {\n        outline: 0 none;\n        outline-offset: 0;\n        box-shadow: inset 0 0 0 0.2rem rgba(38, 143, 255, 0.5);\n    }\n\n    .p-tabview .p-tabview-nav li:not(.p-highlight):not(.p-disabled):hover .p-tabview-nav-link {\n        background: #ffffff;\n        border-color: #e4717c;\n        color: #e4717c;\n    }\n\n    /* .p-tabview .p-tabview-nav li.p-highlight .p-tabview-nav-link {\n        background: #ffffff;\n        border-color: #dee2e6 #dee2e6 #ffffff #dee2e6;\n        color: #495057;\n    } */\n\n    .p-tabview .p-tabview-nav li.p-highlight .p-tabview-nav-link {\n        background: #ffffff;\n        border-color: #cf0000 #cf0000 #ffffff #cf0000;\n        color: #cf0000;\n    }\n\n    .p-tabview .p-tabview-close {\n        margin-left: 0.5rem;\n    }\n\n    .p-tabview .p-tabview-nav-btn.p-link {\n        background: #ffffff;\n        color: #495057;\n        width: 2.357rem;\n        box-shadow: 0 3px 1px -2px rgba(0, 0, 0, 0.2), 0 2px 2px 0 rgba(0, 0, 0, 0.14), 0 1px 5px 0 rgba(0, 0, 0, 0.12);\n        border-radius: 0;\n    }\n\n    .p-tabview .p-tabview-nav-btn.p-link:focus-visible {\n        outline: 0 none;\n        outline-offset: 0;\n        box-shadow: inset 0 0 0 0.2rem rgba(38, 143, 255, 0.5);\n    }\n\n    .p-tabview .p-tabview-panels {\n        background: #ffffff;\n        padding: 1.25rem;\n        /* border: 1px solid #cf0000; */\n        border-left: 1px solid #cf0000;\n        border-right: 1px solid #cf0000;\n        border-bottom: 1px solid #cf0000;\n        color: #212529;\n        border-bottom-right-radius: 4px;\n        border-bottom-left-radius: 4px;\n    }\n\n    .p-toolbar {\n        background: #efefef;\n        border: 1px solid #dee2e6;\n        padding: 1rem 1.25rem;\n        border-radius: 4px;\n        gap: 0.5rem;\n    }\n\n    .p-toolbar .p-toolbar-separator {\n        margin: 0 0.5rem;\n    }\n\n    .p-confirm-popup {\n        background: #ffffff;\n        color: #212529;\n        border: 1px solid rgba(0, 0, 0, 0.2);\n        border-radius: 4px;\n        box-shadow: none;\n    }\n\n    .p-confirm-popup .p-confirm-popup-content {\n        padding: 1.25rem;\n    }\n\n    .p-confirm-popup .p-confirm-popup-footer {\n        text-align: right;\n        padding: 0 1.25rem 1.25rem 1.25rem;\n    }\n\n    .p-confirm-popup .p-confirm-popup-footer button {\n        margin: 0 0.5rem 0 0;\n        width: auto;\n    }\n\n    .p-confirm-popup .p-confirm-popup-footer button:last-child {\n        margin: 0;\n    }\n\n    .p-confirm-popup:after {\n        border: solid transparent;\n        border-color: rgba(255, 255, 255, 0);\n        border-bottom-color: #ffffff;\n    }\n\n    .p-confirm-popup:before {\n        border: solid transparent;\n        border-color: rgba(0, 0, 0, 0);\n        border-bottom-color: rgba(0, 0, 0, 0.2);\n    }\n\n    .p-confirm-popup.p-confirm-popup-flipped:after {\n        border-top-color: #ffffff;\n    }\n\n    .p-confirm-popup.p-confirm-popup-flipped:before {\n        border-top-color: rgba(0, 0, 0, 0.2);\n    }\n\n    .p-confirm-popup .p-confirm-popup-icon {\n        font-size: 1.5rem;\n    }\n\n    .p-confirm-popup .p-confirm-popup-icon.p-icon {\n        width: 1.5rem;\n        height: 1.5rem;\n    }\n\n    .p-confirm-popup .p-confirm-popup-message {\n        margin-left: 1rem;\n    }\n\n    .p-dialog {\n        border-radius: 4px;\n        box-shadow: none;\n        border: 1px solid rgba(0, 0, 0, 0.2);\n    }\n\n    .p-dialog .p-dialog-header {\n        border-bottom: 1px solid #e9ecef;\n        background: #cf0000;\n        color: #ffffff;\n        padding: 1em;\n        border-top-right-radius: 5px;\n        border-top-left-radius: 5px;\n        box-shadow: 0px 1px 8px -1px #dc3545;\n    }\n\n    .p-dialog .p-dialog-header .p-dialog-title {\n        font-weight: 400;\n        font-size: 15px;\n    }\n\n    .p-dialog .p-dialog-header .p-dialog-header-icon {\n        width: 2rem;\n        height: 2rem;\n        color: #ffffff;\n        border: 0 none;\n        background: transparent;\n        border-radius: 50%;\n        transition: box-shadow 0.15s;\n        margin-right: 0.5rem;\n    }\n\n    .p-dialog .p-dialog-header .p-dialog-header-icon:enabled:hover {\n        color: #495057;\n        border-color: transparent;\n        background: transparent;\n    }\n\n    .p-dialog .p-dialog-header .p-dialog-header-icon:focus-visible {\n        outline: 0 none;\n        outline-offset: 0;\n        box-shadow: 0 0 0 0.2rem #e4717c;\n    }\n\n    .p-dialog .p-dialog-header .p-dialog-header-icon:last-child {\n        margin-right: 0;\n    }\n\n    .p-dialog .p-dialog-content {\n        background: #ffffff;\n        color: #212529;\n        padding: 1rem;\n    }\n\n    .p-dialog .p-dialog-content:last-of-type {\n        border-bottom-right-radius: 4px;\n        border-bottom-left-radius: 4px;\n    }\n\n    .p-dialog .p-dialog-footer {\n        border-top: 1px solid #e9ecef;\n        background: #ffffff;\n        color: #212529;\n        padding: 1em;\n        text-align: right;\n        border-bottom-right-radius: 5px;\n        border-bottom-left-radius: 5px;\n    }\n\n    .p-dialog .p-dialog-footer button {\n        margin: 0 0.5rem 0 0;\n        width: auto;\n    }\n\n    .p-dialog.p-dialog-maximized .p-dialog-header,\n    .p-dialog.p-dialog-maximized .p-dialog-content:last-of-type {\n        border-radius: 0;\n    }\n\n    .p-dialog.p-confirm-dialog .p-confirm-dialog-icon {\n        font-size: 2rem;\n    }\n\n    .p-dialog.p-confirm-dialog .p-confirm-dialog-icon.p-icon {\n        width: 2rem;\n        height: 2rem;\n    }\n\n    .p-dialog.p-confirm-dialog .p-confirm-dialog-message {\n        margin-left: 1rem;\n    }\n\n    .p-overlaypanel {\n        background: #ffffff;\n        color: #212529;\n        border: 1px solid rgba(0, 0, 0, 0.2);\n        border-radius: 5px;\n        box-shadow: 0px 0px 8px 1px #c7c9cb;\n    }\n\n    .p-overlaypanel .p-overlaypanel-content {\n        padding: 1.25rem;\n    }\n\n    .p-overlaypanel .p-overlaypanel-close {\n        background: #007bff;\n        color: #ffffff;\n        width: 2rem;\n        height: 2rem;\n        transition: box-shadow 0.15s;\n        border-radius: 50%;\n        position: absolute;\n        top: -1rem;\n        right: -1rem;\n    }\n\n    .p-overlaypanel .p-overlaypanel-close:enabled:hover {\n        background: #0069d9;\n        color: #ffffff;\n    }\n\n    .p-overlaypanel:after {\n        border: solid transparent;\n        border-color: rgba(255, 255, 255, 0);\n        border-bottom-color: #ffffff;\n    }\n\n    .p-overlaypanel:before {\n        border: solid transparent;\n        border-color: rgba(0, 0, 0, 0);\n        border-bottom-color: rgba(0, 0, 0, 0.2);\n    }\n\n    .p-overlaypanel.p-overlaypanel-flipped:after {\n        border-top-color: #ffffff;\n    }\n\n    .p-overlaypanel.p-overlaypanel-flipped:before {\n        border-top-color: rgba(0, 0, 0, 0.2);\n    }\n\n    .p-sidebar {\n        background: #efefef;\n        color: #212529;\n        border: 1px solid rgba(0, 0, 0, 0.2);\n        box-shadow: none;\n    }\n\n    .p-sidebar .p-sidebar-header {\n        padding: 1rem 1.25rem;\n    }\n\n    .p-sidebar .p-sidebar-header .p-sidebar-close,\n    .p-sidebar .p-sidebar-header .p-sidebar-icon {\n        width: 2rem;\n        height: 2rem;\n        color: #6c757d;\n        border: 0 none;\n        background: transparent;\n        border-radius: 50%;\n        transition: box-shadow 0.15s;\n    }\n\n    .p-sidebar .p-sidebar-header .p-sidebar-close:enabled:hover,\n    .p-sidebar .p-sidebar-header .p-sidebar-icon:enabled:hover {\n        color: #495057;\n        border-color: transparent;\n        background: transparent;\n    }\n\n    .p-sidebar .p-sidebar-header .p-sidebar-close:focus-visible,\n    .p-sidebar .p-sidebar-header .p-sidebar-icon:focus-visible {\n        outline: 0 none;\n        outline-offset: 0;\n        box-shadow: 0 0 0 0.2rem #e4717c;\n    }\n\n    .p-sidebar .p-sidebar-header+.p-sidebar-content {\n        padding-top: 0;\n    }\n\n    .p-sidebar .p-sidebar-content {\n        padding: 1.25rem;\n    }\n\n    .p-tooltip .p-tooltip-text {\n        background: #eb4152;\n        color: #efefef;\n        /* background: #212529;\n        color: #ffffff; */\n        padding: 0.5rem 0.75rem;\n        box-shadow: 0px 1px 8px -1px #dc3545;\n        border-radius: 5px;\n    }\n\n    .p-tooltip.p-tooltip-right .p-tooltip-arrow {\n        border-right-color: #eb4152;\n    }\n\n    .p-tooltip.p-tooltip-left .p-tooltip-arrow {\n        border-left-color: #eb4152;\n    }\n\n    .p-tooltip.p-tooltip-top .p-tooltip-arrow {\n        border-top-color: #eb4152;\n    }\n\n    .p-tooltip.p-tooltip-bottom .p-tooltip-arrow {\n        border-bottom-color: #eb4152;\n    }\n\n    .p-fileupload .p-fileupload-buttonbar {\n        background: #efefef;\n        padding: 1rem 1.25rem;\n        border: 1px solid #dee2e6;\n        color: #212529;\n        border-bottom: 0 none;\n        border-top-right-radius: 4px;\n        border-top-left-radius: 4px;\n        gap: 0.5rem;\n    }\n\n    .p-fileupload .p-fileupload-buttonbar .p-button {\n        margin-right: 0.5rem;\n    }\n\n    .p-fileupload .p-fileupload-content {\n        background: #ffffff;\n        /* padding: 2rem 1rem; */\n        height: 80px;\n        border: 1px solid #dee2e6;\n        color: #212529;\n        border-bottom-right-radius: 4px;\n        border-bottom-left-radius: 4px;\n    }\n\n    .p-fileupload .p-progressbar {\n        display: none;\n        height: 0.25rem;\n    }\n\n    .p-fileupload .p-fileupload-row>div {\n        padding: 1rem 1rem;\n    }\n\n    .p-fileupload.p-fileupload-advanced .p-message {\n        margin-top: 0;\n    }\n\n    .p-breadcrumb {\n        background: #efefef;\n        border: 0 none;\n        border-radius: 4px;\n        padding: 0.5rem;\n    }\n\n    .p-breadcrumb .p-breadcrumb-list li .p-menuitem-link {\n        transition: box-shadow 0.15s;\n        border-radius: 4px;\n    }\n\n    .p-breadcrumb .p-breadcrumb-list li .p-menuitem-link:focus-visible {\n        outline: 0 none;\n        outline-offset: 0;\n        box-shadow: 0 0 0 0.2rem rgba(38, 143, 255, 0.5);\n    }\n\n    .p-breadcrumb .p-breadcrumb-list li .p-menuitem-link .p-menuitem-text {\n        color: #007bff;\n    }\n\n    .p-breadcrumb .p-breadcrumb-list li .p-menuitem-link .p-menuitem-icon {\n        color: #787a7d;\n    }\n\n    .p-breadcrumb .p-breadcrumb-list li.p-menuitem-separator {\n        margin: 0 0.5rem 0 0.5rem;\n        color: #6c757d;\n    }\n\n    .p-breadcrumb .p-breadcrumb-list li:last-child .p-menuitem-text {\n        color: #6c757d;\n    }\n\n    .p-breadcrumb .p-breadcrumb-list li:last-child .p-menuitem-icon {\n        color: #6c757d;\n    }\n\n    .p-contextmenu {\n        padding: 0.5rem 0;\n        background: #ffffff;\n        color: #212529;\n        border: 1px solid rgba(0, 0, 0, 0.15);\n        box-shadow: none;\n        border-radius: 4px;\n        width: 12.5rem;\n    }\n\n    .p-contextmenu .p-contextmenu-root-list {\n        outline: 0 none;\n    }\n\n    .p-contextmenu .p-submenu-list {\n        padding: 0.5rem 0;\n        background: #ffffff;\n        border: 1px solid rgba(0, 0, 0, 0.15);\n        box-shadow: none;\n        border-radius: 4px;\n    }\n\n    .p-contextmenu .p-menuitem>.p-menuitem-content {\n        color: #212529;\n        transition: box-shadow 0.15s;\n        border-radius: 0;\n    }\n\n    .p-contextmenu .p-menuitem>.p-menuitem-content .p-menuitem-link {\n        color: #212529;\n        padding: 0.75rem 1rem;\n        user-select: none;\n    }\n\n    .p-contextmenu .p-menuitem>.p-menuitem-content .p-menuitem-link .p-menuitem-text {\n        color: #212529;\n    }\n\n    .p-contextmenu .p-menuitem>.p-menuitem-content .p-menuitem-link .p-menuitem-icon {\n        color: #212529;\n        margin-right: 0.5rem;\n    }\n\n    .p-contextmenu .p-menuitem>.p-menuitem-content .p-menuitem-link .p-submenu-icon {\n        color: #212529;\n    }\n\n    .p-contextmenu .p-menuitem.p-highlight>.p-menuitem-content {\n        color: #212529;\n        background: #e9ecef;\n    }\n\n    .p-contextmenu .p-menuitem.p-highlight>.p-menuitem-content .p-menuitem-link .p-menuitem-text {\n        color: #212529;\n    }\n\n    .p-contextmenu .p-menuitem.p-highlight>.p-menuitem-content .p-menuitem-link .p-menuitem-icon,\n    .p-contextmenu .p-menuitem.p-highlight>.p-menuitem-content .p-menuitem-link .p-submenu-icon {\n        color: #212529;\n    }\n\n    .p-contextmenu .p-menuitem.p-highlight.p-focus>.p-menuitem-content {\n        background: #e9ecef;\n    }\n\n    .p-contextmenu .p-menuitem:not(.p-highlight):not(.p-disabled).p-focus>.p-menuitem-content {\n        color: #212529;\n        background: #dee2e6;\n    }\n\n    .p-contextmenu .p-menuitem:not(.p-highlight):not(.p-disabled).p-focus>.p-menuitem-content .p-menuitem-link .p-menuitem-text {\n        color: #212529;\n    }\n\n    .p-contextmenu .p-menuitem:not(.p-highlight):not(.p-disabled).p-focus>.p-menuitem-content .p-menuitem-link .p-menuitem-icon,\n    .p-contextmenu .p-menuitem:not(.p-highlight):not(.p-disabled).p-focus>.p-menuitem-content .p-menuitem-link .p-submenu-icon {\n        color: #212529;\n    }\n\n    .p-contextmenu .p-menuitem:not(.p-highlight):not(.p-disabled)>.p-menuitem-content:hover {\n        color: #212529;\n        background: #e9ecef;\n    }\n\n    .p-contextmenu .p-menuitem:not(.p-highlight):not(.p-disabled)>.p-menuitem-content:hover .p-menuitem-link .p-menuitem-text {\n        color: #212529;\n    }\n\n    .p-contextmenu .p-menuitem:not(.p-highlight):not(.p-disabled)>.p-menuitem-content:hover .p-menuitem-link .p-menuitem-icon,\n    .p-contextmenu .p-menuitem:not(.p-highlight):not(.p-disabled)>.p-menuitem-content:hover .p-menuitem-link .p-submenu-icon {\n        color: #212529;\n    }\n\n    .p-contextmenu .p-menuitem-separator {\n        border-top: 1px solid #dee2e6;\n        margin: 0.5rem 0;\n    }\n\n    .p-contextmenu .p-submenu-icon {\n        font-size: 0.875rem;\n    }\n\n    .p-contextmenu .p-submenu-icon.p-icon {\n        width: 0.875rem;\n        height: 0.875rem;\n    }\n\n    .p-dock .p-dock-list-container {\n        background: rgba(255, 255, 255, 0.1);\n        border: 1px solid rgba(255, 255, 255, 0.2);\n        padding: 0.5rem 0.5rem;\n        border-radius: 0.5rem;\n    }\n\n    .p-dock .p-dock-list-container .p-dock-list {\n        outline: 0 none;\n    }\n\n    .p-dock .p-dock-item {\n        padding: 0.5rem;\n        border-radius: 4px;\n    }\n\n    .p-dock .p-dock-item.p-focus {\n        outline: 0 none;\n        outline-offset: 0;\n        box-shadow: inset 0 0 0 0.15rem rgba(38, 143, 255, 0.5);\n    }\n\n    .p-dock .p-dock-action {\n        width: 4rem;\n        height: 4rem;\n    }\n\n    .p-dock.p-dock-top .p-dock-item-second-prev,\n    .p-dock.p-dock-top .p-dock-item-second-next,\n    .p-dock.p-dock-bottom .p-dock-item-second-prev,\n    .p-dock.p-dock-bottom .p-dock-item-second-next {\n        margin: 0 0.9rem;\n    }\n\n    .p-dock.p-dock-top .p-dock-item-prev,\n    .p-dock.p-dock-top .p-dock-item-next,\n    .p-dock.p-dock-bottom .p-dock-item-prev,\n    .p-dock.p-dock-bottom .p-dock-item-next {\n        margin: 0 1.3rem;\n    }\n\n    .p-dock.p-dock-top .p-dock-item-current,\n    .p-dock.p-dock-bottom .p-dock-item-current {\n        margin: 0 1.5rem;\n    }\n\n    .p-dock.p-dock-left .p-dock-item-second-prev,\n    .p-dock.p-dock-left .p-dock-item-second-next,\n    .p-dock.p-dock-right .p-dock-item-second-prev,\n    .p-dock.p-dock-right .p-dock-item-second-next {\n        margin: 0.9rem 0;\n    }\n\n    .p-dock.p-dock-left .p-dock-item-prev,\n    .p-dock.p-dock-left .p-dock-item-next,\n    .p-dock.p-dock-right .p-dock-item-prev,\n    .p-dock.p-dock-right .p-dock-item-next {\n        margin: 1.3rem 0;\n    }\n\n    .p-dock.p-dock-left .p-dock-item-current,\n    .p-dock.p-dock-right .p-dock-item-current {\n        margin: 1.5rem 0;\n    }\n\n    .p-dock.p-dock-mobile.p-dock-top .p-dock-list-container,\n    .p-dock.p-dock-mobile.p-dock-bottom .p-dock-list-container {\n        overflow-x: auto;\n        width: 100%;\n    }\n\n    .p-dock.p-dock-mobile.p-dock-top .p-dock-list-container .p-dock-list,\n    .p-dock.p-dock-mobile.p-dock-bottom .p-dock-list-container .p-dock-list {\n        margin: 0 auto;\n    }\n\n    .p-dock.p-dock-mobile.p-dock-left .p-dock-list-container,\n    .p-dock.p-dock-mobile.p-dock-right .p-dock-list-container {\n        overflow-y: auto;\n        height: 100%;\n    }\n\n    .p-dock.p-dock-mobile.p-dock-left .p-dock-list-container .p-dock-list,\n    .p-dock.p-dock-mobile.p-dock-right .p-dock-list-container .p-dock-list {\n        margin: auto 0;\n    }\n\n    .p-dock.p-dock-mobile .p-dock-list .p-dock-item {\n        transform: none;\n        margin: 0;\n    }\n\n    .p-dock.p-dock-mobile.p-dock-magnification.p-dock-top .p-dock-item-second-prev,\n    .p-dock.p-dock-mobile.p-dock-magnification.p-dock-top .p-dock-item-second-next,\n    .p-dock.p-dock-mobile.p-dock-magnification.p-dock-top .p-dock-item-prev,\n    .p-dock.p-dock-mobile.p-dock-magnification.p-dock-top .p-dock-item-next,\n    .p-dock.p-dock-mobile.p-dock-magnification.p-dock-top .p-dock-item-current,\n    .p-dock.p-dock-mobile.p-dock-magnification.p-dock-bottom .p-dock-item-second-prev,\n    .p-dock.p-dock-mobile.p-dock-magnification.p-dock-bottom .p-dock-item-second-next,\n    .p-dock.p-dock-mobile.p-dock-magnification.p-dock-bottom .p-dock-item-prev,\n    .p-dock.p-dock-mobile.p-dock-magnification.p-dock-bottom .p-dock-item-next,\n    .p-dock.p-dock-mobile.p-dock-magnification.p-dock-bottom .p-dock-item-current,\n    .p-dock.p-dock-mobile.p-dock-magnification.p-dock-left .p-dock-item-second-prev,\n    .p-dock.p-dock-mobile.p-dock-magnification.p-dock-left .p-dock-item-second-next,\n    .p-dock.p-dock-mobile.p-dock-magnification.p-dock-left .p-dock-item-prev,\n    .p-dock.p-dock-mobile.p-dock-magnification.p-dock-left .p-dock-item-next,\n    .p-dock.p-dock-mobile.p-dock-magnification.p-dock-left .p-dock-item-current,\n    .p-dock.p-dock-mobile.p-dock-magnification.p-dock-right .p-dock-item-second-prev,\n    .p-dock.p-dock-mobile.p-dock-magnification.p-dock-right .p-dock-item-second-next,\n    .p-dock.p-dock-mobile.p-dock-magnification.p-dock-right .p-dock-item-prev,\n    .p-dock.p-dock-mobile.p-dock-magnification.p-dock-right .p-dock-item-next,\n    .p-dock.p-dock-mobile.p-dock-magnification.p-dock-right .p-dock-item-current {\n        transform: none;\n        margin: 0;\n    }\n\n    .p-megamenu {\n        padding: 0.5rem 1rem;\n        background: #efefef;\n        color: rgba(0, 0, 0, 0.9);\n        border: 0 none;\n        border-radius: 4px;\n    }\n\n    .p-megamenu .p-megamenu-root-list {\n        outline: 0 none;\n    }\n\n    .p-megamenu .p-menuitem>.p-menuitem-content {\n        color: #212529;\n        transition: box-shadow 0.15s;\n        border-radius: 0;\n    }\n\n    .p-megamenu .p-menuitem>.p-menuitem-content .p-menuitem-link {\n        color: #212529;\n        padding: 0.75rem 1rem;\n        user-select: none;\n    }\n\n    .p-megamenu .p-menuitem>.p-menuitem-content .p-menuitem-link .p-menuitem-text {\n        color: #212529;\n    }\n\n    .p-megamenu .p-menuitem>.p-menuitem-content .p-menuitem-link .p-menuitem-icon {\n        color: #212529;\n        margin-right: 0.5rem;\n    }\n\n    .p-megamenu .p-menuitem>.p-menuitem-content .p-menuitem-link .p-submenu-icon {\n        color: #212529;\n    }\n\n    .p-megamenu .p-menuitem.p-highlight>.p-menuitem-content {\n        color: #212529;\n        background: #e9ecef;\n    }\n\n    .p-megamenu .p-menuitem.p-highlight>.p-menuitem-content .p-menuitem-link .p-menuitem-text {\n        color: #212529;\n    }\n\n    .p-megamenu .p-menuitem.p-highlight>.p-menuitem-content .p-menuitem-link .p-menuitem-icon,\n    .p-megamenu .p-menuitem.p-highlight>.p-menuitem-content .p-menuitem-link .p-submenu-icon {\n        color: #212529;\n    }\n\n    .p-megamenu .p-menuitem.p-highlight.p-focus>.p-menuitem-content {\n        background: #e9ecef;\n    }\n\n    .p-megamenu .p-menuitem:not(.p-highlight):not(.p-disabled).p-focus>.p-menuitem-content {\n        color: #212529;\n        background: #dee2e6;\n    }\n\n    .p-megamenu .p-menuitem:not(.p-highlight):not(.p-disabled).p-focus>.p-menuitem-content .p-menuitem-link .p-menuitem-text {\n        color: #212529;\n    }\n\n    .p-megamenu .p-menuitem:not(.p-highlight):not(.p-disabled).p-focus>.p-menuitem-content .p-menuitem-link .p-menuitem-icon,\n    .p-megamenu .p-menuitem:not(.p-highlight):not(.p-disabled).p-focus>.p-menuitem-content .p-menuitem-link .p-submenu-icon {\n        color: #212529;\n    }\n\n    .p-megamenu .p-menuitem:not(.p-highlight):not(.p-disabled)>.p-menuitem-content:hover {\n        color: #212529;\n        background: #e9ecef;\n    }\n\n    .p-megamenu .p-menuitem:not(.p-highlight):not(.p-disabled)>.p-menuitem-content:hover .p-menuitem-link .p-menuitem-text {\n        color: #212529;\n    }\n\n    .p-megamenu .p-menuitem:not(.p-highlight):not(.p-disabled)>.p-menuitem-content:hover .p-menuitem-link .p-menuitem-icon,\n    .p-megamenu .p-menuitem:not(.p-highlight):not(.p-disabled)>.p-menuitem-content:hover .p-menuitem-link .p-submenu-icon {\n        color: #212529;\n    }\n\n    .p-megamenu .p-megamenu-panel {\n        background: #ffffff;\n        color: #212529;\n        border: 1px solid rgba(0, 0, 0, 0.15);\n        box-shadow: none;\n    }\n\n    .p-megamenu .p-submenu-header {\n        margin: 0;\n        padding: 0.75rem 1rem;\n        color: #212529;\n        background: #ffffff;\n        font-weight: 600;\n        border-top-right-radius: 4px;\n        border-top-left-radius: 4px;\n    }\n\n    .p-megamenu .p-submenu-list {\n        padding: 0.5rem 0;\n        width: 12.5rem;\n    }\n\n    .p-megamenu .p-submenu-list .p-menuitem-separator {\n        border-top: 1px solid #dee2e6;\n        margin: 0.5rem 0;\n    }\n\n    .p-megamenu.p-megamenu-vertical {\n        width: 12.5rem;\n        padding: 0.5rem 0;\n    }\n\n    .p-megamenu .p-megamenu-button {\n        width: 2rem;\n        height: 2rem;\n        color: rgba(0, 0, 0, 0.5);\n        border-radius: 50%;\n        transition: box-shadow 0.15s;\n    }\n\n    .p-megamenu .p-megamenu-button:hover {\n        color: rgba(0, 0, 0, 0.7);\n        background: transparent;\n    }\n\n    .p-megamenu .p-megamenu-button:focus {\n        outline: 0 none;\n        outline-offset: 0;\n        box-shadow: 0 0 0 0.2rem rgba(38, 143, 255, 0.5);\n    }\n\n    .p-megamenu.p-megamenu-horizontal .p-megamenu-root-list>.p-menuitem>.p-menuitem-content {\n        color: rgba(0, 0, 0, 0.5);\n        transition: box-shadow 0.15s;\n        border-radius: 4px;\n    }\n\n    .p-megamenu.p-megamenu-horizontal .p-megamenu-root-list>.p-menuitem>.p-menuitem-content .p-menuitem-link {\n        padding: 1rem;\n        user-select: none;\n    }\n\n    .p-megamenu.p-megamenu-horizontal .p-megamenu-root-list>.p-menuitem>.p-menuitem-content .p-menuitem-link .p-menuitem-text {\n        color: rgba(0, 0, 0, 0.5);\n    }\n\n    .p-megamenu.p-megamenu-horizontal .p-megamenu-root-list>.p-menuitem>.p-menuitem-content .p-menuitem-link .p-menuitem-icon {\n        color: rgba(0, 0, 0, 0.5);\n        margin-right: 0.5rem;\n    }\n\n    .p-megamenu.p-megamenu-horizontal .p-megamenu-root-list>.p-menuitem>.p-menuitem-content .p-menuitem-link .p-submenu-icon {\n        color: rgba(0, 0, 0, 0.5);\n        margin-left: 0.5rem;\n    }\n\n    .p-megamenu.p-megamenu-horizontal .p-megamenu-root-list>.p-menuitem:not(.p-highlight):not(.p-disabled)>.p-menuitem-content:hover {\n        color: rgba(0, 0, 0, 0.7);\n        background: transparent;\n    }\n\n    .p-megamenu.p-megamenu-horizontal .p-megamenu-root-list>.p-menuitem:not(.p-highlight):not(.p-disabled)>.p-menuitem-content:hover .p-menuitem-link .p-menuitem-text {\n        color: rgba(0, 0, 0, 0.7);\n    }\n\n    .p-megamenu.p-megamenu-horizontal .p-megamenu-root-list>.p-menuitem:not(.p-highlight):not(.p-disabled)>.p-menuitem-content:hover .p-menuitem-link .p-menuitem-icon,\n    .p-megamenu.p-megamenu-horizontal .p-megamenu-root-list>.p-menuitem:not(.p-highlight):not(.p-disabled)>.p-menuitem-content:hover .p-menuitem-link .p-submenu-icon {\n        color: rgba(0, 0, 0, 0.7);\n    }\n\n    .p-megamenu.p-megamenu-mobile-active .p-megamenu-root-list {\n        padding: 0.5rem 0;\n        background: #ffffff;\n        border: 1px solid rgba(0, 0, 0, 0.15);\n        box-shadow: none;\n    }\n\n    .p-megamenu.p-megamenu-mobile-active .p-megamenu-root-list .p-menu-separator {\n        border-top: 1px solid #dee2e6;\n        margin: 0.5rem 0;\n    }\n\n    .p-megamenu.p-megamenu-mobile-active .p-megamenu-root-list .p-submenu-icon {\n        font-size: 0.875rem;\n    }\n\n    .p-megamenu.p-megamenu-mobile-active .p-megamenu-root-list .p-submenu-icon.p-icon {\n        width: 0.875rem;\n        height: 0.875rem;\n    }\n\n    .p-megamenu.p-megamenu-mobile-active .p-megamenu-root-list>.p-menuitem {\n        width: 100%;\n        position: static;\n    }\n\n    .p-megamenu.p-megamenu-mobile-active .p-megamenu-root-list>.p-menuitem>.p-menuitem-link>.p-menuitem-content {\n        color: #212529;\n        transition: box-shadow 0.15s;\n        border-radius: 0;\n    }\n\n    .p-megamenu.p-megamenu-mobile-active .p-megamenu-root-list>.p-menuitem>.p-menuitem-link>.p-menuitem-content .p-menuitem-link {\n        color: #212529;\n        padding: 0.75rem 1rem;\n        user-select: none;\n    }\n\n    .p-megamenu.p-megamenu-mobile-active .p-megamenu-root-list>.p-menuitem>.p-menuitem-link>.p-menuitem-content .p-menuitem-link .p-menuitem-text {\n        color: #212529;\n    }\n\n    .p-megamenu.p-megamenu-mobile-active .p-megamenu-root-list>.p-menuitem>.p-menuitem-link>.p-menuitem-content .p-menuitem-link .p-menuitem-icon {\n        color: #212529;\n        margin-right: 0.5rem;\n    }\n\n    .p-megamenu.p-megamenu-mobile-active .p-megamenu-root-list>.p-menuitem>.p-menuitem-link>.p-menuitem-content .p-menuitem-link .p-submenu-icon {\n        color: #212529;\n    }\n\n    .p-megamenu.p-megamenu-mobile-active .p-megamenu-root-list>.p-menuitem>.p-menuitem-link.p-highlight>.p-menuitem-content {\n        color: #212529;\n        background: #e9ecef;\n    }\n\n    .p-megamenu.p-megamenu-mobile-active .p-megamenu-root-list>.p-menuitem>.p-menuitem-link.p-highlight>.p-menuitem-content .p-menuitem-link .p-menuitem-text {\n        color: #212529;\n    }\n\n    .p-megamenu.p-megamenu-mobile-active .p-megamenu-root-list>.p-menuitem>.p-menuitem-link.p-highlight>.p-menuitem-content .p-menuitem-link .p-menuitem-icon,\n    .p-megamenu.p-megamenu-mobile-active .p-megamenu-root-list>.p-menuitem>.p-menuitem-link.p-highlight>.p-menuitem-content .p-menuitem-link .p-submenu-icon {\n        color: #212529;\n    }\n\n    .p-megamenu.p-megamenu-mobile-active .p-megamenu-root-list>.p-menuitem>.p-menuitem-link.p-highlight.p-focus>.p-menuitem-content {\n        background: #e9ecef;\n    }\n\n    .p-megamenu.p-megamenu-mobile-active .p-megamenu-root-list>.p-menuitem>.p-menuitem-link:not(.p-highlight):not(.p-disabled).p-focus>.p-menuitem-content {\n        color: #212529;\n        background: #dee2e6;\n    }\n\n    .p-megamenu.p-megamenu-mobile-active .p-megamenu-root-list>.p-menuitem>.p-menuitem-link:not(.p-highlight):not(.p-disabled).p-focus>.p-menuitem-content .p-menuitem-link .p-menuitem-text {\n        color: #212529;\n    }\n\n    .p-megamenu.p-megamenu-mobile-active .p-megamenu-root-list>.p-menuitem>.p-menuitem-link:not(.p-highlight):not(.p-disabled).p-focus>.p-menuitem-content .p-menuitem-link .p-menuitem-icon,\n    .p-megamenu.p-megamenu-mobile-active .p-megamenu-root-list>.p-menuitem>.p-menuitem-link:not(.p-highlight):not(.p-disabled).p-focus>.p-menuitem-content .p-menuitem-link .p-submenu-icon {\n        color: #212529;\n    }\n\n    .p-megamenu.p-megamenu-mobile-active .p-megamenu-root-list>.p-menuitem>.p-menuitem-link:not(.p-highlight):not(.p-disabled)>.p-menuitem-content:hover {\n        color: #212529;\n        background: #e9ecef;\n    }\n\n    .p-megamenu.p-megamenu-mobile-active .p-megamenu-root-list>.p-menuitem>.p-menuitem-link:not(.p-highlight):not(.p-disabled)>.p-menuitem-content:hover .p-menuitem-link .p-menuitem-text {\n        color: #212529;\n    }\n\n    .p-megamenu.p-megamenu-mobile-active .p-megamenu-root-list>.p-menuitem>.p-menuitem-link:not(.p-highlight):not(.p-disabled)>.p-menuitem-content:hover .p-menuitem-link .p-menuitem-icon,\n    .p-megamenu.p-megamenu-mobile-active .p-megamenu-root-list>.p-menuitem>.p-menuitem-link:not(.p-highlight):not(.p-disabled)>.p-menuitem-content:hover .p-menuitem-link .p-submenu-icon {\n        color: #212529;\n    }\n\n    .p-megamenu.p-megamenu-mobile-active .p-megamenu-root-list>.p-menuitem>.p-menuitem-link>.p-submenu-icon {\n        margin-left: auto;\n    }\n\n    .p-megamenu.p-megamenu-mobile-active .p-megamenu-root-list>.p-menuitem.p-menuitem-active>.p-menuitem-link>.p-submenu-icon {\n        transform: rotate(-180deg);\n    }\n\n    .p-megamenu.p-megamenu-mobile-active .p-megamenu-root-list .p-submenu-list {\n        width: 100%;\n        position: static;\n        box-shadow: none;\n        border: 0 none;\n    }\n\n    .p-megamenu.p-megamenu-mobile-active .p-megamenu-root-list .p-submenu-list .p-submenu-icon {\n        transition: transform 0.15s;\n        transform: rotate(90deg);\n    }\n\n    .p-megamenu.p-megamenu-mobile-active .p-megamenu-root-list .p-submenu-list .p-menuitem-active>.p-menuitem-link>.p-submenu-icon {\n        transform: rotate(-90deg);\n    }\n\n    .p-megamenu.p-megamenu-mobile-active .p-megamenu-root-list .p-menuitem {\n        width: 100%;\n        position: static;\n    }\n\n    .p-menu {\n        padding: 0.5rem 0;\n        background: #efefef;\n        color: #212529;\n        border: 1px solid #efefef;\n        border-radius: 4px;\n        width: 12.5rem;\n    }\n\n    .p-menu .p-menuitem>.p-menuitem-content {\n        color: #212529;\n        transition: box-shadow 0.15s;\n        border-radius: 0;\n    }\n\n    .p-menu .p-menuitem>.p-menuitem-content .p-menuitem-link {\n        color: #212529;\n        padding: 0.75rem 1rem;\n        user-select: none;\n    }\n\n    .p-menu .p-menuitem>.p-menuitem-content .p-menuitem-link .p-menuitem-text {\n        color: #212529;\n    }\n\n    .p-menu .p-menuitem>.p-menuitem-content .p-menuitem-link .p-menuitem-icon {\n        color: #212529;\n        margin-right: 0.5rem;\n    }\n\n    .p-menu .p-menuitem>.p-menuitem-content .p-menuitem-link .p-submenu-icon {\n        color: #212529;\n    }\n\n    .p-menu .p-menuitem.p-highlight>.p-menuitem-content {\n        color: #212529;\n        background: #e9ecef;\n    }\n\n    .p-menu .p-menuitem.p-highlight>.p-menuitem-content .p-menuitem-link .p-menuitem-text {\n        color: #212529;\n    }\n\n    .p-menu .p-menuitem.p-highlight>.p-menuitem-content .p-menuitem-link .p-menuitem-icon,\n    .p-menu .p-menuitem.p-highlight>.p-menuitem-content .p-menuitem-link .p-submenu-icon {\n        color: #212529;\n    }\n\n    .p-menu .p-menuitem.p-highlight.p-focus>.p-menuitem-content {\n        background: #e9ecef;\n    }\n\n    .p-menu .p-menuitem:not(.p-highlight):not(.p-disabled).p-focus>.p-menuitem-content {\n        color: #212529;\n        background: #dee2e6;\n    }\n\n    .p-menu .p-menuitem:not(.p-highlight):not(.p-disabled).p-focus>.p-menuitem-content .p-menuitem-link .p-menuitem-text {\n        color: #212529;\n    }\n\n    .p-menu .p-menuitem:not(.p-highlight):not(.p-disabled).p-focus>.p-menuitem-content .p-menuitem-link .p-menuitem-icon,\n    .p-menu .p-menuitem:not(.p-highlight):not(.p-disabled).p-focus>.p-menuitem-content .p-menuitem-link .p-submenu-icon {\n        color: #212529;\n    }\n\n    /* .p-menu .p-menuitem:not(.p-highlight):not(.p-disabled)>.p-menuitem-content:hover {\n        color: #212529;\n        background: #e9ecef;\n    } */\n    .p-menu .p-menuitem:not(.p-highlight):not(.p-disabled)>.p-menuitem-content:hover {\n        color: #212529;\n        background: #efefef;\n        box-shadow: 0px 3px 0px -1px #cf0000;\n    }\n\n    .p-menu .p-menuitem:not(.p-highlight):not(.p-disabled)>.p-menuitem-content:hover .p-menuitem-link .p-menuitem-text {\n        color: #212529;\n    }\n\n    .p-menu .p-menuitem:not(.p-highlight):not(.p-disabled)>.p-menuitem-content:hover .p-menuitem-link .p-menuitem-icon,\n    .p-menu .p-menuitem:not(.p-highlight):not(.p-disabled)>.p-menuitem-content:hover .p-menuitem-link .p-submenu-icon {\n        color: #212529;\n    }\n\n    .p-menu.p-menu-overlay {\n        background: #ffffff;\n        border: 1px solid rgba(0, 0, 0, 0.15);\n        box-shadow: none;\n    }\n\n    .p-menu .p-submenu-header {\n        margin: 0;\n        padding: 0.75rem 1rem;\n        color: #212529;\n        background: #ffffff;\n        font-weight: 600;\n        border-top-right-radius: 0;\n        border-top-left-radius: 0;\n    }\n\n    .p-menu .p-menu-separator {\n        border-top: 1px solid #dee2e6;\n        margin: 0.5rem 0;\n    }\n\n    .p-menubar {\n        padding: 0.5rem 1rem;\n        background: #efefef;\n        color: rgba(0, 0, 0, 0.9);\n        border: 0 none;\n        border-radius: 0px;\n    }\n\n    .p-menubar .p-menubar-root-list {\n        outline: 0 none;\n    }\n\n    .p-menubar .p-menubar-root-list>.p-menuitem>.p-menuitem-content {\n        color: rgba(0, 0, 0, 0.5);\n        transition: box-shadow 0.15s;\n        border-radius: 4px;\n    }\n\n    .p-menubar .p-menubar-root-list>.p-menuitem>.p-menuitem-content .p-menuitem-link {\n        padding: 1rem;\n        user-select: none;\n    }\n\n    .p-menubar .p-menubar-root-list>.p-menuitem>.p-menuitem-content .p-menuitem-link .p-menuitem-text {\n        color: rgba(0, 0, 0, 0.5);\n    }\n\n    .p-menubar .p-menubar-root-list>.p-menuitem>.p-menuitem-content .p-menuitem-link .p-menuitem-icon {\n        color: rgba(0, 0, 0, 0.5);\n        margin-right: 0.5rem;\n    }\n\n    .p-menubar .p-menubar-root-list>.p-menuitem>.p-menuitem-content .p-menuitem-link .p-submenu-icon {\n        color: rgba(0, 0, 0, 0.5);\n        margin-left: 0.5rem;\n    }\n\n    .p-menubar .p-menubar-root-list>.p-menuitem:not(.p-highlight):not(.p-disabled)>.p-menuitem-content:hover {\n        color: rgba(0, 0, 0, 0.7);\n        background: transparent;\n    }\n\n    .p-menubar .p-menubar-root-list>.p-menuitem:not(.p-highlight):not(.p-disabled)>.p-menuitem-content:hover .p-menuitem-link .p-menuitem-text {\n        color: rgba(0, 0, 0, 0.7);\n    }\n\n    .p-menubar .p-menubar-root-list>.p-menuitem:not(.p-highlight):not(.p-disabled)>.p-menuitem-content:hover .p-menuitem-link .p-menuitem-icon,\n    .p-menubar .p-menubar-root-list>.p-menuitem:not(.p-highlight):not(.p-disabled)>.p-menuitem-content:hover .p-menuitem-link .p-submenu-icon {\n        color: rgba(0, 0, 0, 0.7);\n    }\n\n    .p-menubar .p-menuitem>.p-menuitem-content {\n        color: #212529;\n        transition: box-shadow 0.15s;\n        border-radius: 0;\n    }\n\n    .p-menubar .p-menuitem>.p-menuitem-content .p-menuitem-link {\n        color: #212529;\n        padding: 0.75rem 1rem;\n        user-select: none;\n    }\n\n    .p-menubar .p-menuitem>.p-menuitem-content .p-menuitem-link .p-menuitem-text {\n        color: #212529;\n    }\n\n    .p-menubar .p-menuitem>.p-menuitem-content .p-menuitem-link .p-menuitem-icon {\n        color: #212529;\n        margin-right: 0.5rem;\n    }\n\n    .p-menubar .p-menuitem>.p-menuitem-content .p-menuitem-link .p-submenu-icon {\n        color: #212529;\n    }\n\n    .p-menubar .p-menuitem.p-highlight>.p-menuitem-content {\n        color: #212529;\n        background: #e9ecef;\n    }\n\n    .p-menubar .p-menuitem.p-highlight>.p-menuitem-content .p-menuitem-link .p-menuitem-text {\n        color: #212529;\n    }\n\n    .p-menubar .p-menuitem.p-highlight>.p-menuitem-content .p-menuitem-link .p-menuitem-icon,\n    .p-menubar .p-menuitem.p-highlight>.p-menuitem-content .p-menuitem-link .p-submenu-icon {\n        color: #212529;\n    }\n\n    .p-menubar .p-menuitem.p-highlight.p-focus>.p-menuitem-content {\n        background: #e9ecef;\n    }\n\n    .p-menubar .p-menuitem:not(.p-highlight):not(.p-disabled).p-focus>.p-menuitem-content {\n        color: #212529;\n        background: #dee2e6;\n    }\n\n    .p-menubar .p-menuitem:not(.p-highlight):not(.p-disabled).p-focus>.p-menuitem-content .p-menuitem-link .p-menuitem-text {\n        color: #212529;\n    }\n\n    .p-menubar .p-menuitem:not(.p-highlight):not(.p-disabled).p-focus>.p-menuitem-content .p-menuitem-link .p-menuitem-icon,\n    .p-menubar .p-menuitem:not(.p-highlight):not(.p-disabled).p-focus>.p-menuitem-content .p-menuitem-link .p-submenu-icon {\n        color: #212529;\n    }\n\n    .p-menubar .p-menuitem:not(.p-highlight):not(.p-disabled)>.p-menuitem-content:hover {\n        color: #212529;\n        background: #e9ecef;\n    }\n\n    .p-menubar .p-menuitem:not(.p-highlight):not(.p-disabled)>.p-menuitem-content:hover .p-menuitem-link .p-menuitem-text {\n        color: #212529;\n    }\n\n    .p-menubar .p-menuitem:not(.p-highlight):not(.p-disabled)>.p-menuitem-content:hover .p-menuitem-link .p-menuitem-icon,\n    .p-menubar .p-menuitem:not(.p-highlight):not(.p-disabled)>.p-menuitem-content:hover .p-menuitem-link .p-submenu-icon {\n        color: #212529;\n    }\n\n    .p-menubar .p-submenu-list {\n        padding: 0.5rem 0;\n        background: #ffffff;\n        border: 1px solid rgba(0, 0, 0, 0.15);\n        box-shadow: none;\n        width: 12.5rem;\n    }\n\n    .p-menubar .p-submenu-list .p-menuitem-separator {\n        border-top: 1px solid #dee2e6;\n        margin: 0.5rem 0;\n    }\n\n    .p-menubar .p-submenu-list .p-submenu-icon {\n        font-size: 0.875rem;\n    }\n\n    .p-menubar.p-menubar-mobile .p-menubar-button {\n        width: 2rem;\n        height: 2rem;\n        color: rgba(0, 0, 0, 0.5);\n        border-radius: 50%;\n        transition: box-shadow 0.15s;\n    }\n\n    .p-menubar.p-menubar-mobile .p-menubar-button:hover {\n        color: rgba(0, 0, 0, 0.7);\n        background: transparent;\n    }\n\n    .p-menubar.p-menubar-mobile .p-menubar-button:focus {\n        outline: 0 none;\n        outline-offset: 0;\n        box-shadow: 0 0 0 0.2rem rgba(38, 143, 255, 0.5);\n    }\n\n    .p-menubar.p-menubar-mobile .p-menubar-root-list {\n        padding: 0.5rem 0;\n        background: #ffffff;\n        border: 1px solid rgba(0, 0, 0, 0.15);\n        box-shadow: none;\n    }\n\n    .p-menubar.p-menubar-mobile .p-menubar-root-list .p-menuitem-separator {\n        border-top: 1px solid #dee2e6;\n        margin: 0.5rem 0;\n    }\n\n    .p-menubar.p-menubar-mobile .p-menubar-root-list .p-submenu-icon {\n        font-size: 0.875rem;\n    }\n\n    .p-menubar.p-menubar-mobile .p-menubar-root-list .p-menuitem .p-menuitem-content .p-menuitem-link .p-submenu-icon {\n        margin-left: auto;\n        transition: transform 0.15s;\n    }\n\n    .p-menubar.p-menubar-mobile .p-menubar-root-list .p-menuitem.p-menuitem-active>.p-menuitem-content>.p-menuitem-link>.p-submenu-icon {\n        transform: rotate(-180deg);\n    }\n\n    .p-menubar.p-menubar-mobile .p-menubar-root-list .p-submenu-list .p-submenu-icon {\n        transition: transform 0.15s;\n        transform: rotate(90deg);\n    }\n\n    .p-menubar.p-menubar-mobile .p-menubar-root-list .p-submenu-list .p-menuitem-active>.p-menuitem-content>.p-menuitem-link>.p-submenu-icon {\n        transform: rotate(-90deg);\n    }\n\n    .p-menubar.p-menubar-mobile .p-menubar-root-list ul li a {\n        padding-left: 2.25rem;\n    }\n\n    .p-menubar.p-menubar-mobile .p-menubar-root-list ul li ul li a {\n        padding-left: 3.75rem;\n    }\n\n    .p-menubar.p-menubar-mobile .p-menubar-root-list ul li ul li ul li a {\n        padding-left: 5.25rem;\n    }\n\n    .p-menubar.p-menubar-mobile .p-menubar-root-list ul li ul li ul li ul li a {\n        padding-left: 6.75rem;\n    }\n\n    .p-menubar.p-menubar-mobile .p-menubar-root-list ul li ul li ul li ul li ul li a {\n        padding-left: 8.25rem;\n    }\n\n    @media screen and (max-width: 960px) {\n        .p-menubar {\n            position: relative;\n        }\n\n        /* //navebar button */\n        .p-menubar .p-menubar-button {\n            display: none;\n            width: 2rem;\n            height: 2rem;\n            color: rgba(0, 0, 0, 0.5);\n            border-radius: 50%;\n            transition: box-shadow 0.15s;\n        }\n\n        .p-menubar .p-menubar-button:hover {\n            color: rgba(0, 0, 0, 0.7);\n            background: transparent;\n        }\n\n        .p-menubar .p-menubar-button:focus {\n            outline: 0 none;\n            outline-offset: 0;\n            box-shadow: 0 0 0 0.2rem rgba(38, 143, 255, 0.5);\n        }\n\n        .p-menubar .p-menubar-root-list {\n            position: absolute;\n            display: none;\n            padding: 0.5rem 0;\n            background: #ffffff;\n            border: 1px solid rgba(0, 0, 0, 0.15);\n            box-shadow: none;\n            width: 100%;\n        }\n\n        .p-menubar .p-menubar-root-list .p-menu-separator {\n            border-top: 1px solid #dee2e6;\n            margin: 0.5rem 0;\n        }\n\n        .p-menubar .p-menubar-root-list .p-submenu-icon {\n            font-size: 0.875rem;\n        }\n\n        .p-menubar .p-menubar-root-list .p-submenu-icon.p-icon {\n            width: 0.875rem;\n            height: 0.875rem;\n        }\n\n        .p-menubar .p-menubar-root-list>.p-menuitem {\n            width: 100%;\n            position: static;\n        }\n\n        .p-menubar .p-menubar-root-list>.p-menuitem>.p-menuitem-link>.p-menuitem-content {\n            color: #212529;\n            transition: box-shadow 0.15s;\n            border-radius: 0;\n        }\n\n        .p-menubar .p-menubar-root-list>.p-menuitem>.p-menuitem-link>.p-menuitem-content .p-menuitem-link {\n            color: #212529;\n            padding: 0.75rem 1rem;\n            user-select: none;\n        }\n\n        .p-menubar .p-menubar-root-list>.p-menuitem>.p-menuitem-link>.p-menuitem-content .p-menuitem-link .p-menuitem-text {\n            color: #212529;\n        }\n\n        .p-menubar .p-menubar-root-list>.p-menuitem>.p-menuitem-link>.p-menuitem-content .p-menuitem-link .p-menuitem-icon {\n            color: #212529;\n            margin-right: 0.5rem;\n        }\n\n        .p-menubar .p-menubar-root-list>.p-menuitem>.p-menuitem-link>.p-menuitem-content .p-menuitem-link .p-submenu-icon {\n            color: #212529;\n        }\n\n        .p-menubar .p-menubar-root-list>.p-menuitem>.p-menuitem-link.p-highlight>.p-menuitem-content {\n            color: #212529;\n            background: #e9ecef;\n        }\n\n        .p-menubar .p-menubar-root-list>.p-menuitem>.p-menuitem-link.p-highlight>.p-menuitem-content .p-menuitem-link .p-menuitem-text {\n            color: #212529;\n        }\n\n        .p-menubar .p-menubar-root-list>.p-menuitem>.p-menuitem-link.p-highlight>.p-menuitem-content .p-menuitem-link .p-menuitem-icon,\n        .p-menubar .p-menubar-root-list>.p-menuitem>.p-menuitem-link.p-highlight>.p-menuitem-content .p-menuitem-link .p-submenu-icon {\n            color: #212529;\n        }\n\n        .p-menubar .p-menubar-root-list>.p-menuitem>.p-menuitem-link.p-highlight.p-focus>.p-menuitem-content {\n            background: #e9ecef;\n        }\n\n        .p-menubar .p-menubar-root-list>.p-menuitem>.p-menuitem-link:not(.p-highlight):not(.p-disabled).p-focus>.p-menuitem-content {\n            color: #212529;\n            background: #dee2e6;\n        }\n\n        .p-menubar .p-menubar-root-list>.p-menuitem>.p-menuitem-link:not(.p-highlight):not(.p-disabled).p-focus>.p-menuitem-content .p-menuitem-link .p-menuitem-text {\n            color: #212529;\n        }\n\n        .p-menubar .p-menubar-root-list>.p-menuitem>.p-menuitem-link:not(.p-highlight):not(.p-disabled).p-focus>.p-menuitem-content .p-menuitem-link .p-menuitem-icon,\n        .p-menubar .p-menubar-root-list>.p-menuitem>.p-menuitem-link:not(.p-highlight):not(.p-disabled).p-focus>.p-menuitem-content .p-menuitem-link .p-submenu-icon {\n            color: #212529;\n        }\n\n        .p-menubar .p-menubar-root-list>.p-menuitem>.p-menuitem-link:not(.p-highlight):not(.p-disabled)>.p-menuitem-content:hover {\n            color: #212529;\n            background: #e9ecef;\n        }\n\n        .p-menubar .p-menubar-root-list>.p-menuitem>.p-menuitem-link:not(.p-highlight):not(.p-disabled)>.p-menuitem-content:hover .p-menuitem-link .p-menuitem-text {\n            color: #212529;\n        }\n\n        .p-menubar .p-menubar-root-list>.p-menuitem>.p-menuitem-link:not(.p-highlight):not(.p-disabled)>.p-menuitem-content:hover .p-menuitem-link .p-menuitem-icon,\n        .p-menubar .p-menubar-root-list>.p-menuitem>.p-menuitem-link:not(.p-highlight):not(.p-disabled)>.p-menuitem-content:hover .p-menuitem-link .p-submenu-icon {\n            color: #212529;\n        }\n\n        .p-menubar .p-menubar-root-list>.p-menuitem>.p-menuitem-link>.p-submenu-icon {\n            margin-left: auto;\n            transition: transform 0.15s;\n        }\n\n        .p-menubar .p-menubar-root-list>.p-menuitem.p-menuitem-active>.p-menuitem-link>.p-submenu-icon {\n            transform: rotate(-180deg);\n        }\n\n        .p-menubar .p-menubar-root-list .p-submenu-list {\n            width: 100%;\n            position: static;\n            box-shadow: none;\n            border: 0 none;\n        }\n\n        .p-menubar .p-menubar-root-list .p-submenu-list .p-submenu-icon {\n            transition: transform 0.15s;\n            transform: rotate(90deg);\n        }\n\n        .p-menubar .p-menubar-root-list .p-submenu-list .p-menuitem-active>.p-menuitem-link>.p-submenu-icon {\n            transform: rotate(-90deg);\n        }\n\n        .p-menubar .p-menubar-root-list .p-menuitem {\n            width: 100%;\n            position: static;\n        }\n\n        .p-menubar .p-menubar-root-list ul li a {\n            padding-left: 2.25rem;\n        }\n\n        .p-menubar .p-menubar-root-list ul li ul li a {\n            padding-left: 3.75rem;\n        }\n\n        .p-menubar .p-menubar-root-list ul li ul li ul li a {\n            padding-left: 5.25rem;\n        }\n\n        .p-menubar .p-menubar-root-list ul li ul li ul li ul li a {\n            padding-left: 6.75rem;\n        }\n\n        .p-menubar .p-menubar-root-list ul li ul li ul li ul li ul li a {\n            padding-left: 8.25rem;\n        }\n\n        .p-menubar.p-menubar-mobile-active .p-menubar-root-list {\n            display: flex;\n            flex-direction: column;\n            top: 100%;\n            left: 0;\n            z-index: 1;\n        }\n    }\n\n    .p-panelmenu .p-panelmenu-header {\n        outline: 0 none;\n    }\n\n    .p-panelmenu .p-panelmenu-header .p-panelmenu-header-content {\n        border: 1px solid #dee2e6;\n        color: #212529;\n        background: #efefef;\n        border-radius: 4px;\n        transition: box-shadow 0.15s;\n    }\n\n    .p-panelmenu .p-panelmenu-header .p-panelmenu-header-content .p-panelmenu-header-link {\n        color: #212529;\n        padding: 1rem 1.25rem;\n        font-weight: 600;\n    }\n\n    .p-panelmenu .p-panelmenu-header .p-panelmenu-header-content .p-panelmenu-header-link .p-submenu-icon {\n        margin-right: 0.5rem;\n    }\n\n    .p-panelmenu .p-panelmenu-header .p-panelmenu-header-content .p-panelmenu-header-link .p-menuitem-icon {\n        margin-right: 0.5rem;\n    }\n\n    .p-panelmenu .p-panelmenu-header:not(.p-disabled):focus-visible .p-panelmenu-header-content {\n        outline: 0 none;\n        outline-offset: 0;\n        box-shadow: inset 0 0 0 0.2rem rgba(38, 143, 255, 0.5);\n    }\n\n    .p-panelmenu .p-panelmenu-header:not(.p-highlight):not(.p-disabled):hover .p-panelmenu-header-content {\n        background: #e9ecef;\n        border-color: #dee2e6;\n        color: #212529;\n    }\n\n    .p-panelmenu .p-panelmenu-header:not(.p-disabled).p-highlight .p-panelmenu-header-content {\n        background: #efefef;\n        border-color: #dee2e6;\n        color: #212529;\n        border-bottom-right-radius: 0;\n        border-bottom-left-radius: 0;\n        margin-bottom: 0;\n    }\n\n    .p-panelmenu .p-panelmenu-header:not(.p-disabled).p-highlight:hover .p-panelmenu-header-content {\n        border-color: #dee2e6;\n        background: #e9ecef;\n        color: #212529;\n    }\n\n    .p-panelmenu .p-panelmenu-content {\n        padding: 0.5rem 0;\n        border: 1px solid #dee2e6;\n        background: #ffffff;\n        color: #212529;\n        border-top: 0;\n        border-top-right-radius: 0;\n        border-top-left-radius: 0;\n        border-bottom-right-radius: 4px;\n        border-bottom-left-radius: 4px;\n    }\n\n    .p-panelmenu .p-panelmenu-content .p-panelmenu-root-list {\n        outline: 0 none;\n    }\n\n    .p-panelmenu .p-panelmenu-content .p-menuitem>.p-menuitem-content {\n        color: #212529;\n        transition: box-shadow 0.15s;\n        border-radius: 0;\n    }\n\n    .p-panelmenu .p-panelmenu-content .p-menuitem>.p-menuitem-content .p-menuitem-link {\n        color: #212529;\n        padding: 0.75rem 1rem;\n        user-select: none;\n    }\n\n    .p-panelmenu .p-panelmenu-content .p-menuitem>.p-menuitem-content .p-menuitem-link .p-menuitem-text {\n        color: #212529;\n    }\n\n    .p-panelmenu .p-panelmenu-content .p-menuitem>.p-menuitem-content .p-menuitem-link .p-menuitem-icon {\n        color: #212529;\n        margin-right: 0.5rem;\n    }\n\n    .p-panelmenu .p-panelmenu-content .p-menuitem>.p-menuitem-content .p-menuitem-link .p-submenu-icon {\n        color: #212529;\n    }\n\n    .p-panelmenu .p-panelmenu-content .p-menuitem.p-highlight>.p-menuitem-content {\n        color: #212529;\n        background: #e9ecef;\n    }\n\n    .p-panelmenu .p-panelmenu-content .p-menuitem.p-highlight>.p-menuitem-content .p-menuitem-link .p-menuitem-text {\n        color: #212529;\n    }\n\n    .p-panelmenu .p-panelmenu-content .p-menuitem.p-highlight>.p-menuitem-content .p-menuitem-link .p-menuitem-icon,\n    .p-panelmenu .p-panelmenu-content .p-menuitem.p-highlight>.p-menuitem-content .p-menuitem-link .p-submenu-icon {\n        color: #212529;\n    }\n\n    .p-panelmenu .p-panelmenu-content .p-menuitem.p-highlight.p-focus>.p-menuitem-content {\n        background: #e9ecef;\n    }\n\n    .p-panelmenu .p-panelmenu-content .p-menuitem:not(.p-highlight):not(.p-disabled).p-focus>.p-menuitem-content {\n        color: #212529;\n        background: #dee2e6;\n    }\n\n    .p-panelmenu .p-panelmenu-content .p-menuitem:not(.p-highlight):not(.p-disabled).p-focus>.p-menuitem-content .p-menuitem-link .p-menuitem-text {\n        color: #212529;\n    }\n\n    .p-panelmenu .p-panelmenu-content .p-menuitem:not(.p-highlight):not(.p-disabled).p-focus>.p-menuitem-content .p-menuitem-link .p-menuitem-icon,\n    .p-panelmenu .p-panelmenu-content .p-menuitem:not(.p-highlight):not(.p-disabled).p-focus>.p-menuitem-content .p-menuitem-link .p-submenu-icon {\n        color: #212529;\n    }\n\n    .p-panelmenu .p-panelmenu-content .p-menuitem:not(.p-highlight):not(.p-disabled)>.p-menuitem-content:hover {\n        color: #212529;\n        background: #e9ecef;\n    }\n\n    .p-panelmenu .p-panelmenu-content .p-menuitem:not(.p-highlight):not(.p-disabled)>.p-menuitem-content:hover .p-menuitem-link .p-menuitem-text {\n        color: #212529;\n    }\n\n    .p-panelmenu .p-panelmenu-content .p-menuitem:not(.p-highlight):not(.p-disabled)>.p-menuitem-content:hover .p-menuitem-link .p-menuitem-icon,\n    .p-panelmenu .p-panelmenu-content .p-menuitem:not(.p-highlight):not(.p-disabled)>.p-menuitem-content:hover .p-menuitem-link .p-submenu-icon {\n        color: #212529;\n    }\n\n    .p-panelmenu .p-panelmenu-content .p-menuitem .p-menuitem-content .p-menuitem-link .p-submenu-icon {\n        margin-right: 0.5rem;\n    }\n\n    .p-panelmenu .p-panelmenu-content .p-menuitem-separator {\n        border-top: 1px solid #dee2e6;\n        margin: 0.5rem 0;\n    }\n\n    .p-panelmenu .p-panelmenu-content .p-submenu-list:not(.p-panelmenu-root-list) {\n        padding: 0 0 0 1rem;\n    }\n\n    .p-panelmenu .p-panelmenu-panel {\n        margin-bottom: 0;\n    }\n\n    .p-panelmenu .p-panelmenu-panel .p-panelmenu-header .p-panelmenu-header-content {\n        border-radius: 0;\n    }\n\n    .p-panelmenu .p-panelmenu-panel .p-panelmenu-content {\n        border-radius: 0;\n    }\n\n    .p-panelmenu .p-panelmenu-panel:not(:first-child) .p-panelmenu-header .p-panelmenu-header-content {\n        border-top: 0 none;\n    }\n\n    .p-panelmenu .p-panelmenu-panel:not(:first-child) .p-panelmenu-header:not(.p-highlight):not(.p-disabled):hover .p-panelmenu-header-content,\n    .p-panelmenu .p-panelmenu-panel:not(:first-child) .p-panelmenu-header:not(.p-disabled).p-highlight:hover .p-panelmenu-header-content {\n        border-top: 0 none;\n    }\n\n    .p-panelmenu .p-panelmenu-panel:first-child .p-panelmenu-header .p-panelmenu-header-content {\n        border-top-right-radius: 4px;\n        border-top-left-radius: 4px;\n    }\n\n    .p-panelmenu .p-panelmenu-panel:last-child .p-panelmenu-header:not(.p-highlight) .p-panelmenu-header-content {\n        border-bottom-right-radius: 4px;\n        border-bottom-left-radius: 4px;\n    }\n\n    .p-panelmenu .p-panelmenu-panel:last-child .p-panelmenu-content {\n        border-bottom-right-radius: 4px;\n        border-bottom-left-radius: 4px;\n    }\n\n    .p-slidemenu {\n        padding: 0.5rem 0;\n        background: #ffffff;\n        color: #212529;\n        border: 1px solid #dee2e6;\n        border-radius: 4px;\n        width: 12.5rem;\n    }\n\n    .p-slidemenu .p-menuitem-link>.p-menuitem-content {\n        color: #212529;\n        transition: box-shadow 0.15s;\n        border-radius: 0;\n    }\n\n    .p-slidemenu .p-menuitem-link>.p-menuitem-content .p-menuitem-link {\n        color: #212529;\n        padding: 0.75rem 1rem;\n        user-select: none;\n    }\n\n    .p-slidemenu .p-menuitem-link>.p-menuitem-content .p-menuitem-link .p-menuitem-text {\n        color: #212529;\n    }\n\n    .p-slidemenu .p-menuitem-link>.p-menuitem-content .p-menuitem-link .p-menuitem-icon {\n        color: #212529;\n        margin-right: 0.5rem;\n    }\n\n    .p-slidemenu .p-menuitem-link>.p-menuitem-content .p-menuitem-link .p-submenu-icon {\n        color: #212529;\n    }\n\n    .p-slidemenu .p-menuitem-link.p-highlight>.p-menuitem-content {\n        color: #212529;\n        background: #e9ecef;\n    }\n\n    .p-slidemenu .p-menuitem-link.p-highlight>.p-menuitem-content .p-menuitem-link .p-menuitem-text {\n        color: #212529;\n    }\n\n    .p-slidemenu .p-menuitem-link.p-highlight>.p-menuitem-content .p-menuitem-link .p-menuitem-icon,\n    .p-slidemenu .p-menuitem-link.p-highlight>.p-menuitem-content .p-menuitem-link .p-submenu-icon {\n        color: #212529;\n    }\n\n    .p-slidemenu .p-menuitem-link.p-highlight.p-focus>.p-menuitem-content {\n        background: #e9ecef;\n    }\n\n    .p-slidemenu .p-menuitem-link:not(.p-highlight):not(.p-disabled).p-focus>.p-menuitem-content {\n        color: #212529;\n        background: #dee2e6;\n    }\n\n    .p-slidemenu .p-menuitem-link:not(.p-highlight):not(.p-disabled).p-focus>.p-menuitem-content .p-menuitem-link .p-menuitem-text {\n        color: #212529;\n    }\n\n    .p-slidemenu .p-menuitem-link:not(.p-highlight):not(.p-disabled).p-focus>.p-menuitem-content .p-menuitem-link .p-menuitem-icon,\n    .p-slidemenu .p-menuitem-link:not(.p-highlight):not(.p-disabled).p-focus>.p-menuitem-content .p-menuitem-link .p-submenu-icon {\n        color: #212529;\n    }\n\n    .p-slidemenu .p-menuitem-link:not(.p-highlight):not(.p-disabled)>.p-menuitem-content:hover {\n        color: #212529;\n        background: #e9ecef;\n    }\n\n    .p-slidemenu .p-menuitem-link:not(.p-highlight):not(.p-disabled)>.p-menuitem-content:hover .p-menuitem-link .p-menuitem-text {\n        color: #212529;\n    }\n\n    .p-slidemenu .p-menuitem-link:not(.p-highlight):not(.p-disabled)>.p-menuitem-content:hover .p-menuitem-link .p-menuitem-icon,\n    .p-slidemenu .p-menuitem-link:not(.p-highlight):not(.p-disabled)>.p-menuitem-content:hover .p-menuitem-link .p-submenu-icon {\n        color: #212529;\n    }\n\n    .p-slidemenu.p-slidemenu-overlay {\n        background: #ffffff;\n        border: 1px solid rgba(0, 0, 0, 0.15);\n        box-shadow: none;\n    }\n\n    .p-slidemenu .p-slidemenu-list {\n        padding: 0.5rem 0;\n        background: #ffffff;\n        border: 1px solid rgba(0, 0, 0, 0.15);\n        box-shadow: none;\n    }\n\n    .p-slidemenu .p-slidemenu.p-slidemenu-active>.p-slidemenu-link {\n        background: #e9ecef;\n    }\n\n    .p-slidemenu .p-slidemenu.p-slidemenu-active>.p-slidemenu-link .p-slidemenu-text {\n        color: #212529;\n    }\n\n    .p-slidemenu .p-slidemenu.p-slidemenu-active>.p-slidemenu-link .p-slidemenu-icon,\n    .p-slidemenu .p-slidemenu.p-slidemenu-active>.p-slidemenu-link .p-slidemenu-icon {\n        color: #212529;\n    }\n\n    .p-slidemenu .p-slidemenu-separator {\n        border-top: 1px solid #dee2e6;\n        margin: 0.5rem 0;\n    }\n\n    .p-slidemenu .p-slidemenu-icon {\n        font-size: 0.875rem;\n    }\n\n    .p-slidemenu .p-slidemenu-icon.p-icon {\n        width: 0.875rem;\n        height: 0.875rem;\n    }\n\n    .p-slidemenu .p-slidemenu-backward {\n        padding: 0.75rem 1rem;\n        color: #212529;\n    }\n\n    .p-steps .p-steps-item .p-menuitem-link {\n        background: transparent;\n        transition: box-shadow 0.15s;\n        border-radius: 4px;\n        background: transparent;\n    }\n\n    .p-steps .p-steps-item .p-menuitem-link .p-steps-number {\n        color: #212529;\n        border: 1px solid #dee2e6;\n        background: transparent;\n        min-width: 2rem;\n        height: 2rem;\n        line-height: 2rem;\n        font-size: 12px;\n        z-index: 1;\n        border-radius: 4px;\n    }\n\n    .p-steps .p-steps-item .p-menuitem-link .p-steps-title {\n        margin-top: 0.5rem;\n        color: #6c757d;\n    }\n\n    .p-steps .p-steps-item .p-menuitem-link:not(.p-disabled):focus-visible {\n        outline: 0 none;\n        outline-offset: 0;\n        box-shadow: 0 0 0 0.2rem rgba(38, 143, 255, 0.5);\n    }\n\n    .p-steps .p-steps-item.p-highlight .p-steps-number {\n        background: #007bff;\n        color: #ffffff;\n    }\n\n    .p-steps .p-steps-item.p-highlight .p-steps-title {\n        font-weight: 600;\n        color: #212529;\n    }\n\n    .p-steps .p-steps-item:before {\n        content: \" \";\n        border-top: 1px solid #dee2e6;\n        width: 100%;\n        top: 50%;\n        left: 0;\n        display: block;\n        position: absolute;\n        margin-top: -1rem;\n    }\n\n    .p-tabmenu .p-tabmenu-nav {\n        background: transparent;\n        border: 1px solid #dee2e6;\n        border-width: 0 0 1px 0;\n    }\n\n    .p-tabmenu .p-tabmenu-nav .p-tabmenuitem {\n        margin-right: 0;\n    }\n\n    .p-tabmenu .p-tabmenu-nav .p-tabmenuitem .p-menuitem-link {\n        border: solid;\n        border-width: 1px;\n        border-color: #ffffff #ffffff #dee2e6 #ffffff;\n        background: #ffffff;\n        color: #6c757d;\n        padding: 0.75rem 1rem;\n        font-weight: 600;\n        border-top-right-radius: 4px;\n        border-top-left-radius: 4px;\n        transition: box-shadow 0.15s;\n        margin: 0 0 -1px 0;\n        height: calc(100% + 1px);\n    }\n\n    .p-tabmenu .p-tabmenu-nav .p-tabmenuitem .p-menuitem-link .p-menuitem-icon {\n        margin-right: 0.5rem;\n    }\n\n    .p-tabmenu .p-tabmenu-nav .p-tabmenuitem .p-menuitem-link:not(.p-disabled):focus-visible {\n        outline: 0 none;\n        outline-offset: 0;\n        box-shadow: inset 0 0 0 0.2rem rgba(38, 143, 255, 0.5);\n    }\n\n    .p-tabmenu .p-tabmenu-nav .p-tabmenuitem:not(.p-highlight):not(.p-disabled):hover .p-menuitem-link {\n        background: #ffffff;\n        border-color: #dee2e6;\n        color: #6c757d;\n    }\n\n    .p-tabmenu .p-tabmenu-nav .p-tabmenuitem.p-highlight .p-menuitem-link {\n        background: #ffffff;\n        border-color: #dee2e6 #dee2e6 #ffffff #dee2e6;\n        color: #495057;\n    }\n\n    .p-tieredmenu {\n        padding: 0.5rem 0;\n        background: #ffffff;\n        color: #212529;\n        border: 1px solid #dee2e6;\n        border-radius: 4px;\n        width: 12.5rem;\n    }\n\n    .p-tieredmenu.p-tieredmenu-overlay {\n        background: #ffffff;\n        border: 1px solid rgba(0, 0, 0, 0.15);\n        box-shadow: none;\n    }\n\n    .p-tieredmenu .p-tieredmenu-root-list {\n        outline: 0 none;\n    }\n\n    .p-tieredmenu .p-submenu-list {\n        padding: 0.5rem 0;\n        background: #ffffff;\n        border: 1px solid rgba(0, 0, 0, 0.15);\n        box-shadow: none;\n    }\n\n    .p-tieredmenu .p-menuitem>.p-menuitem-content {\n        color: #212529;\n        transition: box-shadow 0.15s;\n        border-radius: 0;\n    }\n\n    .p-tieredmenu .p-menuitem>.p-menuitem-content .p-menuitem-link {\n        color: #212529;\n        padding: 0.75rem 1rem;\n        user-select: none;\n    }\n\n    .p-tieredmenu .p-menuitem>.p-menuitem-content .p-menuitem-link .p-menuitem-text {\n        color: #212529;\n    }\n\n    .p-tieredmenu .p-menuitem>.p-menuitem-content .p-menuitem-link .p-menuitem-icon {\n        color: #212529;\n        margin-right: 0.5rem;\n    }\n\n    .p-tieredmenu .p-menuitem>.p-menuitem-content .p-menuitem-link .p-submenu-icon {\n        color: #212529;\n    }\n\n    .p-tieredmenu .p-menuitem.p-highlight>.p-menuitem-content {\n        color: #212529;\n        background: #e9ecef;\n    }\n\n    .p-tieredmenu .p-menuitem.p-highlight>.p-menuitem-content .p-menuitem-link .p-menuitem-text {\n        color: #212529;\n    }\n\n    .p-tieredmenu .p-menuitem.p-highlight>.p-menuitem-content .p-menuitem-link .p-menuitem-icon,\n    .p-tieredmenu .p-menuitem.p-highlight>.p-menuitem-content .p-menuitem-link .p-submenu-icon {\n        color: #212529;\n    }\n\n    .p-tieredmenu .p-menuitem.p-highlight.p-focus>.p-menuitem-content {\n        background: #e9ecef;\n    }\n\n    .p-tieredmenu .p-menuitem:not(.p-highlight):not(.p-disabled).p-focus>.p-menuitem-content {\n        color: #212529;\n        background: #dee2e6;\n    }\n\n    .p-tieredmenu .p-menuitem:not(.p-highlight):not(.p-disabled).p-focus>.p-menuitem-content .p-menuitem-link .p-menuitem-text {\n        color: #212529;\n    }\n\n    .p-tieredmenu .p-menuitem:not(.p-highlight):not(.p-disabled).p-focus>.p-menuitem-content .p-menuitem-link .p-menuitem-icon,\n    .p-tieredmenu .p-menuitem:not(.p-highlight):not(.p-disabled).p-focus>.p-menuitem-content .p-menuitem-link .p-submenu-icon {\n        color: #212529;\n    }\n\n    .p-tieredmenu .p-menuitem:not(.p-highlight):not(.p-disabled)>.p-menuitem-content:hover {\n        color: #212529;\n        background: #e9ecef;\n    }\n\n    .p-tieredmenu .p-menuitem:not(.p-highlight):not(.p-disabled)>.p-menuitem-content:hover .p-menuitem-link .p-menuitem-text {\n        color: #212529;\n    }\n\n    .p-tieredmenu .p-menuitem:not(.p-highlight):not(.p-disabled)>.p-menuitem-content:hover .p-menuitem-link .p-menuitem-icon,\n    .p-tieredmenu .p-menuitem:not(.p-highlight):not(.p-disabled)>.p-menuitem-content:hover .p-menuitem-link .p-submenu-icon {\n        color: #212529;\n    }\n\n    .p-tieredmenu .p-menuitem-separator {\n        border-top: 1px solid #dee2e6;\n        margin: 0.5rem 0;\n    }\n\n    .p-tieredmenu .p-submenu-icon {\n        font-size: 0.875rem;\n    }\n\n    .p-tieredmenu .p-submenu-icon.p-icon {\n        width: 0.875rem;\n        height: 0.875rem;\n    }\n\n    .p-inline-message {\n        padding: 0.5rem 0.75rem;\n        margin: 0;\n        border-radius: 4px;\n    }\n\n    .p-inline-message.p-inline-message-info {\n        background: #cce5ff;\n        border: solid #b8daff;\n        border-width: 0px;\n        color: #004085;\n    }\n\n    .p-inline-message.p-inline-message-info .p-inline-message-icon {\n        color: #004085;\n    }\n\n    .p-inline-message.p-inline-message-success {\n        background: #d4edda;\n        border: solid #c3e6cb;\n        border-width: 0px;\n        color: #155724;\n    }\n\n    .p-inline-message.p-inline-message-success .p-inline-message-icon {\n        color: #155724;\n    }\n\n    .p-inline-message.p-inline-message-warn {\n        background: #fff3cd;\n        border: solid #ffeeba;\n        border-width: 0px;\n        color: #856404;\n    }\n\n    .p-inline-message.p-inline-message-warn .p-inline-message-icon {\n        color: #856404;\n    }\n\n    .p-inline-message.p-inline-message-error {\n        background: #f8d7da;\n        border: solid #f5c6cb;\n        border-width: 0px;\n        color: #721c24;\n    }\n\n    .p-inline-message.p-inline-message-error .p-inline-message-icon {\n        color: #721c24;\n    }\n\n    .p-inline-message .p-inline-message-icon {\n        font-size: 1rem;\n        margin-right: 0.5rem;\n    }\n\n    .p-inline-message .p-inline-message-icon.p-icon {\n        width: 1rem;\n        height: 1rem;\n    }\n\n    .p-inline-message .p-inline-message-text {\n        font-size: 12px;\n    }\n\n    .p-inline-message.p-inline-message-icon-only .p-inline-message-icon {\n        margin-right: 0;\n    }\n\n    .p-message {\n        margin: 1rem 0;\n        border-radius: 4px;\n    }\n\n    .p-message .p-message-wrapper {\n        padding: 1rem 1.25rem;\n    }\n\n    .p-message .p-message-close {\n        width: 2rem;\n        height: 2rem;\n        border-radius: 50%;\n        background: transparent;\n        transition: box-shadow 0.15s;\n    }\n\n    .p-message .p-message-close:hover {\n        background: rgba(255, 255, 255, 0.5);\n    }\n\n    .p-message .p-message-close:focus-visible {\n        outline: 0 none;\n        outline-offset: 0;\n        box-shadow: 0 0 0 0.2rem rgba(38, 143, 255, 0.5);\n    }\n\n    .p-message.p-message-info {\n        background: #cce5ff;\n        border: solid #b8daff;\n        border-width: 1px;\n        color: #004085;\n    }\n\n    .p-message.p-message-info .p-message-icon {\n        color: #004085;\n    }\n\n    .p-message.p-message-info .p-message-close {\n        color: #004085;\n    }\n\n    .p-message.p-message-success {\n        background: #d4edda;\n        border: solid #c3e6cb;\n        border-width: 1px;\n        color: #155724;\n    }\n\n    .p-message.p-message-success .p-message-icon {\n        color: #155724;\n    }\n\n    .p-message.p-message-success .p-message-close {\n        color: #155724;\n    }\n\n    .p-message.p-message-warn {\n        background: #fff3cd;\n        border: solid #ffeeba;\n        border-width: 1px;\n        color: #856404;\n    }\n\n    .p-message.p-message-warn .p-message-icon {\n        color: #856404;\n    }\n\n    .p-message.p-message-warn .p-message-close {\n        color: #856404;\n    }\n\n    .p-message.p-message-error {\n        background: #f8d7da;\n        border: solid #f5c6cb;\n        border-width: 1px;\n        color: #721c24;\n    }\n\n    .p-message.p-message-error .p-message-icon {\n        color: #721c24;\n    }\n\n    .p-message.p-message-error .p-message-close {\n        color: #721c24;\n    }\n\n    .p-message .p-message-text {\n        font-size: 12px;\n        font-weight: 500;\n    }\n\n    .p-message .p-message-icon {\n        font-size: 1.5rem;\n        margin-right: 0.5rem;\n    }\n\n    .p-message .p-message-icon.p-icon {\n        width: 1.5rem;\n        height: 1.5rem;\n    }\n\n    .p-message .p-message-summary {\n        font-weight: 700;\n    }\n\n    .p-message .p-message-detail {\n        margin-left: 0.5rem;\n    }\n\n    .p-toast {\n        opacity: 1;\n    }\n\n    .p-toast .p-toast-message {\n        margin: 0 0 1rem 0;\n        box-shadow: 0 0.25rem 0.75rem rgba(0, 0, 0, 0.1);\n        border-radius: 4px;\n    }\n\n    .p-toast .p-toast-message .p-toast-message-content {\n        padding: 1rem;\n        border-width: 0;\n    }\n\n    .p-toast .p-toast-message .p-toast-message-content .p-toast-message-text {\n        margin: 0 0 0 1rem;\n    }\n\n    .p-toast .p-toast-message .p-toast-message-content .p-toast-message-icon {\n        font-size: 2rem;\n    }\n\n    .p-toast .p-toast-message .p-toast-message-content .p-toast-message-icon.p-icon {\n        width: 2rem;\n        height: 2rem;\n    }\n\n    .p-toast .p-toast-message .p-toast-message-content .p-toast-summary {\n        font-weight: 700;\n    }\n\n    .p-toast .p-toast-message .p-toast-message-content .p-toast-detail {\n        margin: 0.5rem 0 0 0;\n    }\n\n    .p-toast .p-toast-message .p-toast-icon-close {\n        width: 2rem;\n        height: 2rem;\n        border-radius: 50%;\n        background: transparent;\n        transition: box-shadow 0.15s;\n    }\n\n    .p-toast .p-toast-message .p-toast-icon-close:hover {\n        background: rgba(255, 255, 255, 0.5);\n    }\n\n    .p-toast .p-toast-message .p-toast-icon-close:focus-visible {\n        outline: 0 none;\n        outline-offset: 0;\n        box-shadow: 0 0 0 0.2rem rgba(38, 143, 255, 0.5);\n    }\n\n    .p-toast .p-toast-message.p-toast-message-info {\n        background: #cce5ff;\n        border: solid #b8daff;\n        border-width: 1px;\n        color: #004085;\n    }\n\n    .p-toast .p-toast-message.p-toast-message-info .p-toast-message-icon,\n    .p-toast .p-toast-message.p-toast-message-info .p-toast-icon-close {\n        color: #004085;\n    }\n\n    .p-toast .p-toast-message.p-toast-message-success {\n        background: #d4edda;\n        border: solid #c3e6cb;\n        border-width: 1px;\n        color: #155724;\n    }\n\n    .p-toast .p-toast-message.p-toast-message-success .p-toast-message-icon,\n    .p-toast .p-toast-message.p-toast-message-success .p-toast-icon-close {\n        color: #155724;\n    }\n\n    .p-toast .p-toast-message.p-toast-message-warn {\n        background: #fff3cd;\n        border: solid #ffeeba;\n        border-width: 1px;\n        color: #856404;\n    }\n\n    .p-toast .p-toast-message.p-toast-message-warn .p-toast-message-icon,\n    .p-toast .p-toast-message.p-toast-message-warn .p-toast-icon-close {\n        color: #856404;\n    }\n\n    .p-toast .p-toast-message.p-toast-message-error {\n        background: #f8d7da;\n        border: solid #f5c6cb;\n        border-width: 1px;\n        color: #721c24;\n    }\n\n    .p-toast .p-toast-message.p-toast-message-error .p-toast-message-icon,\n    .p-toast .p-toast-message.p-toast-message-error .p-toast-icon-close {\n        color: #721c24;\n    }\n\n    .p-galleria .p-galleria-close {\n        margin: 0.5rem;\n        background: transparent;\n        color: #efefef;\n        width: 4rem;\n        height: 4rem;\n        transition: box-shadow 0.15s;\n        border-radius: 4px;\n    }\n\n    .p-galleria .p-galleria-close .p-galleria-close-icon {\n        font-size: 2rem;\n    }\n\n    .p-galleria .p-galleria-close .p-galleria-close-icon.p-icon {\n        width: 2rem;\n        height: 2rem;\n    }\n\n    .p-galleria .p-galleria-close:hover {\n        background: rgba(255, 255, 255, 0.1);\n        color: #efefef;\n    }\n\n    .p-galleria .p-galleria-item-nav {\n        background: transparent;\n        color: #efefef;\n        width: 4rem;\n        height: 4rem;\n        transition: box-shadow 0.15s;\n        border-radius: 4px;\n        margin: 0 0.5rem;\n    }\n\n    .p-galleria .p-galleria-item-nav .p-galleria-item-prev-icon,\n    .p-galleria .p-galleria-item-nav .p-galleria-item-next-icon {\n        font-size: 2rem;\n    }\n\n    .p-galleria .p-galleria-item-nav .p-galleria-item-prev-icon.p-icon,\n    .p-galleria .p-galleria-item-nav .p-galleria-item-next-icon.p-icon {\n        width: 2rem;\n        height: 2rem;\n    }\n\n    .p-galleria .p-galleria-item-nav:not(.p-disabled):hover {\n        background: rgba(255, 255, 255, 0.1);\n        color: #efefef;\n    }\n\n    .p-galleria .p-galleria-caption {\n        background: rgba(0, 0, 0, 0.5);\n        color: #efefef;\n        padding: 1rem;\n    }\n\n    .p-galleria .p-galleria-indicators {\n        padding: 1rem;\n    }\n\n    .p-galleria .p-galleria-indicators .p-galleria-indicator button {\n        background-color: #e9ecef;\n        width: 1rem;\n        height: 1rem;\n        transition: box-shadow 0.15s;\n        border-radius: 4px;\n    }\n\n    .p-galleria .p-galleria-indicators .p-galleria-indicator button:hover {\n        background: #dee2e6;\n    }\n\n    .p-galleria .p-galleria-indicators .p-galleria-indicator.p-highlight button {\n        background: #007bff;\n        color: #ffffff;\n    }\n\n    .p-galleria.p-galleria-indicators-bottom .p-galleria-indicator,\n    .p-galleria.p-galleria-indicators-top .p-galleria-indicator {\n        margin-right: 0.5rem;\n    }\n\n    .p-galleria.p-galleria-indicators-left .p-galleria-indicator,\n    .p-galleria.p-galleria-indicators-right .p-galleria-indicator {\n        margin-bottom: 0.5rem;\n    }\n\n    .p-galleria.p-galleria-indicator-onitem .p-galleria-indicators {\n        background: rgba(0, 0, 0, 0.5);\n    }\n\n    .p-galleria.p-galleria-indicator-onitem .p-galleria-indicators .p-galleria-indicator button {\n        background: rgba(255, 255, 255, 0.4);\n    }\n\n    .p-galleria.p-galleria-indicator-onitem .p-galleria-indicators .p-galleria-indicator button:hover {\n        background: rgba(255, 255, 255, 0.6);\n    }\n\n    .p-galleria.p-galleria-indicator-onitem .p-galleria-indicators .p-galleria-indicator.p-highlight button {\n        background: #007bff;\n        color: #ffffff;\n    }\n\n    .p-galleria .p-galleria-thumbnail-container {\n        background: rgba(0, 0, 0, 0.9);\n        padding: 1rem 0.25rem;\n    }\n\n    .p-galleria .p-galleria-thumbnail-container .p-galleria-thumbnail-prev,\n    .p-galleria .p-galleria-thumbnail-container .p-galleria-thumbnail-next {\n        margin: 0.5rem;\n        background-color: transparent;\n        color: #efefef;\n        width: 2rem;\n        height: 2rem;\n        transition: box-shadow 0.15s;\n        border-radius: 4px;\n    }\n\n    .p-galleria .p-galleria-thumbnail-container .p-galleria-thumbnail-prev:hover,\n    .p-galleria .p-galleria-thumbnail-container .p-galleria-thumbnail-next:hover {\n        background: rgba(255, 255, 255, 0.1);\n        color: #efefef;\n    }\n\n    .p-galleria .p-galleria-thumbnail-container .p-galleria-thumbnail-item-content {\n        transition: box-shadow 0.15s;\n    }\n\n    .p-galleria .p-galleria-thumbnail-container .p-galleria-thumbnail-item-content:focus-visible {\n        outline: 0 none;\n        outline-offset: 0;\n        box-shadow: 0 0 0 0.2rem rgba(38, 143, 255, 0.5);\n    }\n\n    .p-galleria-mask {\n        --maskbg: rgba(0, 0, 0, 0.9);\n    }\n\n    .p-image-mask {\n        --maskbg: rgba(0, 0, 0, 0.9);\n    }\n\n    .p-image-preview-indicator {\n        background-color: transparent;\n        color: #f8f9fa;\n        transition: box-shadow 0.15s;\n    }\n\n    .p-image-preview-indicator .p-icon {\n        width: 1.5rem;\n        height: 1.5rem;\n    }\n\n    .p-image-preview-container:hover>.p-image-preview-indicator {\n        background-color: rgba(0, 0, 0, 0.5);\n    }\n\n    .p-image-toolbar {\n        padding: 1rem;\n    }\n\n    .p-image-action.p-link {\n        color: #f8f9fa;\n        background-color: transparent;\n        width: 3rem;\n        height: 3rem;\n        border-radius: 50%;\n        transition: box-shadow 0.15s;\n        margin-right: 0.5rem;\n    }\n\n    .p-image-action.p-link:last-child {\n        margin-right: 0;\n    }\n\n    .p-image-action.p-link:hover {\n        color: #f8f9fa;\n        background-color: rgba(255, 255, 255, 0.1);\n    }\n\n    .p-image-action.p-link span {\n        font-size: 12px;\n    }\n\n    .p-image-action.p-link .p-icon {\n        width: 1.5rem;\n        height: 1.5rem;\n    }\n\n    .p-avatar {\n        background-color: #dee2e6;\n        border-radius: 4px;\n    }\n\n    .p-avatar.p-avatar-lg {\n        width: 3rem;\n        height: 3rem;\n        font-size: 12px;\n    }\n\n    .p-avatar.p-avatar-lg .p-avatar-icon {\n        font-size: 1.5rem;\n    }\n\n    .p-avatar.p-avatar-xl {\n        width: 4rem;\n        height: 4rem;\n        font-size: 12px;\n    }\n\n    .p-avatar.p-avatar-xl .p-avatar-icon {\n        font-size: 2rem;\n    }\n\n    .p-avatar-circle {\n        border-radius: 50%;\n    }\n\n    .p-avatar-group .p-avatar {\n        border: 2px solid #ffffff;\n    }\n\n    .p-chip {\n        background-color: #dee2e6;\n        color: #212529;\n        border-radius: 16px;\n        padding: 0 0.75rem;\n    }\n\n    .p-chip .p-chip-text {\n        line-height: 1.5;\n        margin-top: 0.25rem;\n        margin-bottom: 0.25rem;\n    }\n\n    .p-chip .p-chip-icon {\n        margin-right: 0.5rem;\n    }\n\n    .p-chip img {\n        width: 2rem;\n        height: 2rem;\n        margin-left: -0.75rem;\n        margin-right: 0.5rem;\n    }\n\n    .p-chip .p-chip-remove-icon {\n        border-radius: 4px;\n        transition: box-shadow 0.15s;\n        margin-left: 0.5rem;\n    }\n\n    .p-chip .p-chip-remove-icon:focus-visible {\n        outline: 0 none;\n        outline-offset: 0;\n        box-shadow: 0 0 0 0.2rem rgba(38, 143, 255, 0.5);\n    }\n\n    .p-chip .p-chip-remove-icon:focus {\n        outline: 0 none;\n    }\n\n    .p-scrolltop {\n        width: 3rem;\n        height: 3rem;\n        border-radius: 4px;\n        box-shadow: none;\n        transition: box-shadow 0.15s;\n    }\n\n    .p-scrolltop.p-link {\n        background: rgba(0, 0, 0, 0.7);\n    }\n\n    .p-scrolltop.p-link:hover {\n        background: rgba(0, 0, 0, 0.8);\n    }\n\n    .p-scrolltop .p-scrolltop-icon {\n        font-size: 1.5rem;\n        color: #efefef;\n    }\n\n    .p-scrolltop .p-scrolltop-icon.p-icon {\n        width: 1.5rem;\n        height: 1.5rem;\n    }\n\n    .p-skeleton {\n        background-color: #e9ecef;\n        border-radius: 4px;\n    }\n\n    .p-skeleton:after {\n        background: linear-gradient(90deg, rgba(255, 255, 255, 0), rgba(255, 255, 255, 0.4), rgba(255, 255, 255, 0));\n    }\n\n    .p-tag {\n        background: #cf0000;\n        color: #ffffff;\n        font-size: 12px;\n        font-weight: 700;\n        padding: 0.25rem 0.4rem;\n        border-radius: 4px;\n    }\n\n    .p-tag.p-tag-success {\n        background-color: #28a745;\n        color: #ffffff;\n    }\n\n    .p-tag.p-tag-info {\n        background-color: #17a2b8;\n        color: #ffffff;\n    }\n\n    .p-tag.p-tag-warning {\n        background-color: #ffc107;\n        color: #212529;\n    }\n\n    .p-tag.p-tag-danger {\n        background-color: #dc3545;\n        color: #ffffff;\n    }\n\n    .p-tag .p-tag-icon {\n        margin-right: 0.25rem;\n        font-size: 0.75rem;\n    }\n\n    .p-tag .p-tag-icon.p-icon {\n        width: 0.75rem;\n        height: 0.75rem;\n    }\n\n    .p-inplace .p-inplace-display {\n        padding: 0.5rem 0.75rem;\n        border-radius: 4px;\n        transition: background-color 0.15s, border-color 0.15s, box-shadow 0.15s;\n    }\n\n    .p-inplace .p-inplace-display:not(.p-disabled):hover {\n        background: #e9ecef;\n        color: #212529;\n    }\n\n    .p-inplace .p-inplace-display:focus {\n        outline: 0 none;\n        outline-offset: 0;\n        box-shadow: 0 0 0 0.2rem rgba(38, 143, 255, 0.5);\n    }\n\n    .p-progressbar {\n        border: 0 none;\n        height: 1.5rem;\n        background: #e9ecef;\n        border-radius: 4px;\n    }\n\n    .p-progressbar .p-progressbar-value {\n        border: 0 none;\n        margin: 0;\n        background: #cf0000;\n    }\n\n    .p-progressbar .p-progressbar-label {\n        color: #ffffff;\n        line-height: 1.5rem;\n    }\n\n    .p-terminal {\n        background: #ffffff;\n        color: #212529;\n        border: 1px solid #dee2e6;\n        padding: 1.25rem;\n    }\n\n    .p-terminal .p-terminal-input {\n        font-family: var(--font-family);\n        font-feature-settings: var(--font-feature-settings, normal);\n        font-size: 12px;\n    }\n\n    .p-badge {\n        background: #007bff;\n        color: #ffffff;\n        font-size: 12px;\n        font-weight: 700;\n        min-width: 1.5rem;\n        height: 1.5rem;\n        line-height: 1.5rem;\n    }\n\n    .p-badge.p-badge-secondary {\n        background-color: #6c757d;\n        color: #ffffff;\n    }\n\n    .p-badge.p-badge-success {\n        background-color: #28a745;\n        color: #ffffff;\n    }\n\n    .p-badge.p-badge-info {\n        background-color: #17a2b8;\n        color: #ffffff;\n    }\n\n    .p-badge.p-badge-warning {\n        background-color: #ffc107;\n        color: #212529;\n    }\n\n    .p-badge.p-badge-danger {\n        background-color: #dc3545;\n        color: #ffffff;\n    }\n\n    .p-badge.p-badge-lg {\n        font-size: 12px;\n        min-width: 2.25rem;\n        height: 2.25rem;\n        line-height: 2.25rem;\n    }\n\n    .p-badge.p-badge-xl {\n        font-size: 12px;\n        min-width: 3rem;\n        height: 3rem;\n        line-height: 3rem;\n    }\n\n    .p-tag {\n        background: #cf0000;\n        color: #ffffff;\n        font-size: 12px;\n        font-weight: 700;\n        padding: 0.25rem 0.4rem;\n        border-radius: 4px;\n    }\n\n    .p-tag.p-tag-success {\n        background-color: #28a745;\n        color: #ffffff;\n    }\n\n    .p-tag.p-tag-info {\n        background-color: #17a2b8;\n        color: #ffffff;\n    }\n\n    .p-tag.p-tag-warning {\n        background-color: #ffc107;\n        color: #212529;\n    }\n\n    .p-tag.p-tag-danger {\n        background-color: #dc3545;\n        color: #ffffff;\n    }\n}\n\n/* Vendor extensions to the designer enhanced bootstrap compatibility */\n@layer primereact {\n    .p-breadcrumb .p-breadcrumb-chevron {\n        font-family: -apple-system, BlinkMacSystemFont, \"Segoe UI\", Roboto, Helvetica, Arial, sans-serif, \"Apple Color Emoji\", \"Segoe UI Emoji\", \"Segoe UI Symbol\";\n    }\n\n    .p-breadcrumb .p-breadcrumb-chevron:before {\n        content: \"/\";\n    }\n}\n\n/* Customizations to the designer theme should be defined here */"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
